// Authoritative 2024–2026 General Ledger Dataset
// Source: docs/VSB Farm Contract Growing FIN.xlsb (1).xlsx (Sheet: Ledger, 2024–2026 rows)
// Reconciled authoritative baseline dataset.

export interface AuthoritativeLedgerRow {
  id: string;
  rowIndex: number;
  date: string;
  rawDate?: number | null;
  raiser: string;
  batch: string;
  cycleCode: string;
  supplier: string | null;
  customer: string | null;
  ledgerNr: string;
  ledgerDescription: string;
  invoiceRef: string | null;
  description: string | null;
  qty: number | null;
  qtyKg: number | null;
  price: number | null;
  total: number;
}

export const AUTHORITATIVE_LEDGER_ENTRIES: AuthoritativeLedgerRow[] = [
  {
    "id": "ledger-2024-2026-1",
    "rowIndex": 1,
    "date": "2024-09-20",
    "rawDate": 45555,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "3J",
    "qty": 275,
    "qtyKg": null,
    "price": 7732.2,
    "total": 2126355
  },
  {
    "id": "ledger-2024-2026-2",
    "rowIndex": 2,
    "date": "2024-11-02",
    "rawDate": 45598,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "3J",
    "qty": 100,
    "qtyKg": null,
    "price": 7600,
    "total": 760000
  },
  {
    "id": "ledger-2024-2026-3",
    "rowIndex": 3,
    "date": "2024-11-02",
    "rawDate": 45598,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25040",
    "description": "HPS Deluxe",
    "qty": 13,
    "qtyKg": null,
    "price": 2241,
    "total": 29133
  },
  {
    "id": "ledger-2024-2026-4",
    "rowIndex": 4,
    "date": "2024-11-02",
    "rawDate": 45598,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25040",
    "description": "HSP A2",
    "qty": 127,
    "qtyKg": null,
    "price": 1474,
    "total": 187198
  },
  {
    "id": "ledger-2024-2026-5",
    "rowIndex": 5,
    "date": "2024-11-04",
    "rawDate": 45600,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 8500,
    "total": 850000
  },
  {
    "id": "ledger-2024-2026-6",
    "rowIndex": 6,
    "date": "2024-11-04",
    "rawDate": 45600,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25086",
    "description": "HPS",
    "qty": 10,
    "qtyKg": null,
    "price": 2241,
    "total": 22410
  },
  {
    "id": "ledger-2024-2026-7",
    "rowIndex": 7,
    "date": "2024-11-04",
    "rawDate": 45600,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25086",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1474,
    "total": 14740
  },
  {
    "id": "ledger-2024-2026-8",
    "rowIndex": 8,
    "date": "2024-11-08",
    "rawDate": 45604,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 10608,
    "total": 530400
  },
  {
    "id": "ledger-2024-2026-9",
    "rowIndex": 9,
    "date": "2024-11-08",
    "rawDate": 45604,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": 20,
    "price": 1474,
    "total": 29480
  },
  {
    "id": "ledger-2024-2026-10",
    "rowIndex": 10,
    "date": "2024-11-09",
    "rawDate": 45605,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25407",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1474,
    "total": 22110
  },
  {
    "id": "ledger-2024-2026-11",
    "rowIndex": 11,
    "date": "2024-11-13",
    "rawDate": 45609,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25630",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1454,
    "total": 14540
  },
  {
    "id": "ledger-2024-2026-12",
    "rowIndex": 12,
    "date": "2024-11-13",
    "rawDate": 45609,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25630",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1454,
    "total": 79970
  },
  {
    "id": "ledger-2024-2026-13",
    "rowIndex": 13,
    "date": "2024-11-13",
    "rawDate": 45609,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25606",
    "description": "HSP A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1454,
    "total": 218100
  },
  {
    "id": "ledger-2024-2026-14",
    "rowIndex": 14,
    "date": "2024-11-15",
    "rawDate": 45611,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25739",
    "description": "HPS",
    "qty": 10,
    "qtyKg": null,
    "price": 2231,
    "total": 22310
  },
  {
    "id": "ledger-2024-2026-15",
    "rowIndex": 15,
    "date": "2024-11-15",
    "rawDate": 45611,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25739",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1454,
    "total": 14540
  },
  {
    "id": "ledger-2024-2026-16",
    "rowIndex": 16,
    "date": "2024-11-16",
    "rawDate": 45612,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 9614,
    "total": 480700
  },
  {
    "id": "ledger-2024-2026-17",
    "rowIndex": 17,
    "date": "2024-11-16",
    "rawDate": 45612,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25993",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1454,
    "total": 14540
  },
  {
    "id": "ledger-2024-2026-18",
    "rowIndex": 18,
    "date": "2024-11-21",
    "rawDate": 45617,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25994",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-19",
    "rowIndex": 19,
    "date": "2024-11-21",
    "rawDate": 45617,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25993",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-20",
    "rowIndex": 20,
    "date": "2024-11-21",
    "rawDate": 45617,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 10700,
    "total": 642000
  },
  {
    "id": "ledger-2024-2026-21",
    "rowIndex": 21,
    "date": "2024-11-21",
    "rawDate": 45617,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25992",
    "description": "HPS Deluxe",
    "qty": 30,
    "qtyKg": null,
    "price": 1205,
    "total": 36150
  },
  {
    "id": "ledger-2024-2026-22",
    "rowIndex": 22,
    "date": "2024-11-21",
    "rawDate": 45617,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "25992",
    "description": "HSP A2",
    "qty": 105,
    "qtyKg": null,
    "price": 1444,
    "total": 151620
  },
  {
    "id": "ledger-2024-2026-23",
    "rowIndex": 23,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-24",
    "rowIndex": 24,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-25",
    "rowIndex": 25,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-26",
    "rowIndex": 26,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-27",
    "rowIndex": 27,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-28",
    "rowIndex": 28,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-29",
    "rowIndex": 29,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-30",
    "rowIndex": 30,
    "date": "2024-11-25",
    "rawDate": 45621,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26182",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1444,
    "total": 43320
  },
  {
    "id": "ledger-2024-2026-31",
    "rowIndex": 31,
    "date": "2024-11-26",
    "rawDate": 45622,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 190,
    "qtyKg": null,
    "price": 11200,
    "total": 2128000
  },
  {
    "id": "ledger-2024-2026-32",
    "rowIndex": 32,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 11200,
    "total": 560000
  },
  {
    "id": "ledger-2024-2026-33",
    "rowIndex": 33,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26399",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-34",
    "rowIndex": 34,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 75,
    "qtyKg": null,
    "price": 10733.333333333334,
    "total": 805000
  },
  {
    "id": "ledger-2024-2026-35",
    "rowIndex": 35,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26399",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1444,
    "total": 36100
  },
  {
    "id": "ledger-2024-2026-36",
    "rowIndex": 36,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26399",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-37",
    "rowIndex": 37,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26421",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-38",
    "rowIndex": 38,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 12200,
    "total": 427000
  },
  {
    "id": "ledger-2024-2026-39",
    "rowIndex": 39,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26399",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-40",
    "rowIndex": 40,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26420",
    "description": "HPS 25 Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1205,
    "total": 30125
  },
  {
    "id": "ledger-2024-2026-41",
    "rowIndex": 41,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26420",
    "description": "HSP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1444,
    "total": 86640
  },
  {
    "id": "ledger-2024-2026-42",
    "rowIndex": 42,
    "date": "2024-11-29",
    "rawDate": 45625,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26420",
    "description": "HGP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1364,
    "total": 81840
  },
  {
    "id": "ledger-2024-2026-43",
    "rowIndex": 43,
    "date": "2024-12-03",
    "rawDate": 45629,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26605",
    "description": "HSP A2",
    "qty": 42,
    "qtyKg": null,
    "price": 1444,
    "total": 60648
  },
  {
    "id": "ledger-2024-2026-44",
    "rowIndex": 44,
    "date": "2024-12-03",
    "rawDate": 45629,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26605",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1444,
    "total": 40432
  },
  {
    "id": "ledger-2024-2026-45",
    "rowIndex": 45,
    "date": "2024-12-05",
    "rawDate": 45631,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26673",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-46",
    "rowIndex": 46,
    "date": "2024-12-05",
    "rawDate": 45631,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26673",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-47",
    "rowIndex": 47,
    "date": "2024-12-05",
    "rawDate": 45631,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26673",
    "description": "HSP A2",
    "qty": 45,
    "qtyKg": null,
    "price": 1444,
    "total": 64980
  },
  {
    "id": "ledger-2024-2026-48",
    "rowIndex": 48,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26758",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-49",
    "rowIndex": 49,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26759",
    "description": "HPS 25 Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1205,
    "total": 12050
  },
  {
    "id": "ledger-2024-2026-50",
    "rowIndex": 50,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26759",
    "description": "HGP",
    "qty": 20,
    "qtyKg": null,
    "price": 1324,
    "total": 26480
  },
  {
    "id": "ledger-2024-2026-51",
    "rowIndex": 51,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26759",
    "description": "HGP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1364,
    "total": 54560
  },
  {
    "id": "ledger-2024-2026-52",
    "rowIndex": 52,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26759",
    "description": "HG HD A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1444,
    "total": 86640
  },
  {
    "id": "ledger-2024-2026-53",
    "rowIndex": 53,
    "date": "2024-12-06",
    "rawDate": 45632,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26763",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-54",
    "rowIndex": 54,
    "date": "2024-12-11",
    "rawDate": 45637,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26966",
    "description": "HSP VT",
    "qty": 15,
    "qtyKg": null,
    "price": 1414,
    "total": 21210
  },
  {
    "id": "ledger-2024-2026-55",
    "rowIndex": 55,
    "date": "2024-12-11",
    "rawDate": 45637,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26966",
    "description": "HSP VT",
    "qty": 17,
    "qtyKg": null,
    "price": 1454,
    "total": 24718
  },
  {
    "id": "ledger-2024-2026-56",
    "rowIndex": 56,
    "date": "2024-12-11",
    "rawDate": 45637,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "26966",
    "description": "HSP VT",
    "qty": 8,
    "qtyKg": null,
    "price": 1454,
    "total": 11632
  },
  {
    "id": "ledger-2024-2026-57",
    "rowIndex": 57,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27107",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-58",
    "rowIndex": 58,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27107",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-59",
    "rowIndex": 59,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27107",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-60",
    "rowIndex": 60,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27086",
    "description": "HG HD VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1414,
    "total": 35350
  },
  {
    "id": "ledger-2024-2026-61",
    "rowIndex": 61,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27107",
    "description": "HSP A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1444,
    "total": 50540
  },
  {
    "id": "ledger-2024-2026-62",
    "rowIndex": 62,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27085",
    "description": "HPS 50 Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 2231,
    "total": 17848
  },
  {
    "id": "ledger-2024-2026-63",
    "rowIndex": 63,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27085",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1444,
    "total": 10108
  },
  {
    "id": "ledger-2024-2026-64",
    "rowIndex": 64,
    "date": "2024-12-13",
    "rawDate": 45639,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27085",
    "description": "HG HD VI",
    "qty": 110,
    "qtyKg": null,
    "price": 1414,
    "total": 155540
  },
  {
    "id": "ledger-2024-2026-65",
    "rowIndex": 65,
    "date": "2024-12-17",
    "rawDate": 45643,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27236",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-66",
    "rowIndex": 66,
    "date": "2024-12-17",
    "rawDate": 45643,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27236",
    "description": "HSP VI",
    "qty": 35,
    "qtyKg": null,
    "price": 1414,
    "total": 49490
  },
  {
    "id": "ledger-2024-2026-67",
    "rowIndex": 67,
    "date": "2024-12-17",
    "rawDate": 45643,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27236",
    "description": "HSP VI",
    "qty": 28,
    "qtyKg": null,
    "price": 1414,
    "total": 39592
  },
  {
    "id": "ledger-2024-2026-68",
    "rowIndex": 68,
    "date": "2024-12-17",
    "rawDate": 45643,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27236",
    "description": "HSP VI",
    "qty": 12,
    "qtyKg": null,
    "price": 1414,
    "total": 16968
  },
  {
    "id": "ledger-2024-2026-69",
    "rowIndex": 69,
    "date": "2024-12-17",
    "rawDate": 45643,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27236",
    "description": "HSP VI",
    "qty": 65,
    "qtyKg": null,
    "price": 1414,
    "total": 91910
  },
  {
    "id": "ledger-2024-2026-70",
    "rowIndex": 70,
    "date": "2024-12-19",
    "rawDate": 45645,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27381",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1444,
    "total": 36100
  },
  {
    "id": "ledger-2024-2026-71",
    "rowIndex": 71,
    "date": "2024-12-19",
    "rawDate": 45645,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27378",
    "description": "HPS 50 Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 2231,
    "total": 17848
  },
  {
    "id": "ledger-2024-2026-72",
    "rowIndex": 72,
    "date": "2024-12-19",
    "rawDate": 45645,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27378",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1444,
    "total": 17328
  },
  {
    "id": "ledger-2024-2026-73",
    "rowIndex": 73,
    "date": "2024-12-19",
    "rawDate": 45645,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27378",
    "description": "HG HD",
    "qty": 105,
    "qtyKg": null,
    "price": 1404,
    "total": 147420
  },
  {
    "id": "ledger-2024-2026-74",
    "rowIndex": 74,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1444,
    "total": 10108
  },
  {
    "id": "ledger-2024-2026-75",
    "rowIndex": 75,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-76",
    "rowIndex": 76,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1444,
    "total": 8664
  },
  {
    "id": "ledger-2024-2026-77",
    "rowIndex": 77,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP VI",
    "qty": 14,
    "qtyKg": null,
    "price": 1414,
    "total": 19796
  },
  {
    "id": "ledger-2024-2026-78",
    "rowIndex": 78,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27451",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-79",
    "rowIndex": 79,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27451",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-80",
    "rowIndex": 80,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27451",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1444,
    "total": 10108
  },
  {
    "id": "ledger-2024-2026-81",
    "rowIndex": 81,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1444,
    "total": 8664
  },
  {
    "id": "ledger-2024-2026-82",
    "rowIndex": 82,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27452",
    "description": "HSP VI",
    "qty": 7,
    "qtyKg": null,
    "price": 1414,
    "total": 9898
  },
  {
    "id": "ledger-2024-2026-83",
    "rowIndex": 83,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27451",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1444,
    "total": 11552
  },
  {
    "id": "ledger-2024-2026-84",
    "rowIndex": 84,
    "date": "2024-12-21",
    "rawDate": 45647,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27451",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1444,
    "total": 43320
  },
  {
    "id": "ledger-2024-2026-85",
    "rowIndex": 85,
    "date": "2024-12-26",
    "rawDate": 45652,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27671",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1444,
    "total": 57760
  },
  {
    "id": "ledger-2024-2026-86",
    "rowIndex": 86,
    "date": "2024-12-26",
    "rawDate": 45652,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27670",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1444,
    "total": 36100
  },
  {
    "id": "ledger-2024-2026-87",
    "rowIndex": 87,
    "date": "2024-12-26",
    "rawDate": 45652,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27670",
    "description": "HG HD VR",
    "qty": 95,
    "qtyKg": null,
    "price": 1424,
    "total": 135280
  },
  {
    "id": "ledger-2024-2026-88",
    "rowIndex": 88,
    "date": "2024-12-27",
    "rawDate": 45653,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27695",
    "description": "HSP A2",
    "qty": 2,
    "qtyKg": null,
    "price": 1444,
    "total": 2888
  },
  {
    "id": "ledger-2024-2026-89",
    "rowIndex": 89,
    "date": "2024-12-27",
    "rawDate": 45653,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27695",
    "description": "HSP A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1444,
    "total": 33212
  },
  {
    "id": "ledger-2024-2026-90",
    "rowIndex": 90,
    "date": "2024-12-27",
    "rawDate": 45653,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27695",
    "description": "HSP A2",
    "qty": 130,
    "qtyKg": null,
    "price": 1444,
    "total": 187720
  },
  {
    "id": "ledger-2024-2026-91",
    "rowIndex": 91,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27776",
    "description": "HSP A2",
    "qty": 21,
    "qtyKg": null,
    "price": 1444,
    "total": 30324
  },
  {
    "id": "ledger-2024-2026-92",
    "rowIndex": 92,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27776",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1444,
    "total": 40432
  },
  {
    "id": "ledger-2024-2026-93",
    "rowIndex": 93,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27777",
    "description": "HSP",
    "qty": 28,
    "qtyKg": null,
    "price": 1404,
    "total": 39312
  },
  {
    "id": "ledger-2024-2026-94",
    "rowIndex": 94,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27777",
    "description": "HSP A2",
    "qty": 32,
    "qtyKg": null,
    "price": 1444,
    "total": 46208
  },
  {
    "id": "ledger-2024-2026-95",
    "rowIndex": 95,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27777",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-96",
    "rowIndex": 96,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27777",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-97",
    "rowIndex": 97,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27777",
    "description": "HGP",
    "qty": 10,
    "qtyKg": null,
    "price": 1324,
    "total": 13240
  },
  {
    "id": "ledger-2024-2026-98",
    "rowIndex": 98,
    "date": "2024-12-28",
    "rawDate": 45654,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27776",
    "description": "HSP A2",
    "qty": 11,
    "qtyKg": null,
    "price": 1444,
    "total": 15884
  },
  {
    "id": "ledger-2024-2026-99",
    "rowIndex": 99,
    "date": "2024-12-30",
    "rawDate": 45656,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27848",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1444,
    "total": 43320
  },
  {
    "id": "ledger-2024-2026-100",
    "rowIndex": 100,
    "date": "2024-12-30",
    "rawDate": 45656,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "27848",
    "description": "HG HD VR",
    "qty": 130,
    "qtyKg": null,
    "price": 1424,
    "total": 185120
  },
  {
    "id": "ledger-2024-2026-101",
    "rowIndex": 101,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-102",
    "rowIndex": 102,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1444,
    "total": 10108
  },
  {
    "id": "ledger-2024-2026-103",
    "rowIndex": 103,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HGP",
    "qty": 7,
    "qtyKg": null,
    "price": 1324,
    "total": 9268
  },
  {
    "id": "ledger-2024-2026-104",
    "rowIndex": 104,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1404,
    "total": 8424
  },
  {
    "id": "ledger-2024-2026-105",
    "rowIndex": 105,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28030",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1404,
    "total": 42120
  },
  {
    "id": "ledger-2024-2026-106",
    "rowIndex": 106,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28030",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-107",
    "rowIndex": 107,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-108",
    "rowIndex": 108,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28032",
    "description": "HSP A2",
    "qty": 95,
    "qtyKg": null,
    "price": 1444,
    "total": 137180
  },
  {
    "id": "ledger-2024-2026-109",
    "rowIndex": 109,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28031",
    "description": "HSP VI",
    "qty": 35,
    "qtyKg": null,
    "price": 1414,
    "total": 49490
  },
  {
    "id": "ledger-2024-2026-110",
    "rowIndex": 110,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28031",
    "description": "HG HD",
    "qty": 35,
    "qtyKg": null,
    "price": 1404,
    "total": 49140
  },
  {
    "id": "ledger-2024-2026-111",
    "rowIndex": 111,
    "date": "2025-01-06",
    "rawDate": 45663,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28031",
    "description": "HG HD VR2",
    "qty": 30,
    "qtyKg": null,
    "price": 1424,
    "total": 42720
  },
  {
    "id": "ledger-2024-2026-112",
    "rowIndex": 112,
    "date": "2025-01-08",
    "rawDate": 45665,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1444,
    "total": 36100
  },
  {
    "id": "ledger-2024-2026-113",
    "rowIndex": 113,
    "date": "2025-01-08",
    "rawDate": 45665,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 31,
    "qtyKg": null,
    "price": 1444,
    "total": 44764
  },
  {
    "id": "ledger-2024-2026-114",
    "rowIndex": 114,
    "date": "2025-01-08",
    "rawDate": 45665,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28161",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1444,
    "total": 79420
  },
  {
    "id": "ledger-2024-2026-115",
    "rowIndex": 115,
    "date": "2025-01-08",
    "rawDate": 45665,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-116",
    "rowIndex": 116,
    "date": "2025-01-08",
    "rawDate": 45665,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 19,
    "qtyKg": null,
    "price": 1444,
    "total": 27436
  },
  {
    "id": "ledger-2024-2026-117",
    "rowIndex": 117,
    "date": "2025-01-13",
    "rawDate": 45670,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28322",
    "description": "HGP VF",
    "qty": 10,
    "qtyKg": null,
    "price": 1344,
    "total": 13440
  },
  {
    "id": "ledger-2024-2026-118",
    "rowIndex": 118,
    "date": "2025-01-13",
    "rawDate": 45670,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28321",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-119",
    "rowIndex": 119,
    "date": "2025-01-13",
    "rawDate": 45670,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28320",
    "description": "HSP A2",
    "qty": 100,
    "qtyKg": null,
    "price": 1444,
    "total": 144400
  },
  {
    "id": "ledger-2024-2026-120",
    "rowIndex": 120,
    "date": "2025-01-13",
    "rawDate": 45670,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28321",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-121",
    "rowIndex": 121,
    "date": "2025-01-14",
    "rawDate": 45671,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28386",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-122",
    "rowIndex": 122,
    "date": "2025-01-14",
    "rawDate": 45671,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28386",
    "description": "HGP",
    "qty": 10,
    "qtyKg": null,
    "price": 1324,
    "total": 13240
  },
  {
    "id": "ledger-2024-2026-123",
    "rowIndex": 123,
    "date": "2025-01-14",
    "rawDate": 45671,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28388",
    "description": "HSP A2",
    "qty": 45,
    "qtyKg": null,
    "price": 1444,
    "total": 64980
  },
  {
    "id": "ledger-2024-2026-124",
    "rowIndex": 124,
    "date": "2025-01-14",
    "rawDate": 45671,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28388",
    "description": "HGP",
    "qty": 10,
    "qtyKg": null,
    "price": 1324,
    "total": 13240
  },
  {
    "id": "ledger-2024-2026-125",
    "rowIndex": 125,
    "date": "2025-01-14",
    "rawDate": 45671,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28388",
    "description": "HGP VF",
    "qty": 70,
    "qtyKg": null,
    "price": 1409,
    "total": 98630
  },
  {
    "id": "ledger-2024-2026-126",
    "rowIndex": 126,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28526",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1444,
    "total": 17328
  },
  {
    "id": "ledger-2024-2026-127",
    "rowIndex": 127,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28526",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1444,
    "total": 24548
  },
  {
    "id": "ledger-2024-2026-128",
    "rowIndex": 128,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28490",
    "description": "HSP A2",
    "qty": 80,
    "qtyKg": null,
    "price": 1444,
    "total": 115520
  },
  {
    "id": "ledger-2024-2026-129",
    "rowIndex": 129,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28490",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1404,
    "total": 28080
  },
  {
    "id": "ledger-2024-2026-130",
    "rowIndex": 130,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28490",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1444,
    "total": 21660
  },
  {
    "id": "ledger-2024-2026-131",
    "rowIndex": 131,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28490",
    "description": "HGP",
    "qty": 25,
    "qtyKg": null,
    "price": 1324,
    "total": 33100
  },
  {
    "id": "ledger-2024-2026-132",
    "rowIndex": 132,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28490",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-133",
    "rowIndex": 133,
    "date": "2025-01-16",
    "rawDate": 45673,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28526",
    "description": "HSP A2",
    "qty": 11,
    "qtyKg": null,
    "price": 1444,
    "total": 15884
  },
  {
    "id": "ledger-2024-2026-134",
    "rowIndex": 134,
    "date": "2025-01-20",
    "rawDate": 45677,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28587",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-135",
    "rowIndex": 135,
    "date": "2025-01-20",
    "rawDate": 45677,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28587",
    "description": "HG HD VB",
    "qty": 10,
    "qtyKg": null,
    "price": 1434,
    "total": 14340
  },
  {
    "id": "ledger-2024-2026-136",
    "rowIndex": 136,
    "date": "2025-01-20",
    "rawDate": 45677,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28587",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-137",
    "rowIndex": 137,
    "date": "2025-01-20",
    "rawDate": 45677,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28587",
    "description": "HSP A2",
    "qty": 110,
    "qtyKg": null,
    "price": 1444,
    "total": 158840
  },
  {
    "id": "ledger-2024-2026-138",
    "rowIndex": 138,
    "date": "2025-01-22",
    "rawDate": 45679,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28700",
    "description": "HG HD VF",
    "qty": 25,
    "qtyKg": null,
    "price": 1489,
    "total": 37225
  },
  {
    "id": "ledger-2024-2026-139",
    "rowIndex": 139,
    "date": "2025-01-22",
    "rawDate": 45679,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28700",
    "description": "HG HD VR2",
    "qty": 40,
    "qtyKg": null,
    "price": 1424,
    "total": 56960
  },
  {
    "id": "ledger-2024-2026-140",
    "rowIndex": 140,
    "date": "2025-01-22",
    "rawDate": 45679,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28701",
    "description": "HSP A2",
    "qty": 65,
    "qtyKg": null,
    "price": 1444,
    "total": 93860
  },
  {
    "id": "ledger-2024-2026-141",
    "rowIndex": 141,
    "date": "2025-01-22",
    "rawDate": 45679,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28701",
    "description": "HG HD",
    "qty": 80,
    "qtyKg": null,
    "price": 1404,
    "total": 112320
  },
  {
    "id": "ledger-2024-2026-142",
    "rowIndex": 142,
    "date": "2025-01-22",
    "rawDate": 45679,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28701",
    "description": "HG HD VR2",
    "qty": 90,
    "qtyKg": null,
    "price": 1424,
    "total": 128160
  },
  {
    "id": "ledger-2024-2026-143",
    "rowIndex": 143,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1404,
    "total": 21060
  },
  {
    "id": "ledger-2024-2026-144",
    "rowIndex": 144,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HG HD VF",
    "qty": 8,
    "qtyKg": null,
    "price": 1489,
    "total": 11912
  },
  {
    "id": "ledger-2024-2026-145",
    "rowIndex": 145,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HSP",
    "qty": 27,
    "qtyKg": null,
    "price": 1404,
    "total": 37908
  },
  {
    "id": "ledger-2024-2026-146",
    "rowIndex": 146,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HG HD VF",
    "qty": 10,
    "qtyKg": null,
    "price": 1489,
    "total": 14890
  },
  {
    "id": "ledger-2024-2026-147",
    "rowIndex": 147,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-148",
    "rowIndex": 148,
    "date": "2025-01-24",
    "rawDate": 45681,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28832",
    "description": "HG HD VF",
    "qty": 5,
    "qtyKg": null,
    "price": 1489,
    "total": 7445
  },
  {
    "id": "ledger-2024-2026-149",
    "rowIndex": 149,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD VF",
    "qty": 5,
    "qtyKg": null,
    "price": 1489,
    "total": 7445
  },
  {
    "id": "ledger-2024-2026-150",
    "rowIndex": 150,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD VR2",
    "qty": 40,
    "qtyKg": null,
    "price": 1424,
    "total": 56960
  },
  {
    "id": "ledger-2024-2026-151",
    "rowIndex": 151,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD VF",
    "qty": 8,
    "qtyKg": null,
    "price": 1489,
    "total": 11912
  },
  {
    "id": "ledger-2024-2026-152",
    "rowIndex": 152,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD VR2",
    "qty": 17,
    "qtyKg": null,
    "price": 1489,
    "total": 25313
  },
  {
    "id": "ledger-2024-2026-153",
    "rowIndex": 153,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-154",
    "rowIndex": 154,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28948",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1454,
    "total": 58160
  },
  {
    "id": "ledger-2024-2026-155",
    "rowIndex": 155,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28929",
    "description": "HG HD VAS",
    "qty": 18,
    "qtyKg": null,
    "price": 1624,
    "total": 29232
  },
  {
    "id": "ledger-2024-2026-156",
    "rowIndex": 156,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28929",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1444,
    "total": 28880
  },
  {
    "id": "ledger-2024-2026-157",
    "rowIndex": 157,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28929",
    "description": "HG HD VAS",
    "qty": 62,
    "qtyKg": null,
    "price": 1624,
    "total": 100688
  },
  {
    "id": "ledger-2024-2026-158",
    "rowIndex": 158,
    "date": "2025-01-28",
    "rawDate": 45685,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "28929",
    "description": "HG HD VR2",
    "qty": 50,
    "qtyKg": null,
    "price": 1424,
    "total": 71200
  },
  {
    "id": "ledger-2024-2026-159",
    "rowIndex": 159,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VF",
    "qty": 6,
    "qtyKg": null,
    "price": 1489,
    "total": 8934
  },
  {
    "id": "ledger-2024-2026-160",
    "rowIndex": 160,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-161",
    "rowIndex": 161,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VF",
    "qty": 5,
    "qtyKg": null,
    "price": 1489,
    "total": 7445
  },
  {
    "id": "ledger-2024-2026-162",
    "rowIndex": 162,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1414,
    "total": 24038
  },
  {
    "id": "ledger-2024-2026-163",
    "rowIndex": 163,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VF",
    "qty": 4,
    "qtyKg": null,
    "price": 1489,
    "total": 5956
  },
  {
    "id": "ledger-2024-2026-164",
    "rowIndex": 164,
    "date": "2025-02-01",
    "rawDate": 45689,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29132",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1414,
    "total": 11312
  },
  {
    "id": "ledger-2024-2026-165",
    "rowIndex": 165,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29147",
    "description": "HG HD VR",
    "qty": 93,
    "qtyKg": null,
    "price": 1414,
    "total": 131502
  },
  {
    "id": "ledger-2024-2026-166",
    "rowIndex": 166,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29146",
    "description": "HG HD",
    "qty": 38,
    "qtyKg": null,
    "price": 1404,
    "total": 53352
  },
  {
    "id": "ledger-2024-2026-167",
    "rowIndex": 167,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29147",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1404,
    "total": 9828
  },
  {
    "id": "ledger-2024-2026-168",
    "rowIndex": 168,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29146",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1404,
    "total": 2808
  },
  {
    "id": "ledger-2024-2026-169",
    "rowIndex": 169,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29146",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-170",
    "rowIndex": 170,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29146",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1414,
    "total": 7070
  },
  {
    "id": "ledger-2024-2026-171",
    "rowIndex": 171,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29143",
    "description": "HD VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1414,
    "total": 98980
  },
  {
    "id": "ledger-2024-2026-172",
    "rowIndex": 172,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29142",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1404,
    "total": 35100
  },
  {
    "id": "ledger-2024-2026-173",
    "rowIndex": 173,
    "date": "2025-02-03",
    "rawDate": 45691,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29142",
    "description": "HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1414,
    "total": 84840
  },
  {
    "id": "ledger-2024-2026-174",
    "rowIndex": 174,
    "date": "2025-02-05",
    "rawDate": 45693,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29259",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1414,
    "total": 35350
  },
  {
    "id": "ledger-2024-2026-175",
    "rowIndex": 175,
    "date": "2025-02-05",
    "rawDate": 45693,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29259",
    "description": "HG HD VF",
    "qty": 70,
    "qtyKg": null,
    "price": 1489,
    "total": 104230
  },
  {
    "id": "ledger-2024-2026-176",
    "rowIndex": 176,
    "date": "2025-02-05",
    "rawDate": 45693,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29259",
    "description": "HG HD VR",
    "qty": 55,
    "qtyKg": null,
    "price": 1414,
    "total": 77770
  },
  {
    "id": "ledger-2024-2026-177",
    "rowIndex": 177,
    "date": "2025-02-07",
    "rawDate": 45695,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29384",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1414,
    "total": 21210
  },
  {
    "id": "ledger-2024-2026-178",
    "rowIndex": 178,
    "date": "2025-02-07",
    "rawDate": 45695,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29384",
    "description": "HG HD VR",
    "qty": 23,
    "qtyKg": null,
    "price": 1414,
    "total": 32522
  },
  {
    "id": "ledger-2024-2026-179",
    "rowIndex": 179,
    "date": "2025-02-07",
    "rawDate": 45695,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29384",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1414,
    "total": 16968
  },
  {
    "id": "ledger-2024-2026-180",
    "rowIndex": 180,
    "date": "2025-02-07",
    "rawDate": 45695,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29381",
    "description": "HG HD VR",
    "qty": 105,
    "qtyKg": null,
    "price": 1414,
    "total": 148470
  },
  {
    "id": "ledger-2024-2026-181",
    "rowIndex": 181,
    "date": "2025-02-07",
    "rawDate": 45695,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29382",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1404,
    "total": 63180
  },
  {
    "id": "ledger-2024-2026-182",
    "rowIndex": 182,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29544",
    "description": "HG HD VR",
    "qty": 16,
    "qtyKg": null,
    "price": 1414,
    "total": 22624
  },
  {
    "id": "ledger-2024-2026-183",
    "rowIndex": 183,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": 700,
    "total": 1400
  },
  {
    "id": "ledger-2024-2026-184",
    "rowIndex": 184,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29543",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-185",
    "rowIndex": 185,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29544",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1414,
    "total": 21210
  },
  {
    "id": "ledger-2024-2026-186",
    "rowIndex": 186,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1414,
    "total": 70700
  },
  {
    "id": "ledger-2024-2026-187",
    "rowIndex": 187,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1404,
    "total": 28080
  },
  {
    "id": "ledger-2024-2026-188",
    "rowIndex": 188,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1414,
    "total": 7070
  },
  {
    "id": "ledger-2024-2026-189",
    "rowIndex": 189,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1404,
    "total": 2808
  },
  {
    "id": "ledger-2024-2026-190",
    "rowIndex": 190,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29544",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1414,
    "total": 19796
  },
  {
    "id": "ledger-2024-2026-191",
    "rowIndex": 191,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1414,
    "total": 21210
  },
  {
    "id": "ledger-2024-2026-192",
    "rowIndex": 192,
    "date": "2025-02-12",
    "rawDate": 45700,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29541",
    "description": "HG HD VR",
    "qty": 58,
    "qtyKg": null,
    "price": 1414,
    "total": 82012
  },
  {
    "id": "ledger-2024-2026-193",
    "rowIndex": 193,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29697",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1414,
    "total": 56560
  },
  {
    "id": "ledger-2024-2026-194",
    "rowIndex": 194,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29697",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1414,
    "total": 35350
  },
  {
    "id": "ledger-2024-2026-195",
    "rowIndex": 195,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29698",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1414,
    "total": 35350
  },
  {
    "id": "ledger-2024-2026-196",
    "rowIndex": 196,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29698",
    "description": "HG HD VF",
    "qty": 30,
    "qtyKg": null,
    "price": 1474,
    "total": 44220
  },
  {
    "id": "ledger-2024-2026-197",
    "rowIndex": 197,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29698",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1404,
    "total": 28080
  },
  {
    "id": "ledger-2024-2026-198",
    "rowIndex": 198,
    "date": "2025-02-14",
    "rawDate": 45702,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29698",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-199",
    "rowIndex": 199,
    "date": "2025-02-17",
    "rawDate": 45705,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29729",
    "description": "HG HD VR",
    "qty": 105,
    "qtyKg": null,
    "price": 1399,
    "total": 146895
  },
  {
    "id": "ledger-2024-2026-200",
    "rowIndex": 200,
    "date": "2025-02-17",
    "rawDate": 45705,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29729",
    "description": "HG HD",
    "qty": 45,
    "qtyKg": null,
    "price": 1389,
    "total": 62505
  },
  {
    "id": "ledger-2024-2026-201",
    "rowIndex": 201,
    "date": "2025-02-17",
    "rawDate": 45705,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29730",
    "description": "HG HD VR",
    "qty": 1,
    "qtyKg": null,
    "price": 1399,
    "total": 1399
  },
  {
    "id": "ledger-2024-2026-202",
    "rowIndex": 202,
    "date": "2025-02-17",
    "rawDate": 45705,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29730",
    "description": "HG HD VR",
    "qty": 24,
    "qtyKg": null,
    "price": 1399,
    "total": 33576
  },
  {
    "id": "ledger-2024-2026-203",
    "rowIndex": 203,
    "date": "2025-02-17",
    "rawDate": 45705,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29730",
    "description": "HG HD VR",
    "qty": 125,
    "qtyKg": null,
    "price": 1399,
    "total": 174875
  },
  {
    "id": "ledger-2024-2026-204",
    "rowIndex": 204,
    "date": "2025-02-18",
    "rawDate": 45706,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 12300,
    "total": 492000
  },
  {
    "id": "ledger-2024-2026-205",
    "rowIndex": 205,
    "date": "2025-02-18",
    "rawDate": 45706,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 12300,
    "total": 738000
  },
  {
    "id": "ledger-2024-2026-206",
    "rowIndex": 206,
    "date": "2025-02-18",
    "rawDate": 45706,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 29,
    "qtyKg": null,
    "price": 10550,
    "total": 305950
  },
  {
    "id": "ledger-2024-2026-207",
    "rowIndex": 207,
    "date": "2025-02-18",
    "rawDate": 45706,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 51,
    "qtyKg": null,
    "price": 14500,
    "total": 739500
  },
  {
    "id": "ledger-2024-2026-208",
    "rowIndex": 208,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD",
    "qty": 23,
    "qtyKg": null,
    "price": 1389,
    "total": 31947
  },
  {
    "id": "ledger-2024-2026-209",
    "rowIndex": 209,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-210",
    "rowIndex": 210,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HSP A2",
    "qty": 11,
    "qtyKg": null,
    "price": 1474,
    "total": 16214
  },
  {
    "id": "ledger-2024-2026-211",
    "rowIndex": 211,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD",
    "qty": 34,
    "qtyKg": null,
    "price": 1389,
    "total": 47226
  },
  {
    "id": "ledger-2024-2026-212",
    "rowIndex": 212,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-213",
    "rowIndex": 213,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29912",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1389,
    "total": 6945
  },
  {
    "id": "ledger-2024-2026-214",
    "rowIndex": 214,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HSP A2",
    "qty": 16,
    "qtyKg": null,
    "price": 1474,
    "total": 23584
  },
  {
    "id": "ledger-2024-2026-215",
    "rowIndex": 215,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1444,
    "total": 14440
  },
  {
    "id": "ledger-2024-2026-216",
    "rowIndex": 216,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1474,
    "total": 19162
  },
  {
    "id": "ledger-2024-2026-217",
    "rowIndex": 217,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1389,
    "total": 20835
  },
  {
    "id": "ledger-2024-2026-218",
    "rowIndex": 218,
    "date": "2025-02-19",
    "rawDate": 45707,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "29844",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1399,
    "total": 11192
  },
  {
    "id": "ledger-2024-2026-219",
    "rowIndex": 219,
    "date": "2025-02-23",
    "rawDate": 45711,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 50,
    "qtyKg": null,
    "price": 11750,
    "total": 587500
  },
  {
    "id": "ledger-2024-2026-220",
    "rowIndex": 220,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30015",
    "description": "HG HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1399,
    "total": 83940
  },
  {
    "id": "ledger-2024-2026-221",
    "rowIndex": 221,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30072",
    "description": "HG HD VF",
    "qty": 5,
    "qtyKg": null,
    "price": 1474,
    "total": 7370
  },
  {
    "id": "ledger-2024-2026-222",
    "rowIndex": 222,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30072",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1389,
    "total": 27780
  },
  {
    "id": "ledger-2024-2026-223",
    "rowIndex": 223,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30072",
    "description": "HG HD VF",
    "qty": 125,
    "qtyKg": null,
    "price": 1474,
    "total": 184250
  },
  {
    "id": "ledger-2024-2026-224",
    "rowIndex": 224,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30014",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1404,
    "total": 35100
  },
  {
    "id": "ledger-2024-2026-225",
    "rowIndex": 225,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30014",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1389,
    "total": 55560
  },
  {
    "id": "ledger-2024-2026-226",
    "rowIndex": 226,
    "date": "2025-02-24",
    "rawDate": 45712,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30014",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1459,
    "total": 36475
  },
  {
    "id": "ledger-2024-2026-227",
    "rowIndex": 227,
    "date": "2025-02-26",
    "rawDate": 45714,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30154",
    "description": "HG HD VR",
    "qty": 110,
    "qtyKg": null,
    "price": 1399,
    "total": 153890
  },
  {
    "id": "ledger-2024-2026-228",
    "rowIndex": 228,
    "date": "2025-02-26",
    "rawDate": 45714,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30154",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1389,
    "total": 55560
  },
  {
    "id": "ledger-2024-2026-229",
    "rowIndex": 229,
    "date": "2025-02-27",
    "rawDate": 45715,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 80,
    "qtyKg": null,
    "price": 10450,
    "total": 836000
  },
  {
    "id": "ledger-2024-2026-230",
    "rowIndex": 230,
    "date": "2025-02-27",
    "rawDate": 45715,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 11600,
    "total": 464000
  },
  {
    "id": "ledger-2024-2026-231",
    "rowIndex": 231,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1399,
    "total": 41970
  },
  {
    "id": "ledger-2024-2026-232",
    "rowIndex": 232,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HSP VTC",
    "qty": 12,
    "qtyKg": null,
    "price": 1474,
    "total": 17688
  },
  {
    "id": "ledger-2024-2026-233",
    "rowIndex": 233,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1399,
    "total": 55960
  },
  {
    "id": "ledger-2024-2026-234",
    "rowIndex": 234,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30243",
    "description": "HPS Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-235",
    "rowIndex": 235,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30243",
    "description": "HSP VTC",
    "qty": 10,
    "qtyKg": null,
    "price": 1474,
    "total": 14740
  },
  {
    "id": "ledger-2024-2026-236",
    "rowIndex": 236,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30243",
    "description": "HPS Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 2241,
    "total": 22410
  },
  {
    "id": "ledger-2024-2026-237",
    "rowIndex": 237,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30243",
    "description": "HSP VTC",
    "qty": 10,
    "qtyKg": null,
    "price": 1474,
    "total": 14740
  },
  {
    "id": "ledger-2024-2026-238",
    "rowIndex": 238,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HSP VTC",
    "qty": 17,
    "qtyKg": null,
    "price": 1474,
    "total": 25058
  },
  {
    "id": "ledger-2024-2026-239",
    "rowIndex": 239,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HSP VTC",
    "qty": 20,
    "qtyKg": null,
    "price": 1474,
    "total": 29480
  },
  {
    "id": "ledger-2024-2026-240",
    "rowIndex": 240,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HSP VTC",
    "qty": 16,
    "qtyKg": null,
    "price": 1474,
    "total": 23584
  },
  {
    "id": "ledger-2024-2026-241",
    "rowIndex": 241,
    "date": "2025-02-28",
    "rawDate": 45716,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30246",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1399,
    "total": 27980
  },
  {
    "id": "ledger-2024-2026-242",
    "rowIndex": 242,
    "date": "2025-03-03",
    "rawDate": 45719,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30289",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1389,
    "total": 6945
  },
  {
    "id": "ledger-2024-2026-243",
    "rowIndex": 243,
    "date": "2025-03-03",
    "rawDate": 45719,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30289",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-244",
    "rowIndex": 244,
    "date": "2025-03-03",
    "rawDate": 45719,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30289",
    "description": "HG HD",
    "qty": 135,
    "qtyKg": null,
    "price": 1389,
    "total": 187515
  },
  {
    "id": "ledger-2024-2026-245",
    "rowIndex": 245,
    "date": "2025-03-04",
    "rawDate": 45720,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30391",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1389,
    "total": 27780
  },
  {
    "id": "ledger-2024-2026-246",
    "rowIndex": 246,
    "date": "2025-03-04",
    "rawDate": 45720,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30391",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1399,
    "total": 34975
  },
  {
    "id": "ledger-2024-2026-247",
    "rowIndex": 247,
    "date": "2025-03-04",
    "rawDate": 45720,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30390",
    "description": "HG HD",
    "qty": 75,
    "qtyKg": null,
    "price": 1389,
    "total": 104175
  },
  {
    "id": "ledger-2024-2026-248",
    "rowIndex": 248,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1671",
    "description": null,
    "qty": 26,
    "qtyKg": 2657.4,
    "price": 250,
    "total": 664350
  },
  {
    "id": "ledger-2024-2026-249",
    "rowIndex": 249,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1671",
    "description": null,
    "qty": 1,
    "qtyKg": 97,
    "price": 250,
    "total": 24250
  },
  {
    "id": "ledger-2024-2026-250",
    "rowIndex": 250,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1672",
    "description": null,
    "qty": 19,
    "qtyKg": 1925.2,
    "price": 250,
    "total": 481300
  },
  {
    "id": "ledger-2024-2026-251",
    "rowIndex": 251,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30544",
    "description": "HG HD VR",
    "qty": 100,
    "qtyKg": null,
    "price": 1399,
    "total": 139900
  },
  {
    "id": "ledger-2024-2026-252",
    "rowIndex": 252,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30545",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-253",
    "rowIndex": 253,
    "date": "2025-03-07",
    "rawDate": 45723,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30544",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1389,
    "total": 55560
  },
  {
    "id": "ledger-2024-2026-254",
    "rowIndex": 254,
    "date": "2025-03-08",
    "rawDate": 45724,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1673",
    "description": null,
    "qty": 13,
    "qtyKg": 1311.6,
    "price": 250,
    "total": 327900
  },
  {
    "id": "ledger-2024-2026-255",
    "rowIndex": 255,
    "date": "2025-03-08",
    "rawDate": 45724,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1673",
    "description": null,
    "qty": 6,
    "qtyKg": 651.4,
    "price": 250,
    "total": 162850
  },
  {
    "id": "ledger-2024-2026-256",
    "rowIndex": 256,
    "date": "2025-03-08",
    "rawDate": 45724,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1674",
    "description": null,
    "qty": 11,
    "qtyKg": 1209.8,
    "price": 250,
    "total": 302450
  },
  {
    "id": "ledger-2024-2026-257",
    "rowIndex": 257,
    "date": "2025-03-10",
    "rawDate": 45726,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30562",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1389,
    "total": 27780
  },
  {
    "id": "ledger-2024-2026-258",
    "rowIndex": 258,
    "date": "2025-03-10",
    "rawDate": 45726,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30562",
    "description": "HG HD VR",
    "qty": 130,
    "qtyKg": null,
    "price": 1389,
    "total": 180570
  },
  {
    "id": "ledger-2024-2026-259",
    "rowIndex": 259,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HG HD",
    "qty": 3,
    "qtyKg": null,
    "price": 1389,
    "total": 4167
  },
  {
    "id": "ledger-2024-2026-260",
    "rowIndex": 260,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP TC",
    "qty": 3,
    "qtyKg": null,
    "price": 1459,
    "total": 4377
  },
  {
    "id": "ledger-2024-2026-261",
    "rowIndex": 261,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP VI",
    "qty": 7,
    "qtyKg": null,
    "price": 1399,
    "total": 9793
  },
  {
    "id": "ledger-2024-2026-262",
    "rowIndex": 262,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1379,
    "total": 17927
  },
  {
    "id": "ledger-2024-2026-263",
    "rowIndex": 263,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30637",
    "description": "HSP TC",
    "qty": 4,
    "qtyKg": null,
    "price": 1459,
    "total": 5836
  },
  {
    "id": "ledger-2024-2026-264",
    "rowIndex": 264,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30637",
    "description": "HSP TC",
    "qty": 6,
    "qtyKg": null,
    "price": 1419,
    "total": 8514
  },
  {
    "id": "ledger-2024-2026-265",
    "rowIndex": 265,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP TC",
    "qty": 8,
    "qtyKg": null,
    "price": 1459,
    "total": 11672
  },
  {
    "id": "ledger-2024-2026-266",
    "rowIndex": 266,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-267",
    "rowIndex": 267,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP TC",
    "qty": 6,
    "qtyKg": null,
    "price": 1459,
    "total": 8754
  },
  {
    "id": "ledger-2024-2026-268",
    "rowIndex": 268,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP VI",
    "qty": 14,
    "qtyKg": null,
    "price": 1399,
    "total": 19586
  },
  {
    "id": "ledger-2024-2026-269",
    "rowIndex": 269,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP TC",
    "qty": 6,
    "qtyKg": null,
    "price": 1459,
    "total": 8754
  },
  {
    "id": "ledger-2024-2026-270",
    "rowIndex": 270,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-271",
    "rowIndex": 271,
    "date": "2025-03-11",
    "rawDate": 45727,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30657",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1389,
    "total": 6945
  },
  {
    "id": "ledger-2024-2026-272",
    "rowIndex": 272,
    "date": "2025-03-12",
    "rawDate": 45728,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 9000,
    "total": 9000
  },
  {
    "id": "ledger-2024-2026-273",
    "rowIndex": 273,
    "date": "2025-03-12",
    "rawDate": 45728,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1675",
    "description": null,
    "qty": 12,
    "qtyKg": 1317.4,
    "price": 250,
    "total": 329350
  },
  {
    "id": "ledger-2024-2026-274",
    "rowIndex": 274,
    "date": "2025-03-13",
    "rawDate": 45729,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30778",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-275",
    "rowIndex": 275,
    "date": "2025-03-13",
    "rawDate": 45729,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30777",
    "description": "HG HD",
    "qty": 80,
    "qtyKg": null,
    "price": 1379,
    "total": 110320
  },
  {
    "id": "ledger-2024-2026-276",
    "rowIndex": 276,
    "date": "2025-03-14",
    "rawDate": 45730,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1676",
    "description": null,
    "qty": 22,
    "qtyKg": 3161,
    "price": 245,
    "total": 774445
  },
  {
    "id": "ledger-2024-2026-277",
    "rowIndex": 277,
    "date": "2025-03-14",
    "rawDate": 45730,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1678",
    "description": null,
    "qty": 18,
    "qtyKg": 2412,
    "price": 250,
    "total": 603000
  },
  {
    "id": "ledger-2024-2026-278",
    "rowIndex": 278,
    "date": "2025-03-15",
    "rawDate": 45731,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1679",
    "description": null,
    "qty": 5,
    "qtyKg": 577,
    "price": 250,
    "total": 144250
  },
  {
    "id": "ledger-2024-2026-279",
    "rowIndex": 279,
    "date": "2025-03-15",
    "rawDate": 45731,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1681",
    "description": null,
    "qty": 15,
    "qtyKg": 1642.4,
    "price": 250,
    "total": 410600
  },
  {
    "id": "ledger-2024-2026-280",
    "rowIndex": 280,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30921",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1389,
    "total": 69450
  },
  {
    "id": "ledger-2024-2026-281",
    "rowIndex": 281,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30921",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-282",
    "rowIndex": 282,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30918",
    "description": "HSP VI",
    "qty": 12,
    "qtyKg": null,
    "price": 1399,
    "total": 16788
  },
  {
    "id": "ledger-2024-2026-283",
    "rowIndex": 283,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30918",
    "description": "HSP VI",
    "qty": 13,
    "qtyKg": null,
    "price": 1399,
    "total": 18187
  },
  {
    "id": "ledger-2024-2026-284",
    "rowIndex": 284,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30921",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1389,
    "total": 25002
  },
  {
    "id": "ledger-2024-2026-285",
    "rowIndex": 285,
    "date": "2025-03-18",
    "rawDate": 45734,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "30921",
    "description": "HG HD VR",
    "qty": 82,
    "qtyKg": null,
    "price": 1389,
    "total": 113898
  },
  {
    "id": "ledger-2024-2026-286",
    "rowIndex": 286,
    "date": "2025-03-19",
    "rawDate": 45735,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1682",
    "description": null,
    "qty": 20,
    "qtyKg": 2302.4,
    "price": 245,
    "total": 564088
  },
  {
    "id": "ledger-2024-2026-287",
    "rowIndex": 287,
    "date": "2025-03-19",
    "rawDate": 45735,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1682",
    "description": null,
    "qty": 1,
    "qtyKg": 75,
    "price": 245,
    "total": 18375
  },
  {
    "id": "ledger-2024-2026-288",
    "rowIndex": 288,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HG HD",
    "qty": 17,
    "qtyKg": null,
    "price": 1379,
    "total": 23443
  },
  {
    "id": "ledger-2024-2026-289",
    "rowIndex": 289,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1389,
    "total": 8334
  },
  {
    "id": "ledger-2024-2026-290",
    "rowIndex": 290,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP TC",
    "qty": 10,
    "qtyKg": null,
    "price": 1459,
    "total": 14590
  },
  {
    "id": "ledger-2024-2026-291",
    "rowIndex": 291,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HG HD",
    "qty": 22,
    "qtyKg": null,
    "price": 1379,
    "total": 30338
  },
  {
    "id": "ledger-2024-2026-292",
    "rowIndex": 292,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1389,
    "total": 20835
  },
  {
    "id": "ledger-2024-2026-293",
    "rowIndex": 293,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP TC",
    "qty": 15,
    "qtyKg": null,
    "price": 1459,
    "total": 21885
  },
  {
    "id": "ledger-2024-2026-294",
    "rowIndex": 294,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1389,
    "total": 13890
  },
  {
    "id": "ledger-2024-2026-295",
    "rowIndex": 295,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP TC",
    "qty": 16,
    "qtyKg": null,
    "price": 1459,
    "total": 23344
  },
  {
    "id": "ledger-2024-2026-296",
    "rowIndex": 296,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1389,
    "total": 13890
  },
  {
    "id": "ledger-2024-2026-297",
    "rowIndex": 297,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HSP TC",
    "qty": 10,
    "qtyKg": null,
    "price": 1459,
    "total": 14590
  },
  {
    "id": "ledger-2024-2026-298",
    "rowIndex": 298,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31021",
    "description": "HG HD",
    "qty": 9,
    "qtyKg": null,
    "price": 1379,
    "total": 12411
  },
  {
    "id": "ledger-2024-2026-299",
    "rowIndex": 299,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 9900,
    "total": 792000
  },
  {
    "id": "ledger-2024-2026-300",
    "rowIndex": 300,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 100,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-301",
    "rowIndex": 301,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31022",
    "description": "HPS",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-302",
    "rowIndex": 302,
    "date": "2025-03-20",
    "rawDate": 45736,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31022",
    "description": "HSP TC",
    "qty": 5,
    "qtyKg": null,
    "price": 1459,
    "total": 7295
  },
  {
    "id": "ledger-2024-2026-303",
    "rowIndex": 303,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1684",
    "description": null,
    "qty": 21,
    "qtyKg": 2431,
    "price": 240,
    "total": 583440
  },
  {
    "id": "ledger-2024-2026-304",
    "rowIndex": 304,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1685",
    "description": null,
    "qty": 7,
    "qtyKg": 757,
    "price": 240,
    "total": 181680
  },
  {
    "id": "ledger-2024-2026-305",
    "rowIndex": 305,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1686",
    "description": null,
    "qty": 13,
    "qtyKg": 1380,
    "price": 240,
    "total": 331200
  },
  {
    "id": "ledger-2024-2026-306",
    "rowIndex": 306,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1687",
    "description": null,
    "qty": 16,
    "qtyKg": 1781,
    "price": 240,
    "total": 427440
  },
  {
    "id": "ledger-2024-2026-307",
    "rowIndex": 307,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1683",
    "description": null,
    "qty": 12,
    "qtyKg": 1827,
    "price": 240,
    "total": 438480
  },
  {
    "id": "ledger-2024-2026-308",
    "rowIndex": 308,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1683",
    "description": null,
    "qty": 2,
    "qtyKg": 247,
    "price": 235,
    "total": 58045
  },
  {
    "id": "ledger-2024-2026-309",
    "rowIndex": 309,
    "date": "2025-03-21",
    "rawDate": 45737,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1684",
    "description": null,
    "qty": 2,
    "qtyKg": 278,
    "price": 240,
    "total": 66720
  },
  {
    "id": "ledger-2024-2026-310",
    "rowIndex": 310,
    "date": "2025-03-22",
    "rawDate": 45738,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1688",
    "description": null,
    "qty": 12,
    "qtyKg": 1245,
    "price": 245,
    "total": 305025
  },
  {
    "id": "ledger-2024-2026-311",
    "rowIndex": 311,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HG HD VR",
    "qty": 42,
    "qtyKg": null,
    "price": 1389,
    "total": 58338
  },
  {
    "id": "ledger-2024-2026-312",
    "rowIndex": 312,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1379,
    "total": 11032
  },
  {
    "id": "ledger-2024-2026-313",
    "rowIndex": 313,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1389,
    "total": 13890
  },
  {
    "id": "ledger-2024-2026-314",
    "rowIndex": 314,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1389,
    "total": 13890
  },
  {
    "id": "ledger-2024-2026-315",
    "rowIndex": 315,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1389,
    "total": 20835
  },
  {
    "id": "ledger-2024-2026-316",
    "rowIndex": 316,
    "date": "2025-03-24",
    "rawDate": 45740,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31102",
    "description": "HG HD VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1389,
    "total": 97230
  },
  {
    "id": "ledger-2024-2026-317",
    "rowIndex": 317,
    "date": "2025-03-27",
    "rawDate": 45743,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1692",
    "description": null,
    "qty": 23,
    "qtyKg": 2450.3999999999996,
    "price": 240,
    "total": 588095.9999999999
  },
  {
    "id": "ledger-2024-2026-318",
    "rowIndex": 318,
    "date": "2025-03-27",
    "rawDate": 45743,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1693",
    "description": null,
    "qty": 11,
    "qtyKg": 1281,
    "price": 240,
    "total": 307440
  },
  {
    "id": "ledger-2024-2026-319",
    "rowIndex": 319,
    "date": "2025-03-27",
    "rawDate": 45743,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 8000,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-320",
    "rowIndex": 320,
    "date": "2025-03-27",
    "rawDate": 45743,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 7000,
    "total": 7000
  },
  {
    "id": "ledger-2024-2026-321",
    "rowIndex": 321,
    "date": "2025-03-27",
    "rawDate": 45743,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 10000,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-322",
    "rowIndex": 322,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 12210,
    "total": 2136750
  },
  {
    "id": "ledger-2024-2026-323",
    "rowIndex": 323,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 200,
    "total": 35000
  },
  {
    "id": "ledger-2024-2026-324",
    "rowIndex": 324,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HSP TC",
    "qty": 10,
    "qtyKg": null,
    "price": 1449,
    "total": 14490
  },
  {
    "id": "ledger-2024-2026-325",
    "rowIndex": 325,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1369,
    "total": 54760
  },
  {
    "id": "ledger-2024-2026-326",
    "rowIndex": 326,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1369,
    "total": 13690
  },
  {
    "id": "ledger-2024-2026-327",
    "rowIndex": 327,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-328",
    "rowIndex": 328,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-329",
    "rowIndex": 329,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-330",
    "rowIndex": 330,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HG HD",
    "qty": 55,
    "qtyKg": null,
    "price": 1369,
    "total": 75295
  },
  {
    "id": "ledger-2024-2026-331",
    "rowIndex": 331,
    "date": "2025-03-28",
    "rawDate": 45744,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31345",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1389,
    "total": 13890
  },
  {
    "id": "ledger-2024-2026-332",
    "rowIndex": 332,
    "date": "2025-03-29",
    "rawDate": 45745,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31374",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-333",
    "rowIndex": 333,
    "date": "2025-03-29",
    "rawDate": 45745,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1697",
    "description": null,
    "qty": 10,
    "qtyKg": 1141.6,
    "price": 242,
    "total": 276267.19999999995
  },
  {
    "id": "ledger-2024-2026-334",
    "rowIndex": 334,
    "date": "2025-03-29",
    "rawDate": 45745,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31373",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1369,
    "total": 13690
  },
  {
    "id": "ledger-2024-2026-335",
    "rowIndex": 335,
    "date": "2025-03-29",
    "rawDate": 45745,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31373",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-336",
    "rowIndex": 336,
    "date": "2025-03-31",
    "rawDate": 45747,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31380",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1369,
    "total": 34225
  },
  {
    "id": "ledger-2024-2026-337",
    "rowIndex": 337,
    "date": "2025-03-31",
    "rawDate": 45747,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31380",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1359,
    "total": 13590
  },
  {
    "id": "ledger-2024-2026-338",
    "rowIndex": 338,
    "date": "2025-03-31",
    "rawDate": 45747,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31380",
    "description": "HSP",
    "qty": 27,
    "qtyKg": null,
    "price": 1369,
    "total": 36963
  },
  {
    "id": "ledger-2024-2026-339",
    "rowIndex": 339,
    "date": "2025-03-31",
    "rawDate": 45747,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31380",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-340",
    "rowIndex": 340,
    "date": "2025-03-31",
    "rawDate": 45747,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31380",
    "description": "HSP",
    "qty": 28,
    "qtyKg": null,
    "price": 1369,
    "total": 38332
  },
  {
    "id": "ledger-2024-2026-341",
    "rowIndex": 341,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1699",
    "description": null,
    "qty": 17,
    "qtyKg": 1886.8000000000002,
    "price": 240,
    "total": 452832.00000000006
  },
  {
    "id": "ledger-2024-2026-342",
    "rowIndex": 342,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 9900,
    "total": 693000
  },
  {
    "id": "ledger-2024-2026-343",
    "rowIndex": 343,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 200,
    "total": 14000
  },
  {
    "id": "ledger-2024-2026-344",
    "rowIndex": 344,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 11990,
    "total": 1258950
  },
  {
    "id": "ledger-2024-2026-345",
    "rowIndex": 345,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 200,
    "total": 21000
  },
  {
    "id": "ledger-2024-2026-346",
    "rowIndex": 346,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1698",
    "description": null,
    "qty": 14,
    "qtyKg": 1633.4,
    "price": 240,
    "total": 392016
  },
  {
    "id": "ledger-2024-2026-347",
    "rowIndex": 347,
    "date": "2025-04-01",
    "rawDate": 45748,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1699",
    "description": null,
    "qty": 3,
    "qtyKg": 297,
    "price": 240,
    "total": 71280
  },
  {
    "id": "ledger-2024-2026-348",
    "rowIndex": 348,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HSP TC",
    "qty": 5,
    "qtyKg": null,
    "price": 1439,
    "total": 7195
  },
  {
    "id": "ledger-2024-2026-349",
    "rowIndex": 349,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HSP TC",
    "qty": 5,
    "qtyKg": null,
    "price": 1439,
    "total": 7195
  },
  {
    "id": "ledger-2024-2026-350",
    "rowIndex": 350,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HSP TC",
    "qty": 10,
    "qtyKg": null,
    "price": 1439,
    "total": 14390
  },
  {
    "id": "ledger-2024-2026-351",
    "rowIndex": 351,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HSP TC",
    "qty": 15,
    "qtyKg": null,
    "price": 1439,
    "total": 21585
  },
  {
    "id": "ledger-2024-2026-352",
    "rowIndex": 352,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1700",
    "description": null,
    "qty": 20,
    "qtyKg": 2346,
    "price": 240,
    "total": 563040
  },
  {
    "id": "ledger-2024-2026-353",
    "rowIndex": 353,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1701",
    "description": null,
    "qty": 15,
    "qtyKg": 1745.6,
    "price": 240,
    "total": 418944
  },
  {
    "id": "ledger-2024-2026-354",
    "rowIndex": 354,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1359,
    "total": 13590
  },
  {
    "id": "ledger-2024-2026-355",
    "rowIndex": 355,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HG HD",
    "qty": 100,
    "qtyKg": null,
    "price": 1359,
    "total": 135900
  },
  {
    "id": "ledger-2024-2026-356",
    "rowIndex": 356,
    "date": "2025-04-02",
    "rawDate": 45749,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31497",
    "description": "HSP TC",
    "qty": 5,
    "qtyKg": null,
    "price": 1439,
    "total": 7195
  },
  {
    "id": "ledger-2024-2026-357",
    "rowIndex": 357,
    "date": "2025-04-03",
    "rawDate": 45750,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1702",
    "description": null,
    "qty": 25,
    "qtyKg": 2770.6,
    "price": 240,
    "total": 664944
  },
  {
    "id": "ledger-2024-2026-358",
    "rowIndex": 358,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 35,
    "qtyKg": null,
    "price": 1584,
    "total": 55440
  },
  {
    "id": "ledger-2024-2026-359",
    "rowIndex": 359,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1704",
    "description": null,
    "qty": 8,
    "qtyKg": 851.4,
    "price": 240,
    "total": 204336
  },
  {
    "id": "ledger-2024-2026-360",
    "rowIndex": 360,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1705",
    "description": null,
    "qty": 16,
    "qtyKg": 1839,
    "price": 240,
    "total": 441360
  },
  {
    "id": "ledger-2024-2026-361",
    "rowIndex": 361,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1704",
    "description": null,
    "qty": 19,
    "qtyKg": 1976.8,
    "price": 240,
    "total": 474432
  },
  {
    "id": "ledger-2024-2026-362",
    "rowIndex": 362,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1705",
    "description": null,
    "qty": 1,
    "qtyKg": 108,
    "price": 240,
    "total": 25920
  },
  {
    "id": "ledger-2024-2026-363",
    "rowIndex": 363,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1705",
    "description": null,
    "qty": 8,
    "qtyKg": 931,
    "price": 240,
    "total": 223440
  },
  {
    "id": "ledger-2024-2026-364",
    "rowIndex": 364,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1706",
    "description": null,
    "qty": 12,
    "qtyKg": 1392.2,
    "price": 240,
    "total": 334128
  },
  {
    "id": "ledger-2024-2026-365",
    "rowIndex": 365,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HG DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1342,
    "total": 20130
  },
  {
    "id": "ledger-2024-2026-366",
    "rowIndex": 366,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from J. Casas II",
    "description": "HG DP",
    "qty": 3,
    "qtyKg": null,
    "price": 1342,
    "total": 4026
  },
  {
    "id": "ledger-2024-2026-367",
    "rowIndex": 367,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HG DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1342,
    "total": 20130
  },
  {
    "id": "ledger-2024-2026-368",
    "rowIndex": 368,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to J. Casas I",
    "description": "HG DP",
    "qty": -3,
    "qtyKg": null,
    "price": 1342,
    "total": -4026
  },
  {
    "id": "ledger-2024-2026-369",
    "rowIndex": 369,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 12,
    "qtyKg": null,
    "price": 1584,
    "total": 19008
  },
  {
    "id": "ledger-2024-2026-370",
    "rowIndex": 370,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 23,
    "qtyKg": null,
    "price": 1584,
    "total": 36432
  },
  {
    "id": "ledger-2024-2026-371",
    "rowIndex": 371,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 20,
    "qtyKg": null,
    "price": 1584,
    "total": 31680
  },
  {
    "id": "ledger-2024-2026-372",
    "rowIndex": 372,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1584,
    "total": 15840
  },
  {
    "id": "ledger-2024-2026-373",
    "rowIndex": 373,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1703",
    "description": null,
    "qty": 20,
    "qtyKg": 2043,
    "price": 240,
    "total": 490320
  },
  {
    "id": "ledger-2024-2026-374",
    "rowIndex": 374,
    "date": "2025-04-04",
    "rawDate": 45751,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31618",
    "description": "HS DP",
    "qty": 20,
    "qtyKg": null,
    "price": 1584,
    "total": 31680
  },
  {
    "id": "ledger-2024-2026-375",
    "rowIndex": 375,
    "date": "2025-04-05",
    "rawDate": 45752,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1707",
    "description": null,
    "qty": 20,
    "qtyKg": 2132.2,
    "price": 240,
    "total": 511727.99999999994
  },
  {
    "id": "ledger-2024-2026-376",
    "rowIndex": 376,
    "date": "2025-04-07",
    "rawDate": 45754,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1708",
    "description": null,
    "qty": 30,
    "qtyKg": 3603,
    "price": 240,
    "total": 864720
  },
  {
    "id": "ledger-2024-2026-377",
    "rowIndex": 377,
    "date": "2025-04-08",
    "rawDate": 45755,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1709",
    "description": null,
    "qty": 20,
    "qtyKg": 2504.8,
    "price": 240,
    "total": 601152
  },
  {
    "id": "ledger-2024-2026-378",
    "rowIndex": 378,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 35,
    "qtyKg": null,
    "price": 12700,
    "total": 444500
  },
  {
    "id": "ledger-2024-2026-379",
    "rowIndex": 379,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 5,
    "qtyKg": null,
    "price": 1584,
    "total": 7920
  },
  {
    "id": "ledger-2024-2026-380",
    "rowIndex": 380,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from M. Barro",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1379,
    "total": 2758
  },
  {
    "id": "ledger-2024-2026-381",
    "rowIndex": 381,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 80,
    "price": 245,
    "total": 19600
  },
  {
    "id": "ledger-2024-2026-382",
    "rowIndex": 382,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": "Maring",
    "qty": null,
    "qtyKg": 3,
    "price": 200,
    "total": 600
  },
  {
    "id": "ledger-2024-2026-383",
    "rowIndex": 383,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 10,
    "price": 200,
    "total": 2000
  },
  {
    "id": "ledger-2024-2026-384",
    "rowIndex": 384,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 5,
    "price": 150,
    "total": 750
  },
  {
    "id": "ledger-2024-2026-385",
    "rowIndex": 385,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31891",
    "description": "HS DP",
    "qty": 13,
    "qtyKg": null,
    "price": 1584,
    "total": 20592
  },
  {
    "id": "ledger-2024-2026-386",
    "rowIndex": 386,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 3,
    "price": 200,
    "total": 600
  },
  {
    "id": "ledger-2024-2026-387",
    "rowIndex": 387,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "nakarne",
    "qty": 1,
    "qtyKg": null,
    "price": 10400,
    "total": 10400
  },
  {
    "id": "ledger-2024-2026-388",
    "rowIndex": 388,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "tira",
    "qty": 2,
    "qtyKg": 80,
    "price": 245,
    "total": 19600
  },
  {
    "id": "ledger-2024-2026-389",
    "rowIndex": 389,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Joel A.",
    "description": "HG HD",
    "qty": -2,
    "qtyKg": null,
    "price": 1379,
    "total": -2758
  },
  {
    "id": "ledger-2024-2026-390",
    "rowIndex": 390,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Joseph C. I",
    "description": "HG HD",
    "qty": -2,
    "qtyKg": null,
    "price": 1379,
    "total": -2758
  },
  {
    "id": "ledger-2024-2026-391",
    "rowIndex": 391,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1900,
    "total": 1900
  },
  {
    "id": "ledger-2024-2026-392",
    "rowIndex": 392,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3032",
    "ledgerDescription": "Meds - Others",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 2099,
    "total": 2099
  },
  {
    "id": "ledger-2024-2026-393",
    "rowIndex": 393,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 5,
    "price": 200,
    "total": 1000
  },
  {
    "id": "ledger-2024-2026-394",
    "rowIndex": 394,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 3,
    "price": 150,
    "total": 450
  },
  {
    "id": "ledger-2024-2026-395",
    "rowIndex": 395,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from M. Barro",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1379,
    "total": 2758
  },
  {
    "id": "ledger-2024-2026-396",
    "rowIndex": 396,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1711",
    "description": null,
    "qty": 30,
    "qtyKg": 3154.2000000000003,
    "price": 240,
    "total": 757008.0000000001
  },
  {
    "id": "ledger-2024-2026-397",
    "rowIndex": 397,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-398",
    "rowIndex": 398,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-399",
    "rowIndex": 399,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-400",
    "rowIndex": 400,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31891",
    "description": "HS DP",
    "qty": 25,
    "qtyKg": null,
    "price": 1584,
    "total": 39600
  },
  {
    "id": "ledger-2024-2026-401",
    "rowIndex": 401,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 7,
    "price": 200,
    "total": 1400
  },
  {
    "id": "ledger-2024-2026-402",
    "rowIndex": 402,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 106,
    "qtyKg": null,
    "price": 9700,
    "total": 1028200
  },
  {
    "id": "ledger-2024-2026-403",
    "rowIndex": 403,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 106,
    "qtyKg": null,
    "price": 200,
    "total": 21200
  },
  {
    "id": "ledger-2024-2026-404",
    "rowIndex": 404,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-405",
    "rowIndex": 405,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31891",
    "description": "HS DP",
    "qty": 18,
    "qtyKg": null,
    "price": 1584,
    "total": 28512
  },
  {
    "id": "ledger-2024-2026-406",
    "rowIndex": 406,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 6,
    "price": 200,
    "total": 1200
  },
  {
    "id": "ledger-2024-2026-407",
    "rowIndex": 407,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31891",
    "description": "HS DP",
    "qty": 19,
    "qtyKg": null,
    "price": 1584,
    "total": 30096
  },
  {
    "id": "ledger-2024-2026-408",
    "rowIndex": 408,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 6,
    "price": 200,
    "total": 1200
  },
  {
    "id": "ledger-2024-2026-409",
    "rowIndex": 409,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": 6,
    "price": 200,
    "total": 1200
  },
  {
    "id": "ledger-2024-2026-410",
    "rowIndex": 410,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HG DP",
    "qty": 3,
    "qtyKg": null,
    "price": 1342,
    "total": 4026
  },
  {
    "id": "ledger-2024-2026-411",
    "rowIndex": 411,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HG DP",
    "qty": 27,
    "qtyKg": null,
    "price": 1342,
    "total": 36234
  },
  {
    "id": "ledger-2024-2026-412",
    "rowIndex": 412,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31854",
    "description": "HG DP",
    "qty": 35,
    "qtyKg": null,
    "price": 1342,
    "total": 46970
  },
  {
    "id": "ledger-2024-2026-413",
    "rowIndex": 413,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 40,
    "qtyKg": null,
    "price": 13950,
    "total": 558000
  },
  {
    "id": "ledger-2024-2026-414",
    "rowIndex": 414,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HS DP",
    "qty": 5,
    "qtyKg": null,
    "price": 1584,
    "total": 7920
  },
  {
    "id": "ledger-2024-2026-415",
    "rowIndex": 415,
    "date": "2025-04-10",
    "rawDate": 45757,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31853",
    "description": "HPS",
    "qty": 15,
    "qtyKg": null,
    "price": 2241,
    "total": 33615
  },
  {
    "id": "ledger-2024-2026-416",
    "rowIndex": 416,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31906",
    "description": "HSP VI",
    "qty": 29,
    "qtyKg": null,
    "price": 1369,
    "total": 39701
  },
  {
    "id": "ledger-2024-2026-417",
    "rowIndex": 417,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1712",
    "description": null,
    "qty": 1,
    "qtyKg": 89,
    "price": 235,
    "total": 20915
  },
  {
    "id": "ledger-2024-2026-418",
    "rowIndex": 418,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31906",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1359,
    "total": 33975
  },
  {
    "id": "ledger-2024-2026-419",
    "rowIndex": 419,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1712",
    "description": null,
    "qty": 16,
    "qtyKg": 1932,
    "price": 240,
    "total": 463680
  },
  {
    "id": "ledger-2024-2026-420",
    "rowIndex": 420,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1713",
    "description": null,
    "qty": 20,
    "qtyKg": 2327.4,
    "price": 240,
    "total": 558576
  },
  {
    "id": "ledger-2024-2026-421",
    "rowIndex": 421,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1714",
    "description": null,
    "qty": 30,
    "qtyKg": 3549.3999999999996,
    "price": 235,
    "total": 834108.9999999999
  },
  {
    "id": "ledger-2024-2026-422",
    "rowIndex": 422,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1715",
    "description": null,
    "qty": 10,
    "qtyKg": 1262,
    "price": 245,
    "total": 309190
  },
  {
    "id": "ledger-2024-2026-423",
    "rowIndex": 423,
    "date": "2025-04-11",
    "rawDate": 45758,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31906",
    "description": "HS DP",
    "qty": 6,
    "qtyKg": null,
    "price": 1584,
    "total": 9504
  },
  {
    "id": "ledger-2024-2026-424",
    "rowIndex": 424,
    "date": "2025-04-12",
    "rawDate": 45759,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "31928",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1584,
    "total": 15840
  },
  {
    "id": "ledger-2024-2026-425",
    "rowIndex": 425,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 5,
    "qtyKg": null,
    "price": 1584,
    "total": 7920
  },
  {
    "id": "ledger-2024-2026-426",
    "rowIndex": 426,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1584,
    "total": 15840
  },
  {
    "id": "ledger-2024-2026-427",
    "rowIndex": 427,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-428",
    "rowIndex": 428,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-429",
    "rowIndex": 429,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 25,
    "qtyKg": null,
    "price": 1584,
    "total": 39600
  },
  {
    "id": "ledger-2024-2026-430",
    "rowIndex": 430,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HPS",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-431",
    "rowIndex": 431,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32032",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1342,
    "total": 13420
  },
  {
    "id": "ledger-2024-2026-432",
    "rowIndex": 432,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Putingkahoy",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1369,
    "total": 2738
  },
  {
    "id": "ledger-2024-2026-433",
    "rowIndex": 433,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HG DP VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1352,
    "total": 6760
  },
  {
    "id": "ledger-2024-2026-434",
    "rowIndex": 434,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HG DP VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1342,
    "total": 40260
  },
  {
    "id": "ledger-2024-2026-435",
    "rowIndex": 435,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32075",
    "description": "HG DP VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1342,
    "total": 26840
  },
  {
    "id": "ledger-2024-2026-436",
    "rowIndex": 436,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32031",
    "description": "HS DP VR",
    "qty": 90,
    "qtyKg": null,
    "price": 1342,
    "total": 120780
  },
  {
    "id": "ledger-2024-2026-437",
    "rowIndex": 437,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Nato",
    "description": "HG HD",
    "qty": -2,
    "qtyKg": null,
    "price": 1369,
    "total": -2738
  },
  {
    "id": "ledger-2024-2026-438",
    "rowIndex": 438,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 5,
    "qtyKg": null,
    "price": 1584,
    "total": 7920
  },
  {
    "id": "ledger-2024-2026-439",
    "rowIndex": 439,
    "date": "2025-04-15",
    "rawDate": 45762,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32074",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-440",
    "rowIndex": 440,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32153",
    "description": "HS DP",
    "qty": 30,
    "qtyKg": null,
    "price": 1584,
    "total": 47520
  },
  {
    "id": "ledger-2024-2026-441",
    "rowIndex": 441,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32156",
    "description": "HS DP",
    "qty": 20,
    "qtyKg": null,
    "price": 1584,
    "total": 31680
  },
  {
    "id": "ledger-2024-2026-442",
    "rowIndex": 442,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32153",
    "description": "HG DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1342,
    "total": 13420
  },
  {
    "id": "ledger-2024-2026-443",
    "rowIndex": 443,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32153",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1584,
    "total": 15840
  },
  {
    "id": "ledger-2024-2026-444",
    "rowIndex": 444,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32156",
    "description": "HS DP",
    "qty": 27,
    "qtyKg": null,
    "price": 1584,
    "total": 42768
  },
  {
    "id": "ledger-2024-2026-445",
    "rowIndex": 445,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32156",
    "description": "HS DP",
    "qty": 26,
    "qtyKg": null,
    "price": 1584,
    "total": 41184
  },
  {
    "id": "ledger-2024-2026-446",
    "rowIndex": 446,
    "date": "2025-04-16",
    "rawDate": 45763,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32156",
    "description": "HS DP",
    "qty": 27,
    "qtyKg": null,
    "price": 1584,
    "total": 42768
  },
  {
    "id": "ledger-2024-2026-447",
    "rowIndex": 447,
    "date": "2025-04-18",
    "rawDate": 45765,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1723",
    "description": null,
    "qty": 3,
    "qtyKg": 344.4,
    "price": 240,
    "total": 82656
  },
  {
    "id": "ledger-2024-2026-448",
    "rowIndex": 448,
    "date": "2025-04-18",
    "rawDate": 45765,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1724",
    "description": null,
    "qty": 11,
    "qtyKg": 1362.6,
    "price": 250,
    "total": 340650
  },
  {
    "id": "ledger-2024-2026-449",
    "rowIndex": 449,
    "date": "2025-04-18",
    "rawDate": 45765,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 13000,
    "total": 13000
  },
  {
    "id": "ledger-2024-2026-450",
    "rowIndex": 450,
    "date": "2025-04-18",
    "rawDate": 45765,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "nakarne",
    "qty": 1,
    "qtyKg": null,
    "price": 7200,
    "total": 7200
  },
  {
    "id": "ledger-2024-2026-451",
    "rowIndex": 451,
    "date": "2025-04-18",
    "rawDate": 45765,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1722",
    "description": null,
    "qty": 3,
    "qtyKg": 256.6,
    "price": 240,
    "total": 61584.00000000001
  },
  {
    "id": "ledger-2024-2026-452",
    "rowIndex": 452,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 37,
    "qtyKg": null,
    "price": 1584,
    "total": 58608
  },
  {
    "id": "ledger-2024-2026-453",
    "rowIndex": 453,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 8,
    "qtyKg": null,
    "price": 1584,
    "total": 12672
  },
  {
    "id": "ledger-2024-2026-454",
    "rowIndex": 454,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 260,
    "qtyKg": null,
    "price": 50,
    "total": 13000
  },
  {
    "id": "ledger-2024-2026-455",
    "rowIndex": 455,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 260,
    "qtyKg": null,
    "price": 2.5,
    "total": 650
  },
  {
    "id": "ledger-2024-2026-456",
    "rowIndex": 456,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 100,
    "total": 5000
  },
  {
    "id": "ledger-2024-2026-457",
    "rowIndex": 457,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 200,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-458",
    "rowIndex": 458,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 500,
    "total": 25000
  },
  {
    "id": "ledger-2024-2026-459",
    "rowIndex": 459,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Alcantara, Joel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 0,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-460",
    "rowIndex": 460,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 370,
    "qtyKg": null,
    "price": 50,
    "total": 18500
  },
  {
    "id": "ledger-2024-2026-461",
    "rowIndex": 461,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 370,
    "qtyKg": null,
    "price": 2.5,
    "total": 925
  },
  {
    "id": "ledger-2024-2026-462",
    "rowIndex": 462,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 73,
    "qtyKg": null,
    "price": 100,
    "total": 7300
  },
  {
    "id": "ledger-2024-2026-463",
    "rowIndex": 463,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 73,
    "qtyKg": null,
    "price": 200,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-464",
    "rowIndex": 464,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 75,
    "qtyKg": null,
    "price": 500,
    "total": 37500
  },
  {
    "id": "ledger-2024-2026-465",
    "rowIndex": 465,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Barro, Myrna",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-466",
    "rowIndex": 466,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 700,
    "total": 700
  },
  {
    "id": "ledger-2024-2026-467",
    "rowIndex": 467,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 10345,
    "total": 10345
  },
  {
    "id": "ledger-2024-2026-468",
    "rowIndex": 468,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3032",
    "ledgerDescription": "Meds - Others",
    "invoiceRef": null,
    "description": "Doc Kenneth",
    "qty": 1,
    "qtyKg": null,
    "price": 2478,
    "total": 2478
  },
  {
    "id": "ledger-2024-2026-469",
    "rowIndex": 469,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 481,
    "qtyKg": null,
    "price": 50,
    "total": 24050
  },
  {
    "id": "ledger-2024-2026-470",
    "rowIndex": 470,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 481,
    "qtyKg": null,
    "price": 2.5,
    "total": 1202.5
  },
  {
    "id": "ledger-2024-2026-471",
    "rowIndex": 471,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 78,
    "qtyKg": null,
    "price": 100,
    "total": 7800
  },
  {
    "id": "ledger-2024-2026-472",
    "rowIndex": 472,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 78,
    "qtyKg": null,
    "price": 200,
    "total": 15600
  },
  {
    "id": "ledger-2024-2026-473",
    "rowIndex": 473,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 500,
    "total": 50000
  },
  {
    "id": "ledger-2024-2026-474",
    "rowIndex": 474,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 21,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-475",
    "rowIndex": 475,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 22,
    "qtyKg": null,
    "price": 1584,
    "total": 34848
  },
  {
    "id": "ledger-2024-2026-476",
    "rowIndex": 476,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 26,
    "qtyKg": null,
    "price": 1584,
    "total": 41184
  },
  {
    "id": "ledger-2024-2026-477",
    "rowIndex": 477,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-478",
    "rowIndex": 478,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Dimaano, Ingracia",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ingracia",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Martin P.",
    "description": "HG HD VR",
    "qty": -4,
    "qtyKg": null,
    "price": 1399,
    "total": -5596
  },
  {
    "id": "ledger-2024-2026-479",
    "rowIndex": 479,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-480",
    "rowIndex": 480,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 182,
    "qtyKg": null,
    "price": 50,
    "total": 9100
  },
  {
    "id": "ledger-2024-2026-481",
    "rowIndex": 481,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 182,
    "qtyKg": null,
    "price": 2.5,
    "total": 455
  },
  {
    "id": "ledger-2024-2026-482",
    "rowIndex": 482,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 34,
    "qtyKg": null,
    "price": 100,
    "total": 3400
  },
  {
    "id": "ledger-2024-2026-483",
    "rowIndex": 483,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 34,
    "qtyKg": null,
    "price": 200,
    "total": 6800
  },
  {
    "id": "ledger-2024-2026-484",
    "rowIndex": 484,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 500,
    "total": 17500
  },
  {
    "id": "ledger-2024-2026-485",
    "rowIndex": 485,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Patron, Imad",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-486",
    "rowIndex": 486,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Ingracia D.",
    "description": "HG HD VR",
    "qty": 4,
    "qtyKg": null,
    "price": 1399,
    "total": 5596
  },
  {
    "id": "ledger-2024-2026-487",
    "rowIndex": 487,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Rufino P.",
    "description": "HG DP",
    "qty": -4,
    "qtyKg": null,
    "price": 1352,
    "total": -5408
  },
  {
    "id": "ledger-2024-2026-488",
    "rowIndex": 488,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1725",
    "description": null,
    "qty": 25,
    "qtyKg": 3122.2000000000003,
    "price": 245,
    "total": 764939.0000000001
  },
  {
    "id": "ledger-2024-2026-489",
    "rowIndex": 489,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Martin P.",
    "description": "HG DP",
    "qty": 4,
    "qtyKg": null,
    "price": 1352,
    "total": 5408
  },
  {
    "id": "ledger-2024-2026-490",
    "rowIndex": 490,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1584,
    "total": 15840
  },
  {
    "id": "ledger-2024-2026-491",
    "rowIndex": 491,
    "date": "2025-04-21",
    "rawDate": 45768,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32179",
    "description": "HS DP",
    "qty": 17,
    "qtyKg": null,
    "price": 1584,
    "total": 26928
  },
  {
    "id": "ledger-2024-2026-492",
    "rowIndex": 492,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1726",
    "description": null,
    "qty": 17,
    "qtyKg": 2084.2,
    "price": 245,
    "total": 510628.99999999994
  },
  {
    "id": "ledger-2024-2026-493",
    "rowIndex": 493,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1728",
    "description": null,
    "qty": 13,
    "qtyKg": 1379.6,
    "price": 245,
    "total": 338002
  },
  {
    "id": "ledger-2024-2026-494",
    "rowIndex": 494,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1729",
    "description": null,
    "qty": 5,
    "qtyKg": 588,
    "price": 245,
    "total": 144060
  },
  {
    "id": "ledger-2024-2026-495",
    "rowIndex": 495,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1727",
    "description": null,
    "qty": 1,
    "qtyKg": 111,
    "price": 245,
    "total": 27195
  },
  {
    "id": "ledger-2024-2026-496",
    "rowIndex": 496,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1728",
    "description": null,
    "qty": 15,
    "qtyKg": 1563,
    "price": 245,
    "total": 382935
  },
  {
    "id": "ledger-2024-2026-497",
    "rowIndex": 497,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1727",
    "description": null,
    "qty": 39,
    "qtyKg": 4534.799999999999,
    "price": 245,
    "total": 1111025.9999999998
  },
  {
    "id": "ledger-2024-2026-498",
    "rowIndex": 498,
    "date": "2025-04-22",
    "rawDate": 45769,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1728",
    "description": null,
    "qty": 2,
    "qtyKg": 191.8,
    "price": 245,
    "total": 46991
  },
  {
    "id": "ledger-2024-2026-499",
    "rowIndex": 499,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to R. Perez",
    "description": "HS DP",
    "qty": -4,
    "qtyKg": null,
    "price": 1342,
    "total": -5368
  },
  {
    "id": "ledger-2024-2026-500",
    "rowIndex": 500,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32391",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-501",
    "rowIndex": 501,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32391",
    "description": "HS DP",
    "qty": 65,
    "qtyKg": null,
    "price": 1584,
    "total": 102960
  },
  {
    "id": "ledger-2024-2026-502",
    "rowIndex": 502,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32391",
    "description": "HS DP",
    "qty": 55,
    "qtyKg": null,
    "price": 1584,
    "total": 87120
  },
  {
    "id": "ledger-2024-2026-503",
    "rowIndex": 503,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32391",
    "description": "HS DP",
    "qty": 15,
    "qtyKg": null,
    "price": 1584,
    "total": 23760
  },
  {
    "id": "ledger-2024-2026-504",
    "rowIndex": 504,
    "date": "2025-04-24",
    "rawDate": 45771,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from J. Casas",
    "description": "HS DP",
    "qty": 4,
    "qtyKg": null,
    "price": 1342,
    "total": 5368
  },
  {
    "id": "ledger-2024-2026-505",
    "rowIndex": 505,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32415",
    "description": "HS DP",
    "qty": 30,
    "qtyKg": null,
    "price": 1584,
    "total": 47520
  },
  {
    "id": "ledger-2024-2026-506",
    "rowIndex": 506,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32415",
    "description": "HS DP",
    "qty": 42,
    "qtyKg": null,
    "price": 1584,
    "total": 66528
  },
  {
    "id": "ledger-2024-2026-507",
    "rowIndex": 507,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32415",
    "description": "HS DP",
    "qty": 42,
    "qtyKg": null,
    "price": 1584,
    "total": 66528
  },
  {
    "id": "ledger-2024-2026-508",
    "rowIndex": 508,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32415",
    "description": "HS DP",
    "qty": 36,
    "qtyKg": null,
    "price": 1584,
    "total": 57024
  },
  {
    "id": "ledger-2024-2026-509",
    "rowIndex": 509,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1730",
    "description": null,
    "qty": 15,
    "qtyKg": 1828,
    "price": 245,
    "total": 447860
  },
  {
    "id": "ledger-2024-2026-510",
    "rowIndex": 510,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1730",
    "description": null,
    "qty": 1,
    "qtyKg": 103.2,
    "price": 240,
    "total": 24768
  },
  {
    "id": "ledger-2024-2026-511",
    "rowIndex": 511,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1731",
    "description": null,
    "qty": 15,
    "qtyKg": 1688.2,
    "price": 245,
    "total": 413609
  },
  {
    "id": "ledger-2024-2026-512",
    "rowIndex": 512,
    "date": "2025-04-25",
    "rawDate": 45772,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1732",
    "description": null,
    "qty": 27,
    "qtyKg": 2881.6,
    "price": 240,
    "total": 691584
  },
  {
    "id": "ledger-2024-2026-513",
    "rowIndex": 513,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 55,
    "qtyKg": null,
    "price": 1369,
    "total": 75295
  },
  {
    "id": "ledger-2024-2026-514",
    "rowIndex": 514,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1369,
    "total": 10952
  },
  {
    "id": "ledger-2024-2026-515",
    "rowIndex": 515,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1369,
    "total": 27380
  },
  {
    "id": "ledger-2024-2026-516",
    "rowIndex": 516,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-517",
    "rowIndex": 517,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1369,
    "total": 16428
  },
  {
    "id": "ledger-2024-2026-518",
    "rowIndex": 518,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32458",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1369,
    "total": 34225
  },
  {
    "id": "ledger-2024-2026-519",
    "rowIndex": 519,
    "date": "2025-04-28",
    "rawDate": 45775,
    "raiser": "",
    "batch": "",
    "cycleCode": "Unassigned",
    "supplier": null,
    "customer": null,
    "ledgerNr": "",
    "ledgerDescription": "",
    "invoiceRef": null,
    "description": null,
    "qty": null,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-520",
    "rowIndex": 520,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 13000,
    "total": 13000
  },
  {
    "id": "ledger-2024-2026-521",
    "rowIndex": 521,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 6772,
    "total": 6772
  },
  {
    "id": "ledger-2024-2026-522",
    "rowIndex": 522,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 1063,
    "qtyKg": null,
    "price": 50,
    "total": 53150
  },
  {
    "id": "ledger-2024-2026-523",
    "rowIndex": 523,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 1063,
    "qtyKg": null,
    "price": 2.5,
    "total": 2657.5
  },
  {
    "id": "ledger-2024-2026-524",
    "rowIndex": 524,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 185,
    "qtyKg": null,
    "price": 100,
    "total": 18500
  },
  {
    "id": "ledger-2024-2026-525",
    "rowIndex": 525,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 185,
    "qtyKg": null,
    "price": 200,
    "total": 37000
  },
  {
    "id": "ledger-2024-2026-526",
    "rowIndex": 526,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 190,
    "qtyKg": null,
    "price": 500,
    "total": 95000
  },
  {
    "id": "ledger-2024-2026-527",
    "rowIndex": 527,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Casas, Joseph",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 5,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-528",
    "rowIndex": 528,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 46,
    "price": 250,
    "total": 11500
  },
  {
    "id": "ledger-2024-2026-529",
    "rowIndex": 529,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 46,
    "price": 250,
    "total": 11500
  },
  {
    "id": "ledger-2024-2026-530",
    "rowIndex": 530,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 5200,
    "total": 5200
  },
  {
    "id": "ledger-2024-2026-531",
    "rowIndex": 531,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 3132,
    "total": 3132
  },
  {
    "id": "ledger-2024-2026-532",
    "rowIndex": 532,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 331,
    "qtyKg": null,
    "price": 50,
    "total": 16550
  },
  {
    "id": "ledger-2024-2026-533",
    "rowIndex": 533,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 331,
    "qtyKg": null,
    "price": 2.5,
    "total": 827.5
  },
  {
    "id": "ledger-2024-2026-534",
    "rowIndex": 534,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 52,
    "qtyKg": null,
    "price": 100,
    "total": 5200
  },
  {
    "id": "ledger-2024-2026-535",
    "rowIndex": 535,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 52,
    "qtyKg": null,
    "price": 200,
    "total": 10400
  },
  {
    "id": "ledger-2024-2026-536",
    "rowIndex": 536,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 500,
    "total": 30000
  },
  {
    "id": "ledger-2024-2026-537",
    "rowIndex": 537,
    "date": "2025-04-30",
    "rawDate": 45777,
    "raiser": "Perez, Martin",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 8,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-538",
    "rowIndex": 538,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 9000,
    "total": 9000
  },
  {
    "id": "ledger-2024-2026-539",
    "rowIndex": 539,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32650",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-540",
    "rowIndex": 540,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32650",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-541",
    "rowIndex": 541,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 13,
    "qtyKg": 1309,
    "price": 245,
    "total": 320705
  },
  {
    "id": "ledger-2024-2026-542",
    "rowIndex": 542,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": 138,
    "price": 235,
    "total": 32430
  },
  {
    "id": "ledger-2024-2026-543",
    "rowIndex": 543,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3032",
    "ledgerDescription": "Meds - Others",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 14985,
    "total": 14985
  },
  {
    "id": "ledger-2024-2026-544",
    "rowIndex": 544,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 592,
    "qtyKg": null,
    "price": 50,
    "total": 29600
  },
  {
    "id": "ledger-2024-2026-545",
    "rowIndex": 545,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 592,
    "qtyKg": null,
    "price": 2.5,
    "total": 1480
  },
  {
    "id": "ledger-2024-2026-546",
    "rowIndex": 546,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 92,
    "qtyKg": null,
    "price": 100,
    "total": 9200
  },
  {
    "id": "ledger-2024-2026-547",
    "rowIndex": 547,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 92,
    "qtyKg": null,
    "price": 200,
    "total": 18400
  },
  {
    "id": "ledger-2024-2026-548",
    "rowIndex": 548,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 500,
    "total": 50000
  },
  {
    "id": "ledger-2024-2026-549",
    "rowIndex": 549,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Nato",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 8,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-550",
    "rowIndex": 550,
    "date": "2025-05-02",
    "rawDate": 45779,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32650",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-551",
    "rowIndex": 551,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 75,
    "qtyKg": null,
    "price": 11440,
    "total": 858000
  },
  {
    "id": "ledger-2024-2026-552",
    "rowIndex": 552,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 75,
    "qtyKg": null,
    "price": 200,
    "total": 15000
  },
  {
    "id": "ledger-2024-2026-553",
    "rowIndex": 553,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 65,
    "qtyKg": null,
    "price": 11440,
    "total": 743600
  },
  {
    "id": "ledger-2024-2026-554",
    "rowIndex": 554,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 65,
    "qtyKg": null,
    "price": 200,
    "total": 13000
  },
  {
    "id": "ledger-2024-2026-555",
    "rowIndex": 555,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 11440,
    "total": 400400
  },
  {
    "id": "ledger-2024-2026-556",
    "rowIndex": 556,
    "date": "2025-05-03",
    "rawDate": 45780,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 200,
    "total": 7000
  },
  {
    "id": "ledger-2024-2026-557",
    "rowIndex": 557,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32696",
    "description": "HSP",
    "qty": 9,
    "qtyKg": null,
    "price": 1369,
    "total": 12321
  },
  {
    "id": "ledger-2024-2026-558",
    "rowIndex": 558,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 10230,
    "total": 511500
  },
  {
    "id": "ledger-2024-2026-559",
    "rowIndex": 559,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 200,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-560",
    "rowIndex": 560,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1594,
    "total": 15940
  },
  {
    "id": "ledger-2024-2026-561",
    "rowIndex": 561,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HG HD VTA2",
    "qty": 20,
    "qtyKg": null,
    "price": 1399,
    "total": 27980
  },
  {
    "id": "ledger-2024-2026-562",
    "rowIndex": 562,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HS DP",
    "qty": 20,
    "qtyKg": null,
    "price": 1594,
    "total": 31880
  },
  {
    "id": "ledger-2024-2026-563",
    "rowIndex": 563,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32696",
    "description": "HSP",
    "qty": 3,
    "qtyKg": null,
    "price": 1369,
    "total": 4107
  },
  {
    "id": "ledger-2024-2026-564",
    "rowIndex": 564,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32697",
    "description": "HG HD",
    "qty": 17,
    "qtyKg": null,
    "price": 1354,
    "total": 23018
  },
  {
    "id": "ledger-2024-2026-565",
    "rowIndex": 565,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32696",
    "description": "HSP",
    "qty": 33,
    "qtyKg": null,
    "price": 1369,
    "total": 45177
  },
  {
    "id": "ledger-2024-2026-566",
    "rowIndex": 566,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32697",
    "description": "HS DP VI",
    "qty": 50,
    "qtyKg": null,
    "price": 1604,
    "total": 80200
  },
  {
    "id": "ledger-2024-2026-567",
    "rowIndex": 567,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32697",
    "description": "HS DP VI",
    "qty": 30,
    "qtyKg": null,
    "price": 1604,
    "total": 48120
  },
  {
    "id": "ledger-2024-2026-568",
    "rowIndex": 568,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HG HD VTA2",
    "qty": 26,
    "qtyKg": null,
    "price": 1399,
    "total": 36374
  },
  {
    "id": "ledger-2024-2026-569",
    "rowIndex": 569,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HS DP",
    "qty": 17,
    "qtyKg": null,
    "price": 1594,
    "total": 27098
  },
  {
    "id": "ledger-2024-2026-570",
    "rowIndex": 570,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HG HD VTA2",
    "qty": 28,
    "qtyKg": null,
    "price": 1399,
    "total": 39172
  },
  {
    "id": "ledger-2024-2026-571",
    "rowIndex": 571,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HG HD VTA2",
    "qty": 24,
    "qtyKg": null,
    "price": 1399,
    "total": 33576
  },
  {
    "id": "ledger-2024-2026-572",
    "rowIndex": 572,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32695",
    "description": "HS DP",
    "qty": 10,
    "qtyKg": null,
    "price": 1594,
    "total": 15940
  },
  {
    "id": "ledger-2024-2026-573",
    "rowIndex": 573,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32697",
    "description": "HGP",
    "qty": 1,
    "qtyKg": null,
    "price": 1269,
    "total": 1269
  },
  {
    "id": "ledger-2024-2026-574",
    "rowIndex": 574,
    "date": "2025-05-05",
    "rawDate": 45782,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32696",
    "description": "HSP",
    "qty": 13,
    "qtyKg": null,
    "price": 1369,
    "total": 17797
  },
  {
    "id": "ledger-2024-2026-575",
    "rowIndex": 575,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32759",
    "description": "HSP",
    "qty": 85,
    "qtyKg": null,
    "price": 1369,
    "total": 116365
  },
  {
    "id": "ledger-2024-2026-576",
    "rowIndex": 576,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 125,
    "qtyKg": null,
    "price": 10230,
    "total": 1278750
  },
  {
    "id": "ledger-2024-2026-577",
    "rowIndex": 577,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 25,
    "qtyKg": null,
    "price": 9240,
    "total": 231000
  },
  {
    "id": "ledger-2024-2026-578",
    "rowIndex": 578,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 150,
    "qtyKg": null,
    "price": 200,
    "total": 30000
  },
  {
    "id": "ledger-2024-2026-579",
    "rowIndex": 579,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 60,
    "qtyKg": null,
    "price": 9240,
    "total": 554400
  },
  {
    "id": "ledger-2024-2026-580",
    "rowIndex": 580,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 60,
    "qtyKg": null,
    "price": 200,
    "total": 12000
  },
  {
    "id": "ledger-2024-2026-581",
    "rowIndex": 581,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32759",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-582",
    "rowIndex": 582,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 70,
    "qtyKg": null,
    "price": 9240,
    "total": 646800
  },
  {
    "id": "ledger-2024-2026-583",
    "rowIndex": 583,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": "Nueva Ecija",
    "qty": 70,
    "qtyKg": null,
    "price": 200,
    "total": 14000
  },
  {
    "id": "ledger-2024-2026-584",
    "rowIndex": 584,
    "date": "2025-05-06",
    "rawDate": 45783,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32759",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1369,
    "total": 47915
  },
  {
    "id": "ledger-2024-2026-585",
    "rowIndex": 585,
    "date": "2025-05-07",
    "rawDate": 45784,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32832",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1354,
    "total": 54160
  },
  {
    "id": "ledger-2024-2026-586",
    "rowIndex": 586,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP VI",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-587",
    "rowIndex": 587,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1354,
    "total": 16248
  },
  {
    "id": "ledger-2024-2026-588",
    "rowIndex": 588,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32951",
    "description": "HSP",
    "qty": 17,
    "qtyKg": null,
    "price": 1369,
    "total": 23273
  },
  {
    "id": "ledger-2024-2026-589",
    "rowIndex": 589,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1369,
    "total": 27380
  },
  {
    "id": "ledger-2024-2026-590",
    "rowIndex": 590,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32951",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-591",
    "rowIndex": 591,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32951",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1369,
    "total": 27380
  },
  {
    "id": "ledger-2024-2026-592",
    "rowIndex": 592,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1369,
    "total": 27380
  },
  {
    "id": "ledger-2024-2026-593",
    "rowIndex": 593,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-594",
    "rowIndex": 594,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HPS Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-595",
    "rowIndex": 595,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1369,
    "total": 8214
  },
  {
    "id": "ledger-2024-2026-596",
    "rowIndex": 596,
    "date": "2025-05-09",
    "rawDate": 45786,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "32952",
    "description": "HSP VI",
    "qty": 9,
    "qtyKg": null,
    "price": 1379,
    "total": 12411
  },
  {
    "id": "ledger-2024-2026-597",
    "rowIndex": 597,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HSP VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-598",
    "rowIndex": 598,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD",
    "qty": 11,
    "qtyKg": null,
    "price": 1354,
    "total": 14894
  },
  {
    "id": "ledger-2024-2026-599",
    "rowIndex": 599,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1364,
    "total": 16368
  },
  {
    "id": "ledger-2024-2026-600",
    "rowIndex": 600,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HSP VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-601",
    "rowIndex": 601,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD",
    "qty": 18,
    "qtyKg": null,
    "price": 1354,
    "total": 24372
  },
  {
    "id": "ledger-2024-2026-602",
    "rowIndex": 602,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-603",
    "rowIndex": 603,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HSP VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-604",
    "rowIndex": 604,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1354,
    "total": 16248
  },
  {
    "id": "ledger-2024-2026-605",
    "rowIndex": 605,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-606",
    "rowIndex": 606,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1354,
    "total": 13540
  },
  {
    "id": "ledger-2024-2026-607",
    "rowIndex": 607,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1364,
    "total": 23188
  },
  {
    "id": "ledger-2024-2026-608",
    "rowIndex": 608,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33008",
    "description": "HSP VTA",
    "qty": 5,
    "qtyKg": null,
    "price": 1414,
    "total": 7070
  },
  {
    "id": "ledger-2024-2026-609",
    "rowIndex": 609,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1751",
    "description": "Anus - Jun",
    "qty": 22,
    "qtyKg": 2780.4,
    "price": 260,
    "total": 722904
  },
  {
    "id": "ledger-2024-2026-610",
    "rowIndex": 610,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1752",
    "description": "Anus - Jun",
    "qty": 28,
    "qtyKg": 3377.6,
    "price": 260,
    "total": 878176
  },
  {
    "id": "ledger-2024-2026-611",
    "rowIndex": 611,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1752",
    "description": "Anus - Bert",
    "qty": 2,
    "qtyKg": 247.2,
    "price": 260,
    "total": 64272
  },
  {
    "id": "ledger-2024-2026-612",
    "rowIndex": 612,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1752",
    "description": "Anus - Bert",
    "qty": 1,
    "qtyKg": 77.8,
    "price": 250,
    "total": 19450
  },
  {
    "id": "ledger-2024-2026-613",
    "rowIndex": 613,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1753",
    "description": "Anus - Jun",
    "qty": 2,
    "qtyKg": 158,
    "price": 260,
    "total": 41080
  },
  {
    "id": "ledger-2024-2026-614",
    "rowIndex": 614,
    "date": "2025-05-13",
    "rawDate": 45790,
    "raiser": "VSB Anus",
    "batch": "",
    "cycleCode": "VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1753",
    "description": "Anus - Bert",
    "qty": 23,
    "qtyKg": 2400.2,
    "price": 260,
    "total": 624052
  },
  {
    "id": "ledger-2024-2026-615",
    "rowIndex": 615,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1369,
    "total": 13690
  },
  {
    "id": "ledger-2024-2026-616",
    "rowIndex": 616,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33071",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1354,
    "total": 27080
  },
  {
    "id": "ledger-2024-2026-617",
    "rowIndex": 617,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-618",
    "rowIndex": 618,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HG HD VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1399,
    "total": 13990
  },
  {
    "id": "ledger-2024-2026-619",
    "rowIndex": 619,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33071",
    "description": "HG HD VTA",
    "qty": 5,
    "qtyKg": null,
    "price": 1394,
    "total": 6970
  },
  {
    "id": "ledger-2024-2026-620",
    "rowIndex": 620,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-621",
    "rowIndex": 621,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-622",
    "rowIndex": 622,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-623",
    "rowIndex": 623,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP VTAA",
    "qty": 8,
    "qtyKg": null,
    "price": 1419,
    "total": 11352
  },
  {
    "id": "ledger-2024-2026-624",
    "rowIndex": 624,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1369,
    "total": 16428
  },
  {
    "id": "ledger-2024-2026-625",
    "rowIndex": 625,
    "date": "2025-05-14",
    "rawDate": 45791,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33070",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-626",
    "rowIndex": 626,
    "date": "2025-05-15",
    "rawDate": 45792,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33167",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1369,
    "total": 61605
  },
  {
    "id": "ledger-2024-2026-627",
    "rowIndex": 627,
    "date": "2025-05-15",
    "rawDate": 45792,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33167",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-628",
    "rowIndex": 628,
    "date": "2025-05-15",
    "rawDate": 45792,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33167",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1369,
    "total": 68450
  },
  {
    "id": "ledger-2024-2026-629",
    "rowIndex": 629,
    "date": "2025-05-15",
    "rawDate": 45792,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33167",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1369,
    "total": 54760
  },
  {
    "id": "ledger-2024-2026-630",
    "rowIndex": 630,
    "date": "2025-05-16",
    "rawDate": 45793,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1755",
    "description": null,
    "qty": 30,
    "qtyKg": 4172,
    "price": 255,
    "total": 1063860
  },
  {
    "id": "ledger-2024-2026-631",
    "rowIndex": 631,
    "date": "2025-05-16",
    "rawDate": 45793,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1756",
    "description": null,
    "qty": 20,
    "qtyKg": 2626,
    "price": 255,
    "total": 669630
  },
  {
    "id": "ledger-2024-2026-632",
    "rowIndex": 632,
    "date": "2025-05-18",
    "rawDate": 45795,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 12200,
    "total": 12200
  },
  {
    "id": "ledger-2024-2026-633",
    "rowIndex": 633,
    "date": "2025-05-19",
    "rawDate": 45796,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1757",
    "description": "Anus - Jun",
    "qty": 25,
    "qtyKg": 2758.2000000000003,
    "price": 265,
    "total": 730923.0000000001
  },
  {
    "id": "ledger-2024-2026-634",
    "rowIndex": 634,
    "date": "2025-05-19",
    "rawDate": 45796,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1757",
    "description": "Anus - Jun",
    "qty": 5,
    "qtyKg": 638.6,
    "price": 265,
    "total": 169229
  },
  {
    "id": "ledger-2024-2026-635",
    "rowIndex": 635,
    "date": "2025-05-19",
    "rawDate": 45796,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1758",
    "description": "Anus - Jun",
    "qty": 20,
    "qtyKg": 2555.6,
    "price": 265,
    "total": 677234
  },
  {
    "id": "ledger-2024-2026-636",
    "rowIndex": 636,
    "date": "2025-05-20",
    "rawDate": 45797,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1759",
    "description": "Anus -Bert",
    "qty": 30,
    "qtyKg": 3557,
    "price": 265,
    "total": 942605
  },
  {
    "id": "ledger-2024-2026-637",
    "rowIndex": 637,
    "date": "2025-05-20",
    "rawDate": 45797,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1760",
    "description": "Anus - Jun",
    "qty": 30,
    "qtyKg": 3377.6000000000004,
    "price": 265,
    "total": 895064.0000000001
  },
  {
    "id": "ledger-2024-2026-638",
    "rowIndex": 638,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1369,
    "total": 13690
  },
  {
    "id": "ledger-2024-2026-639",
    "rowIndex": 639,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1369,
    "total": 2738
  },
  {
    "id": "ledger-2024-2026-640",
    "rowIndex": 640,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP VI",
    "qty": 8,
    "qtyKg": null,
    "price": 1379,
    "total": 11032
  },
  {
    "id": "ledger-2024-2026-641",
    "rowIndex": 641,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1354,
    "total": 13540
  },
  {
    "id": "ledger-2024-2026-642",
    "rowIndex": 642,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD VR",
    "qty": 11,
    "qtyKg": null,
    "price": 1364,
    "total": 15004
  },
  {
    "id": "ledger-2024-2026-643",
    "rowIndex": 643,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP",
    "qty": 3,
    "qtyKg": null,
    "price": 1369,
    "total": 4107
  },
  {
    "id": "ledger-2024-2026-644",
    "rowIndex": 644,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP VI",
    "qty": 12,
    "qtyKg": null,
    "price": 1379,
    "total": 16548
  },
  {
    "id": "ledger-2024-2026-645",
    "rowIndex": 645,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1364,
    "total": 24552
  },
  {
    "id": "ledger-2024-2026-646",
    "rowIndex": 646,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HG HD",
    "qty": 34,
    "qtyKg": null,
    "price": 1354,
    "total": 46036
  },
  {
    "id": "ledger-2024-2026-647",
    "rowIndex": 647,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33331",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1369,
    "total": 41070
  },
  {
    "id": "ledger-2024-2026-648",
    "rowIndex": 648,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33331",
    "description": "HSP",
    "qty": 70,
    "qtyKg": null,
    "price": 1369,
    "total": 95830
  },
  {
    "id": "ledger-2024-2026-649",
    "rowIndex": 649,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33331",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1369,
    "total": 68450
  },
  {
    "id": "ledger-2024-2026-650",
    "rowIndex": 650,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1354,
    "total": 17602
  },
  {
    "id": "ledger-2024-2026-651",
    "rowIndex": 651,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1364,
    "total": 19096
  },
  {
    "id": "ledger-2024-2026-652",
    "rowIndex": 652,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1369,
    "total": 1369
  },
  {
    "id": "ledger-2024-2026-653",
    "rowIndex": 653,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1369,
    "total": 2738
  },
  {
    "id": "ledger-2024-2026-654",
    "rowIndex": 654,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-655",
    "rowIndex": 655,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1354,
    "total": 13540
  },
  {
    "id": "ledger-2024-2026-656",
    "rowIndex": 656,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-657",
    "rowIndex": 657,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1354,
    "total": 16248
  },
  {
    "id": "ledger-2024-2026-658",
    "rowIndex": 658,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-659",
    "rowIndex": 659,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1369,
    "total": 2738
  },
  {
    "id": "ledger-2024-2026-660",
    "rowIndex": 660,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33368",
    "description": "HSP VI",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-661",
    "rowIndex": 661,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1369,
    "total": 9583
  },
  {
    "id": "ledger-2024-2026-662",
    "rowIndex": 662,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HSP",
    "qty": 13,
    "qtyKg": null,
    "price": 1369,
    "total": 17797
  },
  {
    "id": "ledger-2024-2026-663",
    "rowIndex": 663,
    "date": "2025-05-21",
    "rawDate": 45798,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33305",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1369,
    "total": 24642
  },
  {
    "id": "ledger-2024-2026-664",
    "rowIndex": 664,
    "date": "2025-05-22",
    "rawDate": 45799,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1761",
    "description": "Anus - Jun",
    "qty": 20,
    "qtyKg": 2226.8,
    "price": 265,
    "total": 590102
  },
  {
    "id": "ledger-2024-2026-665",
    "rowIndex": 665,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HG HD VTA",
    "qty": 15,
    "qtyKg": null,
    "price": 1399,
    "total": 20985
  },
  {
    "id": "ledger-2024-2026-666",
    "rowIndex": 666,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP",
    "qty": 70,
    "qtyKg": null,
    "price": 1369,
    "total": 95830
  },
  {
    "id": "ledger-2024-2026-667",
    "rowIndex": 667,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-668",
    "rowIndex": 668,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-669",
    "rowIndex": 669,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-670",
    "rowIndex": 670,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1762",
    "description": null,
    "qty": 1,
    "qtyKg": 128,
    "price": 260,
    "total": 33280
  },
  {
    "id": "ledger-2024-2026-671",
    "rowIndex": 671,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HG HD VR",
    "qty": 27,
    "qtyKg": null,
    "price": 1364,
    "total": 36828
  },
  {
    "id": "ledger-2024-2026-672",
    "rowIndex": 672,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HG HD VR",
    "qty": 43,
    "qtyKg": null,
    "price": 1364,
    "total": 58652
  },
  {
    "id": "ledger-2024-2026-673",
    "rowIndex": 673,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-674",
    "rowIndex": 674,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1369,
    "total": 9583
  },
  {
    "id": "ledger-2024-2026-675",
    "rowIndex": 675,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP VTA",
    "qty": 3,
    "qtyKg": null,
    "price": 1414,
    "total": 4242
  },
  {
    "id": "ledger-2024-2026-676",
    "rowIndex": 676,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33463",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-677",
    "rowIndex": 677,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1762",
    "description": null,
    "qty": 19,
    "qtyKg": 2489,
    "price": 260,
    "total": 647140
  },
  {
    "id": "ledger-2024-2026-678",
    "rowIndex": 678,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Puting Kahoy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Puting Kahoy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1763",
    "description": null,
    "qty": 20,
    "qtyKg": 2853,
    "price": 260,
    "total": 741780
  },
  {
    "id": "ledger-2024-2026-679",
    "rowIndex": 679,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-680",
    "rowIndex": 680,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HG HD VTA2",
    "qty": 14,
    "qtyKg": null,
    "price": 1424,
    "total": 19936
  },
  {
    "id": "ledger-2024-2026-681",
    "rowIndex": 681,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HG HD A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1394,
    "total": 18122
  },
  {
    "id": "ledger-2024-2026-682",
    "rowIndex": 682,
    "date": "2025-05-23",
    "rawDate": 45800,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1369,
    "total": 34225
  },
  {
    "id": "ledger-2024-2026-683",
    "rowIndex": 683,
    "date": "2025-05-26",
    "rawDate": 45803,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1764",
    "description": "Anus - Jun",
    "qty": 18,
    "qtyKg": 1973.8000000000002,
    "price": 265,
    "total": 523057.00000000006
  },
  {
    "id": "ledger-2024-2026-684",
    "rowIndex": 684,
    "date": "2025-05-26",
    "rawDate": 45803,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1764",
    "description": "Anus - Loreto",
    "qty": 2,
    "qtyKg": 204,
    "price": 265,
    "total": 54060
  },
  {
    "id": "ledger-2024-2026-685",
    "rowIndex": 685,
    "date": "2025-05-27",
    "rawDate": 45804,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33572",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1369,
    "total": 10952
  },
  {
    "id": "ledger-2024-2026-686",
    "rowIndex": 686,
    "date": "2025-05-27",
    "rawDate": 45804,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1765",
    "description": "Anus - Loreto",
    "qty": 23,
    "qtyKg": 2271.2,
    "price": 265,
    "total": 601868
  },
  {
    "id": "ledger-2024-2026-687",
    "rowIndex": 687,
    "date": "2025-05-27",
    "rawDate": 45804,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1766",
    "description": "Anus - Loreto",
    "qty": 10,
    "qtyKg": 1087,
    "price": 265,
    "total": 288055
  },
  {
    "id": "ledger-2024-2026-688",
    "rowIndex": 688,
    "date": "2025-05-28",
    "rawDate": 45805,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1767",
    "description": "Anus - Jun",
    "qty": 13,
    "qtyKg": 1372.6000000000001,
    "price": 265,
    "total": 363739.00000000006
  },
  {
    "id": "ledger-2024-2026-689",
    "rowIndex": 689,
    "date": "2025-05-28",
    "rawDate": 45805,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1767",
    "description": "Anus - Loreto",
    "qty": 17,
    "qtyKg": 1831.6000000000001,
    "price": 265,
    "total": 485374.00000000006
  },
  {
    "id": "ledger-2024-2026-690",
    "rowIndex": 690,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1369,
    "total": 9583
  },
  {
    "id": "ledger-2024-2026-691",
    "rowIndex": 691,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1354,
    "total": 10832
  },
  {
    "id": "ledger-2024-2026-692",
    "rowIndex": 692,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1369,
    "total": 19166
  },
  {
    "id": "ledger-2024-2026-693",
    "rowIndex": 693,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1364,
    "total": 17732
  },
  {
    "id": "ledger-2024-2026-694",
    "rowIndex": 694,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-695",
    "rowIndex": 695,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1364,
    "total": 19096
  },
  {
    "id": "ledger-2024-2026-696",
    "rowIndex": 696,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1364,
    "total": 19096
  },
  {
    "id": "ledger-2024-2026-697",
    "rowIndex": 697,
    "date": "2025-05-29",
    "rawDate": 45806,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33646",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1369,
    "total": 6845
  },
  {
    "id": "ledger-2024-2026-698",
    "rowIndex": 698,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1354,
    "total": 27080
  },
  {
    "id": "ledger-2024-2026-699",
    "rowIndex": 699,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HSP VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1479,
    "total": 29580
  },
  {
    "id": "ledger-2024-2026-700",
    "rowIndex": 700,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1369,
    "total": 20535
  },
  {
    "id": "ledger-2024-2026-701",
    "rowIndex": 701,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1389,
    "total": 34725
  },
  {
    "id": "ledger-2024-2026-702",
    "rowIndex": 702,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HSP VAS",
    "qty": 50,
    "qtyKg": null,
    "price": 1479,
    "total": 73950
  },
  {
    "id": "ledger-2024-2026-703",
    "rowIndex": 703,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33704",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1369,
    "total": 27380
  },
  {
    "id": "ledger-2024-2026-704",
    "rowIndex": 704,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1768",
    "description": "Anus - Jun",
    "qty": 24,
    "qtyKg": 2394.8,
    "price": 270,
    "total": 646596
  },
  {
    "id": "ledger-2024-2026-705",
    "rowIndex": 705,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1768",
    "description": "Anus - Jun",
    "qty": 3,
    "qtyKg": 327.4,
    "price": 270,
    "total": 88398
  },
  {
    "id": "ledger-2024-2026-706",
    "rowIndex": 706,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1768",
    "description": "Anus - Jun",
    "qty": 5,
    "qtyKg": 613.4,
    "price": 270,
    "total": 165618
  },
  {
    "id": "ledger-2024-2026-707",
    "rowIndex": 707,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1769",
    "description": "Anus - Loreto",
    "qty": 24,
    "qtyKg": 2483.2000000000003,
    "price": 265,
    "total": 658048.0000000001
  },
  {
    "id": "ledger-2024-2026-708",
    "rowIndex": 708,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1770",
    "description": "Anus - Jun",
    "qty": 5,
    "qtyKg": 579.6,
    "price": 270,
    "total": 156492
  },
  {
    "id": "ledger-2024-2026-709",
    "rowIndex": 709,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1770",
    "description": "Anus - Loreto",
    "qty": 14,
    "qtyKg": 1603,
    "price": 270,
    "total": 432810
  },
  {
    "id": "ledger-2024-2026-710",
    "rowIndex": 710,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1771",
    "description": "Anus - Jun",
    "qty": 15,
    "qtyKg": 1727.8,
    "price": 270,
    "total": 466506
  },
  {
    "id": "ledger-2024-2026-711",
    "rowIndex": 711,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1772",
    "description": "Anus - Loreto",
    "qty": 17,
    "qtyKg": 1423,
    "price": 265,
    "total": 377095
  },
  {
    "id": "ledger-2024-2026-712",
    "rowIndex": 712,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1772",
    "description": "Anus - Jun",
    "qty": 13,
    "qtyKg": 1833,
    "price": 265,
    "total": 485745
  },
  {
    "id": "ledger-2024-2026-713",
    "rowIndex": 713,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1773",
    "description": "Anus - Loreto",
    "qty": 16,
    "qtyKg": 1720,
    "price": 265,
    "total": 455800
  },
  {
    "id": "ledger-2024-2026-714",
    "rowIndex": 714,
    "date": "2025-05-30",
    "rawDate": 45807,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1773",
    "description": "Anus - Loreto",
    "qty": 2,
    "qtyKg": 142,
    "price": 250,
    "total": 35500
  },
  {
    "id": "ledger-2024-2026-715",
    "rowIndex": 715,
    "date": "2025-05-31",
    "rawDate": 45808,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1775",
    "description": "Anus - Jun",
    "qty": 20,
    "qtyKg": 2300.8,
    "price": 265,
    "total": 609712
  },
  {
    "id": "ledger-2024-2026-716",
    "rowIndex": 716,
    "date": "2025-05-31",
    "rawDate": 45808,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1775",
    "description": "Anus - Loreto",
    "qty": 12,
    "qtyKg": 1197.7,
    "price": 265,
    "total": 317390.5
  },
  {
    "id": "ledger-2024-2026-717",
    "rowIndex": 717,
    "date": "2025-05-31",
    "rawDate": 45808,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1779",
    "description": "Anus - Jun",
    "qty": 5,
    "qtyKg": 587,
    "price": 260,
    "total": 152620
  },
  {
    "id": "ledger-2024-2026-718",
    "rowIndex": 718,
    "date": "2025-05-31",
    "rawDate": 45808,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1780",
    "description": "Anus - Loreto",
    "qty": 8,
    "qtyKg": 814.4,
    "price": 255,
    "total": 207672
  },
  {
    "id": "ledger-2024-2026-719",
    "rowIndex": 719,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1781",
    "description": null,
    "qty": 1,
    "qtyKg": 106,
    "price": 265,
    "total": 28090
  },
  {
    "id": "ledger-2024-2026-720",
    "rowIndex": 720,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1781",
    "description": "Anus - Jun",
    "qty": 20,
    "qtyKg": 2287.8,
    "price": 270,
    "total": 617706
  },
  {
    "id": "ledger-2024-2026-721",
    "rowIndex": 721,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1781",
    "description": "Anus - Jun",
    "qty": 3,
    "qtyKg": 330.4,
    "price": 270,
    "total": 89208
  },
  {
    "id": "ledger-2024-2026-722",
    "rowIndex": 722,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1781",
    "description": "Anus - Loreto",
    "qty": 1,
    "qtyKg": 126.2,
    "price": 270,
    "total": 34074
  },
  {
    "id": "ledger-2024-2026-723",
    "rowIndex": 723,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1782",
    "description": "Anus - Loreto",
    "qty": 19,
    "qtyKg": 2220.6,
    "price": 265,
    "total": 588459
  },
  {
    "id": "ledger-2024-2026-724",
    "rowIndex": 724,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1783",
    "description": "Anus - Loreto",
    "qty": 19,
    "qtyKg": 1938,
    "price": 255,
    "total": 494190
  },
  {
    "id": "ledger-2024-2026-725",
    "rowIndex": 725,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1783",
    "description": "Anus - Loreto",
    "qty": 1,
    "qtyKg": 61,
    "price": 240,
    "total": 14640
  },
  {
    "id": "ledger-2024-2026-726",
    "rowIndex": 726,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1784",
    "description": "Anus - Loreto",
    "qty": 25,
    "qtyKg": 2692,
    "price": 255,
    "total": 686460
  },
  {
    "id": "ledger-2024-2026-727",
    "rowIndex": 727,
    "date": "2025-06-01",
    "rawDate": 45809,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1785",
    "description": "Anus - Jun",
    "qty": 10,
    "qtyKg": 1257.2,
    "price": 265,
    "total": 333158
  },
  {
    "id": "ledger-2024-2026-728",
    "rowIndex": 728,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-729",
    "rowIndex": 729,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-730",
    "rowIndex": 730,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1379,
    "total": 19306
  },
  {
    "id": "ledger-2024-2026-731",
    "rowIndex": 731,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 15450,
    "total": 15450
  },
  {
    "id": "ledger-2024-2026-732",
    "rowIndex": 732,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-733",
    "rowIndex": 733,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-734",
    "rowIndex": 734,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HG HD",
    "qty": 14,
    "qtyKg": null,
    "price": 1364,
    "total": 19096
  },
  {
    "id": "ledger-2024-2026-735",
    "rowIndex": 735,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1364,
    "total": 16368
  },
  {
    "id": "ledger-2024-2026-736",
    "rowIndex": 736,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33731",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-737",
    "rowIndex": 737,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1786",
    "description": "Anus - Loreto",
    "qty": 20,
    "qtyKg": 2400.2,
    "price": 270,
    "total": 648054
  },
  {
    "id": "ledger-2024-2026-738",
    "rowIndex": 738,
    "date": "2025-06-02",
    "rawDate": 45810,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1787",
    "description": "Anus - Loreto",
    "qty": 40,
    "qtyKg": 4678.4,
    "price": 265,
    "total": 1239776
  },
  {
    "id": "ledger-2024-2026-739",
    "rowIndex": 739,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD VR",
    "qty": 62,
    "qtyKg": null,
    "price": 1374,
    "total": 85188
  },
  {
    "id": "ledger-2024-2026-740",
    "rowIndex": 740,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD",
    "qty": 18,
    "qtyKg": null,
    "price": 1364,
    "total": 24552
  },
  {
    "id": "ledger-2024-2026-741",
    "rowIndex": 741,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1414,
    "total": 14140
  },
  {
    "id": "ledger-2024-2026-742",
    "rowIndex": 742,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-743",
    "rowIndex": 743,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1789",
    "description": null,
    "qty": 1,
    "qtyKg": 92,
    "price": 265,
    "total": 24380
  },
  {
    "id": "ledger-2024-2026-744",
    "rowIndex": 744,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-745",
    "rowIndex": 745,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD",
    "qty": 3,
    "qtyKg": null,
    "price": 1364,
    "total": 4092
  },
  {
    "id": "ledger-2024-2026-746",
    "rowIndex": 746,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-747",
    "rowIndex": 747,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-748",
    "rowIndex": 748,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD",
    "qty": 36,
    "qtyKg": null,
    "price": 1364,
    "total": 49104
  },
  {
    "id": "ledger-2024-2026-749",
    "rowIndex": 749,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1788",
    "description": null,
    "qty": 7,
    "qtyKg": 720.4,
    "price": 265,
    "total": 190906
  },
  {
    "id": "ledger-2024-2026-750",
    "rowIndex": 750,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1789",
    "description": null,
    "qty": 19,
    "qtyKg": 2136.6,
    "price": 265,
    "total": 566199
  },
  {
    "id": "ledger-2024-2026-751",
    "rowIndex": 751,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1364,
    "total": 5456
  },
  {
    "id": "ledger-2024-2026-752",
    "rowIndex": 752,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1374,
    "total": 24732
  },
  {
    "id": "ledger-2024-2026-753",
    "rowIndex": 753,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-754",
    "rowIndex": 754,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-755",
    "rowIndex": 755,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33821",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-756",
    "rowIndex": 756,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Lope",
    "description": "HG HD Asmicosin",
    "qty": 30,
    "qtyKg": null,
    "price": 1514,
    "total": 45420
  },
  {
    "id": "ledger-2024-2026-757",
    "rowIndex": 757,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1788",
    "description": "Anus - Loreto",
    "qty": 11,
    "qtyKg": 1299.4,
    "price": 270,
    "total": 350838
  },
  {
    "id": "ledger-2024-2026-758",
    "rowIndex": 758,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1788",
    "description": "Anus - Jun",
    "qty": 2,
    "qtyKg": 246,
    "price": 270,
    "total": 66420
  },
  {
    "id": "ledger-2024-2026-759",
    "rowIndex": 759,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Amie C.",
    "description": "HG HD",
    "qty": -3,
    "qtyKg": null,
    "price": 1364,
    "total": -4092
  },
  {
    "id": "ledger-2024-2026-760",
    "rowIndex": 760,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Amie C.",
    "description": "HG HD VR",
    "qty": -10,
    "qtyKg": null,
    "price": 1374,
    "total": -13740
  },
  {
    "id": "ledger-2024-2026-761",
    "rowIndex": 761,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie C.",
    "description": "HG HD",
    "qty": -36,
    "qtyKg": null,
    "price": 1364,
    "total": -49104
  },
  {
    "id": "ledger-2024-2026-762",
    "rowIndex": 762,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie P.",
    "description": "HG HD",
    "qty": -4,
    "qtyKg": null,
    "price": 1364,
    "total": -5456
  },
  {
    "id": "ledger-2024-2026-763",
    "rowIndex": 763,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie P.",
    "description": "HG HD VR",
    "qty": -18,
    "qtyKg": null,
    "price": 1374,
    "total": -24732
  },
  {
    "id": "ledger-2024-2026-764",
    "rowIndex": 764,
    "date": "2025-06-03",
    "rawDate": 45811,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Andres S.",
    "description": "HG HD Asmicosin",
    "qty": -30,
    "qtyKg": null,
    "price": 1394,
    "total": -41820
  },
  {
    "id": "ledger-2024-2026-765",
    "rowIndex": 765,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1379,
    "total": 34475
  },
  {
    "id": "ledger-2024-2026-766",
    "rowIndex": 766,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-767",
    "rowIndex": 767,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1379,
    "total": 41370
  },
  {
    "id": "ledger-2024-2026-768",
    "rowIndex": 768,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HG HD VTA",
    "qty": 20,
    "qtyKg": null,
    "price": 1434,
    "total": 28680
  },
  {
    "id": "ledger-2024-2026-769",
    "rowIndex": 769,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HG HD VTA",
    "qty": 25,
    "qtyKg": null,
    "price": 1434,
    "total": 35850
  },
  {
    "id": "ledger-2024-2026-770",
    "rowIndex": 770,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1790",
    "description": null,
    "qty": 33,
    "qtyKg": 3675.2000000000003,
    "price": 265,
    "total": 973928.0000000001
  },
  {
    "id": "ledger-2024-2026-771",
    "rowIndex": 771,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP Asmicosin",
    "qty": 15,
    "qtyKg": null,
    "price": 1489,
    "total": 22335
  },
  {
    "id": "ledger-2024-2026-772",
    "rowIndex": 772,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP Asmicosin",
    "qty": 10,
    "qtyKg": null,
    "price": 1489,
    "total": 14890
  },
  {
    "id": "ledger-2024-2026-773",
    "rowIndex": 773,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33926",
    "description": "HSP Asmicosin",
    "qty": 20,
    "qtyKg": null,
    "price": 1409,
    "total": 28180
  },
  {
    "id": "ledger-2024-2026-774",
    "rowIndex": 774,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1790",
    "description": "Anus - Loreto",
    "qty": 2,
    "qtyKg": 226.2,
    "price": 270,
    "total": 61074
  },
  {
    "id": "ledger-2024-2026-775",
    "rowIndex": 775,
    "date": "2025-06-05",
    "rawDate": 45813,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1790",
    "description": "Anus - Jun",
    "qty": 1,
    "qtyKg": 85.2,
    "price": 270,
    "total": 23004
  },
  {
    "id": "ledger-2024-2026-776",
    "rowIndex": 776,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33977",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-777",
    "rowIndex": 777,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Jerome D.",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1364,
    "total": 8184
  },
  {
    "id": "ledger-2024-2026-778",
    "rowIndex": 778,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Ladie H.",
    "description": "HG HD",
    "qty": 7.5,
    "qtyKg": null,
    "price": 1364,
    "total": 10230
  },
  {
    "id": "ledger-2024-2026-779",
    "rowIndex": 779,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33977",
    "description": "HSP",
    "qty": 13,
    "qtyKg": null,
    "price": 1379,
    "total": 17927
  },
  {
    "id": "ledger-2024-2026-780",
    "rowIndex": 780,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1793",
    "description": null,
    "qty": 1,
    "qtyKg": 118,
    "price": 265,
    "total": 31270
  },
  {
    "id": "ledger-2024-2026-781",
    "rowIndex": 781,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to John A.",
    "description": "HG HD",
    "qty": -6,
    "qtyKg": null,
    "price": 1364,
    "total": -8184
  },
  {
    "id": "ledger-2024-2026-782",
    "rowIndex": 782,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33977",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1379,
    "total": 16548
  },
  {
    "id": "ledger-2024-2026-783",
    "rowIndex": 783,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1791",
    "description": null,
    "qty": 28,
    "qtyKg": 2860,
    "price": 265,
    "total": 757900
  },
  {
    "id": "ledger-2024-2026-784",
    "rowIndex": 784,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1792",
    "description": null,
    "qty": 20,
    "qtyKg": 2308.6,
    "price": 265,
    "total": 611779
  },
  {
    "id": "ledger-2024-2026-785",
    "rowIndex": 785,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1793",
    "description": null,
    "qty": 18,
    "qtyKg": 1812.2,
    "price": 265,
    "total": 480233
  },
  {
    "id": "ledger-2024-2026-786",
    "rowIndex": 786,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1793",
    "description": null,
    "qty": 1,
    "qtyKg": 70.2,
    "price": 255,
    "total": 17901
  },
  {
    "id": "ledger-2024-2026-787",
    "rowIndex": 787,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": 26000,
    "total": 52000
  },
  {
    "id": "ledger-2024-2026-788",
    "rowIndex": 788,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to John A.",
    "description": "HG HD",
    "qty": -7.5,
    "qtyKg": null,
    "price": 1364,
    "total": -10230
  },
  {
    "id": "ledger-2024-2026-789",
    "rowIndex": 789,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Loreto",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1364,
    "total": 5456
  },
  {
    "id": "ledger-2024-2026-790",
    "rowIndex": 790,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Anus - Jun",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1364,
    "total": 24552
  },
  {
    "id": "ledger-2024-2026-791",
    "rowIndex": 791,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "33977",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-792",
    "rowIndex": 792,
    "date": "2025-06-06",
    "rawDate": 45814,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie P.",
    "description": "HG HD",
    "qty": -4,
    "qtyKg": null,
    "price": 1364,
    "total": -5456
  },
  {
    "id": "ledger-2024-2026-793",
    "rowIndex": 793,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-794",
    "rowIndex": 794,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1364,
    "total": 5456
  },
  {
    "id": "ledger-2024-2026-795",
    "rowIndex": 795,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1379,
    "total": 41370
  },
  {
    "id": "ledger-2024-2026-796",
    "rowIndex": 796,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 22,
    "qtyKg": null,
    "price": 1379,
    "total": 30338
  },
  {
    "id": "ledger-2024-2026-797",
    "rowIndex": 797,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-798",
    "rowIndex": 798,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-799",
    "rowIndex": 799,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-800",
    "rowIndex": 800,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-801",
    "rowIndex": 801,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-802",
    "rowIndex": 802,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HSP",
    "qty": 11,
    "qtyKg": null,
    "price": 1379,
    "total": 15169
  },
  {
    "id": "ledger-2024-2026-803",
    "rowIndex": 803,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34054",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1374,
    "total": 16488
  },
  {
    "id": "ledger-2024-2026-804",
    "rowIndex": 804,
    "date": "2025-06-09",
    "rawDate": 45817,
    "raiser": "VSB Anus",
    "batch": "2025-01",
    "cycleCode": "2025-01 - VSB Anus",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie P.",
    "description": "HG HD VR",
    "qty": -18,
    "qtyKg": null,
    "price": 1364,
    "total": -24552
  },
  {
    "id": "ledger-2024-2026-805",
    "rowIndex": 805,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34126",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1379,
    "total": 16548
  },
  {
    "id": "ledger-2024-2026-806",
    "rowIndex": 806,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34126",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-807",
    "rowIndex": 807,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34126",
    "description": "HSP",
    "qty": 21,
    "qtyKg": null,
    "price": 1379,
    "total": 28959
  },
  {
    "id": "ledger-2024-2026-808",
    "rowIndex": 808,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34126",
    "description": "HSP",
    "qty": 16,
    "qtyKg": null,
    "price": 1379,
    "total": 22064
  },
  {
    "id": "ledger-2024-2026-809",
    "rowIndex": 809,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34125",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-810",
    "rowIndex": 810,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34125",
    "description": "HSP VAS",
    "qty": 19,
    "qtyKg": null,
    "price": 1489,
    "total": 28291
  },
  {
    "id": "ledger-2024-2026-811",
    "rowIndex": 811,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34126",
    "description": "HSP",
    "qty": 11,
    "qtyKg": null,
    "price": 1379,
    "total": 15169
  },
  {
    "id": "ledger-2024-2026-812",
    "rowIndex": 812,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34125",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-813",
    "rowIndex": 813,
    "date": "2025-06-11",
    "rawDate": 45819,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34125",
    "description": "HSP VAS",
    "qty": 19,
    "qtyKg": null,
    "price": 1489,
    "total": 28291
  },
  {
    "id": "ledger-2024-2026-814",
    "rowIndex": 814,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34216",
    "description": "HG HD",
    "qty": 85,
    "qtyKg": null,
    "price": 1364,
    "total": 115940
  },
  {
    "id": "ledger-2024-2026-815",
    "rowIndex": 815,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1795",
    "description": null,
    "qty": 9,
    "qtyKg": 1021.2,
    "price": 265,
    "total": 270618
  },
  {
    "id": "ledger-2024-2026-816",
    "rowIndex": 816,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1794",
    "description": null,
    "qty": 1,
    "qtyKg": 98,
    "price": 265,
    "total": 25970
  },
  {
    "id": "ledger-2024-2026-817",
    "rowIndex": 817,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34217",
    "description": "HSP VT",
    "qty": 10,
    "qtyKg": null,
    "price": 1409,
    "total": 14090
  },
  {
    "id": "ledger-2024-2026-818",
    "rowIndex": 818,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 82,
    "price": 260,
    "total": 21320
  },
  {
    "id": "ledger-2024-2026-819",
    "rowIndex": 819,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 4000,
    "total": 4000
  },
  {
    "id": "ledger-2024-2026-820",
    "rowIndex": 820,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 310,
    "qtyKg": null,
    "price": 50,
    "total": 15500
  },
  {
    "id": "ledger-2024-2026-821",
    "rowIndex": 821,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 310,
    "qtyKg": null,
    "price": 2.5,
    "total": 775
  },
  {
    "id": "ledger-2024-2026-822",
    "rowIndex": 822,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 100,
    "total": 6000
  },
  {
    "id": "ledger-2024-2026-823",
    "rowIndex": 823,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 200,
    "total": 12000
  },
  {
    "id": "ledger-2024-2026-824",
    "rowIndex": 824,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 500,
    "total": 30000
  },
  {
    "id": "ledger-2024-2026-825",
    "rowIndex": 825,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Dimaano, Mabuhay - Jerome",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Mabuhay - Jerome",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 0,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-826",
    "rowIndex": 826,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34217",
    "description": "HSP VT",
    "qty": 15,
    "qtyKg": null,
    "price": 1409,
    "total": 21135
  },
  {
    "id": "ledger-2024-2026-827",
    "rowIndex": 827,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 298,
    "qtyKg": null,
    "price": 50,
    "total": 14900
  },
  {
    "id": "ledger-2024-2026-828",
    "rowIndex": 828,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 298,
    "qtyKg": null,
    "price": 2.5,
    "total": 745
  },
  {
    "id": "ledger-2024-2026-829",
    "rowIndex": 829,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": null,
    "price": 100,
    "total": 6900
  },
  {
    "id": "ledger-2024-2026-830",
    "rowIndex": 830,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": null,
    "price": 200,
    "total": 13800
  },
  {
    "id": "ledger-2024-2026-831",
    "rowIndex": 831,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": null,
    "price": 500,
    "total": 34500
  },
  {
    "id": "ledger-2024-2026-832",
    "rowIndex": 832,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 0,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-833",
    "rowIndex": 833,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1794",
    "description": null,
    "qty": 27,
    "qtyKg": 3233.6000000000004,
    "price": 265,
    "total": 856904.0000000001
  },
  {
    "id": "ledger-2024-2026-834",
    "rowIndex": 834,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1795",
    "description": null,
    "qty": 11,
    "qtyKg": 1291.6000000000001,
    "price": 265,
    "total": 342274.00000000006
  },
  {
    "id": "ledger-2024-2026-835",
    "rowIndex": 835,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1796",
    "description": null,
    "qty": 2,
    "qtyKg": 247,
    "price": 265,
    "total": 65455
  },
  {
    "id": "ledger-2024-2026-836",
    "rowIndex": 836,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34216",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-837",
    "rowIndex": 837,
    "date": "2025-06-13",
    "rawDate": 45821,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34217",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-838",
    "rowIndex": 838,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-839",
    "rowIndex": 839,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP",
    "qty": 3,
    "qtyKg": null,
    "price": 1379,
    "total": 4137
  },
  {
    "id": "ledger-2024-2026-840",
    "rowIndex": 840,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-841",
    "rowIndex": 841,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-842",
    "rowIndex": 842,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-843",
    "rowIndex": 843,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-844",
    "rowIndex": 844,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1379,
    "total": 34475
  },
  {
    "id": "ledger-2024-2026-845",
    "rowIndex": 845,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-846",
    "rowIndex": 846,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-847",
    "rowIndex": 847,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1434,
    "total": 14340
  },
  {
    "id": "ledger-2024-2026-848",
    "rowIndex": 848,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-849",
    "rowIndex": 849,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HSP VTA",
    "qty": 10,
    "qtyKg": null,
    "price": 1429,
    "total": 14290
  },
  {
    "id": "ledger-2024-2026-850",
    "rowIndex": 850,
    "date": "2025-06-16",
    "rawDate": 45824,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34271",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-851",
    "rowIndex": 851,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HSP",
    "qty": 32,
    "qtyKg": null,
    "price": 1379,
    "total": 44128
  },
  {
    "id": "ledger-2024-2026-852",
    "rowIndex": 852,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1364,
    "total": 2728
  },
  {
    "id": "ledger-2024-2026-853",
    "rowIndex": 853,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1379,
    "total": 68950
  },
  {
    "id": "ledger-2024-2026-854",
    "rowIndex": 854,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HSP",
    "qty": 44,
    "qtyKg": null,
    "price": 1379,
    "total": 60676
  },
  {
    "id": "ledger-2024-2026-855",
    "rowIndex": 855,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1364,
    "total": 1364
  },
  {
    "id": "ledger-2024-2026-856",
    "rowIndex": 856,
    "date": "2025-06-17",
    "rawDate": 45825,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34367",
    "description": "HSP",
    "qty": 21,
    "qtyKg": null,
    "price": 1379,
    "total": 28959
  },
  {
    "id": "ledger-2024-2026-857",
    "rowIndex": 857,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34398",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-858",
    "rowIndex": 858,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34399",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1379,
    "total": 62055
  },
  {
    "id": "ledger-2024-2026-859",
    "rowIndex": 859,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34409",
    "description": "HSP",
    "qty": 59,
    "qtyKg": null,
    "price": 1379,
    "total": 81361
  },
  {
    "id": "ledger-2024-2026-860",
    "rowIndex": 860,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34409",
    "description": "HG HD VA2",
    "qty": 45,
    "qtyKg": null,
    "price": 1404,
    "total": 63180
  },
  {
    "id": "ledger-2024-2026-861",
    "rowIndex": 861,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34409",
    "description": "HSP",
    "qty": 11,
    "qtyKg": null,
    "price": 1379,
    "total": 15169
  },
  {
    "id": "ledger-2024-2026-862",
    "rowIndex": 862,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34409",
    "description": "HG HD VA2",
    "qty": 35,
    "qtyKg": null,
    "price": 1404,
    "total": 49140
  },
  {
    "id": "ledger-2024-2026-863",
    "rowIndex": 863,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34399",
    "description": "HSP VA2",
    "qty": 28,
    "qtyKg": null,
    "price": 1419,
    "total": 39732
  },
  {
    "id": "ledger-2024-2026-864",
    "rowIndex": 864,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34399",
    "description": "HSP",
    "qty": 17,
    "qtyKg": null,
    "price": 1379,
    "total": 23443
  },
  {
    "id": "ledger-2024-2026-865",
    "rowIndex": 865,
    "date": "2025-06-18",
    "rawDate": 45826,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34399",
    "description": "HSP VA2",
    "qty": 50,
    "qtyKg": null,
    "price": 1419,
    "total": 70950
  },
  {
    "id": "ledger-2024-2026-866",
    "rowIndex": 866,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HSP VT",
    "qty": 4,
    "qtyKg": null,
    "price": 1429,
    "total": 5716
  },
  {
    "id": "ledger-2024-2026-867",
    "rowIndex": 867,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD A2",
    "qty": 9,
    "qtyKg": null,
    "price": 1404,
    "total": 12636
  },
  {
    "id": "ledger-2024-2026-868",
    "rowIndex": 868,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-869",
    "rowIndex": 869,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD",
    "qty": 23,
    "qtyKg": null,
    "price": 1364,
    "total": 31372
  },
  {
    "id": "ledger-2024-2026-870",
    "rowIndex": 870,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HSP VT",
    "qty": 16,
    "qtyKg": null,
    "price": 1429,
    "total": 22864
  },
  {
    "id": "ledger-2024-2026-871",
    "rowIndex": 871,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1364,
    "total": 10912
  },
  {
    "id": "ledger-2024-2026-872",
    "rowIndex": 872,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1374,
    "total": 9618
  },
  {
    "id": "ledger-2024-2026-873",
    "rowIndex": 873,
    "date": "2025-06-19",
    "rawDate": 45827,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34480",
    "description": "HG HD VR",
    "qty": 23,
    "qtyKg": null,
    "price": 1374,
    "total": 31602
  },
  {
    "id": "ledger-2024-2026-874",
    "rowIndex": 874,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1797",
    "description": null,
    "qty": 29,
    "qtyKg": 3467.4000000000005,
    "price": 265,
    "total": 918861.0000000001
  },
  {
    "id": "ledger-2024-2026-875",
    "rowIndex": 875,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1798",
    "description": null,
    "qty": 8,
    "qtyKg": 1053.6,
    "price": 265,
    "total": 279204
  },
  {
    "id": "ledger-2024-2026-876",
    "rowIndex": 876,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1799",
    "description": null,
    "qty": 2,
    "qtyKg": 256.79999999999995,
    "price": 265,
    "total": 68051.99999999999
  },
  {
    "id": "ledger-2024-2026-877",
    "rowIndex": 877,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1797",
    "description": null,
    "qty": 1,
    "qtyKg": 101.2,
    "price": 265,
    "total": 26818
  },
  {
    "id": "ledger-2024-2026-878",
    "rowIndex": 878,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1798",
    "description": null,
    "qty": 1,
    "qtyKg": 86.6,
    "price": 265,
    "total": 22949
  },
  {
    "id": "ledger-2024-2026-879",
    "rowIndex": 879,
    "date": "2025-06-20",
    "rawDate": 45828,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1798",
    "description": null,
    "qty": 10,
    "qtyKg": 1184.8,
    "price": 265,
    "total": 313972
  },
  {
    "id": "ledger-2024-2026-880",
    "rowIndex": 880,
    "date": "2025-06-23",
    "rawDate": 45831,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34561",
    "description": "HG HD",
    "qty": 65,
    "qtyKg": null,
    "price": 1364,
    "total": 88660
  },
  {
    "id": "ledger-2024-2026-881",
    "rowIndex": 881,
    "date": "2025-06-23",
    "rawDate": 45831,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34562",
    "description": "HG HD",
    "qty": 19,
    "qtyKg": null,
    "price": 1364,
    "total": 25916
  },
  {
    "id": "ledger-2024-2026-882",
    "rowIndex": 882,
    "date": "2025-06-23",
    "rawDate": 45831,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34562",
    "description": "HG HD VR",
    "qty": 31,
    "qtyKg": null,
    "price": 1374,
    "total": 42594
  },
  {
    "id": "ledger-2024-2026-883",
    "rowIndex": 883,
    "date": "2025-06-23",
    "rawDate": 45831,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34562",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-884",
    "rowIndex": 884,
    "date": "2025-06-23",
    "rawDate": 45831,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34562",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-885",
    "rowIndex": 885,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-886",
    "rowIndex": 886,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1374,
    "total": 9618
  },
  {
    "id": "ledger-2024-2026-887",
    "rowIndex": 887,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-888",
    "rowIndex": 888,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-889",
    "rowIndex": 889,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1404,
    "total": 11232
  },
  {
    "id": "ledger-2024-2026-890",
    "rowIndex": 890,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-891",
    "rowIndex": 891,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-892",
    "rowIndex": 892,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1419,
    "total": 17028
  },
  {
    "id": "ledger-2024-2026-893",
    "rowIndex": 893,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1419,
    "total": 42570
  },
  {
    "id": "ledger-2024-2026-894",
    "rowIndex": 894,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HSP",
    "qty": 3,
    "qtyKg": null,
    "price": 1379,
    "total": 4137
  },
  {
    "id": "ledger-2024-2026-895",
    "rowIndex": 895,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-896",
    "rowIndex": 896,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-897",
    "rowIndex": 897,
    "date": "2025-06-25",
    "rawDate": 45833,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34638",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-898",
    "rowIndex": 898,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 250,
    "qtyKg": null,
    "price": 50,
    "total": 12500
  },
  {
    "id": "ledger-2024-2026-899",
    "rowIndex": 899,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 250,
    "qtyKg": null,
    "price": 2.5,
    "total": 625
  },
  {
    "id": "ledger-2024-2026-900",
    "rowIndex": 900,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 39,
    "qtyKg": null,
    "price": 100,
    "total": 3900
  },
  {
    "id": "ledger-2024-2026-901",
    "rowIndex": 901,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 39,
    "qtyKg": null,
    "price": 200,
    "total": 7800
  },
  {
    "id": "ledger-2024-2026-902",
    "rowIndex": 902,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 500,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-903",
    "rowIndex": 903,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Alcantara, John",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-904",
    "rowIndex": 904,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 302,
    "qtyKg": null,
    "price": 50,
    "total": 15100
  },
  {
    "id": "ledger-2024-2026-905",
    "rowIndex": 905,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 302,
    "qtyKg": null,
    "price": 2.5,
    "total": 755
  },
  {
    "id": "ledger-2024-2026-906",
    "rowIndex": 906,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 100,
    "total": 5000
  },
  {
    "id": "ledger-2024-2026-907",
    "rowIndex": 907,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 200,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-908",
    "rowIndex": 908,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 51,
    "qtyKg": null,
    "price": 500,
    "total": 25500
  },
  {
    "id": "ledger-2024-2026-909",
    "rowIndex": 909,
    "date": "2025-06-28",
    "rawDate": 45836,
    "raiser": "Patron, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-910",
    "rowIndex": 910,
    "date": "2025-06-30",
    "rawDate": 45838,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34780",
    "description": "HSP VA2",
    "qty": 40,
    "qtyKg": null,
    "price": 1419,
    "total": 56760
  },
  {
    "id": "ledger-2024-2026-911",
    "rowIndex": 911,
    "date": "2025-06-30",
    "rawDate": 45838,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "napera",
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": 7150,
    "total": 14300
  },
  {
    "id": "ledger-2024-2026-912",
    "rowIndex": 912,
    "date": "2025-06-30",
    "rawDate": 45838,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "napera",
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": 7350,
    "total": 14700
  },
  {
    "id": "ledger-2024-2026-913",
    "rowIndex": 913,
    "date": "2025-06-30",
    "rawDate": 45838,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34780",
    "description": "HSP VA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-914",
    "rowIndex": 914,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1379,
    "total": 1379
  },
  {
    "id": "ledger-2024-2026-915",
    "rowIndex": 915,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HG HD A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-916",
    "rowIndex": 916,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-917",
    "rowIndex": 917,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1379,
    "total": 24822
  },
  {
    "id": "ledger-2024-2026-918",
    "rowIndex": 918,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP",
    "qty": 26,
    "qtyKg": null,
    "price": 1379,
    "total": 35854
  },
  {
    "id": "ledger-2024-2026-919",
    "rowIndex": 919,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1801",
    "description": null,
    "qty": 28,
    "qtyKg": 3438.8,
    "price": 255,
    "total": 876894
  },
  {
    "id": "ledger-2024-2026-920",
    "rowIndex": 920,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1801",
    "description": null,
    "qty": 1,
    "qtyKg": 90,
    "price": 260,
    "total": 23400
  },
  {
    "id": "ledger-2024-2026-921",
    "rowIndex": 921,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1364,
    "total": 1364
  },
  {
    "id": "ledger-2024-2026-922",
    "rowIndex": 922,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1801",
    "description": null,
    "qty": 1,
    "qtyKg": 130,
    "price": 260,
    "total": 33800
  },
  {
    "id": "ledger-2024-2026-923",
    "rowIndex": 923,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HG HD",
    "qty": 26,
    "qtyKg": null,
    "price": 1364,
    "total": 35464
  },
  {
    "id": "ledger-2024-2026-924",
    "rowIndex": 924,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1419,
    "total": 18447
  },
  {
    "id": "ledger-2024-2026-925",
    "rowIndex": 925,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HG HD",
    "qty": 28,
    "qtyKg": null,
    "price": 1364,
    "total": 38192
  },
  {
    "id": "ledger-2024-2026-926",
    "rowIndex": 926,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1802",
    "description": null,
    "qty": 10,
    "qtyKg": 676.4000000000001,
    "price": 175,
    "total": 118370.00000000001
  },
  {
    "id": "ledger-2024-2026-927",
    "rowIndex": 927,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1803",
    "description": null,
    "qty": 5,
    "qtyKg": 555.2,
    "price": 255,
    "total": 141576
  },
  {
    "id": "ledger-2024-2026-928",
    "rowIndex": 928,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1802",
    "description": null,
    "qty": 3,
    "qtyKg": 215.8,
    "price": 175,
    "total": 37765
  },
  {
    "id": "ledger-2024-2026-929",
    "rowIndex": 929,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1803",
    "description": null,
    "qty": 20,
    "qtyKg": 2103.8,
    "price": 255,
    "total": 536469
  },
  {
    "id": "ledger-2024-2026-930",
    "rowIndex": 930,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP",
    "qty": 24,
    "qtyKg": null,
    "price": 1379,
    "total": 33096
  },
  {
    "id": "ledger-2024-2026-931",
    "rowIndex": 931,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HG HD A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1404,
    "total": 42120
  },
  {
    "id": "ledger-2024-2026-932",
    "rowIndex": 932,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1379,
    "total": 16548
  },
  {
    "id": "ledger-2024-2026-933",
    "rowIndex": 933,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1419,
    "total": 24123
  },
  {
    "id": "ledger-2024-2026-934",
    "rowIndex": 934,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Perez, Rufino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1419,
    "total": 70950
  },
  {
    "id": "ledger-2024-2026-935",
    "rowIndex": 935,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1419,
    "total": 24123
  },
  {
    "id": "ledger-2024-2026-936",
    "rowIndex": 936,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1801",
    "description": null,
    "qty": 1,
    "qtyKg": 100,
    "price": 255,
    "total": 25500
  },
  {
    "id": "ledger-2024-2026-937",
    "rowIndex": 937,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34867",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-938",
    "rowIndex": 938,
    "date": "2025-07-01",
    "rawDate": 45839,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34900",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1419,
    "total": 17028
  },
  {
    "id": "ledger-2024-2026-939",
    "rowIndex": 939,
    "date": "2025-07-02",
    "rawDate": 45840,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1804",
    "description": null,
    "qty": 25,
    "qtyKg": 2764.4,
    "price": 255,
    "total": 704922
  },
  {
    "id": "ledger-2024-2026-940",
    "rowIndex": 940,
    "date": "2025-07-02",
    "rawDate": 45840,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "34910",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-941",
    "rowIndex": 941,
    "date": "2025-07-03",
    "rawDate": 45841,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1805",
    "description": null,
    "qty": 7,
    "qtyKg": 447.00000000000006,
    "price": 175,
    "total": 78225.00000000001
  },
  {
    "id": "ledger-2024-2026-942",
    "rowIndex": 942,
    "date": "2025-07-03",
    "rawDate": 45841,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1805",
    "description": null,
    "qty": 3,
    "qtyKg": 199.39999999999998,
    "price": 175,
    "total": 34894.99999999999
  },
  {
    "id": "ledger-2024-2026-943",
    "rowIndex": 943,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35007",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1374,
    "total": 68700
  },
  {
    "id": "ledger-2024-2026-944",
    "rowIndex": 944,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1806",
    "description": null,
    "qty": 5,
    "qtyKg": 531.4,
    "price": 255,
    "total": 135507
  },
  {
    "id": "ledger-2024-2026-945",
    "rowIndex": 945,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1806",
    "description": null,
    "qty": 9,
    "qtyKg": 1008.1999999999998,
    "price": 255,
    "total": 257090.99999999994
  },
  {
    "id": "ledger-2024-2026-946",
    "rowIndex": 946,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1806",
    "description": null,
    "qty": 1,
    "qtyKg": 83.6,
    "price": 255,
    "total": 21318
  },
  {
    "id": "ledger-2024-2026-947",
    "rowIndex": 947,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35007",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-948",
    "rowIndex": 948,
    "date": "2025-07-04",
    "rawDate": 45842,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35008",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-949",
    "rowIndex": 949,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Richard S.",
    "description": "HG HD",
    "qty": 6.5,
    "qtyKg": null,
    "price": 1364,
    "total": 8866
  },
  {
    "id": "ledger-2024-2026-950",
    "rowIndex": 950,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Bernie C.",
    "description": null,
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-951",
    "rowIndex": 951,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Bernie C.",
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": 1374,
    "total": 2748
  },
  {
    "id": "ledger-2024-2026-952",
    "rowIndex": 952,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35089",
    "description": "HSP",
    "qty": 23,
    "qtyKg": null,
    "price": 1379,
    "total": 31717
  },
  {
    "id": "ledger-2024-2026-953",
    "rowIndex": 953,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35089",
    "description": "HSP",
    "qty": 33,
    "qtyKg": null,
    "price": 1379,
    "total": 45507
  },
  {
    "id": "ledger-2024-2026-954",
    "rowIndex": 954,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35090",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1379,
    "total": 68950
  },
  {
    "id": "ledger-2024-2026-955",
    "rowIndex": 955,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Richard S.",
    "description": "HG HD",
    "qty": -1,
    "qtyKg": null,
    "price": 1364,
    "total": -1364
  },
  {
    "id": "ledger-2024-2026-956",
    "rowIndex": 956,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ailene",
    "description": "HG HD",
    "qty": -10,
    "qtyKg": null,
    "price": 1364,
    "total": -13640
  },
  {
    "id": "ledger-2024-2026-957",
    "rowIndex": 957,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ailene",
    "description": "HG HD VR",
    "qty": -2,
    "qtyKg": null,
    "price": 1374,
    "total": -2748
  },
  {
    "id": "ledger-2024-2026-958",
    "rowIndex": 958,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35089",
    "description": "HSP",
    "qty": 29,
    "qtyKg": null,
    "price": 1379,
    "total": 39991
  },
  {
    "id": "ledger-2024-2026-959",
    "rowIndex": 959,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35089",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-960",
    "rowIndex": 960,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35090",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-961",
    "rowIndex": 961,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35090",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1419,
    "total": 70950
  },
  {
    "id": "ledger-2024-2026-962",
    "rowIndex": 962,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35090",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-963",
    "rowIndex": 963,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35090",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-964",
    "rowIndex": 964,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Bernie C.",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1364,
    "total": 1364
  },
  {
    "id": "ledger-2024-2026-965",
    "rowIndex": 965,
    "date": "2025-07-07",
    "rawDate": 45845,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ailyn M.",
    "description": "HG HD",
    "qty": -6.5,
    "qtyKg": null,
    "price": 1364,
    "total": -8866
  },
  {
    "id": "ledger-2024-2026-966",
    "rowIndex": 966,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HSP",
    "qty": 13,
    "qtyKg": null,
    "price": 1379,
    "total": 17927
  },
  {
    "id": "ledger-2024-2026-967",
    "rowIndex": 967,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1364,
    "total": 40920
  },
  {
    "id": "ledger-2024-2026-968",
    "rowIndex": 968,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1364,
    "total": 54560
  },
  {
    "id": "ledger-2024-2026-969",
    "rowIndex": 969,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1379,
    "total": 13790
  },
  {
    "id": "ledger-2024-2026-970",
    "rowIndex": 970,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-971",
    "rowIndex": 971,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HSP",
    "qty": 16,
    "qtyKg": null,
    "price": 1379,
    "total": 22064
  },
  {
    "id": "ledger-2024-2026-972",
    "rowIndex": 972,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1419,
    "total": 8514
  },
  {
    "id": "ledger-2024-2026-973",
    "rowIndex": 973,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1364,
    "total": 2728
  },
  {
    "id": "ledger-2024-2026-974",
    "rowIndex": 974,
    "date": "2025-07-09",
    "rawDate": 45847,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35151",
    "description": "HG HD A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1404,
    "total": 18252
  },
  {
    "id": "ledger-2024-2026-975",
    "rowIndex": 975,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35228",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1374,
    "total": 54960
  },
  {
    "id": "ledger-2024-2026-976",
    "rowIndex": 976,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1807",
    "description": null,
    "qty": 8,
    "qtyKg": 850.2,
    "price": 245,
    "total": 208299
  },
  {
    "id": "ledger-2024-2026-977",
    "rowIndex": 977,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1808",
    "description": null,
    "qty": 6,
    "qtyKg": 627.9999999999999,
    "price": 250,
    "total": 156999.99999999997
  },
  {
    "id": "ledger-2024-2026-978",
    "rowIndex": 978,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1808",
    "description": null,
    "qty": 1,
    "qtyKg": 72,
    "price": 230,
    "total": 16560
  },
  {
    "id": "ledger-2024-2026-979",
    "rowIndex": 979,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1809",
    "description": null,
    "qty": 4,
    "qtyKg": 384.8,
    "price": 250,
    "total": 96200
  },
  {
    "id": "ledger-2024-2026-980",
    "rowIndex": 980,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1808",
    "description": null,
    "qty": 1,
    "qtyKg": 88.6,
    "price": 250,
    "total": 22150
  },
  {
    "id": "ledger-2024-2026-981",
    "rowIndex": 981,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1807",
    "description": null,
    "qty": 6,
    "qtyKg": 586.4,
    "price": 245,
    "total": 143668
  },
  {
    "id": "ledger-2024-2026-982",
    "rowIndex": 982,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1808",
    "description": null,
    "qty": 2,
    "qtyKg": 174.8,
    "price": 250,
    "total": 43700
  },
  {
    "id": "ledger-2024-2026-983",
    "rowIndex": 983,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1809",
    "description": null,
    "qty": 1,
    "qtyKg": 87.8,
    "price": 250,
    "total": 21950
  },
  {
    "id": "ledger-2024-2026-984",
    "rowIndex": 984,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1807",
    "description": null,
    "qty": 6,
    "qtyKg": 628.8,
    "price": 245,
    "total": 154056
  },
  {
    "id": "ledger-2024-2026-985",
    "rowIndex": 985,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1808",
    "description": null,
    "qty": 7,
    "qtyKg": 684.8000000000001,
    "price": 250,
    "total": 171200.00000000003
  },
  {
    "id": "ledger-2024-2026-986",
    "rowIndex": 986,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1809",
    "description": null,
    "qty": 3,
    "qtyKg": 295.79999999999995,
    "price": 250,
    "total": 73949.99999999999
  },
  {
    "id": "ledger-2024-2026-987",
    "rowIndex": 987,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35228",
    "description": "HG HD",
    "qty": 25,
    "qtyKg": null,
    "price": 1364,
    "total": 34100
  },
  {
    "id": "ledger-2024-2026-988",
    "rowIndex": 988,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35228",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-989",
    "rowIndex": 989,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35228",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1419,
    "total": 70950
  },
  {
    "id": "ledger-2024-2026-990",
    "rowIndex": 990,
    "date": "2025-07-10",
    "rawDate": 45848,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35228",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1374,
    "total": 41220
  },
  {
    "id": "ledger-2024-2026-991",
    "rowIndex": 991,
    "date": "2025-07-11",
    "rawDate": 45849,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1811",
    "description": null,
    "qty": 20,
    "qtyKg": 2137.8,
    "price": 245,
    "total": 523761.00000000006
  },
  {
    "id": "ledger-2024-2026-992",
    "rowIndex": 992,
    "date": "2025-07-11",
    "rawDate": 45849,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1810",
    "description": null,
    "qty": 14,
    "qtyKg": 1432.2,
    "price": 245,
    "total": 350889
  },
  {
    "id": "ledger-2024-2026-993",
    "rowIndex": 993,
    "date": "2025-07-11",
    "rawDate": 45849,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1811",
    "description": null,
    "qty": 10,
    "qtyKg": 1084.8,
    "price": 245,
    "total": 265776
  },
  {
    "id": "ledger-2024-2026-994",
    "rowIndex": 994,
    "date": "2025-07-12",
    "rawDate": 45850,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1812",
    "description": null,
    "qty": 10,
    "qtyKg": 1142.8000000000002,
    "price": 245,
    "total": 279986.00000000006
  },
  {
    "id": "ledger-2024-2026-995",
    "rowIndex": 995,
    "date": "2025-07-12",
    "rawDate": 45850,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1812",
    "description": null,
    "qty": 1,
    "qtyKg": 91.6,
    "price": 245,
    "total": 22442
  },
  {
    "id": "ledger-2024-2026-996",
    "rowIndex": 996,
    "date": "2025-07-12",
    "rawDate": 45850,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1812",
    "description": null,
    "qty": 14,
    "qtyKg": 1508.8000000000002,
    "price": 245,
    "total": 369656.00000000006
  },
  {
    "id": "ledger-2024-2026-997",
    "rowIndex": 997,
    "date": "2025-07-14",
    "rawDate": 45852,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35354",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-998",
    "rowIndex": 998,
    "date": "2025-07-14",
    "rawDate": 45852,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35354",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-999",
    "rowIndex": 999,
    "date": "2025-07-14",
    "rawDate": 45852,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35354",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1000",
    "rowIndex": 1000,
    "date": "2025-07-14",
    "rawDate": 45852,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 10000,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-1001",
    "rowIndex": 1001,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1002",
    "rowIndex": 1002,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HG HD A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1404,
    "total": 19656
  },
  {
    "id": "ledger-2024-2026-1003",
    "rowIndex": 1003,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1419,
    "total": 42570
  },
  {
    "id": "ledger-2024-2026-1004",
    "rowIndex": 1004,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HG HD A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1404,
    "total": 28080
  },
  {
    "id": "ledger-2024-2026-1005",
    "rowIndex": 1005,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1813",
    "description": null,
    "qty": 1,
    "qtyKg": 84.6,
    "price": 240,
    "total": 20304
  },
  {
    "id": "ledger-2024-2026-1006",
    "rowIndex": 1006,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1813",
    "description": null,
    "qty": 19,
    "qtyKg": 1876.8000000000002,
    "price": 240,
    "total": 450432.00000000006
  },
  {
    "id": "ledger-2024-2026-1007",
    "rowIndex": 1007,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1008",
    "rowIndex": 1008,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HG HD A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1404,
    "total": 23868
  },
  {
    "id": "ledger-2024-2026-1009",
    "rowIndex": 1009,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1010",
    "rowIndex": 1010,
    "date": "2025-07-15",
    "rawDate": 45853,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35400",
    "description": "HG HD A2",
    "qty": 9,
    "qtyKg": null,
    "price": 1404,
    "total": 12636
  },
  {
    "id": "ledger-2024-2026-1011",
    "rowIndex": 1011,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1364,
    "total": 54560
  },
  {
    "id": "ledger-2024-2026-1012",
    "rowIndex": 1012,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1013",
    "rowIndex": 1013,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-1014",
    "rowIndex": 1014,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35447",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1379,
    "total": 55160
  },
  {
    "id": "ledger-2024-2026-1015",
    "rowIndex": 1015,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 276,
    "qtyKg": null,
    "price": 50,
    "total": 13800
  },
  {
    "id": "ledger-2024-2026-1016",
    "rowIndex": 1016,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 276,
    "qtyKg": null,
    "price": 2.5,
    "total": 690
  },
  {
    "id": "ledger-2024-2026-1017",
    "rowIndex": 1017,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 49,
    "qtyKg": null,
    "price": 100,
    "total": 4900
  },
  {
    "id": "ledger-2024-2026-1018",
    "rowIndex": 1018,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 49,
    "qtyKg": null,
    "price": 200,
    "total": 9800
  },
  {
    "id": "ledger-2024-2026-1019",
    "rowIndex": 1019,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 500,
    "total": 25000
  },
  {
    "id": "ledger-2024-2026-1020",
    "rowIndex": 1020,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Amie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1021",
    "rowIndex": 1021,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1900,
    "total": 1900
  },
  {
    "id": "ledger-2024-2026-1022",
    "rowIndex": 1022,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1503,
    "total": 1503
  },
  {
    "id": "ledger-2024-2026-1023",
    "rowIndex": 1023,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 462,
    "qtyKg": null,
    "price": 50,
    "total": 23100
  },
  {
    "id": "ledger-2024-2026-1024",
    "rowIndex": 1024,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 462,
    "qtyKg": null,
    "price": 2.5,
    "total": 1155
  },
  {
    "id": "ledger-2024-2026-1025",
    "rowIndex": 1025,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 79,
    "qtyKg": null,
    "price": 100,
    "total": 7900
  },
  {
    "id": "ledger-2024-2026-1026",
    "rowIndex": 1026,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 79,
    "qtyKg": null,
    "price": 200,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-1027",
    "rowIndex": 1027,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 500,
    "total": 40000
  },
  {
    "id": "ledger-2024-2026-1028",
    "rowIndex": 1028,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Coliat, Bernie",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1029",
    "rowIndex": 1029,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1419,
    "total": 24123
  },
  {
    "id": "ledger-2024-2026-1030",
    "rowIndex": 1030,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-1031",
    "rowIndex": 1031,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1032",
    "rowIndex": 1032,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1033",
    "rowIndex": 1033,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1034",
    "rowIndex": 1034,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1419,
    "total": 25542
  },
  {
    "id": "ledger-2024-2026-1035",
    "rowIndex": 1035,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35445",
    "description": "HSP VI",
    "qty": 65,
    "qtyKg": null,
    "price": 1434,
    "total": 93210
  },
  {
    "id": "ledger-2024-2026-1036",
    "rowIndex": 1036,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1037",
    "rowIndex": 1037,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 50,
    "total": 8750
  },
  {
    "id": "ledger-2024-2026-1038",
    "rowIndex": 1038,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 2.5,
    "total": 437.5
  },
  {
    "id": "ledger-2024-2026-1039",
    "rowIndex": 1039,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 39,
    "qtyKg": null,
    "price": 100,
    "total": 3900
  },
  {
    "id": "ledger-2024-2026-1040",
    "rowIndex": 1040,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 39,
    "qtyKg": null,
    "price": 200,
    "total": 7800
  },
  {
    "id": "ledger-2024-2026-1041",
    "rowIndex": 1041,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 500,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-1042",
    "rowIndex": 1042,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Salvacion, Richard",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1043",
    "rowIndex": 1043,
    "date": "2025-07-16",
    "rawDate": 45854,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35446",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1044",
    "rowIndex": 1044,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35555",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1045",
    "rowIndex": 1045,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35555",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1046",
    "rowIndex": 1046,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35555",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1047",
    "rowIndex": 1047,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35555",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1048",
    "rowIndex": 1048,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1814",
    "description": null,
    "qty": 14,
    "qtyKg": 1480.8,
    "price": 240,
    "total": 355392
  },
  {
    "id": "ledger-2024-2026-1049",
    "rowIndex": 1049,
    "date": "2025-07-18",
    "rawDate": 45856,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1814",
    "description": null,
    "qty": 1,
    "qtyKg": 112,
    "price": 230,
    "total": 25760
  },
  {
    "id": "ledger-2024-2026-1050",
    "rowIndex": 1050,
    "date": "2025-07-19",
    "rawDate": 45857,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1815",
    "description": null,
    "qty": 20,
    "qtyKg": 2091.6,
    "price": 240,
    "total": 501984
  },
  {
    "id": "ledger-2024-2026-1051",
    "rowIndex": 1051,
    "date": "2025-07-21",
    "rawDate": 45859,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 8750,
    "total": 8750
  },
  {
    "id": "ledger-2024-2026-1052",
    "rowIndex": 1052,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1364,
    "total": 54560
  },
  {
    "id": "ledger-2024-2026-1053",
    "rowIndex": 1053,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1054",
    "rowIndex": 1054,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HG HD A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1404,
    "total": 35100
  },
  {
    "id": "ledger-2024-2026-1055",
    "rowIndex": 1055,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1449,
    "total": 28980
  },
  {
    "id": "ledger-2024-2026-1056",
    "rowIndex": 1056,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1057",
    "rowIndex": 1057,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35671",
    "description": "HSP VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1449,
    "total": 36225
  },
  {
    "id": "ledger-2024-2026-1058",
    "rowIndex": 1058,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35671",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1374,
    "total": 41220
  },
  {
    "id": "ledger-2024-2026-1059",
    "rowIndex": 1059,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35671",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-1060",
    "rowIndex": 1060,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35671",
    "description": "HSP A2",
    "qty": 80,
    "qtyKg": null,
    "price": 1419,
    "total": 113520
  },
  {
    "id": "ledger-2024-2026-1061",
    "rowIndex": 1061,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1379,
    "total": 27580
  },
  {
    "id": "ledger-2024-2026-1062",
    "rowIndex": 1062,
    "date": "2025-07-22",
    "rawDate": 45860,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35694",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1063",
    "rowIndex": 1063,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1816",
    "description": null,
    "qty": 5,
    "qtyKg": 584.2,
    "price": 225,
    "total": 131445
  },
  {
    "id": "ledger-2024-2026-1064",
    "rowIndex": 1064,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1817",
    "description": null,
    "qty": 14,
    "qtyKg": 1299.6,
    "price": 235,
    "total": 305406
  },
  {
    "id": "ledger-2024-2026-1065",
    "rowIndex": 1065,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1817",
    "description": null,
    "qty": 1,
    "qtyKg": 68.2,
    "price": 215,
    "total": 14663
  },
  {
    "id": "ledger-2024-2026-1066",
    "rowIndex": 1066,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1818",
    "description": null,
    "qty": 4,
    "qtyKg": 403.6,
    "price": 235,
    "total": 94846
  },
  {
    "id": "ledger-2024-2026-1067",
    "rowIndex": 1067,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1818",
    "description": null,
    "qty": 1,
    "qtyKg": 75.6,
    "price": 225,
    "total": 17010
  },
  {
    "id": "ledger-2024-2026-1068",
    "rowIndex": 1068,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35752",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1069",
    "rowIndex": 1069,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35752",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-1070",
    "rowIndex": 1070,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35752",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1071",
    "rowIndex": 1071,
    "date": "2025-07-24",
    "rawDate": 45862,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1816",
    "description": null,
    "qty": 18,
    "qtyKg": 1995.6,
    "price": 225,
    "total": 449010
  },
  {
    "id": "ledger-2024-2026-1072",
    "rowIndex": 1072,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1821",
    "description": null,
    "qty": 26,
    "qtyKg": 2730.2000000000003,
    "price": 230,
    "total": 627946.0000000001
  },
  {
    "id": "ledger-2024-2026-1073",
    "rowIndex": 1073,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35814",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-1074",
    "rowIndex": 1074,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35814",
    "description": "HG HD",
    "qty": 16,
    "qtyKg": null,
    "price": 1364,
    "total": 21824
  },
  {
    "id": "ledger-2024-2026-1075",
    "rowIndex": 1075,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1819",
    "description": null,
    "qty": 9,
    "qtyKg": 894.0000000000001,
    "price": 230,
    "total": 205620.00000000003
  },
  {
    "id": "ledger-2024-2026-1076",
    "rowIndex": 1076,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1821",
    "description": null,
    "qty": 1,
    "qtyKg": 60,
    "price": 175,
    "total": 10500
  },
  {
    "id": "ledger-2024-2026-1077",
    "rowIndex": 1077,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1819",
    "description": null,
    "qty": 6,
    "qtyKg": 623.4,
    "price": 230,
    "total": 143382
  },
  {
    "id": "ledger-2024-2026-1078",
    "rowIndex": 1078,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35814",
    "description": "HG HD",
    "qty": 19,
    "qtyKg": null,
    "price": 1364,
    "total": 25916
  },
  {
    "id": "ledger-2024-2026-1079",
    "rowIndex": 1079,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35814",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1364,
    "total": 8184
  },
  {
    "id": "ledger-2024-2026-1080",
    "rowIndex": 1080,
    "date": "2025-07-25",
    "rawDate": 45863,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1820",
    "description": null,
    "qty": 15,
    "qtyKg": 1555.6,
    "price": 220,
    "total": 342232
  },
  {
    "id": "ledger-2024-2026-1081",
    "rowIndex": 1081,
    "date": "2025-07-26",
    "rawDate": 45864,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1822",
    "description": null,
    "qty": 25,
    "qtyKg": 2676.8,
    "price": 235,
    "total": 629048
  },
  {
    "id": "ledger-2024-2026-1082",
    "rowIndex": 1082,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1083",
    "rowIndex": 1083,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1084",
    "rowIndex": 1084,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HG HD A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1404,
    "total": 9828
  },
  {
    "id": "ledger-2024-2026-1085",
    "rowIndex": 1085,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1419,
    "total": 4257
  },
  {
    "id": "ledger-2024-2026-1086",
    "rowIndex": 1086,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HG HD A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1404,
    "total": 7020
  },
  {
    "id": "ledger-2024-2026-1087",
    "rowIndex": 1087,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HSP A2",
    "qty": 71,
    "qtyKg": null,
    "price": 1419,
    "total": 100749
  },
  {
    "id": "ledger-2024-2026-1088",
    "rowIndex": 1088,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1419,
    "total": 19866
  },
  {
    "id": "ledger-2024-2026-1089",
    "rowIndex": 1089,
    "date": "2025-07-28",
    "rawDate": 45866,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35901",
    "description": "HG HD A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1404,
    "total": 21060
  },
  {
    "id": "ledger-2024-2026-1090",
    "rowIndex": 1090,
    "date": "2025-07-29",
    "rawDate": 45867,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1823",
    "description": null,
    "qty": 18,
    "qtyKg": 1953.4,
    "price": 230,
    "total": 449282
  },
  {
    "id": "ledger-2024-2026-1091",
    "rowIndex": 1091,
    "date": "2025-07-29",
    "rawDate": 45867,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35964",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1364,
    "total": 68200
  },
  {
    "id": "ledger-2024-2026-1092",
    "rowIndex": 1092,
    "date": "2025-07-29",
    "rawDate": 45867,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35964",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1093",
    "rowIndex": 1093,
    "date": "2025-07-29",
    "rawDate": 45867,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35964",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1094",
    "rowIndex": 1094,
    "date": "2025-07-29",
    "rawDate": 45867,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35964",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1095",
    "rowIndex": 1095,
    "date": "2025-07-30",
    "rawDate": 45868,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35982",
    "description": "HG HD",
    "qty": 28,
    "qtyKg": null,
    "price": 1364,
    "total": 38192
  },
  {
    "id": "ledger-2024-2026-1096",
    "rowIndex": 1096,
    "date": "2025-07-30",
    "rawDate": 45868,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35982",
    "description": "HG HD",
    "qty": 41,
    "qtyKg": null,
    "price": 1364,
    "total": 55924
  },
  {
    "id": "ledger-2024-2026-1097",
    "rowIndex": 1097,
    "date": "2025-07-30",
    "rawDate": 45868,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35982",
    "description": "HG HD",
    "qty": 37,
    "qtyKg": null,
    "price": 1364,
    "total": 50468
  },
  {
    "id": "ledger-2024-2026-1098",
    "rowIndex": 1098,
    "date": "2025-07-30",
    "rawDate": 45868,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35982",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1099",
    "rowIndex": 1099,
    "date": "2025-07-30",
    "rawDate": 45868,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "35982",
    "description": "HSP A2",
    "qty": 24,
    "qtyKg": null,
    "price": 1419,
    "total": 34056
  },
  {
    "id": "ledger-2024-2026-1100",
    "rowIndex": 1100,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 174,
    "qtyKg": null,
    "price": 50,
    "total": 8700
  },
  {
    "id": "ledger-2024-2026-1101",
    "rowIndex": 1101,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 174,
    "qtyKg": null,
    "price": 2.5,
    "total": 435
  },
  {
    "id": "ledger-2024-2026-1102",
    "rowIndex": 1102,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 100,
    "total": 3500
  },
  {
    "id": "ledger-2024-2026-1103",
    "rowIndex": 1103,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 200,
    "total": 7000
  },
  {
    "id": "ledger-2024-2026-1104",
    "rowIndex": 1104,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 500,
    "total": 17500
  },
  {
    "id": "ledger-2024-2026-1105",
    "rowIndex": 1105,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 0,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1106",
    "rowIndex": 1106,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1824",
    "description": null,
    "qty": 13,
    "qtyKg": 1210,
    "price": 230,
    "total": 278300
  },
  {
    "id": "ledger-2024-2026-1107",
    "rowIndex": 1107,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1824",
    "description": null,
    "qty": 3,
    "qtyKg": 325,
    "price": 220,
    "total": 71500
  },
  {
    "id": "ledger-2024-2026-1108",
    "rowIndex": 1108,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1825",
    "description": null,
    "qty": 3,
    "qtyKg": 289,
    "price": 230,
    "total": 66470
  },
  {
    "id": "ledger-2024-2026-1109",
    "rowIndex": 1109,
    "date": "2025-07-31",
    "rawDate": 45869,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1825",
    "description": null,
    "qty": 1,
    "qtyKg": 112,
    "price": 220,
    "total": 24640
  },
  {
    "id": "ledger-2024-2026-1110",
    "rowIndex": 1110,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HG HD A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1404,
    "total": 23868
  },
  {
    "id": "ledger-2024-2026-1111",
    "rowIndex": 1111,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HG HD VR",
    "qty": 23,
    "qtyKg": null,
    "price": 1374,
    "total": 31602
  },
  {
    "id": "ledger-2024-2026-1112",
    "rowIndex": 1112,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1113",
    "rowIndex": 1113,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1374,
    "total": 24732
  },
  {
    "id": "ledger-2024-2026-1114",
    "rowIndex": 1114,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HG HD A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1404,
    "total": 16848
  },
  {
    "id": "ledger-2024-2026-1115",
    "rowIndex": 1115,
    "date": "2025-08-01",
    "rawDate": 45870,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36087",
    "description": "HSP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1419,
    "total": 85140
  },
  {
    "id": "ledger-2024-2026-1116",
    "rowIndex": 1116,
    "date": "2025-08-02",
    "rawDate": 45871,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1826",
    "description": null,
    "qty": 12,
    "qtyKg": 1310,
    "price": 225,
    "total": 294750
  },
  {
    "id": "ledger-2024-2026-1117",
    "rowIndex": 1117,
    "date": "2025-08-02",
    "rawDate": 45871,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1827",
    "description": null,
    "qty": 25,
    "qtyKg": 2430.8,
    "price": 225,
    "total": 546930
  },
  {
    "id": "ledger-2024-2026-1118",
    "rowIndex": 1118,
    "date": "2025-08-02",
    "rawDate": 45871,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 8000,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-1119",
    "rowIndex": 1119,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36227",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1374,
    "total": 24732
  },
  {
    "id": "ledger-2024-2026-1120",
    "rowIndex": 1120,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36231",
    "description": "HG HD VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1474,
    "total": 36850
  },
  {
    "id": "ledger-2024-2026-1121",
    "rowIndex": 1121,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36227",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-1122",
    "rowIndex": 1122,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36226",
    "description": "HG HD A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1404,
    "total": 14040
  },
  {
    "id": "ledger-2024-2026-1123",
    "rowIndex": 1123,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36226",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1124",
    "rowIndex": 1124,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36227",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-1125",
    "rowIndex": 1125,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36226",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1374,
    "total": 41220
  },
  {
    "id": "ledger-2024-2026-1126",
    "rowIndex": 1126,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36227",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1127",
    "rowIndex": 1127,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36231",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1128",
    "rowIndex": 1128,
    "date": "2025-08-05",
    "rawDate": 45874,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36226",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-1129",
    "rowIndex": 1129,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HG HD VAS",
    "qty": 35,
    "qtyKg": null,
    "price": 1474,
    "total": 51590
  },
  {
    "id": "ledger-2024-2026-1130",
    "rowIndex": 1130,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1419,
    "total": 24123
  },
  {
    "id": "ledger-2024-2026-1131",
    "rowIndex": 1131,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1374,
    "total": 10992
  },
  {
    "id": "ledger-2024-2026-1132",
    "rowIndex": 1132,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1374,
    "total": 10992
  },
  {
    "id": "ledger-2024-2026-1133",
    "rowIndex": 1133,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-1134",
    "rowIndex": 1134,
    "date": "2025-08-07",
    "rawDate": 45876,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36329",
    "description": "HSP A2",
    "qty": 75,
    "qtyKg": null,
    "price": 1419,
    "total": 106425
  },
  {
    "id": "ledger-2024-2026-1135",
    "rowIndex": 1135,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1828",
    "description": null,
    "qty": 14,
    "qtyKg": 1460.6,
    "price": 215,
    "total": 314029
  },
  {
    "id": "ledger-2024-2026-1136",
    "rowIndex": 1136,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1137",
    "rowIndex": 1137,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1374,
    "total": 10992
  },
  {
    "id": "ledger-2024-2026-1138",
    "rowIndex": 1138,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1139",
    "rowIndex": 1139,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1374,
    "total": 17862
  },
  {
    "id": "ledger-2024-2026-1140",
    "rowIndex": 1140,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36386",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1141",
    "rowIndex": 1141,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36386",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-1142",
    "rowIndex": 1142,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36386",
    "description": "HG HD VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1434,
    "total": 28680
  },
  {
    "id": "ledger-2024-2026-1143",
    "rowIndex": 1143,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1364,
    "total": 16368
  },
  {
    "id": "ledger-2024-2026-1144",
    "rowIndex": 1144,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1145",
    "rowIndex": 1145,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36386",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1374,
    "total": 27480
  },
  {
    "id": "ledger-2024-2026-1146",
    "rowIndex": 1146,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-1147",
    "rowIndex": 1147,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36385",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-1148",
    "rowIndex": 1148,
    "date": "2025-08-08",
    "rawDate": 45877,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1828",
    "description": null,
    "qty": 1,
    "qtyKg": 105,
    "price": 215,
    "total": 22575
  },
  {
    "id": "ledger-2024-2026-1149",
    "rowIndex": 1149,
    "date": "2025-08-09",
    "rawDate": 45878,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1829",
    "description": null,
    "qty": 21,
    "qtyKg": 2156.2000000000003,
    "price": 215,
    "total": 463583.00000000006
  },
  {
    "id": "ledger-2024-2026-1150",
    "rowIndex": 1150,
    "date": "2025-08-09",
    "rawDate": 45878,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1829",
    "description": null,
    "qty": 2,
    "qtyKg": 206,
    "price": 215,
    "total": 44290
  },
  {
    "id": "ledger-2024-2026-1151",
    "rowIndex": 1151,
    "date": "2025-08-11",
    "rawDate": 45880,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1830",
    "description": null,
    "qty": 5,
    "qtyKg": 478,
    "price": 210,
    "total": 100380
  },
  {
    "id": "ledger-2024-2026-1152",
    "rowIndex": 1152,
    "date": "2025-08-11",
    "rawDate": 45880,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1830",
    "description": null,
    "qty": 17,
    "qtyKg": 1874.4,
    "price": 210,
    "total": 393624
  },
  {
    "id": "ledger-2024-2026-1153",
    "rowIndex": 1153,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1379,
    "total": 1379
  },
  {
    "id": "ledger-2024-2026-1154",
    "rowIndex": 1154,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HSP",
    "qty": 22,
    "qtyKg": null,
    "price": 1379,
    "total": 30338
  },
  {
    "id": "ledger-2024-2026-1155",
    "rowIndex": 1155,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36542",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1156",
    "rowIndex": 1156,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1157",
    "rowIndex": 1157,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1158",
    "rowIndex": 1158,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1159",
    "rowIndex": 1159,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HSP",
    "qty": 75,
    "qtyKg": null,
    "price": 1379,
    "total": 103425
  },
  {
    "id": "ledger-2024-2026-1160",
    "rowIndex": 1160,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HSP",
    "qty": 4,
    "qtyKg": null,
    "price": 1379,
    "total": 5516
  },
  {
    "id": "ledger-2024-2026-1161",
    "rowIndex": 1161,
    "date": "2025-08-12",
    "rawDate": 45881,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36543",
    "description": "HG HD",
    "qty": 3,
    "qtyKg": null,
    "price": 1364,
    "total": 4092
  },
  {
    "id": "ledger-2024-2026-1162",
    "rowIndex": 1162,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1374,
    "total": 9618
  },
  {
    "id": "ledger-2024-2026-1163",
    "rowIndex": 1163,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36552",
    "description": "HG HD VR",
    "qty": 26,
    "qtyKg": null,
    "price": 1374,
    "total": 35724
  },
  {
    "id": "ledger-2024-2026-1164",
    "rowIndex": 1164,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36552",
    "description": "HG HD VR",
    "qty": 38,
    "qtyKg": null,
    "price": 1374,
    "total": 52212
  },
  {
    "id": "ledger-2024-2026-1165",
    "rowIndex": 1165,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1364,
    "total": 40920
  },
  {
    "id": "ledger-2024-2026-1166",
    "rowIndex": 1166,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1167",
    "rowIndex": 1167,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HSP",
    "qty": 22,
    "qtyKg": null,
    "price": 1379,
    "total": 30338
  },
  {
    "id": "ledger-2024-2026-1168",
    "rowIndex": 1168,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1169",
    "rowIndex": 1169,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1374,
    "total": 41220
  },
  {
    "id": "ledger-2024-2026-1170",
    "rowIndex": 1170,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Andres S.",
    "description": "HG HD",
    "qty": -1,
    "qtyKg": null,
    "price": 1364,
    "total": -1364
  },
  {
    "id": "ledger-2024-2026-1171",
    "rowIndex": 1171,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Ismael D.",
    "description": "HG HD VR",
    "qty": 1,
    "qtyKg": null,
    "price": 1374,
    "total": 1374
  },
  {
    "id": "ledger-2024-2026-1172",
    "rowIndex": 1172,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ian D.",
    "description": "HG HD VR",
    "qty": -1,
    "qtyKg": null,
    "price": 1374,
    "total": -1374
  },
  {
    "id": "ledger-2024-2026-1173",
    "rowIndex": 1173,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36552",
    "description": "HG HD VR",
    "qty": 34,
    "qtyKg": null,
    "price": 1374,
    "total": 46716
  },
  {
    "id": "ledger-2024-2026-1174",
    "rowIndex": 1174,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36552",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1374,
    "total": 23358
  },
  {
    "id": "ledger-2024-2026-1175",
    "rowIndex": 1175,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1379,
    "total": 11032
  },
  {
    "id": "ledger-2024-2026-1176",
    "rowIndex": 1176,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1177",
    "rowIndex": 1177,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36553",
    "description": "HG HD VR",
    "qty": 3,
    "qtyKg": null,
    "price": 1374,
    "total": 4122
  },
  {
    "id": "ledger-2024-2026-1178",
    "rowIndex": 1178,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Ian D.",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1364,
    "total": 1364
  },
  {
    "id": "ledger-2024-2026-1179",
    "rowIndex": 1179,
    "date": "2025-08-13",
    "rawDate": 45882,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36552",
    "description": "HSP VTA 2",
    "qty": 35,
    "qtyKg": null,
    "price": 1419,
    "total": 49665
  },
  {
    "id": "ledger-2024-2026-1180",
    "rowIndex": 1180,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1831",
    "description": null,
    "qty": 14,
    "qtyKg": 1368.6,
    "price": 210,
    "total": 287406
  },
  {
    "id": "ledger-2024-2026-1181",
    "rowIndex": 1181,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1832",
    "description": null,
    "qty": 8,
    "qtyKg": 813.8,
    "price": 210,
    "total": 170898
  },
  {
    "id": "ledger-2024-2026-1182",
    "rowIndex": 1182,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36623",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1419,
    "total": 17028
  },
  {
    "id": "ledger-2024-2026-1183",
    "rowIndex": 1183,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36623",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1419,
    "total": 11352
  },
  {
    "id": "ledger-2024-2026-1184",
    "rowIndex": 1184,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "",
    "batch": "2025-02",
    "cycleCode": "2025-02",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36622",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1185",
    "rowIndex": 1185,
    "date": "2025-08-14",
    "rawDate": 45883,
    "raiser": "",
    "batch": "2025-02",
    "cycleCode": "2025-02",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36622",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1186",
    "rowIndex": 1186,
    "date": "2025-08-15",
    "rawDate": 45884,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": "1833",
    "description": null,
    "qty": 10,
    "qtyKg": 1042.6,
    "price": 210,
    "total": 218945.99999999997
  },
  {
    "id": "ledger-2024-2026-1187",
    "rowIndex": 1187,
    "date": "2025-08-15",
    "rawDate": 45884,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1833",
    "description": null,
    "qty": 5,
    "qtyKg": 554.4000000000001,
    "price": 210,
    "total": 116424.00000000001
  },
  {
    "id": "ledger-2024-2026-1188",
    "rowIndex": 1188,
    "date": "2025-08-16",
    "rawDate": 45885,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": "1834",
    "description": null,
    "qty": 21,
    "qtyKg": 2207.6,
    "price": 210,
    "total": 463596
  },
  {
    "id": "ledger-2024-2026-1189",
    "rowIndex": 1189,
    "date": "2025-08-16",
    "rawDate": 45885,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1834",
    "description": null,
    "qty": 4,
    "qtyKg": 413.80000000000007,
    "price": 210,
    "total": 86898.00000000001
  },
  {
    "id": "ledger-2024-2026-1190",
    "rowIndex": 1190,
    "date": "2025-08-18",
    "rawDate": 45887,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36733",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1191",
    "rowIndex": 1191,
    "date": "2025-08-18",
    "rawDate": 45887,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36733",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1192",
    "rowIndex": 1192,
    "date": "2025-08-18",
    "rawDate": 45887,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36733",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1193",
    "rowIndex": 1193,
    "date": "2025-08-18",
    "rawDate": 45887,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36733",
    "description": "HSP A2",
    "qty": 85,
    "qtyKg": null,
    "price": 1419,
    "total": 120615
  },
  {
    "id": "ledger-2024-2026-1194",
    "rowIndex": 1194,
    "date": "2025-08-19",
    "rawDate": 45888,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36807",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1364,
    "total": 40920
  },
  {
    "id": "ledger-2024-2026-1195",
    "rowIndex": 1195,
    "date": "2025-08-19",
    "rawDate": 45888,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36807",
    "description": "HG HD VR",
    "qty": 45,
    "qtyKg": null,
    "price": 1374,
    "total": 61830
  },
  {
    "id": "ledger-2024-2026-1196",
    "rowIndex": 1196,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36845",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1197",
    "rowIndex": 1197,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1198",
    "rowIndex": 1198,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-1199",
    "rowIndex": 1199,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1200",
    "rowIndex": 1200,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1384,
    "total": 20760
  },
  {
    "id": "ledger-2024-2026-1201",
    "rowIndex": 1201,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36845",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-1202",
    "rowIndex": 1202,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36845",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1203",
    "rowIndex": 1203,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1204",
    "rowIndex": 1204,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1205",
    "rowIndex": 1205,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1419,
    "total": 5676
  },
  {
    "id": "ledger-2024-2026-1206",
    "rowIndex": 1206,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1419,
    "total": 5676
  },
  {
    "id": "ledger-2024-2026-1207",
    "rowIndex": 1207,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1208",
    "rowIndex": 1208,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1374,
    "total": 6870
  },
  {
    "id": "ledger-2024-2026-1209",
    "rowIndex": 1209,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36845",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1379,
    "total": 6895
  },
  {
    "id": "ledger-2024-2026-1210",
    "rowIndex": 1210,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36845",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1364,
    "total": 27280
  },
  {
    "id": "ledger-2024-2026-1211",
    "rowIndex": 1211,
    "date": "2025-08-20",
    "rawDate": 45889,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "36844",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1419,
    "total": 9933
  },
  {
    "id": "ledger-2024-2026-1212",
    "rowIndex": 1212,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1213",
    "rowIndex": 1213,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ian D.",
    "description": "HG HD",
    "qty": -6,
    "qtyKg": null,
    "price": 1364,
    "total": -8184
  },
  {
    "id": "ledger-2024-2026-1214",
    "rowIndex": 1214,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 22,
    "qtyKg": 2330.4,
    "price": 205,
    "total": 477732
  },
  {
    "id": "ledger-2024-2026-1215",
    "rowIndex": 1215,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Danny D.",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1364,
    "total": 8184
  },
  {
    "id": "ledger-2024-2026-1216",
    "rowIndex": 1216,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HSP VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1217",
    "rowIndex": 1217,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1218",
    "rowIndex": 1218,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1219",
    "rowIndex": 1219,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1379,
    "total": 48265
  },
  {
    "id": "ledger-2024-2026-1220",
    "rowIndex": 1220,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37021",
    "description": "HG HD VAS",
    "qty": 45,
    "qtyKg": null,
    "price": 1404,
    "total": 63180
  },
  {
    "id": "ledger-2024-2026-1221",
    "rowIndex": 1221,
    "date": "2025-08-23",
    "rawDate": 45892,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 107.4,
    "price": 205,
    "total": 22017
  },
  {
    "id": "ledger-2024-2026-1222",
    "rowIndex": 1222,
    "date": "2025-08-25",
    "rawDate": 45894,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1836",
    "description": null,
    "qty": 15,
    "qtyKg": 1562.4,
    "price": 205,
    "total": 320292
  },
  {
    "id": "ledger-2024-2026-1223",
    "rowIndex": 1223,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1364,
    "total": 6820
  },
  {
    "id": "ledger-2024-2026-1224",
    "rowIndex": 1224,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1364,
    "total": 13640
  },
  {
    "id": "ledger-2024-2026-1225",
    "rowIndex": 1225,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1374,
    "total": 10992
  },
  {
    "id": "ledger-2024-2026-1226",
    "rowIndex": 1226,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1227",
    "rowIndex": 1227,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1374,
    "total": 19236
  },
  {
    "id": "ledger-2024-2026-1228",
    "rowIndex": 1228,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1379,
    "total": 2758
  },
  {
    "id": "ledger-2024-2026-1229",
    "rowIndex": 1229,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HSP",
    "qty": 16,
    "qtyKg": null,
    "price": 1379,
    "total": 22064
  },
  {
    "id": "ledger-2024-2026-1230",
    "rowIndex": 1230,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD",
    "qty": 14,
    "qtyKg": null,
    "price": 1364,
    "total": 19096
  },
  {
    "id": "ledger-2024-2026-1231",
    "rowIndex": 1231,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1374,
    "total": 17862
  },
  {
    "id": "ledger-2024-2026-1232",
    "rowIndex": 1232,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-1233",
    "rowIndex": 1233,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-1234",
    "rowIndex": 1234,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1364,
    "total": 9548
  },
  {
    "id": "ledger-2024-2026-1235",
    "rowIndex": 1235,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1374,
    "total": 9618
  },
  {
    "id": "ledger-2024-2026-1236",
    "rowIndex": 1236,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1374,
    "total": 13740
  },
  {
    "id": "ledger-2024-2026-1237",
    "rowIndex": 1237,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1238",
    "rowIndex": 1238,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37028",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1379,
    "total": 68950
  },
  {
    "id": "ledger-2024-2026-1239",
    "rowIndex": 1239,
    "date": "2025-08-26",
    "rawDate": 45895,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37046",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1379,
    "total": 9653
  },
  {
    "id": "ledger-2024-2026-1240",
    "rowIndex": 1240,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37134",
    "description": "HG HD VR",
    "qty": 75,
    "qtyKg": null,
    "price": 1374,
    "total": 103050
  },
  {
    "id": "ledger-2024-2026-1241",
    "rowIndex": 1241,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37134",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1379,
    "total": 41370
  },
  {
    "id": "ledger-2024-2026-1242",
    "rowIndex": 1242,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1837",
    "description": null,
    "qty": 15,
    "qtyKg": 1518.6,
    "price": 205,
    "total": 311313
  },
  {
    "id": "ledger-2024-2026-1243",
    "rowIndex": 1243,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1838",
    "description": null,
    "qty": 5,
    "qtyKg": 559.6,
    "price": 205,
    "total": 114718
  },
  {
    "id": "ledger-2024-2026-1244",
    "rowIndex": 1244,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1838",
    "description": null,
    "qty": 1,
    "qtyKg": 70,
    "price": 190,
    "total": 13300
  },
  {
    "id": "ledger-2024-2026-1245",
    "rowIndex": 1245,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37134",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1379,
    "total": 41370
  },
  {
    "id": "ledger-2024-2026-1246",
    "rowIndex": 1246,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37134",
    "description": "HG HD VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1404,
    "total": 21060
  },
  {
    "id": "ledger-2024-2026-1247",
    "rowIndex": 1247,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37133",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1374,
    "total": 20610
  },
  {
    "id": "ledger-2024-2026-1248",
    "rowIndex": 1248,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37133",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1374,
    "total": 34350
  },
  {
    "id": "ledger-2024-2026-1249",
    "rowIndex": 1249,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37133",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1364,
    "total": 20460
  },
  {
    "id": "ledger-2024-2026-1250",
    "rowIndex": 1250,
    "date": "2025-08-27",
    "rawDate": 45896,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37133",
    "description": "HG HD VAS",
    "qty": 95,
    "qtyKg": null,
    "price": 1404,
    "total": 133380
  },
  {
    "id": "ledger-2024-2026-1251",
    "rowIndex": 1251,
    "date": "2025-08-28",
    "rawDate": 45897,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1839",
    "description": null,
    "qty": 4,
    "qtyKg": 428,
    "price": 205,
    "total": 87740
  },
  {
    "id": "ledger-2024-2026-1252",
    "rowIndex": 1252,
    "date": "2025-08-28",
    "rawDate": 45897,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1839",
    "description": null,
    "qty": 3,
    "qtyKg": 327.6,
    "price": 205,
    "total": 67158
  },
  {
    "id": "ledger-2024-2026-1253",
    "rowIndex": 1253,
    "date": "2025-08-28",
    "rawDate": 45897,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1839",
    "description": null,
    "qty": 11,
    "qtyKg": 1158,
    "price": 205,
    "total": 237390
  },
  {
    "id": "ledger-2024-2026-1254",
    "rowIndex": 1254,
    "date": "2025-08-28",
    "rawDate": 45897,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37194",
    "description": "HSP VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1255",
    "rowIndex": 1255,
    "date": "2025-08-28",
    "rawDate": 45897,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1839",
    "description": null,
    "qty": 2,
    "qtyKg": 190,
    "price": 205,
    "total": 38950
  },
  {
    "id": "ledger-2024-2026-1256",
    "rowIndex": 1256,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 2850,
    "total": 2850
  },
  {
    "id": "ledger-2024-2026-1257",
    "rowIndex": 1257,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 6606,
    "total": 6606
  },
  {
    "id": "ledger-2024-2026-1258",
    "rowIndex": 1258,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 345,
    "qtyKg": null,
    "price": 50,
    "total": 17250
  },
  {
    "id": "ledger-2024-2026-1259",
    "rowIndex": 1259,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 345,
    "qtyKg": null,
    "price": 2.5,
    "total": 862.5
  },
  {
    "id": "ledger-2024-2026-1260",
    "rowIndex": 1260,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 64,
    "qtyKg": null,
    "price": 100,
    "total": 6400
  },
  {
    "id": "ledger-2024-2026-1261",
    "rowIndex": 1261,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 64,
    "qtyKg": null,
    "price": 200,
    "total": 12800
  },
  {
    "id": "ledger-2024-2026-1262",
    "rowIndex": 1262,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 500,
    "total": 35000
  },
  {
    "id": "ledger-2024-2026-1263",
    "rowIndex": 1263,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 6,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1264",
    "rowIndex": 1264,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 6320,
    "total": 6320
  },
  {
    "id": "ledger-2024-2026-1265",
    "rowIndex": 1265,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4188.5,
    "total": 4188.5
  },
  {
    "id": "ledger-2024-2026-1266",
    "rowIndex": 1266,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 495,
    "qtyKg": null,
    "price": 50,
    "total": 24750
  },
  {
    "id": "ledger-2024-2026-1267",
    "rowIndex": 1267,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 495,
    "qtyKg": null,
    "price": 2.5,
    "total": 1237.5
  },
  {
    "id": "ledger-2024-2026-1268",
    "rowIndex": 1268,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 94,
    "qtyKg": null,
    "price": 100,
    "total": 9400
  },
  {
    "id": "ledger-2024-2026-1269",
    "rowIndex": 1269,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 94,
    "qtyKg": null,
    "price": 200,
    "total": 18800
  },
  {
    "id": "ledger-2024-2026-1270",
    "rowIndex": 1270,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 500,
    "total": 52500
  },
  {
    "id": "ledger-2024-2026-1271",
    "rowIndex": 1271,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Dimaano, Ismael",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ismael",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 11,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1272",
    "rowIndex": 1272,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1840",
    "description": null,
    "qty": 25,
    "qtyKg": 2665,
    "price": 205,
    "total": 546325
  },
  {
    "id": "ledger-2024-2026-1273",
    "rowIndex": 1273,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 30000,
    "total": 30000
  },
  {
    "id": "ledger-2024-2026-1274",
    "rowIndex": 1274,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 3256,
    "total": 3256
  },
  {
    "id": "ledger-2024-2026-1275",
    "rowIndex": 1275,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 466,
    "qtyKg": null,
    "price": 50,
    "total": 23300
  },
  {
    "id": "ledger-2024-2026-1276",
    "rowIndex": 1276,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 466,
    "qtyKg": null,
    "price": 2.5,
    "total": 1165
  },
  {
    "id": "ledger-2024-2026-1277",
    "rowIndex": 1277,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 79,
    "qtyKg": null,
    "price": 100,
    "total": 7900
  },
  {
    "id": "ledger-2024-2026-1278",
    "rowIndex": 1278,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 79,
    "qtyKg": null,
    "price": 200,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-1279",
    "rowIndex": 1279,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 500,
    "total": 40000
  },
  {
    "id": "ledger-2024-2026-1280",
    "rowIndex": 1280,
    "date": "2025-08-30",
    "rawDate": 45899,
    "raiser": "Sibal, Andres",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1281",
    "rowIndex": 1281,
    "date": "2025-09-01",
    "rawDate": 45901,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 3,
    "qtyKg": 376.2,
    "price": 210,
    "total": 79002
  },
  {
    "id": "ledger-2024-2026-1282",
    "rowIndex": 1282,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1380,
    "total": 11040
  },
  {
    "id": "ledger-2024-2026-1283",
    "rowIndex": 1283,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Ian D.",
    "description": "HG HD VR",
    "qty": -2,
    "qtyKg": null,
    "price": 1380,
    "total": -2760
  },
  {
    "id": "ledger-2024-2026-1284",
    "rowIndex": 1284,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD",
    "qty": 11,
    "qtyKg": null,
    "price": 1370,
    "total": 15070
  },
  {
    "id": "ledger-2024-2026-1285",
    "rowIndex": 1285,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1380,
    "total": 13800
  },
  {
    "id": "ledger-2024-2026-1286",
    "rowIndex": 1286,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1370,
    "total": 20550
  },
  {
    "id": "ledger-2024-2026-1287",
    "rowIndex": 1287,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1380,
    "total": 20700
  },
  {
    "id": "ledger-2024-2026-1288",
    "rowIndex": 1288,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 16,
    "qtyKg": 1721.8,
    "price": 210,
    "total": 361578
  },
  {
    "id": "ledger-2024-2026-1289",
    "rowIndex": 1289,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1380,
    "total": 16560
  },
  {
    "id": "ledger-2024-2026-1290",
    "rowIndex": 1290,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Rodel A.",
    "description": "HG HD VR",
    "qty": 2,
    "qtyKg": 3525.8,
    "price": 210,
    "total": 740418
  },
  {
    "id": "ledger-2024-2026-1291",
    "rowIndex": 1291,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1370,
    "total": 20550
  },
  {
    "id": "ledger-2024-2026-1292",
    "rowIndex": 1292,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1380,
    "total": 19320
  },
  {
    "id": "ledger-2024-2026-1293",
    "rowIndex": 1293,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1294",
    "rowIndex": 1294,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1370,
    "total": 6850
  },
  {
    "id": "ledger-2024-2026-1295",
    "rowIndex": 1295,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1380,
    "total": 6900
  },
  {
    "id": "ledger-2024-2026-1296",
    "rowIndex": 1296,
    "date": "2025-09-02",
    "rawDate": 45902,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37393",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1380,
    "total": 41400
  },
  {
    "id": "ledger-2024-2026-1297",
    "rowIndex": 1297,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37442",
    "description": "HG HD VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1410,
    "total": 28200
  },
  {
    "id": "ledger-2024-2026-1298",
    "rowIndex": 1298,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Dimaano, Ruel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ruel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37442",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1299",
    "rowIndex": 1299,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37442",
    "description": "HG HD VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1410,
    "total": 28200
  },
  {
    "id": "ledger-2024-2026-1300",
    "rowIndex": 1300,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37441",
    "description": "HG HD",
    "qty": 55,
    "qtyKg": null,
    "price": 1370,
    "total": 75350
  },
  {
    "id": "ledger-2024-2026-1301",
    "rowIndex": 1301,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37442",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1370,
    "total": 6850
  },
  {
    "id": "ledger-2024-2026-1302",
    "rowIndex": 1302,
    "date": "2025-09-03",
    "rawDate": 45903,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37442",
    "description": "HG HD VR",
    "qty": 45,
    "qtyKg": null,
    "price": 1380,
    "total": 62100
  },
  {
    "id": "ledger-2024-2026-1303",
    "rowIndex": 1303,
    "date": "2025-09-05",
    "rawDate": 45905,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37576",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1370,
    "total": 27400
  },
  {
    "id": "ledger-2024-2026-1304",
    "rowIndex": 1304,
    "date": "2025-09-05",
    "rawDate": 45905,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37576",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1449,
    "total": 14490
  },
  {
    "id": "ledger-2024-2026-1305",
    "rowIndex": 1305,
    "date": "2025-09-05",
    "rawDate": 45905,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37575",
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1449,
    "total": 21735
  },
  {
    "id": "ledger-2024-2026-1306",
    "rowIndex": 1306,
    "date": "2025-09-05",
    "rawDate": 45905,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37575",
    "description": "HSP VI",
    "qty": 40,
    "qtyKg": null,
    "price": 1449,
    "total": 57960
  },
  {
    "id": "ledger-2024-2026-1307",
    "rowIndex": 1307,
    "date": "2025-09-05",
    "rawDate": 45905,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37576",
    "description": "HSP VI",
    "qty": 5,
    "qtyKg": null,
    "price": 1449,
    "total": 7245
  },
  {
    "id": "ledger-2024-2026-1308",
    "rowIndex": 1308,
    "date": "2025-09-06",
    "rawDate": 45906,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1842",
    "description": null,
    "qty": 28,
    "qtyKg": 3391.8,
    "price": 210,
    "total": 712278
  },
  {
    "id": "ledger-2024-2026-1309",
    "rowIndex": 1309,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1843",
    "description": null,
    "qty": 10,
    "qtyKg": 972.5999999999999,
    "price": 210,
    "total": 204245.99999999997
  },
  {
    "id": "ledger-2024-2026-1310",
    "rowIndex": 1310,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1844",
    "description": null,
    "qty": 1,
    "qtyKg": 45,
    "price": 200,
    "total": 9000
  },
  {
    "id": "ledger-2024-2026-1311",
    "rowIndex": 1311,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1844",
    "description": null,
    "qty": 5,
    "qtyKg": 616.4,
    "price": 210,
    "total": 129444
  },
  {
    "id": "ledger-2024-2026-1312",
    "rowIndex": 1312,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1845",
    "description": null,
    "qty": 11,
    "qtyKg": 1350.6000000000001,
    "price": 210,
    "total": 283626
  },
  {
    "id": "ledger-2024-2026-1313",
    "rowIndex": 1313,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37664",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1370,
    "total": 41100
  },
  {
    "id": "ledger-2024-2026-1314",
    "rowIndex": 1314,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37664",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1380,
    "total": 48300
  },
  {
    "id": "ledger-2024-2026-1315",
    "rowIndex": 1315,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1843",
    "description": null,
    "qty": 1,
    "qtyKg": 113,
    "price": 210,
    "total": 23730
  },
  {
    "id": "ledger-2024-2026-1316",
    "rowIndex": 1316,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1844",
    "description": null,
    "qty": 1,
    "qtyKg": 94.6,
    "price": 210,
    "total": 19866
  },
  {
    "id": "ledger-2024-2026-1317",
    "rowIndex": 1317,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1845",
    "description": null,
    "qty": 5,
    "qtyKg": 512.8,
    "price": 210,
    "total": 107687.99999999999
  },
  {
    "id": "ledger-2024-2026-1318",
    "rowIndex": 1318,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37664",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1380,
    "total": 6900
  },
  {
    "id": "ledger-2024-2026-1319",
    "rowIndex": 1319,
    "date": "2025-09-08",
    "rawDate": 45908,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37664",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1380,
    "total": 6900
  },
  {
    "id": "ledger-2024-2026-1320",
    "rowIndex": 1320,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37758",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1379,
    "total": 2758
  },
  {
    "id": "ledger-2024-2026-1321",
    "rowIndex": 1321,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37760",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1370,
    "total": 8220
  },
  {
    "id": "ledger-2024-2026-1322",
    "rowIndex": 1322,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Dimaano, Ruel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ruel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37760",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1419,
    "total": 5676
  },
  {
    "id": "ledger-2024-2026-1323",
    "rowIndex": 1323,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37759",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1324",
    "rowIndex": 1324,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37759",
    "description": "HG HD VR",
    "qty": 4,
    "qtyKg": null,
    "price": 1380,
    "total": 5520
  },
  {
    "id": "ledger-2024-2026-1325",
    "rowIndex": 1325,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37759",
    "description": "HG HD VR",
    "qty": 4,
    "qtyKg": null,
    "price": 1380,
    "total": 5520
  },
  {
    "id": "ledger-2024-2026-1326",
    "rowIndex": 1326,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37760",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1380,
    "total": 20700
  },
  {
    "id": "ledger-2024-2026-1327",
    "rowIndex": 1327,
    "date": "2025-09-09",
    "rawDate": 45909,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37760",
    "description": "HG HD VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1410,
    "total": 21150
  },
  {
    "id": "ledger-2024-2026-1328",
    "rowIndex": 1328,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HG HD VR",
    "qty": 24,
    "qtyKg": null,
    "price": 1380,
    "total": 33120
  },
  {
    "id": "ledger-2024-2026-1329",
    "rowIndex": 1329,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1380,
    "total": 13800
  },
  {
    "id": "ledger-2024-2026-1330",
    "rowIndex": 1330,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HG HD VR",
    "qty": 44,
    "qtyKg": null,
    "price": 1380,
    "total": 60720
  },
  {
    "id": "ledger-2024-2026-1331",
    "rowIndex": 1331,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1332",
    "rowIndex": 1332,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1333",
    "rowIndex": 1333,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1334",
    "rowIndex": 1334,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HG HD VR",
    "qty": 2,
    "qtyKg": null,
    "price": 1380,
    "total": 2760
  },
  {
    "id": "ledger-2024-2026-1335",
    "rowIndex": 1335,
    "date": "2025-09-10",
    "rawDate": 45910,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37770",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1419,
    "total": 56760
  },
  {
    "id": "ledger-2024-2026-1336",
    "rowIndex": 1336,
    "date": "2025-09-11",
    "rawDate": 45911,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37863",
    "description": "HG HD",
    "qty": 35,
    "qtyKg": null,
    "price": 1370,
    "total": 47950
  },
  {
    "id": "ledger-2024-2026-1337",
    "rowIndex": 1337,
    "date": "2025-09-11",
    "rawDate": 45911,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37863",
    "description": "HG HD VR",
    "qty": 65,
    "qtyKg": null,
    "price": 1380,
    "total": 89700
  },
  {
    "id": "ledger-2024-2026-1338",
    "rowIndex": 1338,
    "date": "2025-09-11",
    "rawDate": 45911,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37863",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1370,
    "total": 68500
  },
  {
    "id": "ledger-2024-2026-1339",
    "rowIndex": 1339,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1340",
    "rowIndex": 1340,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37916",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1379,
    "total": 1379
  },
  {
    "id": "ledger-2024-2026-1341",
    "rowIndex": 1341,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1380,
    "total": 27600
  },
  {
    "id": "ledger-2024-2026-1342",
    "rowIndex": 1342,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1370,
    "total": 6850
  },
  {
    "id": "ledger-2024-2026-1343",
    "rowIndex": 1343,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1379,
    "total": 20685
  },
  {
    "id": "ledger-2024-2026-1344",
    "rowIndex": 1344,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1380,
    "total": 20700
  },
  {
    "id": "ledger-2024-2026-1345",
    "rowIndex": 1345,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HG HD VR",
    "qty": 22,
    "qtyKg": null,
    "price": 1380,
    "total": 30360
  },
  {
    "id": "ledger-2024-2026-1346",
    "rowIndex": 1346,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1380,
    "total": 34500
  },
  {
    "id": "ledger-2024-2026-1347",
    "rowIndex": 1347,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HSP A2",
    "qty": 31,
    "qtyKg": null,
    "price": 1419,
    "total": 43989
  },
  {
    "id": "ledger-2024-2026-1348",
    "rowIndex": 1348,
    "date": "2025-09-12",
    "rawDate": 45912,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "37915",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1379,
    "total": 8274
  },
  {
    "id": "ledger-2024-2026-1349",
    "rowIndex": 1349,
    "date": "2025-09-13",
    "rawDate": 45913,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1846",
    "description": null,
    "qty": 30,
    "qtyKg": 3630.6,
    "price": 210,
    "total": 762426
  },
  {
    "id": "ledger-2024-2026-1350",
    "rowIndex": 1350,
    "date": "2025-09-15",
    "rawDate": 45915,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1847",
    "description": null,
    "qty": 16,
    "qtyKg": 1918.4,
    "price": 210,
    "total": 402864
  },
  {
    "id": "ledger-2024-2026-1351",
    "rowIndex": 1351,
    "date": "2025-09-15",
    "rawDate": 45915,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1848",
    "description": null,
    "qty": 4,
    "qtyKg": 461,
    "price": 210,
    "total": 96810
  },
  {
    "id": "ledger-2024-2026-1352",
    "rowIndex": 1352,
    "date": "2025-09-15",
    "rawDate": 45915,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1848",
    "description": null,
    "qty": 16,
    "qtyKg": 1735.6,
    "price": 210,
    "total": 364476
  },
  {
    "id": "ledger-2024-2026-1353",
    "rowIndex": 1353,
    "date": "2025-09-16",
    "rawDate": 45916,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1849",
    "description": null,
    "qty": 12,
    "qtyKg": 1541,
    "price": 210,
    "total": 323610
  },
  {
    "id": "ledger-2024-2026-1354",
    "rowIndex": 1354,
    "date": "2025-09-16",
    "rawDate": 45916,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1849",
    "description": null,
    "qty": 1,
    "qtyKg": 92,
    "price": 205,
    "total": 18860
  },
  {
    "id": "ledger-2024-2026-1355",
    "rowIndex": 1355,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38077",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1370,
    "total": 68500
  },
  {
    "id": "ledger-2024-2026-1356",
    "rowIndex": 1356,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1357",
    "rowIndex": 1357,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1358",
    "rowIndex": 1358,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HG HD VAS",
    "qty": 35,
    "qtyKg": null,
    "price": 1410,
    "total": 49350
  },
  {
    "id": "ledger-2024-2026-1359",
    "rowIndex": 1359,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38076",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1370,
    "total": 20550
  },
  {
    "id": "ledger-2024-2026-1360",
    "rowIndex": 1360,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1361",
    "rowIndex": 1361,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38076",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1362",
    "rowIndex": 1362,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Macatangay, Marinel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1419,
    "total": 42570
  },
  {
    "id": "ledger-2024-2026-1363",
    "rowIndex": 1363,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38076",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1364",
    "rowIndex": 1364,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38078",
    "description": "HG HD VAS",
    "qty": 60,
    "qtyKg": null,
    "price": 1410,
    "total": 84600
  },
  {
    "id": "ledger-2024-2026-1365",
    "rowIndex": 1365,
    "date": "2025-09-17",
    "rawDate": 45917,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38076",
    "description": "HSP",
    "qty": 60,
    "qtyKg": null,
    "price": 1379,
    "total": 82740
  },
  {
    "id": "ledger-2024-2026-1366",
    "rowIndex": 1366,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 969,
    "qtyKg": null,
    "price": 50,
    "total": 48450
  },
  {
    "id": "ledger-2024-2026-1367",
    "rowIndex": 1367,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 969,
    "qtyKg": null,
    "price": 2.5,
    "total": 2422.5
  },
  {
    "id": "ledger-2024-2026-1368",
    "rowIndex": 1368,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 166,
    "qtyKg": null,
    "price": 100,
    "total": 16600
  },
  {
    "id": "ledger-2024-2026-1369",
    "rowIndex": 1369,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 166,
    "qtyKg": null,
    "price": 200,
    "total": 33200
  },
  {
    "id": "ledger-2024-2026-1370",
    "rowIndex": 1370,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 500,
    "total": 87500
  },
  {
    "id": "ledger-2024-2026-1371",
    "rowIndex": 1371,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Agon, Rodel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 9,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1372",
    "rowIndex": 1372,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Imad P.",
    "description": "HG HD VR",
    "qty": -2.5,
    "qtyKg": null,
    "price": 1380,
    "total": -3450
  },
  {
    "id": "ledger-2024-2026-1373",
    "rowIndex": 1373,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Estok",
    "description": "HG HD VR",
    "qty": -1.5,
    "qtyKg": null,
    "price": 1380,
    "total": -2070
  },
  {
    "id": "ledger-2024-2026-1374",
    "rowIndex": 1374,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Estok",
    "description": "HG HD VR",
    "qty": -2,
    "qtyKg": null,
    "price": 1380,
    "total": -2760
  },
  {
    "id": "ledger-2024-2026-1375",
    "rowIndex": 1375,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Joel A.",
    "description": "HG HD VR",
    "qty": 1.5,
    "qtyKg": null,
    "price": 1380,
    "total": 2070
  },
  {
    "id": "ledger-2024-2026-1376",
    "rowIndex": 1376,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Myrna B.",
    "description": "HG HD VR",
    "qty": 2,
    "qtyKg": null,
    "price": 1380,
    "total": 2760
  },
  {
    "id": "ledger-2024-2026-1377",
    "rowIndex": 1377,
    "date": "2025-09-18",
    "rawDate": 45918,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Joel A.",
    "description": "HG HD VR",
    "qty": 2.5,
    "qtyKg": null,
    "price": 1380,
    "total": 3450
  },
  {
    "id": "ledger-2024-2026-1378",
    "rowIndex": 1378,
    "date": "2025-09-19",
    "rawDate": 45919,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38209",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1380,
    "total": 41400
  },
  {
    "id": "ledger-2024-2026-1379",
    "rowIndex": 1379,
    "date": "2025-09-19",
    "rawDate": 45919,
    "raiser": "Dimaano, Ruel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ruel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38209",
    "description": "HG HD VAS",
    "qty": 5,
    "qtyKg": null,
    "price": 1410,
    "total": 7050
  },
  {
    "id": "ledger-2024-2026-1380",
    "rowIndex": 1380,
    "date": "2025-09-19",
    "rawDate": 45919,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38209",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1370,
    "total": 27400
  },
  {
    "id": "ledger-2024-2026-1381",
    "rowIndex": 1381,
    "date": "2025-09-19",
    "rawDate": 45919,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38209",
    "description": "HG HD VR",
    "qty": 65,
    "qtyKg": null,
    "price": 1380,
    "total": 89700
  },
  {
    "id": "ledger-2024-2026-1382",
    "rowIndex": 1382,
    "date": "2025-09-19",
    "rawDate": 45919,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38209",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1380,
    "total": 41400
  },
  {
    "id": "ledger-2024-2026-1383",
    "rowIndex": 1383,
    "date": "2025-09-20",
    "rawDate": 45920,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1850",
    "description": null,
    "qty": 4,
    "qtyKg": 485.8,
    "price": 210,
    "total": 102018
  },
  {
    "id": "ledger-2024-2026-1384",
    "rowIndex": 1384,
    "date": "2025-09-20",
    "rawDate": 45920,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1851",
    "description": null,
    "qty": 15,
    "qtyKg": 1857.6,
    "price": 210,
    "total": 390096
  },
  {
    "id": "ledger-2024-2026-1385",
    "rowIndex": 1385,
    "date": "2025-09-20",
    "rawDate": 45920,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 21000,
    "total": 21000
  },
  {
    "id": "ledger-2024-2026-1386",
    "rowIndex": 1386,
    "date": "2025-09-20",
    "rawDate": 45920,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1850",
    "description": null,
    "qty": 23,
    "qtyKg": 3023.2,
    "price": 210,
    "total": 634872
  },
  {
    "id": "ledger-2024-2026-1387",
    "rowIndex": 1387,
    "date": "2025-09-22",
    "rawDate": 45922,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1852",
    "description": null,
    "qty": 15,
    "qtyKg": 1774.2,
    "price": 210,
    "total": 372582
  },
  {
    "id": "ledger-2024-2026-1388",
    "rowIndex": 1388,
    "date": "2025-09-22",
    "rawDate": 45922,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1852",
    "description": null,
    "qty": 1,
    "qtyKg": 102,
    "price": 210,
    "total": 21420
  },
  {
    "id": "ledger-2024-2026-1389",
    "rowIndex": 1389,
    "date": "2025-09-23",
    "rawDate": 45923,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1853",
    "description": null,
    "qty": 2,
    "qtyKg": 267.6,
    "price": 210,
    "total": 56196.00000000001
  },
  {
    "id": "ledger-2024-2026-1390",
    "rowIndex": 1390,
    "date": "2025-09-23",
    "rawDate": 45923,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1853",
    "description": null,
    "qty": 9,
    "qtyKg": 1104,
    "price": 210,
    "total": 231840
  },
  {
    "id": "ledger-2024-2026-1391",
    "rowIndex": 1391,
    "date": "2025-09-23",
    "rawDate": 45923,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38335",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1392",
    "rowIndex": 1392,
    "date": "2025-09-23",
    "rawDate": 45923,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1853",
    "description": null,
    "qty": 1,
    "qtyKg": 113.4,
    "price": 210,
    "total": 23814
  },
  {
    "id": "ledger-2024-2026-1393",
    "rowIndex": 1393,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1854",
    "description": null,
    "qty": 1,
    "qtyKg": 40,
    "price": 200,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-1394",
    "rowIndex": 1394,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38388",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1370,
    "total": 9590
  },
  {
    "id": "ledger-2024-2026-1395",
    "rowIndex": 1395,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38388",
    "description": "HG HD VAS",
    "qty": 45,
    "qtyKg": null,
    "price": 1410,
    "total": 63450
  },
  {
    "id": "ledger-2024-2026-1396",
    "rowIndex": 1396,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1854",
    "description": null,
    "qty": 21,
    "qtyKg": 2789.2,
    "price": 210,
    "total": 585732
  },
  {
    "id": "ledger-2024-2026-1397",
    "rowIndex": 1397,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38387",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1370,
    "total": 9590
  },
  {
    "id": "ledger-2024-2026-1398",
    "rowIndex": 1398,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38388",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1370,
    "total": 17810
  },
  {
    "id": "ledger-2024-2026-1399",
    "rowIndex": 1399,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38387",
    "description": "HSP A2",
    "qty": 33,
    "qtyKg": null,
    "price": 1419,
    "total": 46827
  },
  {
    "id": "ledger-2024-2026-1400",
    "rowIndex": 1400,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38387",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1401",
    "rowIndex": 1401,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1854",
    "description": null,
    "qty": 6,
    "qtyKg": 723.8,
    "price": 210,
    "total": 151998
  },
  {
    "id": "ledger-2024-2026-1402",
    "rowIndex": 1402,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38388",
    "description": "HG HD VR",
    "qty": 75,
    "qtyKg": null,
    "price": 1380,
    "total": 103500
  },
  {
    "id": "ledger-2024-2026-1403",
    "rowIndex": 1403,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38387",
    "description": "HSP",
    "qty": 85,
    "qtyKg": null,
    "price": 1379,
    "total": 117215
  },
  {
    "id": "ledger-2024-2026-1404",
    "rowIndex": 1404,
    "date": "2025-09-24",
    "rawDate": 45924,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38388",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1405",
    "rowIndex": 1405,
    "date": "2025-09-26",
    "rawDate": 45926,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38545",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1380,
    "total": 20700
  },
  {
    "id": "ledger-2024-2026-1406",
    "rowIndex": 1406,
    "date": "2025-09-26",
    "rawDate": 45926,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38545",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1449,
    "total": 14490
  },
  {
    "id": "ledger-2024-2026-1407",
    "rowIndex": 1407,
    "date": "2025-09-26",
    "rawDate": 45926,
    "raiser": "Sibal, Andres",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38545",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1408",
    "rowIndex": 1408,
    "date": "2025-09-26",
    "rawDate": 45926,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38545",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1449,
    "total": 28980
  },
  {
    "id": "ledger-2024-2026-1409",
    "rowIndex": 1409,
    "date": "2025-09-26",
    "rawDate": 45926,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38545",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1410",
    "rowIndex": 1410,
    "date": "2025-09-27",
    "rawDate": 45927,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1855",
    "description": null,
    "qty": 3,
    "qtyKg": 343,
    "price": 210,
    "total": 72030
  },
  {
    "id": "ledger-2024-2026-1411",
    "rowIndex": 1411,
    "date": "2025-09-27",
    "rawDate": 45927,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1855",
    "description": null,
    "qty": 13,
    "qtyKg": 1512.6,
    "price": 210,
    "total": 317646
  },
  {
    "id": "ledger-2024-2026-1412",
    "rowIndex": 1412,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1380,
    "total": 34500
  },
  {
    "id": "ledger-2024-2026-1413",
    "rowIndex": 1413,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1419,
    "total": 5676
  },
  {
    "id": "ledger-2024-2026-1414",
    "rowIndex": 1414,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HG HD VR",
    "qty": 26,
    "qtyKg": null,
    "price": 1380,
    "total": 35880
  },
  {
    "id": "ledger-2024-2026-1415",
    "rowIndex": 1415,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Dimaano, Ruel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ruel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1416",
    "rowIndex": 1416,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Macatangay, Marinel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1419,
    "total": 42570
  },
  {
    "id": "ledger-2024-2026-1417",
    "rowIndex": 1417,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1380,
    "total": 27600
  },
  {
    "id": "ledger-2024-2026-1418",
    "rowIndex": 1418,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1380,
    "total": 34500
  },
  {
    "id": "ledger-2024-2026-1419",
    "rowIndex": 1419,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1380,
    "total": 20700
  },
  {
    "id": "ledger-2024-2026-1420",
    "rowIndex": 1420,
    "date": "2025-09-29",
    "rawDate": 45929,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38566",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1419,
    "total": 7095
  },
  {
    "id": "ledger-2024-2026-1421",
    "rowIndex": 1421,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1856",
    "description": null,
    "qty": 11,
    "qtyKg": 1377.1999999999998,
    "price": 210,
    "total": 289211.99999999994
  },
  {
    "id": "ledger-2024-2026-1422",
    "rowIndex": 1422,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38698",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1380,
    "total": 48300
  },
  {
    "id": "ledger-2024-2026-1423",
    "rowIndex": 1423,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1856",
    "description": null,
    "qty": 3,
    "qtyKg": 342.4,
    "price": 210,
    "total": 71904
  },
  {
    "id": "ledger-2024-2026-1424",
    "rowIndex": 1424,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38698",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1425",
    "rowIndex": 1425,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1857",
    "description": null,
    "qty": 16,
    "qtyKg": 1768,
    "price": 210,
    "total": 371280
  },
  {
    "id": "ledger-2024-2026-1426",
    "rowIndex": 1426,
    "date": "2025-09-30",
    "rawDate": 45930,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38698",
    "description": "HG HD VR",
    "qty": 105,
    "qtyKg": null,
    "price": 1380,
    "total": 144900
  },
  {
    "id": "ledger-2024-2026-1427",
    "rowIndex": 1427,
    "date": "2025-10-01",
    "rawDate": 45931,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1858",
    "description": null,
    "qty": 2,
    "qtyKg": 217,
    "price": 210,
    "total": 45570
  },
  {
    "id": "ledger-2024-2026-1428",
    "rowIndex": 1428,
    "date": "2025-10-01",
    "rawDate": 45931,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1858",
    "description": null,
    "qty": 17,
    "qtyKg": 1731.8,
    "price": 210,
    "total": 363678
  },
  {
    "id": "ledger-2024-2026-1429",
    "rowIndex": 1429,
    "date": "2025-10-01",
    "rawDate": 45931,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1859",
    "description": null,
    "qty": 2,
    "qtyKg": 242,
    "price": 210,
    "total": 50820
  },
  {
    "id": "ledger-2024-2026-1430",
    "rowIndex": 1430,
    "date": "2025-10-01",
    "rawDate": 45931,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1859",
    "description": null,
    "qty": 2,
    "qtyKg": 224.2,
    "price": 210,
    "total": 47082
  },
  {
    "id": "ledger-2024-2026-1431",
    "rowIndex": 1431,
    "date": "2025-10-02",
    "rawDate": 45932,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38785",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1370,
    "total": 20550
  },
  {
    "id": "ledger-2024-2026-1432",
    "rowIndex": 1432,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Agon, Rodel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1433",
    "rowIndex": 1433,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1419,
    "total": 5676
  },
  {
    "id": "ledger-2024-2026-1434",
    "rowIndex": 1434,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1419,
    "total": 8514
  },
  {
    "id": "ledger-2024-2026-1435",
    "rowIndex": 1435,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1436",
    "rowIndex": 1436,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1437",
    "rowIndex": 1437,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1438",
    "rowIndex": 1438,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38845",
    "description": "HG HD VR",
    "qty": 2,
    "qtyKg": null,
    "price": 1380,
    "total": 2760
  },
  {
    "id": "ledger-2024-2026-1439",
    "rowIndex": 1439,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Sibal, Andres",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1419,
    "total": 28380
  },
  {
    "id": "ledger-2024-2026-1440",
    "rowIndex": 1440,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38845",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1419,
    "total": 21285
  },
  {
    "id": "ledger-2024-2026-1441",
    "rowIndex": 1441,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1419,
    "total": 56760
  },
  {
    "id": "ledger-2024-2026-1442",
    "rowIndex": 1442,
    "date": "2025-10-03",
    "rawDate": 45933,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38853",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1443",
    "rowIndex": 1443,
    "date": "2025-10-04",
    "rawDate": 45934,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1860",
    "description": null,
    "qty": 25,
    "qtyKg": 3144.2,
    "price": 205,
    "total": 644561
  },
  {
    "id": "ledger-2024-2026-1444",
    "rowIndex": 1444,
    "date": "2025-10-04",
    "rawDate": 45934,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1861",
    "description": null,
    "qty": 15,
    "qtyKg": 1838.2,
    "price": 205,
    "total": 376831
  },
  {
    "id": "ledger-2024-2026-1445",
    "rowIndex": 1445,
    "date": "2025-10-04",
    "rawDate": 45934,
    "raiser": "Dimaano, Ian",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Ian",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1861",
    "description": null,
    "qty": 1,
    "qtyKg": 120,
    "price": 205,
    "total": 24600
  },
  {
    "id": "ledger-2024-2026-1446",
    "rowIndex": 1446,
    "date": "2025-10-04",
    "rawDate": 45934,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1862",
    "description": null,
    "qty": 25,
    "qtyKg": 3038.6,
    "price": 195,
    "total": 592527
  },
  {
    "id": "ledger-2024-2026-1447",
    "rowIndex": 1447,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1419,
    "total": 9933
  },
  {
    "id": "ledger-2024-2026-1448",
    "rowIndex": 1448,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Dimaano, Bino",
    "batch": "",
    "cycleCode": "Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1370,
    "total": 41100
  },
  {
    "id": "ledger-2024-2026-1449",
    "rowIndex": 1449,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Dimaano, Ruel",
    "batch": "",
    "cycleCode": "Dimaano, Ruel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1419,
    "total": 4257
  },
  {
    "id": "ledger-2024-2026-1450",
    "rowIndex": 1450,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1451",
    "rowIndex": 1451,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1419,
    "total": 14190
  },
  {
    "id": "ledger-2024-2026-1452",
    "rowIndex": 1452,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HSP",
    "qty": 36,
    "qtyKg": null,
    "price": 1379,
    "total": 49644
  },
  {
    "id": "ledger-2024-2026-1453",
    "rowIndex": 1453,
    "date": "2025-10-06",
    "rawDate": 45936,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38946",
    "description": "HSP A2",
    "qty": 54,
    "qtyKg": null,
    "price": 1419,
    "total": 76626
  },
  {
    "id": "ledger-2024-2026-1454",
    "rowIndex": 1454,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Agon, Rodel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38986",
    "description": "HSP A2",
    "qty": 45,
    "qtyKg": null,
    "price": 1419,
    "total": 63855
  },
  {
    "id": "ledger-2024-2026-1455",
    "rowIndex": 1455,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1000,
    "total": 1000
  },
  {
    "id": "ledger-2024-2026-1456",
    "rowIndex": 1456,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 329,
    "qtyKg": null,
    "price": 50,
    "total": 16450
  },
  {
    "id": "ledger-2024-2026-1457",
    "rowIndex": 1457,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 329,
    "qtyKg": null,
    "price": 2.5,
    "total": 822.5
  },
  {
    "id": "ledger-2024-2026-1458",
    "rowIndex": 1458,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 48,
    "qtyKg": null,
    "price": 100,
    "total": 4800
  },
  {
    "id": "ledger-2024-2026-1459",
    "rowIndex": 1459,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 48,
    "qtyKg": null,
    "price": 200,
    "total": 9600
  },
  {
    "id": "ledger-2024-2026-1460",
    "rowIndex": 1460,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 500,
    "total": 25000
  },
  {
    "id": "ledger-2024-2026-1461",
    "rowIndex": 1461,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Alcantara, Joel",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1462",
    "rowIndex": 1462,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4766,
    "total": 4766
  },
  {
    "id": "ledger-2024-2026-1463",
    "rowIndex": 1463,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 481,
    "qtyKg": null,
    "price": 50,
    "total": 24050
  },
  {
    "id": "ledger-2024-2026-1464",
    "rowIndex": 1464,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 481,
    "qtyKg": null,
    "price": 2.5,
    "total": 1202.5
  },
  {
    "id": "ledger-2024-2026-1465",
    "rowIndex": 1465,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 72,
    "qtyKg": null,
    "price": 100,
    "total": 7200
  },
  {
    "id": "ledger-2024-2026-1466",
    "rowIndex": 1466,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 72,
    "qtyKg": null,
    "price": 200,
    "total": 14400
  },
  {
    "id": "ledger-2024-2026-1467",
    "rowIndex": 1467,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 75,
    "qtyKg": null,
    "price": 500,
    "total": 37500
  },
  {
    "id": "ledger-2024-2026-1468",
    "rowIndex": 1468,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Barro, Myrna",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 3,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1469",
    "rowIndex": 1469,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38986",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1470",
    "rowIndex": 1470,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38986",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1380,
    "total": 48300
  },
  {
    "id": "ledger-2024-2026-1471",
    "rowIndex": 1471,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Jerry V.",
    "description": "HG HD",
    "qty": -6,
    "qtyKg": null,
    "price": 1370,
    "total": -8220
  },
  {
    "id": "ledger-2024-2026-1472",
    "rowIndex": 1472,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38976",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1473",
    "rowIndex": 1473,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1000,
    "total": 1000
  },
  {
    "id": "ledger-2024-2026-1474",
    "rowIndex": 1474,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3032",
    "ledgerDescription": "Meds - Others",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1000,
    "total": 1000
  },
  {
    "id": "ledger-2024-2026-1475",
    "rowIndex": 1475,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 214,
    "qtyKg": null,
    "price": 50,
    "total": 10700
  },
  {
    "id": "ledger-2024-2026-1476",
    "rowIndex": 1476,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 214,
    "qtyKg": null,
    "price": 2.5,
    "total": 535
  },
  {
    "id": "ledger-2024-2026-1477",
    "rowIndex": 1477,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 34,
    "qtyKg": null,
    "price": 100,
    "total": 3400
  },
  {
    "id": "ledger-2024-2026-1478",
    "rowIndex": 1478,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 34,
    "qtyKg": null,
    "price": 200,
    "total": 6800
  },
  {
    "id": "ledger-2024-2026-1479",
    "rowIndex": 1479,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 35,
    "qtyKg": null,
    "price": 500,
    "total": 17500
  },
  {
    "id": "ledger-2024-2026-1480",
    "rowIndex": 1480,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Patron, Imad",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Imad",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1481",
    "rowIndex": 1481,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38976",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1370,
    "total": 13700
  },
  {
    "id": "ledger-2024-2026-1482",
    "rowIndex": 1482,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38976",
    "description": "HG HD VR",
    "qty": 130,
    "qtyKg": null,
    "price": 1380,
    "total": 179400
  },
  {
    "id": "ledger-2024-2026-1483",
    "rowIndex": 1483,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Sibal, Andres",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38986",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1419,
    "total": 35475
  },
  {
    "id": "ledger-2024-2026-1484",
    "rowIndex": 1484,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "Virtucio, Jerry",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Estok",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1370,
    "total": 8220
  },
  {
    "id": "ledger-2024-2026-1485",
    "rowIndex": 1485,
    "date": "2025-10-07",
    "rawDate": 45937,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "38986",
    "description": "HSP A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1419,
    "total": 49665
  },
  {
    "id": "ledger-2024-2026-1486",
    "rowIndex": 1486,
    "date": "2025-10-08",
    "rawDate": 45938,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1863",
    "description": null,
    "qty": 16,
    "qtyKg": 1909.8,
    "price": 205,
    "total": 391509
  },
  {
    "id": "ledger-2024-2026-1487",
    "rowIndex": 1487,
    "date": "2025-10-08",
    "rawDate": 45938,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39042",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1430,
    "total": 35750
  },
  {
    "id": "ledger-2024-2026-1488",
    "rowIndex": 1488,
    "date": "2025-10-08",
    "rawDate": 45938,
    "raiser": "Patron, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39042",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1430,
    "total": 21450
  },
  {
    "id": "ledger-2024-2026-1489",
    "rowIndex": 1489,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP VI",
    "qty": 8,
    "qtyKg": null,
    "price": 1460,
    "total": 11680
  },
  {
    "id": "ledger-2024-2026-1490",
    "rowIndex": 1490,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Ailyn M.",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1430,
    "total": 5720
  },
  {
    "id": "ledger-2024-2026-1491",
    "rowIndex": 1491,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1430,
    "total": 20020
  },
  {
    "id": "ledger-2024-2026-1492",
    "rowIndex": 1492,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Coliat, Amie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1390,
    "total": 1390
  },
  {
    "id": "ledger-2024-2026-1493",
    "rowIndex": 1493,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP VI",
    "qty": 12,
    "qtyKg": null,
    "price": 1460,
    "total": 17520
  },
  {
    "id": "ledger-2024-2026-1494",
    "rowIndex": 1494,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1430,
    "total": 11440
  },
  {
    "id": "ledger-2024-2026-1495",
    "rowIndex": 1495,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP VI",
    "qty": 13,
    "qtyKg": null,
    "price": 1460,
    "total": 18980
  },
  {
    "id": "ledger-2024-2026-1496",
    "rowIndex": 1496,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1430,
    "total": 21450
  },
  {
    "id": "ledger-2024-2026-1497",
    "rowIndex": 1497,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1864",
    "description": null,
    "qty": 15,
    "qtyKg": 2105.8,
    "price": 200,
    "total": 421160.00000000006
  },
  {
    "id": "ledger-2024-2026-1498",
    "rowIndex": 1498,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1377,
    "total": 13770
  },
  {
    "id": "ledger-2024-2026-1499",
    "rowIndex": 1499,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1430,
    "total": 85800
  },
  {
    "id": "ledger-2024-2026-1500",
    "rowIndex": 1500,
    "date": "2025-10-10",
    "rawDate": 45940,
    "raiser": "",
    "batch": "2025-01",
    "cycleCode": "2025-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39183",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1430,
    "total": 7150
  },
  {
    "id": "ledger-2024-2026-1501",
    "rowIndex": 1501,
    "date": "2025-10-11",
    "rawDate": 45941,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1865",
    "description": null,
    "qty": 4,
    "qtyKg": 588.4,
    "price": 200,
    "total": 117680
  },
  {
    "id": "ledger-2024-2026-1502",
    "rowIndex": 1502,
    "date": "2025-10-11",
    "rawDate": 45941,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1865",
    "description": null,
    "qty": 24,
    "qtyKg": 3068.7999999999997,
    "price": 200,
    "total": 613760
  },
  {
    "id": "ledger-2024-2026-1503",
    "rowIndex": 1503,
    "date": "2025-10-11",
    "rawDate": 45941,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1866",
    "description": null,
    "qty": 16,
    "qtyKg": 1907.4,
    "price": 200,
    "total": 381480
  },
  {
    "id": "ledger-2024-2026-1504",
    "rowIndex": 1504,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1377,
    "total": 6885
  },
  {
    "id": "ledger-2024-2026-1505",
    "rowIndex": 1505,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HSP VI",
    "qty": 17,
    "qtyKg": null,
    "price": 1460,
    "total": 24820
  },
  {
    "id": "ledger-2024-2026-1506",
    "rowIndex": 1506,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1387,
    "total": 27740
  },
  {
    "id": "ledger-2024-2026-1507",
    "rowIndex": 1507,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Eleonor",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1387,
    "total": 27740
  },
  {
    "id": "ledger-2024-2026-1508",
    "rowIndex": 1508,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 22000,
    "total": 22000
  },
  {
    "id": "ledger-2024-2026-1509",
    "rowIndex": 1509,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4010",
    "ledgerDescription": "Adj - Retail Sales Raiser",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1000,
    "total": 1000
  },
  {
    "id": "ledger-2024-2026-1510",
    "rowIndex": 1510,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3032",
    "ledgerDescription": "Meds - Others",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1195,
    "total": 1195
  },
  {
    "id": "ledger-2024-2026-1511",
    "rowIndex": 1511,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 495,
    "qtyKg": null,
    "price": 50,
    "total": 24750
  },
  {
    "id": "ledger-2024-2026-1512",
    "rowIndex": 1512,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 495,
    "qtyKg": null,
    "price": 2.5,
    "total": 1237.5
  },
  {
    "id": "ledger-2024-2026-1513",
    "rowIndex": 1513,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 64,
    "qtyKg": null,
    "price": 100,
    "total": 6400
  },
  {
    "id": "ledger-2024-2026-1514",
    "rowIndex": 1514,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 64,
    "qtyKg": null,
    "price": 200,
    "total": 12800
  },
  {
    "id": "ledger-2024-2026-1515",
    "rowIndex": 1515,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 65,
    "qtyKg": null,
    "price": 500,
    "total": 32500
  },
  {
    "id": "ledger-2024-2026-1516",
    "rowIndex": 1516,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Estok",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1517",
    "rowIndex": 1517,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1867",
    "description": null,
    "qty": 16,
    "qtyKg": 1726.6,
    "price": 195,
    "total": 336687
  },
  {
    "id": "ledger-2024-2026-1518",
    "rowIndex": 1518,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Macatangay, Marinel",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1430,
    "total": 4290
  },
  {
    "id": "ledger-2024-2026-1519",
    "rowIndex": 1519,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1387,
    "total": 13870
  },
  {
    "id": "ledger-2024-2026-1520",
    "rowIndex": 1520,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1387,
    "total": 34675
  },
  {
    "id": "ledger-2024-2026-1521",
    "rowIndex": 1521,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1868",
    "description": null,
    "qty": 4,
    "qtyKg": 500.20000000000005,
    "price": 195,
    "total": 97539.00000000001
  },
  {
    "id": "ledger-2024-2026-1522",
    "rowIndex": 1522,
    "date": "2025-10-14",
    "rawDate": 45944,
    "raiser": "Casas, Joseph 2",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Casas, Joseph 2",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39297",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1430,
    "total": 71500
  },
  {
    "id": "ledger-2024-2026-1523",
    "rowIndex": 1523,
    "date": "2025-10-18",
    "rawDate": 45948,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 90,
    "qtyKg": null,
    "price": 10340,
    "total": 930600
  },
  {
    "id": "ledger-2024-2026-1524",
    "rowIndex": 1524,
    "date": "2025-10-18",
    "rawDate": 45948,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 18000,
    "total": 18000
  },
  {
    "id": "ledger-2024-2026-1525",
    "rowIndex": 1525,
    "date": "2025-10-20",
    "rawDate": 45950,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1874",
    "description": null,
    "qty": 1,
    "qtyKg": 122,
    "price": 175,
    "total": 21350
  },
  {
    "id": "ledger-2024-2026-1526",
    "rowIndex": 1526,
    "date": "2025-10-20",
    "rawDate": 45950,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39545",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1385,
    "total": 9695
  },
  {
    "id": "ledger-2024-2026-1527",
    "rowIndex": 1527,
    "date": "2025-10-20",
    "rawDate": 45950,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39545",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1528",
    "rowIndex": 1528,
    "date": "2025-10-21",
    "rawDate": 45951,
    "raiser": "Dimaano, Bunny",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bunny",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1877",
    "description": null,
    "qty": 47,
    "qtyKg": 2607,
    "price": 145,
    "total": 378015
  },
  {
    "id": "ledger-2024-2026-1529",
    "rowIndex": 1529,
    "date": "2025-10-21",
    "rawDate": 45951,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 10450,
    "total": 836000
  },
  {
    "id": "ledger-2024-2026-1530",
    "rowIndex": 1530,
    "date": "2025-10-21",
    "rawDate": 45951,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 200,
    "total": 16000
  },
  {
    "id": "ledger-2024-2026-1531",
    "rowIndex": 1531,
    "date": "2025-10-21",
    "rawDate": 45951,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39616",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1385,
    "total": 13850
  },
  {
    "id": "ledger-2024-2026-1532",
    "rowIndex": 1532,
    "date": "2025-10-21",
    "rawDate": 45951,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39616",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1385,
    "total": 13850
  },
  {
    "id": "ledger-2024-2026-1533",
    "rowIndex": 1533,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 10175,
    "total": 407000
  },
  {
    "id": "ledger-2024-2026-1534",
    "rowIndex": 1534,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 200,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-1535",
    "rowIndex": 1535,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": null,
    "price": 10175,
    "total": 752950
  },
  {
    "id": "ledger-2024-2026-1536",
    "rowIndex": 1536,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": null,
    "price": 200,
    "total": 14800
  },
  {
    "id": "ledger-2024-2026-1537",
    "rowIndex": 1537,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HPS VA2",
    "qty": 4,
    "qtyKg": null,
    "price": 2306,
    "total": 9224
  },
  {
    "id": "ledger-2024-2026-1538",
    "rowIndex": 1538,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1539",
    "rowIndex": 1539,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HPS VA2",
    "qty": 3,
    "qtyKg": null,
    "price": 2306,
    "total": 6918
  },
  {
    "id": "ledger-2024-2026-1540",
    "rowIndex": 1540,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1541",
    "rowIndex": 1541,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HPS VA2",
    "qty": 5,
    "qtyKg": null,
    "price": 2306,
    "total": 11530
  },
  {
    "id": "ledger-2024-2026-1542",
    "rowIndex": 1542,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1435,
    "total": 4305
  },
  {
    "id": "ledger-2024-2026-1543",
    "rowIndex": 1543,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HPS VA2",
    "qty": 8,
    "qtyKg": null,
    "price": 2306,
    "total": 18448
  },
  {
    "id": "ledger-2024-2026-1544",
    "rowIndex": 1544,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39747",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1435,
    "total": 10045
  },
  {
    "id": "ledger-2024-2026-1545",
    "rowIndex": 1545,
    "date": "2025-10-23",
    "rawDate": 45953,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39753",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1546",
    "rowIndex": 1546,
    "date": "2025-10-24",
    "rawDate": 45954,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39823",
    "description": "HPS",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-1547",
    "rowIndex": 1547,
    "date": "2025-10-24",
    "rawDate": 45954,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39823",
    "description": "HPS",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-1548",
    "rowIndex": 1548,
    "date": "2025-10-24",
    "rawDate": 45954,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39823",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1435,
    "total": 28700
  },
  {
    "id": "ledger-2024-2026-1549",
    "rowIndex": 1549,
    "date": "2025-10-24",
    "rawDate": 45954,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39823",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1550",
    "rowIndex": 1550,
    "date": "2025-10-24",
    "rawDate": 45954,
    "raiser": "",
    "batch": "2026-01",
    "cycleCode": "2026-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39823",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-1551",
    "rowIndex": 1551,
    "date": "2025-10-25",
    "rawDate": 45955,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1879",
    "description": null,
    "qty": 1,
    "qtyKg": 96,
    "price": 195,
    "total": 18720
  },
  {
    "id": "ledger-2024-2026-1552",
    "rowIndex": 1552,
    "date": "2025-10-25",
    "rawDate": 45955,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1880",
    "description": null,
    "qty": 16,
    "qtyKg": 1999,
    "price": 190,
    "total": 379810
  },
  {
    "id": "ledger-2024-2026-1553",
    "rowIndex": 1553,
    "date": "2025-10-25",
    "rawDate": 45955,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1881",
    "description": null,
    "qty": 1,
    "qtyKg": 137,
    "price": 190,
    "total": 26030
  },
  {
    "id": "ledger-2024-2026-1554",
    "rowIndex": 1554,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1882",
    "description": null,
    "qty": 3,
    "qtyKg": 372,
    "price": 175,
    "total": 65100
  },
  {
    "id": "ledger-2024-2026-1555",
    "rowIndex": 1555,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1882",
    "description": null,
    "qty": 6,
    "qtyKg": 730.5999999999999,
    "price": 175,
    "total": 127854.99999999999
  },
  {
    "id": "ledger-2024-2026-1556",
    "rowIndex": 1556,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1882",
    "description": null,
    "qty": 23,
    "qtyKg": 2749.6000000000004,
    "price": 175,
    "total": 481180.00000000006
  },
  {
    "id": "ledger-2024-2026-1557",
    "rowIndex": 1557,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1882",
    "description": null,
    "qty": 18,
    "qtyKg": 2092.4,
    "price": 175,
    "total": 366170
  },
  {
    "id": "ledger-2024-2026-1558",
    "rowIndex": 1558,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1883",
    "description": null,
    "qty": 50,
    "qtyKg": 5762.800000000001,
    "price": 175,
    "total": 1008490.0000000002
  },
  {
    "id": "ledger-2024-2026-1559",
    "rowIndex": 1559,
    "date": "2025-10-26",
    "rawDate": 45956,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1884",
    "description": null,
    "qty": 30,
    "qtyKg": 3399.4,
    "price": 175,
    "total": 594895
  },
  {
    "id": "ledger-2024-2026-1560",
    "rowIndex": 1560,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1886",
    "description": null,
    "qty": 2,
    "qtyKg": 225.2,
    "price": 190,
    "total": 42788
  },
  {
    "id": "ledger-2024-2026-1561",
    "rowIndex": 1561,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 9900,
    "total": 396000
  },
  {
    "id": "ledger-2024-2026-1562",
    "rowIndex": 1562,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 200,
    "total": 8000
  },
  {
    "id": "ledger-2024-2026-1563",
    "rowIndex": 1563,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 10450,
    "total": 731500
  },
  {
    "id": "ledger-2024-2026-1564",
    "rowIndex": 1564,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 200,
    "total": 14000
  },
  {
    "id": "ledger-2024-2026-1565",
    "rowIndex": 1565,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 10450,
    "total": 1097250
  },
  {
    "id": "ledger-2024-2026-1566",
    "rowIndex": 1566,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 200,
    "total": 21000
  },
  {
    "id": "ledger-2024-2026-1567",
    "rowIndex": 1567,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Dominga S.",
    "description": "HG HD",
    "qty": 3,
    "qtyKg": null,
    "price": 1385,
    "total": 4155
  },
  {
    "id": "ledger-2024-2026-1568",
    "rowIndex": 1568,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bino D.",
    "description": "HG HD",
    "qty": -3,
    "qtyKg": null,
    "price": 1385,
    "total": -4155
  },
  {
    "id": "ledger-2024-2026-1569",
    "rowIndex": 1569,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1435,
    "total": 35875
  },
  {
    "id": "ledger-2024-2026-1570",
    "rowIndex": 1570,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1571",
    "rowIndex": 1571,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1435,
    "total": 17220
  },
  {
    "id": "ledger-2024-2026-1572",
    "rowIndex": 1572,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1435,
    "total": 28700
  },
  {
    "id": "ledger-2024-2026-1573",
    "rowIndex": 1573,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1435,
    "total": 4305
  },
  {
    "id": "ledger-2024-2026-1574",
    "rowIndex": 1574,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HPS",
    "qty": 6,
    "qtyKg": null,
    "price": 2241,
    "total": 13446
  },
  {
    "id": "ledger-2024-2026-1575",
    "rowIndex": 1575,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1435,
    "total": 5740
  },
  {
    "id": "ledger-2024-2026-1576",
    "rowIndex": 1576,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HPS",
    "qty": 8,
    "qtyKg": null,
    "price": 2241,
    "total": 17928
  },
  {
    "id": "ledger-2024-2026-1577",
    "rowIndex": 1577,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1435,
    "total": 10045
  },
  {
    "id": "ledger-2024-2026-1578",
    "rowIndex": 1578,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 38,
    "qtyKg": null,
    "price": 1435,
    "total": 54530
  },
  {
    "id": "ledger-2024-2026-1579",
    "rowIndex": 1579,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HPS",
    "qty": 8,
    "qtyKg": null,
    "price": 2241,
    "total": 17928
  },
  {
    "id": "ledger-2024-2026-1580",
    "rowIndex": 1580,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1435,
    "total": 10045
  },
  {
    "id": "ledger-2024-2026-1581",
    "rowIndex": 1581,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HPS",
    "qty": 1,
    "qtyKg": null,
    "price": 2241,
    "total": 2241
  },
  {
    "id": "ledger-2024-2026-1582",
    "rowIndex": 1582,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39919",
    "description": "HSP A2",
    "qty": 1,
    "qtyKg": null,
    "price": 1435,
    "total": 1435
  },
  {
    "id": "ledger-2024-2026-1583",
    "rowIndex": 1583,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1885",
    "description": null,
    "qty": 16,
    "qtyKg": 1770,
    "price": 190,
    "total": 336300
  },
  {
    "id": "ledger-2024-2026-1584",
    "rowIndex": 1584,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1886",
    "description": null,
    "qty": 2,
    "qtyKg": 248.8,
    "price": 190,
    "total": 47272
  },
  {
    "id": "ledger-2024-2026-1585",
    "rowIndex": 1585,
    "date": "2025-10-28",
    "rawDate": 45958,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "39981",
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1410,
    "total": 21150
  },
  {
    "id": "ledger-2024-2026-1586",
    "rowIndex": 1586,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 55,
    "qtyKg": null,
    "price": 10450,
    "total": 574750
  },
  {
    "id": "ledger-2024-2026-1587",
    "rowIndex": 1587,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 55,
    "qtyKg": null,
    "price": 200,
    "total": 11000
  },
  {
    "id": "ledger-2024-2026-1588",
    "rowIndex": 1588,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1888",
    "description": null,
    "qty": 20,
    "qtyKg": 2221.6,
    "price": 190,
    "total": 422104
  },
  {
    "id": "ledger-2024-2026-1589",
    "rowIndex": 1589,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1890",
    "description": null,
    "qty": 20,
    "qtyKg": 2227.6,
    "price": 185,
    "total": 412106
  },
  {
    "id": "ledger-2024-2026-1590",
    "rowIndex": 1590,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1460,
    "total": 11680
  },
  {
    "id": "ledger-2024-2026-1591",
    "rowIndex": 1591,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1460,
    "total": 8760
  },
  {
    "id": "ledger-2024-2026-1592",
    "rowIndex": 1592,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1593",
    "rowIndex": 1593,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1460,
    "total": 18980
  },
  {
    "id": "ledger-2024-2026-1594",
    "rowIndex": 1594,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HPS",
    "qty": 5,
    "qtyKg": null,
    "price": 2241,
    "total": 11205
  },
  {
    "id": "ledger-2024-2026-1595",
    "rowIndex": 1595,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40054",
    "description": "HSP VT A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1460,
    "total": 8760
  },
  {
    "id": "ledger-2024-2026-1596",
    "rowIndex": 1596,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 18671,
    "total": 18671
  },
  {
    "id": "ledger-2024-2026-1597",
    "rowIndex": 1597,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 2850,
    "total": 2850
  },
  {
    "id": "ledger-2024-2026-1598",
    "rowIndex": 1598,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 560,
    "qtyKg": null,
    "price": 50,
    "total": 28000
  },
  {
    "id": "ledger-2024-2026-1599",
    "rowIndex": 1599,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 560,
    "qtyKg": null,
    "price": 2.5,
    "total": 1400
  },
  {
    "id": "ledger-2024-2026-1600",
    "rowIndex": 1600,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 92,
    "qtyKg": null,
    "price": 100,
    "total": 9200
  },
  {
    "id": "ledger-2024-2026-1601",
    "rowIndex": 1601,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 92,
    "qtyKg": null,
    "price": 200,
    "total": 18400
  },
  {
    "id": "ledger-2024-2026-1602",
    "rowIndex": 1602,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 106,
    "qtyKg": null,
    "price": 500,
    "total": 53000
  },
  {
    "id": "ledger-2024-2026-1603",
    "rowIndex": 1603,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Gonzales, Nolly",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Gonzales, Nolly",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 14,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1604",
    "rowIndex": 1604,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1401,
    "total": 1401
  },
  {
    "id": "ledger-2024-2026-1605",
    "rowIndex": 1605,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1900,
    "total": 1900
  },
  {
    "id": "ledger-2024-2026-1606",
    "rowIndex": 1606,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4500,
    "total": 4500
  },
  {
    "id": "ledger-2024-2026-1607",
    "rowIndex": 1607,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 444,
    "qtyKg": null,
    "price": 50,
    "total": 22200
  },
  {
    "id": "ledger-2024-2026-1608",
    "rowIndex": 1608,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 444,
    "qtyKg": null,
    "price": 2.5,
    "total": 1110
  },
  {
    "id": "ledger-2024-2026-1609",
    "rowIndex": 1609,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 63,
    "qtyKg": null,
    "price": 100,
    "total": 6300
  },
  {
    "id": "ledger-2024-2026-1610",
    "rowIndex": 1610,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 63,
    "qtyKg": null,
    "price": 200,
    "total": 12600
  },
  {
    "id": "ledger-2024-2026-1611",
    "rowIndex": 1611,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 500,
    "total": 35000
  },
  {
    "id": "ledger-2024-2026-1612",
    "rowIndex": 1612,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Salvacion, Dominga",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 7,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1613",
    "rowIndex": 1613,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Dimaano, Bino",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Joseph C.",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1385,
    "total": 1385
  },
  {
    "id": "ledger-2024-2026-1614",
    "rowIndex": 1614,
    "date": "2025-10-30",
    "rawDate": 45960,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bino D.",
    "description": "HG HD",
    "qty": -1,
    "qtyKg": null,
    "price": 1385,
    "total": -1385
  },
  {
    "id": "ledger-2024-2026-1615",
    "rowIndex": 1615,
    "date": "2025-11-01",
    "rawDate": 45962,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1892",
    "description": null,
    "qty": 6,
    "qtyKg": 846.9999999999999,
    "price": 180,
    "total": 152459.99999999997
  },
  {
    "id": "ledger-2024-2026-1616",
    "rowIndex": 1616,
    "date": "2025-11-01",
    "rawDate": 45962,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1892",
    "description": null,
    "qty": 2,
    "qtyKg": 221.6,
    "price": 180,
    "total": 39888
  },
  {
    "id": "ledger-2024-2026-1617",
    "rowIndex": 1617,
    "date": "2025-11-03",
    "rawDate": 45964,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1893",
    "description": null,
    "qty": 10,
    "qtyKg": 815.5,
    "price": 145,
    "total": 118247.5
  },
  {
    "id": "ledger-2024-2026-1618",
    "rowIndex": 1618,
    "date": "2025-11-03",
    "rawDate": 45964,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1893",
    "description": null,
    "qty": 10,
    "qtyKg": 762.2,
    "price": 95,
    "total": 72409
  },
  {
    "id": "ledger-2024-2026-1619",
    "rowIndex": 1619,
    "date": "2025-11-04",
    "rawDate": 45965,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1894",
    "description": null,
    "qty": 15,
    "qtyKg": 1396.2,
    "price": 145,
    "total": 202449
  },
  {
    "id": "ledger-2024-2026-1620",
    "rowIndex": 1620,
    "date": "2025-11-04",
    "rawDate": 45965,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1894",
    "description": null,
    "qty": 10,
    "qtyKg": 817.2,
    "price": 95,
    "total": 77634
  },
  {
    "id": "ledger-2024-2026-1621",
    "rowIndex": 1621,
    "date": "2025-11-05",
    "rawDate": 45966,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1895",
    "description": null,
    "qty": 38,
    "qtyKg": 3966.4,
    "price": 170,
    "total": 674288
  },
  {
    "id": "ledger-2024-2026-1622",
    "rowIndex": 1622,
    "date": "2025-11-05",
    "rawDate": 45966,
    "raiser": "Perez, Rufino",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Rufino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1896",
    "description": null,
    "qty": 31,
    "qtyKg": 3286.6000000000004,
    "price": 170,
    "total": 558722.0000000001
  },
  {
    "id": "ledger-2024-2026-1623",
    "rowIndex": 1623,
    "date": "2025-11-05",
    "rawDate": 45966,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1896",
    "description": null,
    "qty": 1,
    "qtyKg": 81.2,
    "price": 170,
    "total": 13804
  },
  {
    "id": "ledger-2024-2026-1624",
    "rowIndex": 1624,
    "date": "2025-11-05",
    "rawDate": 45966,
    "raiser": "Eleonor",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1896",
    "description": null,
    "qty": 7,
    "qtyKg": 985.1999999999999,
    "price": 170,
    "total": 167484
  },
  {
    "id": "ledger-2024-2026-1625",
    "rowIndex": 1625,
    "date": "2025-11-05",
    "rawDate": 45966,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40279",
    "description": "HSP VA2",
    "qty": 7,
    "qtyKg": null,
    "price": 1460,
    "total": 10220
  },
  {
    "id": "ledger-2024-2026-1626",
    "rowIndex": 1626,
    "date": "2025-11-06",
    "rawDate": 45967,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40345",
    "description": "HSP VA2",
    "qty": 5,
    "qtyKg": null,
    "price": 1460,
    "total": 7300
  },
  {
    "id": "ledger-2024-2026-1627",
    "rowIndex": 1627,
    "date": "2025-11-06",
    "rawDate": 45967,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40346",
    "description": "HSP VA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1628",
    "rowIndex": 1628,
    "date": "2025-11-06",
    "rawDate": 45967,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40346",
    "description": "HSP VA2",
    "qty": 6,
    "qtyKg": null,
    "price": 1460,
    "total": 8760
  },
  {
    "id": "ledger-2024-2026-1629",
    "rowIndex": 1629,
    "date": "2025-11-06",
    "rawDate": 45967,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40346",
    "description": "HSP VA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1630",
    "rowIndex": 1630,
    "date": "2025-11-06",
    "rawDate": 45967,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40346",
    "description": "HSP VA2",
    "qty": 6,
    "qtyKg": null,
    "price": 1460,
    "total": 8760
  },
  {
    "id": "ledger-2024-2026-1631",
    "rowIndex": 1631,
    "date": "2025-11-07",
    "rawDate": 45968,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40414",
    "description": "HSP VA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1632",
    "rowIndex": 1632,
    "date": "2025-11-07",
    "rawDate": 45968,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40414",
    "description": "HSP VA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1633",
    "rowIndex": 1633,
    "date": "2025-11-07",
    "rawDate": 45968,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40414",
    "description": "HSP VA2",
    "qty": 30,
    "qtyKg": null,
    "price": 1460,
    "total": 43800
  },
  {
    "id": "ledger-2024-2026-1634",
    "rowIndex": 1634,
    "date": "2025-11-08",
    "rawDate": 45969,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1901",
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4000,
    "total": 4000
  },
  {
    "id": "ledger-2024-2026-1635",
    "rowIndex": 1635,
    "date": "2025-11-08",
    "rawDate": 45969,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1901",
    "description": null,
    "qty": 1,
    "qtyKg": 100.4,
    "price": 175,
    "total": 17570
  },
  {
    "id": "ledger-2024-2026-1636",
    "rowIndex": 1636,
    "date": "2025-11-08",
    "rawDate": 45969,
    "raiser": "Eleonor",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Eleonor",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "1902",
    "description": null,
    "qty": 1,
    "qtyKg": 107.6,
    "price": 190,
    "total": 20444
  },
  {
    "id": "ledger-2024-2026-1637",
    "rowIndex": 1637,
    "date": "2025-11-11",
    "rawDate": 45972,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40519",
    "description": "HSP VI",
    "qty": 6,
    "qtyKg": null,
    "price": 1410,
    "total": 8460
  },
  {
    "id": "ledger-2024-2026-1638",
    "rowIndex": 1638,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VA2",
    "qty": 40,
    "qtyKg": null,
    "price": 1460,
    "total": 58400
  },
  {
    "id": "ledger-2024-2026-1639",
    "rowIndex": 1639,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VA2",
    "qty": 55,
    "qtyKg": null,
    "price": 1460,
    "total": 80300
  },
  {
    "id": "ledger-2024-2026-1640",
    "rowIndex": 1640,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VA2",
    "qty": 5,
    "qtyKg": null,
    "price": 1460,
    "total": 7300
  },
  {
    "id": "ledger-2024-2026-1641",
    "rowIndex": 1641,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VA2",
    "qty": 40,
    "qtyKg": null,
    "price": 1460,
    "total": 58400
  },
  {
    "id": "ledger-2024-2026-1642",
    "rowIndex": 1642,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1410,
    "total": 21150
  },
  {
    "id": "ledger-2024-2026-1643",
    "rowIndex": 1643,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1410,
    "total": 14100
  },
  {
    "id": "ledger-2024-2026-1644",
    "rowIndex": 1644,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 16220,
    "total": 16220
  },
  {
    "id": "ledger-2024-2026-1645",
    "rowIndex": 1645,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 924,
    "qtyKg": null,
    "price": 50,
    "total": 46200
  },
  {
    "id": "ledger-2024-2026-1646",
    "rowIndex": 1646,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 924,
    "qtyKg": null,
    "price": 2.5,
    "total": 2310
  },
  {
    "id": "ledger-2024-2026-1647",
    "rowIndex": 1647,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 136,
    "qtyKg": null,
    "price": 100,
    "total": 13600
  },
  {
    "id": "ledger-2024-2026-1648",
    "rowIndex": 1648,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 136,
    "qtyKg": null,
    "price": 200,
    "total": 27200
  },
  {
    "id": "ledger-2024-2026-1649",
    "rowIndex": 1649,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 150,
    "qtyKg": null,
    "price": 500,
    "total": 75000
  },
  {
    "id": "ledger-2024-2026-1650",
    "rowIndex": 1650,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Casas, Joseph",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Casas, Joseph",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 14,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1651",
    "rowIndex": 1651,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1976,
    "total": 1976
  },
  {
    "id": "ledger-2024-2026-1652",
    "rowIndex": 1652,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4750,
    "total": 4750
  },
  {
    "id": "ledger-2024-2026-1653",
    "rowIndex": 1653,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 377,
    "qtyKg": null,
    "price": 50,
    "total": 18850
  },
  {
    "id": "ledger-2024-2026-1654",
    "rowIndex": 1654,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 377,
    "qtyKg": null,
    "price": 2.5,
    "total": 942.5
  },
  {
    "id": "ledger-2024-2026-1655",
    "rowIndex": 1655,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 56,
    "qtyKg": null,
    "price": 100,
    "total": 5600
  },
  {
    "id": "ledger-2024-2026-1656",
    "rowIndex": 1656,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 56,
    "qtyKg": null,
    "price": 200,
    "total": 11200
  },
  {
    "id": "ledger-2024-2026-1657",
    "rowIndex": 1657,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 60,
    "qtyKg": null,
    "price": 500,
    "total": 30000
  },
  {
    "id": "ledger-2024-2026-1658",
    "rowIndex": 1658,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Perez, Martin",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Perez, Martin",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 4,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1659",
    "rowIndex": 1659,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 8,
    "qtyKg": null,
    "price": 1410,
    "total": 11280
  },
  {
    "id": "ledger-2024-2026-1660",
    "rowIndex": 1660,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 11,
    "qtyKg": null,
    "price": 1410,
    "total": 15510
  },
  {
    "id": "ledger-2024-2026-1661",
    "rowIndex": 1661,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 12,
    "qtyKg": null,
    "price": 1410,
    "total": 16920
  },
  {
    "id": "ledger-2024-2026-1662",
    "rowIndex": 1662,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1410,
    "total": 21150
  },
  {
    "id": "ledger-2024-2026-1663",
    "rowIndex": 1663,
    "date": "2025-11-12",
    "rawDate": 45973,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP VI",
    "qty": 8,
    "qtyKg": null,
    "price": 1410,
    "total": 11280
  },
  {
    "id": "ledger-2024-2026-1664",
    "rowIndex": 1664,
    "date": "2025-11-13",
    "rawDate": 45974,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40700",
    "description": "HSP VT A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1460,
    "total": 4380
  },
  {
    "id": "ledger-2024-2026-1665",
    "rowIndex": 1665,
    "date": "2025-11-13",
    "rawDate": 45974,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40748",
    "description": "HSP VT A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1460,
    "total": 36500
  },
  {
    "id": "ledger-2024-2026-1666",
    "rowIndex": 1666,
    "date": "2025-11-13",
    "rawDate": 45974,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40748",
    "description": "HSP VT A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1460,
    "total": 73000
  },
  {
    "id": "ledger-2024-2026-1667",
    "rowIndex": 1667,
    "date": "2025-11-13",
    "rawDate": 45974,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40748",
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1410,
    "total": 21150
  },
  {
    "id": "ledger-2024-2026-1668",
    "rowIndex": 1668,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 8900,
    "total": 445000
  },
  {
    "id": "ledger-2024-2026-1669",
    "rowIndex": 1669,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 200,
    "total": 10000
  },
  {
    "id": "ledger-2024-2026-1670",
    "rowIndex": 1670,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 125,
    "qtyKg": null,
    "price": 9150,
    "total": 1143750
  },
  {
    "id": "ledger-2024-2026-1671",
    "rowIndex": 1671,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 125,
    "qtyKg": null,
    "price": 200,
    "total": 25000
  },
  {
    "id": "ledger-2024-2026-1672",
    "rowIndex": 1672,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40856",
    "description": "HSP VT A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1460,
    "total": 11680
  },
  {
    "id": "ledger-2024-2026-1673",
    "rowIndex": 1673,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40856",
    "description": "HSP VT A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1460,
    "total": 18980
  },
  {
    "id": "ledger-2024-2026-1674",
    "rowIndex": 1674,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40856",
    "description": "HSP VT A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1460,
    "total": 20440
  },
  {
    "id": "ledger-2024-2026-1675",
    "rowIndex": 1675,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40856",
    "description": "HSP VT A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1460,
    "total": 26280
  },
  {
    "id": "ledger-2024-2026-1676",
    "rowIndex": 1676,
    "date": "2025-11-18",
    "rawDate": 45979,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40856",
    "description": "HSP VT A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1460,
    "total": 17520
  },
  {
    "id": "ledger-2024-2026-1677",
    "rowIndex": 1677,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40935",
    "description": "HSP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1435,
    "total": 86100
  },
  {
    "id": "ledger-2024-2026-1678",
    "rowIndex": 1678,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40935",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1435,
    "total": 57400
  },
  {
    "id": "ledger-2024-2026-1679",
    "rowIndex": 1679,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40935",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1435,
    "total": 28700
  },
  {
    "id": "ledger-2024-2026-1680",
    "rowIndex": 1680,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40935",
    "description": "HSP VT A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1681",
    "rowIndex": 1681,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40935",
    "description": "HSP VT A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1460,
    "total": 29200
  },
  {
    "id": "ledger-2024-2026-1682",
    "rowIndex": 1682,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1435,
    "total": 78925
  },
  {
    "id": "ledger-2024-2026-1683",
    "rowIndex": 1683,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1684",
    "rowIndex": 1684,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1435,
    "total": 25830
  },
  {
    "id": "ledger-2024-2026-1685",
    "rowIndex": 1685,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP A2",
    "qty": 19,
    "qtyKg": null,
    "price": 1435,
    "total": 27265
  },
  {
    "id": "ledger-2024-2026-1686",
    "rowIndex": 1686,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1435,
    "total": 18655
  },
  {
    "id": "ledger-2024-2026-1687",
    "rowIndex": 1687,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HPS",
    "qty": 2,
    "qtyKg": null,
    "price": 2241,
    "total": 4482
  },
  {
    "id": "ledger-2024-2026-1688",
    "rowIndex": 1688,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP VT A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1460,
    "total": 5840
  },
  {
    "id": "ledger-2024-2026-1689",
    "rowIndex": 1689,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP VT A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1460,
    "total": 10220
  },
  {
    "id": "ledger-2024-2026-1690",
    "rowIndex": 1690,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP VT A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1460,
    "total": 11680
  },
  {
    "id": "ledger-2024-2026-1691",
    "rowIndex": 1691,
    "date": "2025-11-19",
    "rawDate": 45980,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40936",
    "description": "HSP VT A2",
    "qty": 9,
    "qtyKg": null,
    "price": 1460,
    "total": 13140
  },
  {
    "id": "ledger-2024-2026-1692",
    "rowIndex": 1692,
    "date": "2025-11-20",
    "rawDate": 45981,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40964",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1435,
    "total": 71750
  },
  {
    "id": "ledger-2024-2026-1693",
    "rowIndex": 1693,
    "date": "2025-11-20",
    "rawDate": 45981,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40964",
    "description": "HSP VT A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1460,
    "total": 36500
  },
  {
    "id": "ledger-2024-2026-1694",
    "rowIndex": 1694,
    "date": "2025-11-20",
    "rawDate": 45981,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "40964",
    "description": "HSP VT A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1460,
    "total": 36500
  },
  {
    "id": "ledger-2024-2026-1695",
    "rowIndex": 1695,
    "date": "2025-11-21",
    "rawDate": 45982,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41043",
    "description": "HSP A2",
    "qty": 24,
    "qtyKg": null,
    "price": 1435,
    "total": 34440
  },
  {
    "id": "ledger-2024-2026-1696",
    "rowIndex": 1696,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1435,
    "total": 20090
  },
  {
    "id": "ledger-2024-2026-1697",
    "rowIndex": 1697,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-1698",
    "rowIndex": 1698,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1699",
    "rowIndex": 1699,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1435,
    "total": 25830
  },
  {
    "id": "ledger-2024-2026-1700",
    "rowIndex": 1700,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1435,
    "total": 11480
  },
  {
    "id": "ledger-2024-2026-1701",
    "rowIndex": 1701,
    "date": "2025-11-24",
    "rawDate": 45985,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41079",
    "description": "HSP VT A2",
    "qty": 9,
    "qtyKg": null,
    "price": 1460,
    "total": 13140
  },
  {
    "id": "ledger-2024-2026-1702",
    "rowIndex": 1702,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41186",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1435,
    "total": 71750
  },
  {
    "id": "ledger-2024-2026-1703",
    "rowIndex": 1703,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41186",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1435,
    "total": 78925
  },
  {
    "id": "ledger-2024-2026-1704",
    "rowIndex": 1704,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41186",
    "description": "HSP A2",
    "qty": 45,
    "qtyKg": null,
    "price": 1435,
    "total": 64575
  },
  {
    "id": "ledger-2024-2026-1705",
    "rowIndex": 1705,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP VT A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1460,
    "total": 5840
  },
  {
    "id": "ledger-2024-2026-1706",
    "rowIndex": 1706,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP VT A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1460,
    "total": 8760
  },
  {
    "id": "ledger-2024-2026-1707",
    "rowIndex": 1707,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP VT A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1460,
    "total": 14600
  },
  {
    "id": "ledger-2024-2026-1708",
    "rowIndex": 1708,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 16,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1709",
    "rowIndex": 1709,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 21,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1710",
    "rowIndex": 1710,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1711",
    "rowIndex": 1711,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 16,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1712",
    "rowIndex": 1712,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 44,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-1713",
    "rowIndex": 1713,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41187",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1435,
    "total": 11480
  },
  {
    "id": "ledger-2024-2026-1714",
    "rowIndex": 1714,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 10500,
    "total": 1050000
  },
  {
    "id": "ledger-2024-2026-1715",
    "rowIndex": 1715,
    "date": "2025-11-25",
    "rawDate": 45986,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 200,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-1716",
    "rowIndex": 1716,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 9650,
    "total": 1688750
  },
  {
    "id": "ledger-2024-2026-1717",
    "rowIndex": 1717,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 175,
    "qtyKg": null,
    "price": 250,
    "total": 43750
  },
  {
    "id": "ledger-2024-2026-1718",
    "rowIndex": 1718,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1435,
    "total": 8610
  },
  {
    "id": "ledger-2024-2026-1719",
    "rowIndex": 1719,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1720",
    "rowIndex": 1720,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1435,
    "total": 11480
  },
  {
    "id": "ledger-2024-2026-1721",
    "rowIndex": 1721,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-1722",
    "rowIndex": 1722,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1723",
    "rowIndex": 1723,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1405,
    "total": 35125
  },
  {
    "id": "ledger-2024-2026-1724",
    "rowIndex": 1724,
    "date": "2025-11-27",
    "rawDate": 45988,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41345",
    "description": "HSP VT A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1460,
    "total": 10220
  },
  {
    "id": "ledger-2024-2026-1725",
    "rowIndex": 1725,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41369",
    "description": "HSP VT A2",
    "qty": 75,
    "qtyKg": null,
    "price": 1460,
    "total": 109500
  },
  {
    "id": "ledger-2024-2026-1726",
    "rowIndex": 1726,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41371",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1435,
    "total": 21525
  },
  {
    "id": "ledger-2024-2026-1727",
    "rowIndex": 1727,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41371",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1435,
    "total": 28700
  },
  {
    "id": "ledger-2024-2026-1728",
    "rowIndex": 1728,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41371",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-1729",
    "rowIndex": 1729,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41377",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1435,
    "total": 57400
  },
  {
    "id": "ledger-2024-2026-1730",
    "rowIndex": 1730,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41377",
    "description": "HSP A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1435,
    "total": 50225
  },
  {
    "id": "ledger-2024-2026-1731",
    "rowIndex": 1731,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41377",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1435,
    "total": 71750
  },
  {
    "id": "ledger-2024-2026-1732",
    "rowIndex": 1732,
    "date": "2025-11-28",
    "rawDate": 45989,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41377",
    "description": "HSP VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1410,
    "total": 35250
  },
  {
    "id": "ledger-2024-2026-1733",
    "rowIndex": 1733,
    "date": "2025-11-29",
    "rawDate": 45990,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 125,
    "qtyKg": null,
    "price": 9500,
    "total": 1187500
  },
  {
    "id": "ledger-2024-2026-1734",
    "rowIndex": 1734,
    "date": "2025-11-29",
    "rawDate": 45990,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 125,
    "qtyKg": null,
    "price": 250,
    "total": 31250
  },
  {
    "id": "ledger-2024-2026-1735",
    "rowIndex": 1735,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP VT A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1460,
    "total": 11680
  },
  {
    "id": "ledger-2024-2026-1736",
    "rowIndex": 1736,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP VT A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1460,
    "total": 10220
  },
  {
    "id": "ledger-2024-2026-1737",
    "rowIndex": 1737,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1435,
    "total": 20090
  },
  {
    "id": "ledger-2024-2026-1738",
    "rowIndex": 1738,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-1739",
    "rowIndex": 1739,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1435,
    "total": 11480
  },
  {
    "id": "ledger-2024-2026-1740",
    "rowIndex": 1740,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1435,
    "total": 28700
  },
  {
    "id": "ledger-2024-2026-1741",
    "rowIndex": 1741,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 65,
    "qtyKg": null,
    "price": 1435,
    "total": 93275
  },
  {
    "id": "ledger-2024-2026-1742",
    "rowIndex": 1742,
    "date": "2025-12-02",
    "rawDate": 45993,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41503",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1455,
    "total": 4365
  },
  {
    "id": "ledger-2024-2026-1743",
    "rowIndex": 1743,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41597",
    "description": "HSP VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1515,
    "total": 30300
  },
  {
    "id": "ledger-2024-2026-1744",
    "rowIndex": 1744,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP A2",
    "qty": 16,
    "qtyKg": null,
    "price": 1455,
    "total": 23280
  },
  {
    "id": "ledger-2024-2026-1745",
    "rowIndex": 1745,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1455,
    "total": 17460
  },
  {
    "id": "ledger-2024-2026-1746",
    "rowIndex": 1746,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1455,
    "total": 20370
  },
  {
    "id": "ledger-2024-2026-1747",
    "rowIndex": 1747,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-1748",
    "rowIndex": 1748,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-1749",
    "rowIndex": 1749,
    "date": "2025-12-03",
    "rawDate": 45994,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41599",
    "description": "HSP VT A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1480,
    "total": 22200
  },
  {
    "id": "ledger-2024-2026-1750",
    "rowIndex": 1750,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1455,
    "total": 40740
  },
  {
    "id": "ledger-2024-2026-1751",
    "rowIndex": 1751,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1455,
    "total": 10185
  },
  {
    "id": "ledger-2024-2026-1752",
    "rowIndex": 1752,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-1753",
    "rowIndex": 1753,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 21,
    "qtyKg": null,
    "price": 1455,
    "total": 30555
  },
  {
    "id": "ledger-2024-2026-1754",
    "rowIndex": 1754,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1755",
    "rowIndex": 1755,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 4,
    "qtyKg": null,
    "price": 1455,
    "total": 5820
  },
  {
    "id": "ledger-2024-2026-1756",
    "rowIndex": 1756,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1757",
    "rowIndex": 1757,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-1758",
    "rowIndex": 1758,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41680",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-1759",
    "rowIndex": 1759,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41696",
    "description": "HSP A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1455,
    "total": 58200
  },
  {
    "id": "ledger-2024-2026-1760",
    "rowIndex": 1760,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41696",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1455,
    "total": 72750
  },
  {
    "id": "ledger-2024-2026-1761",
    "rowIndex": 1761,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41696",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1762",
    "rowIndex": 1762,
    "date": "2025-12-05",
    "rawDate": 45996,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41696",
    "description": "HSP A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1455,
    "total": 50925
  },
  {
    "id": "ledger-2024-2026-1763",
    "rowIndex": 1763,
    "date": "2025-12-06",
    "rawDate": 45997,
    "raiser": "Hernandez, Ladie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41738",
    "description": "HSP VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1425,
    "total": 42750
  },
  {
    "id": "ledger-2024-2026-1764",
    "rowIndex": 1764,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41782",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1765",
    "rowIndex": 1765,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41782",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1455,
    "total": 72750
  },
  {
    "id": "ledger-2024-2026-1766",
    "rowIndex": 1766,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41782",
    "description": "HSP A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1455,
    "total": 50925
  },
  {
    "id": "ledger-2024-2026-1767",
    "rowIndex": 1767,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41782",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1768",
    "rowIndex": 1768,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41782",
    "description": "HG HD A2",
    "qty": 40,
    "qtyKg": null,
    "price": 1445,
    "total": 57800
  },
  {
    "id": "ledger-2024-2026-1769",
    "rowIndex": 1769,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1455,
    "total": 20370
  },
  {
    "id": "ledger-2024-2026-1770",
    "rowIndex": 1770,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1771",
    "rowIndex": 1771,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP A2",
    "qty": 21,
    "qtyKg": null,
    "price": 1455,
    "total": 30555
  },
  {
    "id": "ledger-2024-2026-1772",
    "rowIndex": 1772,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1455,
    "total": 33465
  },
  {
    "id": "ledger-2024-2026-1773",
    "rowIndex": 1773,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1455,
    "total": 17460
  },
  {
    "id": "ledger-2024-2026-1774",
    "rowIndex": 1774,
    "date": "2025-12-09",
    "rawDate": 46000,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41783",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1430,
    "total": 28600
  },
  {
    "id": "ledger-2024-2026-1775",
    "rowIndex": 1775,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP VI",
    "qty": 7,
    "qtyKg": null,
    "price": 1430,
    "total": 10010
  },
  {
    "id": "ledger-2024-2026-1776",
    "rowIndex": 1776,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1777",
    "rowIndex": 1777,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HG HD A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1445,
    "total": 21675
  },
  {
    "id": "ledger-2024-2026-1778",
    "rowIndex": 1778,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1455,
    "total": 8730
  },
  {
    "id": "ledger-2024-2026-1779",
    "rowIndex": 1779,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HG HD A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-1780",
    "rowIndex": 1780,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 6,
    "qtyKg": null,
    "price": 1455,
    "total": 8730
  },
  {
    "id": "ledger-2024-2026-1781",
    "rowIndex": 1781,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HG HD A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-1782",
    "rowIndex": 1782,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-1783",
    "rowIndex": 1783,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HG HD A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-1784",
    "rowIndex": 1784,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1455,
    "total": 7275
  },
  {
    "id": "ledger-2024-2026-1785",
    "rowIndex": 1785,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1455,
    "total": 18915
  },
  {
    "id": "ledger-2024-2026-1786",
    "rowIndex": 1786,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1455,
    "total": 26190
  },
  {
    "id": "ledger-2024-2026-1787",
    "rowIndex": 1787,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HG HD A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1445,
    "total": 43350
  },
  {
    "id": "ledger-2024-2026-1788",
    "rowIndex": 1788,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41980",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-1789",
    "rowIndex": 1789,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41981",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-1790",
    "rowIndex": 1790,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41981",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-1791",
    "rowIndex": 1791,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41981",
    "description": "HG HD A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1445,
    "total": 21675
  },
  {
    "id": "ledger-2024-2026-1792",
    "rowIndex": 1792,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41981",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1793",
    "rowIndex": 1793,
    "date": "2025-12-12",
    "rawDate": 46003,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41981",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1455,
    "total": 80025
  },
  {
    "id": "ledger-2024-2026-1794",
    "rowIndex": 1794,
    "date": "2025-12-13",
    "rawDate": 46004,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41993",
    "description": "HSP VI",
    "qty": 58,
    "qtyKg": null,
    "price": 1430,
    "total": 82940
  },
  {
    "id": "ledger-2024-2026-1795",
    "rowIndex": 1795,
    "date": "2025-12-13",
    "rawDate": 46004,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41993",
    "description": "HSP VT A2",
    "qty": 22,
    "qtyKg": null,
    "price": 1480,
    "total": 32560
  },
  {
    "id": "ledger-2024-2026-1796",
    "rowIndex": 1796,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 16,
    "qtyKg": null,
    "price": 1455,
    "total": 23280
  },
  {
    "id": "ledger-2024-2026-1797",
    "rowIndex": 1797,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-1798",
    "rowIndex": 1798,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 22,
    "qtyKg": null,
    "price": 1455,
    "total": 32010
  },
  {
    "id": "ledger-2024-2026-1799",
    "rowIndex": 1799,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1455,
    "total": 33465
  },
  {
    "id": "ledger-2024-2026-1800",
    "rowIndex": 1800,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 19,
    "qtyKg": null,
    "price": 1455,
    "total": 27645
  },
  {
    "id": "ledger-2024-2026-1801",
    "rowIndex": 1801,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41997",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1802",
    "rowIndex": 1802,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41998",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-1803",
    "rowIndex": 1803,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41998",
    "description": "HSP A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1455,
    "total": 80025
  },
  {
    "id": "ledger-2024-2026-1804",
    "rowIndex": 1804,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41998",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-1805",
    "rowIndex": 1805,
    "date": "2025-12-15",
    "rawDate": 46006,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "41998",
    "description": "HG HD A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1445,
    "total": 86700
  },
  {
    "id": "ledger-2024-2026-1806",
    "rowIndex": 1806,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD VAS",
    "qty": 12,
    "qtyKg": null,
    "price": 1415,
    "total": 16980
  },
  {
    "id": "ledger-2024-2026-1807",
    "rowIndex": 1807,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD VAS",
    "qty": 12,
    "qtyKg": null,
    "price": 1415,
    "total": 16980
  },
  {
    "id": "ledger-2024-2026-1808",
    "rowIndex": 1808,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1455,
    "total": 7275
  },
  {
    "id": "ledger-2024-2026-1809",
    "rowIndex": 1809,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1405,
    "total": 11240
  },
  {
    "id": "ledger-2024-2026-1810",
    "rowIndex": 1810,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1811",
    "rowIndex": 1811,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1455,
    "total": 4365
  },
  {
    "id": "ledger-2024-2026-1812",
    "rowIndex": 1812,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1405,
    "total": 8430
  },
  {
    "id": "ledger-2024-2026-1813",
    "rowIndex": 1813,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1814",
    "rowIndex": 1814,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1455,
    "total": 10185
  },
  {
    "id": "ledger-2024-2026-1815",
    "rowIndex": 1815,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1455,
    "total": 7275
  },
  {
    "id": "ledger-2024-2026-1816",
    "rowIndex": 1816,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1455,
    "total": 20370
  },
  {
    "id": "ledger-2024-2026-1817",
    "rowIndex": 1817,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1405,
    "total": 42150
  },
  {
    "id": "ledger-2024-2026-1818",
    "rowIndex": 1818,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HG HD VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1415,
    "total": 28300
  },
  {
    "id": "ledger-2024-2026-1819",
    "rowIndex": 1819,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42280",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-1820",
    "rowIndex": 1820,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42281",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-1821",
    "rowIndex": 1821,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42281",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-1822",
    "rowIndex": 1822,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42281",
    "description": "HG HD VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1823",
    "rowIndex": 1823,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42281",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-1824",
    "rowIndex": 1824,
    "date": "2025-12-19",
    "rawDate": 46010,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42281",
    "description": "HSP A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1455,
    "total": 87300
  },
  {
    "id": "ledger-2024-2026-1825",
    "rowIndex": 1825,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-1826",
    "rowIndex": 1826,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1827",
    "rowIndex": 1827,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 24,
    "qtyKg": null,
    "price": 1455,
    "total": 34920
  },
  {
    "id": "ledger-2024-2026-1828",
    "rowIndex": 1828,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1455,
    "total": 40740
  },
  {
    "id": "ledger-2024-2026-1829",
    "rowIndex": 1829,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1455,
    "total": 40740
  },
  {
    "id": "ledger-2024-2026-1830",
    "rowIndex": 1830,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42333",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1455,
    "total": 18915
  },
  {
    "id": "ledger-2024-2026-1831",
    "rowIndex": 1831,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42411",
    "description": "HSP A2",
    "qty": 27,
    "qtyKg": null,
    "price": 1455,
    "total": 39285
  },
  {
    "id": "ledger-2024-2026-1832",
    "rowIndex": 1832,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42411",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1455,
    "total": 18915
  },
  {
    "id": "ledger-2024-2026-1833",
    "rowIndex": 1833,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42411",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1455,
    "total": 72750
  },
  {
    "id": "ledger-2024-2026-1834",
    "rowIndex": 1834,
    "date": "2025-12-22",
    "rawDate": 46013,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42411",
    "description": "HG HD",
    "qty": 60,
    "qtyKg": null,
    "price": 1405,
    "total": 84300
  },
  {
    "id": "ledger-2024-2026-1835",
    "rowIndex": 1835,
    "date": "2025-12-24",
    "rawDate": 46015,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "HSP A2",
    "qty": 80,
    "qtyKg": null,
    "price": 1455,
    "total": 116400
  },
  {
    "id": "ledger-2024-2026-1836",
    "rowIndex": 1836,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42510",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1837",
    "rowIndex": 1837,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42510",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1838",
    "rowIndex": 1838,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42510",
    "description": "HG HD VAS",
    "qty": 27,
    "qtyKg": null,
    "price": 1415,
    "total": 38205
  },
  {
    "id": "ledger-2024-2026-1839",
    "rowIndex": 1839,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42510",
    "description": "HG HD VR",
    "qty": 53,
    "qtyKg": null,
    "price": 1415,
    "total": 74995
  },
  {
    "id": "ledger-2024-2026-1840",
    "rowIndex": 1840,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42510",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1841",
    "rowIndex": 1841,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HG HD",
    "qty": 36,
    "qtyKg": null,
    "price": 1405,
    "total": 50580
  },
  {
    "id": "ledger-2024-2026-1842",
    "rowIndex": 1842,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1843",
    "rowIndex": 1843,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HG HD",
    "qty": 19,
    "qtyKg": null,
    "price": 1405,
    "total": 26695
  },
  {
    "id": "ledger-2024-2026-1844",
    "rowIndex": 1844,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HG HD",
    "qty": 14,
    "qtyKg": null,
    "price": 1405,
    "total": 19670
  },
  {
    "id": "ledger-2024-2026-1845",
    "rowIndex": 1845,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1405,
    "total": 18265
  },
  {
    "id": "ledger-2024-2026-1846",
    "rowIndex": 1846,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1425,
    "total": 14250
  },
  {
    "id": "ledger-2024-2026-1847",
    "rowIndex": 1847,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HSP A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-1848",
    "rowIndex": 1848,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1849",
    "rowIndex": 1849,
    "date": "2025-12-26",
    "rawDate": 46017,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42511",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-1850",
    "rowIndex": 1850,
    "date": "2025-12-27",
    "rawDate": 46018,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42574",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1851",
    "rowIndex": 1851,
    "date": "2025-12-27",
    "rawDate": 46018,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42574",
    "description": "HG HD VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1852",
    "rowIndex": 1852,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP",
    "qty": 17,
    "qtyKg": null,
    "price": 1415,
    "total": 24055
  },
  {
    "id": "ledger-2024-2026-1853",
    "rowIndex": 1853,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1854",
    "rowIndex": 1854,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP",
    "qty": 28,
    "qtyKg": null,
    "price": 1415,
    "total": 39620
  },
  {
    "id": "ledger-2024-2026-1855",
    "rowIndex": 1855,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP A2",
    "qty": 28,
    "qtyKg": null,
    "price": 1455,
    "total": 40740
  },
  {
    "id": "ledger-2024-2026-1856",
    "rowIndex": 1856,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP",
    "qty": 32,
    "qtyKg": null,
    "price": 1415,
    "total": 45280
  },
  {
    "id": "ledger-2024-2026-1857",
    "rowIndex": 1857,
    "date": "2025-12-28",
    "rawDate": 46019,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42600",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1858",
    "rowIndex": 1858,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42602",
    "description": "HG HD VR",
    "qty": 37,
    "qtyKg": null,
    "price": 1415,
    "total": 52355
  },
  {
    "id": "ledger-2024-2026-1859",
    "rowIndex": 1859,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42602",
    "description": "HSP",
    "qty": 38,
    "qtyKg": null,
    "price": 1415,
    "total": 53770
  },
  {
    "id": "ledger-2024-2026-1860",
    "rowIndex": 1860,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42602",
    "description": "HG HD VAS",
    "qty": 22,
    "qtyKg": null,
    "price": 1415,
    "total": 31130
  },
  {
    "id": "ledger-2024-2026-1861",
    "rowIndex": 1861,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42602",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-1862",
    "rowIndex": 1862,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42602",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1863",
    "rowIndex": 1863,
    "date": "2025-12-29",
    "rawDate": 46020,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42619",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1415,
    "total": 7075
  },
  {
    "id": "ledger-2024-2026-1864",
    "rowIndex": 1864,
    "date": "2026-01-02",
    "rawDate": 46024,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42725",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1865",
    "rowIndex": 1865,
    "date": "2026-01-02",
    "rawDate": 46024,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42725",
    "description": "HG HD VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1415,
    "total": 99050
  },
  {
    "id": "ledger-2024-2026-1866",
    "rowIndex": 1866,
    "date": "2026-01-02",
    "rawDate": 46024,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42725",
    "description": "HG HD VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1867",
    "rowIndex": 1867,
    "date": "2026-01-02",
    "rawDate": 46024,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42725",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1868",
    "rowIndex": 1868,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42779",
    "description": "HSP A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1455,
    "total": 218250
  },
  {
    "id": "ledger-2024-2026-1869",
    "rowIndex": 1869,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1405,
    "total": 14050
  },
  {
    "id": "ledger-2024-2026-1870",
    "rowIndex": 1870,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1425,
    "total": 18525
  },
  {
    "id": "ledger-2024-2026-1871",
    "rowIndex": 1871,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP A2",
    "qty": 9,
    "qtyKg": null,
    "price": 1455,
    "total": 13095
  },
  {
    "id": "ledger-2024-2026-1872",
    "rowIndex": 1872,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1405,
    "total": 5620
  },
  {
    "id": "ledger-2024-2026-1873",
    "rowIndex": 1873,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1425,
    "total": 7125
  },
  {
    "id": "ledger-2024-2026-1874",
    "rowIndex": 1874,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1405,
    "total": 5620
  },
  {
    "id": "ledger-2024-2026-1875",
    "rowIndex": 1875,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1405,
    "total": 5620
  },
  {
    "id": "ledger-2024-2026-1876",
    "rowIndex": 1876,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1425,
    "total": 7125
  },
  {
    "id": "ledger-2024-2026-1877",
    "rowIndex": 1877,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP",
    "qty": 4,
    "qtyKg": null,
    "price": 1415,
    "total": 5660
  },
  {
    "id": "ledger-2024-2026-1878",
    "rowIndex": 1878,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1415,
    "total": 19810
  },
  {
    "id": "ledger-2024-2026-1879",
    "rowIndex": 1879,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1880",
    "rowIndex": 1880,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1425,
    "total": 35625
  },
  {
    "id": "ledger-2024-2026-1881",
    "rowIndex": 1881,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1415,
    "total": 11320
  },
  {
    "id": "ledger-2024-2026-1882",
    "rowIndex": 1882,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1415,
    "total": 35375
  },
  {
    "id": "ledger-2024-2026-1883",
    "rowIndex": 1883,
    "date": "2026-01-03",
    "rawDate": 46025,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42790",
    "description": "HG HD VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1625,
    "total": 16250
  },
  {
    "id": "ledger-2024-2026-1884",
    "rowIndex": 1884,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1415,
    "total": 25470
  },
  {
    "id": "ledger-2024-2026-1885",
    "rowIndex": 1885,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1886",
    "rowIndex": 1886,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 29,
    "qtyKg": null,
    "price": 1415,
    "total": 41035
  },
  {
    "id": "ledger-2024-2026-1887",
    "rowIndex": 1887,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 29,
    "qtyKg": null,
    "price": 1415,
    "total": 41035
  },
  {
    "id": "ledger-2024-2026-1888",
    "rowIndex": 1888,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 29,
    "qtyKg": null,
    "price": 1415,
    "total": 41035
  },
  {
    "id": "ledger-2024-2026-1889",
    "rowIndex": 1889,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42805",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1890",
    "rowIndex": 1890,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42863",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1415,
    "total": 49525
  },
  {
    "id": "ledger-2024-2026-1891",
    "rowIndex": 1891,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42863",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1415,
    "total": 63675
  },
  {
    "id": "ledger-2024-2026-1892",
    "rowIndex": 1892,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42863",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1405,
    "total": 70250
  },
  {
    "id": "ledger-2024-2026-1893",
    "rowIndex": 1893,
    "date": "2026-01-05",
    "rawDate": 46027,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42863",
    "description": "HG HD VR",
    "qty": 22,
    "qtyKg": null,
    "price": 1415,
    "total": 31130
  },
  {
    "id": "ledger-2024-2026-1894",
    "rowIndex": 1894,
    "date": "2026-01-06",
    "rawDate": 46028,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42901",
    "description": "HG HD",
    "qty": 45,
    "qtyKg": null,
    "price": 1405,
    "total": 63225
  },
  {
    "id": "ledger-2024-2026-1895",
    "rowIndex": 1895,
    "date": "2026-01-06",
    "rawDate": 46028,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42902",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1405,
    "total": 7025
  },
  {
    "id": "ledger-2024-2026-1896",
    "rowIndex": 1896,
    "date": "2026-01-06",
    "rawDate": 46028,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42902",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1897",
    "rowIndex": 1897,
    "date": "2026-01-06",
    "rawDate": 46028,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42902",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1898",
    "rowIndex": 1898,
    "date": "2026-01-06",
    "rawDate": 46028,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "42903",
    "description": "HG HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1415,
    "total": 84900
  },
  {
    "id": "ledger-2024-2026-1899",
    "rowIndex": 1899,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Culiat, Annabelle",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43041",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1405,
    "total": 70250
  },
  {
    "id": "ledger-2024-2026-1900",
    "rowIndex": 1900,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Culiat, Annabelle",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43041",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1415,
    "total": 70750
  },
  {
    "id": "ledger-2024-2026-1901",
    "rowIndex": 1901,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Baes, Vicente",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43041",
    "description": "HSP A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1455,
    "total": 72750
  },
  {
    "id": "ledger-2024-2026-1902",
    "rowIndex": 1902,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD",
    "qty": 11,
    "qtyKg": null,
    "price": 1405,
    "total": 15455
  },
  {
    "id": "ledger-2024-2026-1903",
    "rowIndex": 1903,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1415,
    "total": 16980
  },
  {
    "id": "ledger-2024-2026-1904",
    "rowIndex": 1904,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-1905",
    "rowIndex": 1905,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1405,
    "total": 8430
  },
  {
    "id": "ledger-2024-2026-1906",
    "rowIndex": 1906,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Amy",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VR",
    "qty": 6,
    "qtyKg": null,
    "price": 1415,
    "total": 8490
  },
  {
    "id": "ledger-2024-2026-1907",
    "rowIndex": 1907,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1405,
    "total": 8430
  },
  {
    "id": "ledger-2024-2026-1908",
    "rowIndex": 1908,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1415,
    "total": 7075
  },
  {
    "id": "ledger-2024-2026-1909",
    "rowIndex": 1909,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1405,
    "total": 9835
  },
  {
    "id": "ledger-2024-2026-1910",
    "rowIndex": 1910,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Ailyn M.",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1415,
    "total": 11320
  },
  {
    "id": "ledger-2024-2026-1911",
    "rowIndex": 1911,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1415,
    "total": 11320
  },
  {
    "id": "ledger-2024-2026-1912",
    "rowIndex": 1912,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1415,
    "total": 28300
  },
  {
    "id": "ledger-2024-2026-1913",
    "rowIndex": 1913,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1415,
    "total": 9905
  },
  {
    "id": "ledger-2024-2026-1914",
    "rowIndex": 1914,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Dimaano, Bino",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Bino",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VR",
    "qty": 4,
    "qtyKg": null,
    "price": 1425,
    "total": 5700
  },
  {
    "id": "ledger-2024-2026-1915",
    "rowIndex": 1915,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1916",
    "rowIndex": 1916,
    "date": "2026-01-09",
    "rawDate": 46031,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43042",
    "description": "HG HD VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1625,
    "total": 40625
  },
  {
    "id": "ledger-2024-2026-1917",
    "rowIndex": 1917,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1415,
    "total": 28300
  },
  {
    "id": "ledger-2024-2026-1918",
    "rowIndex": 1918,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1919",
    "rowIndex": 1919,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 27,
    "qtyKg": null,
    "price": 1415,
    "total": 38205
  },
  {
    "id": "ledger-2024-2026-1920",
    "rowIndex": 1920,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 27,
    "qtyKg": null,
    "price": 1415,
    "total": 38205
  },
  {
    "id": "ledger-2024-2026-1921",
    "rowIndex": 1921,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 28,
    "qtyKg": null,
    "price": 1415,
    "total": 39620
  },
  {
    "id": "ledger-2024-2026-1922",
    "rowIndex": 1922,
    "date": "2026-01-10",
    "rawDate": 46032,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43066",
    "description": "HSP",
    "qty": 16,
    "qtyKg": null,
    "price": 1415,
    "total": 22640
  },
  {
    "id": "ledger-2024-2026-1923",
    "rowIndex": 1923,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43207",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1405,
    "total": 56200
  },
  {
    "id": "ledger-2024-2026-1924",
    "rowIndex": 1924,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43207",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1415,
    "total": 70750
  },
  {
    "id": "ledger-2024-2026-1925",
    "rowIndex": 1925,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43207",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1415,
    "total": 70750
  },
  {
    "id": "ledger-2024-2026-1926",
    "rowIndex": 1926,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43207",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1927",
    "rowIndex": 1927,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43246",
    "description": "HG HD VR",
    "qty": 100,
    "qtyKg": null,
    "price": 1415,
    "total": 141500
  },
  {
    "id": "ledger-2024-2026-1928",
    "rowIndex": 1928,
    "date": "2026-01-14",
    "rawDate": 46036,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43246",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1415,
    "total": 70750
  },
  {
    "id": "ledger-2024-2026-1929",
    "rowIndex": 1929,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HG HD",
    "qty": 16,
    "qtyKg": null,
    "price": 1405,
    "total": 22480
  },
  {
    "id": "ledger-2024-2026-1930",
    "rowIndex": 1930,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1931",
    "rowIndex": 1931,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Coliat, Bernie",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HG HD VR",
    "qty": 3,
    "qtyKg": null,
    "price": 1415,
    "total": 4245
  },
  {
    "id": "ledger-2024-2026-1932",
    "rowIndex": 1932,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HSP",
    "qty": 19,
    "qtyKg": null,
    "price": 1415,
    "total": 26885
  },
  {
    "id": "ledger-2024-2026-1933",
    "rowIndex": 1933,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1415,
    "total": 9905
  },
  {
    "id": "ledger-2024-2026-1934",
    "rowIndex": 1934,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1415,
    "total": 25470
  },
  {
    "id": "ledger-2024-2026-1935",
    "rowIndex": 1935,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HG HD VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1625,
    "total": 40625
  },
  {
    "id": "ledger-2024-2026-1936",
    "rowIndex": 1936,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1415,
    "total": 16980
  },
  {
    "id": "ledger-2024-2026-1937",
    "rowIndex": 1937,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43305",
    "description": "HG HD VAS",
    "qty": 35,
    "qtyKg": null,
    "price": 1625,
    "total": 56875
  },
  {
    "id": "ledger-2024-2026-1938",
    "rowIndex": 1938,
    "date": "2026-01-16",
    "rawDate": 46038,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43306",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1415,
    "total": 212250
  },
  {
    "id": "ledger-2024-2026-1939",
    "rowIndex": 1939,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1940",
    "rowIndex": 1940,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HG HD VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1515,
    "total": 15150
  },
  {
    "id": "ledger-2024-2026-1941",
    "rowIndex": 1941,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1415,
    "total": 9905
  },
  {
    "id": "ledger-2024-2026-1942",
    "rowIndex": 1942,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HG HD VAS",
    "qty": 7,
    "qtyKg": null,
    "price": 1515,
    "total": 10605
  },
  {
    "id": "ledger-2024-2026-1943",
    "rowIndex": 1943,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 12,
    "qtyKg": null,
    "price": 1415,
    "total": 16980
  },
  {
    "id": "ledger-2024-2026-1944",
    "rowIndex": 1944,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HG HD VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1515,
    "total": 15150
  },
  {
    "id": "ledger-2024-2026-1945",
    "rowIndex": 1945,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1415,
    "total": 56600
  },
  {
    "id": "ledger-2024-2026-1946",
    "rowIndex": 1946,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 11,
    "qtyKg": null,
    "price": 1415,
    "total": 15565
  },
  {
    "id": "ledger-2024-2026-1947",
    "rowIndex": 1947,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HG HD VAS",
    "qty": 11,
    "qtyKg": null,
    "price": 1515,
    "total": 16665
  },
  {
    "id": "ledger-2024-2026-1948",
    "rowIndex": 1948,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP",
    "qty": 17,
    "qtyKg": null,
    "price": 1415,
    "total": 24055
  },
  {
    "id": "ledger-2024-2026-1949",
    "rowIndex": 1949,
    "date": "2026-01-17",
    "rawDate": 46039,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43329",
    "description": "HSP VI A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1480,
    "total": 14800
  },
  {
    "id": "ledger-2024-2026-1950",
    "rowIndex": 1950,
    "date": "2026-01-18",
    "rawDate": 46040,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 9477.5,
    "total": 663425
  },
  {
    "id": "ledger-2024-2026-1951",
    "rowIndex": 1951,
    "date": "2026-01-18",
    "rawDate": 46040,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3012",
    "ledgerDescription": "Piglets - Trucking",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 200,
    "total": 14000
  },
  {
    "id": "ledger-2024-2026-1952",
    "rowIndex": 1952,
    "date": "2026-01-19",
    "rawDate": 46041,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43334",
    "description": "HSP VAS",
    "qty": 40,
    "qtyKg": null,
    "price": 1525,
    "total": 61000
  },
  {
    "id": "ledger-2024-2026-1953",
    "rowIndex": 1953,
    "date": "2026-01-19",
    "rawDate": 46041,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43334",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1954",
    "rowIndex": 1954,
    "date": "2026-01-19",
    "rawDate": 46041,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43334",
    "description": "HG HD",
    "qty": 80,
    "qtyKg": null,
    "price": 1405,
    "total": 112400
  },
  {
    "id": "ledger-2024-2026-1955",
    "rowIndex": 1955,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HG HD",
    "qty": 17,
    "qtyKg": null,
    "price": 1405,
    "total": 23885
  },
  {
    "id": "ledger-2024-2026-1956",
    "rowIndex": 1956,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HG HD",
    "qty": 14,
    "qtyKg": null,
    "price": 1405,
    "total": 19670
  },
  {
    "id": "ledger-2024-2026-1957",
    "rowIndex": 1957,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HG HD",
    "qty": 32,
    "qtyKg": null,
    "price": 1405,
    "total": 44960
  },
  {
    "id": "ledger-2024-2026-1958",
    "rowIndex": 1958,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1959",
    "rowIndex": 1959,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HG HD",
    "qty": 25,
    "qtyKg": null,
    "price": 1405,
    "total": 35125
  },
  {
    "id": "ledger-2024-2026-1960",
    "rowIndex": 1960,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1415,
    "total": 25470
  },
  {
    "id": "ledger-2024-2026-1961",
    "rowIndex": 1961,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43560",
    "description": "HSP VI A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1480,
    "total": 20720
  },
  {
    "id": "ledger-2024-2026-1962",
    "rowIndex": 1962,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1405,
    "total": 21075
  },
  {
    "id": "ledger-2024-2026-1963",
    "rowIndex": 1963,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1415,
    "total": 28300
  },
  {
    "id": "ledger-2024-2026-1964",
    "rowIndex": 1964,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1405,
    "total": 14050
  },
  {
    "id": "ledger-2024-2026-1965",
    "rowIndex": 1965,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1966",
    "rowIndex": 1966,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1415,
    "total": 56600
  },
  {
    "id": "ledger-2024-2026-1967",
    "rowIndex": 1967,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1415,
    "total": 42450
  },
  {
    "id": "ledger-2024-2026-1968",
    "rowIndex": 1968,
    "date": "2026-01-23",
    "rawDate": 46045,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43561",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1415,
    "total": 28300
  },
  {
    "id": "ledger-2024-2026-1969",
    "rowIndex": 1969,
    "date": "2026-01-24",
    "rawDate": 46046,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43595",
    "description": "HG HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1415,
    "total": 84900
  },
  {
    "id": "ledger-2024-2026-1970",
    "rowIndex": 1970,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1405,
    "total": 18265
  },
  {
    "id": "ledger-2024-2026-1971",
    "rowIndex": 1971,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Coliat, Nardo",
    "batch": "2025-01",
    "cycleCode": "2025-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1415,
    "total": 19810
  },
  {
    "id": "ledger-2024-2026-1972",
    "rowIndex": 1972,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1973",
    "rowIndex": 1973,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD VAS",
    "qty": 5,
    "qtyKg": null,
    "price": 1515,
    "total": 7575
  },
  {
    "id": "ledger-2024-2026-1974",
    "rowIndex": 1974,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1415,
    "total": 2830
  },
  {
    "id": "ledger-2024-2026-1975",
    "rowIndex": 1975,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1415,
    "total": 21225
  },
  {
    "id": "ledger-2024-2026-1976",
    "rowIndex": 1976,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD",
    "qty": 75,
    "qtyKg": null,
    "price": 1405,
    "total": 105375
  },
  {
    "id": "ledger-2024-2026-1977",
    "rowIndex": 1977,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HSP",
    "qty": 2,
    "qtyKg": null,
    "price": 1415,
    "total": 2830
  },
  {
    "id": "ledger-2024-2026-1978",
    "rowIndex": 1978,
    "date": "2026-01-26",
    "rawDate": 46048,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43607",
    "description": "HG HD VAS",
    "qty": 9,
    "qtyKg": null,
    "price": 1515,
    "total": 13635
  },
  {
    "id": "ledger-2024-2026-1979",
    "rowIndex": 1979,
    "date": "2026-01-27",
    "rawDate": 46049,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43704",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1415,
    "total": 56600
  },
  {
    "id": "ledger-2024-2026-1980",
    "rowIndex": 1980,
    "date": "2026-01-27",
    "rawDate": 46049,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43704",
    "description": "HG HD VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1415,
    "total": 99050
  },
  {
    "id": "ledger-2024-2026-1981",
    "rowIndex": 1981,
    "date": "2026-01-27",
    "rawDate": 46049,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43704",
    "description": "HG HD VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1515,
    "total": 22725
  },
  {
    "id": "ledger-2024-2026-1982",
    "rowIndex": 1982,
    "date": "2026-01-27",
    "rawDate": 46049,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43704",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1415,
    "total": 14150
  },
  {
    "id": "ledger-2024-2026-1983",
    "rowIndex": 1983,
    "date": "2026-01-27",
    "rawDate": 46049,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43704",
    "description": "HG HD VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1515,
    "total": 22725
  },
  {
    "id": "ledger-2024-2026-1984",
    "rowIndex": 1984,
    "date": "2026-01-29",
    "rawDate": 46051,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43844",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1445,
    "total": 216750
  },
  {
    "id": "ledger-2024-2026-1985",
    "rowIndex": 1985,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1445,
    "total": 18785
  },
  {
    "id": "ledger-2024-2026-1986",
    "rowIndex": 1986,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1445,
    "total": 18785
  },
  {
    "id": "ledger-2024-2026-1987",
    "rowIndex": 1987,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1445,
    "total": 26010
  },
  {
    "id": "ledger-2024-2026-1988",
    "rowIndex": 1988,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HSP",
    "qty": 22,
    "qtyKg": null,
    "price": 1445,
    "total": 31790
  },
  {
    "id": "ledger-2024-2026-1989",
    "rowIndex": 1989,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-1990",
    "rowIndex": 1990,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-1991",
    "rowIndex": 1991,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43854",
    "description": "HG HD VAS",
    "qty": 6,
    "qtyKg": null,
    "price": 1545,
    "total": 9270
  },
  {
    "id": "ledger-2024-2026-1992",
    "rowIndex": 1992,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43855",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-1993",
    "rowIndex": 1993,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43855",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-1994",
    "rowIndex": 1994,
    "date": "2026-01-30",
    "rawDate": 46052,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43855",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-1995",
    "rowIndex": 1995,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD",
    "qty": 56,
    "qtyKg": null,
    "price": 1435,
    "total": 80360
  },
  {
    "id": "ledger-2024-2026-1996",
    "rowIndex": 1996,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1445,
    "total": 24565
  },
  {
    "id": "ledger-2024-2026-1997",
    "rowIndex": 1997,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1435,
    "total": 7175
  },
  {
    "id": "ledger-2024-2026-1998",
    "rowIndex": 1998,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1445,
    "total": 7225
  },
  {
    "id": "ledger-2024-2026-1999",
    "rowIndex": 1999,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2000",
    "rowIndex": 2000,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2001",
    "rowIndex": 2001,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HSP",
    "qty": 22,
    "qtyKg": null,
    "price": 1445,
    "total": 31790
  },
  {
    "id": "ledger-2024-2026-2002",
    "rowIndex": 2002,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2003",
    "rowIndex": 2003,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43866",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1445,
    "total": 21675
  },
  {
    "id": "ledger-2024-2026-2004",
    "rowIndex": 2004,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1445,
    "total": 24565
  },
  {
    "id": "ledger-2024-2026-2005",
    "rowIndex": 2005,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1445,
    "total": 20230
  },
  {
    "id": "ledger-2024-2026-2006",
    "rowIndex": 2006,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD VR",
    "qty": 28,
    "qtyKg": null,
    "price": 1445,
    "total": 40460
  },
  {
    "id": "ledger-2024-2026-2007",
    "rowIndex": 2007,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1445,
    "total": 50575
  },
  {
    "id": "ledger-2024-2026-2008",
    "rowIndex": 2008,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1445,
    "total": 36125
  },
  {
    "id": "ledger-2024-2026-2009",
    "rowIndex": 2009,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1435,
    "total": 11480
  },
  {
    "id": "ledger-2024-2026-2010",
    "rowIndex": 2010,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2011",
    "rowIndex": 2011,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43989",
    "description": "HSP VTA2",
    "qty": 13,
    "qtyKg": null,
    "price": 1510,
    "total": 19630
  },
  {
    "id": "ledger-2024-2026-2012",
    "rowIndex": 2012,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1445,
    "total": 36125
  },
  {
    "id": "ledger-2024-2026-2013",
    "rowIndex": 2013,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1445,
    "total": 50575
  },
  {
    "id": "ledger-2024-2026-2014",
    "rowIndex": 2014,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HG HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1445,
    "total": 86700
  },
  {
    "id": "ledger-2024-2026-2015",
    "rowIndex": 2015,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2016",
    "rowIndex": 2016,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2017",
    "rowIndex": 2017,
    "date": "2026-02-03",
    "rawDate": 46056,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "43990",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2018",
    "rowIndex": 2018,
    "date": "2026-02-04",
    "rawDate": 46057,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Andres S.",
    "description": "HG HD",
    "qty": -10,
    "qtyKg": null,
    "price": 1435,
    "total": -14350
  },
  {
    "id": "ledger-2024-2026-2019",
    "rowIndex": 2019,
    "date": "2026-02-04",
    "rawDate": 46057,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Annabelle C.",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2020",
    "rowIndex": 2020,
    "date": "2026-02-04",
    "rawDate": 46057,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Marinel M.",
    "description": "HG HD",
    "qty": -18,
    "qtyKg": null,
    "price": 1435,
    "total": -25830
  },
  {
    "id": "ledger-2024-2026-2021",
    "rowIndex": 2021,
    "date": "2026-02-04",
    "rawDate": 46057,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Annabelle C.",
    "description": "HG HD",
    "qty": 19,
    "qtyKg": null,
    "price": 1435,
    "total": 27265
  },
  {
    "id": "ledger-2024-2026-2022",
    "rowIndex": 2022,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44155",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2023",
    "rowIndex": 2023,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44155",
    "description": "HG HD VAS",
    "qty": 140,
    "qtyKg": null,
    "price": 1545,
    "total": 216300
  },
  {
    "id": "ledger-2024-2026-2024",
    "rowIndex": 2024,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HG HD VR",
    "qty": 19,
    "qtyKg": null,
    "price": 1445,
    "total": 27455
  },
  {
    "id": "ledger-2024-2026-2025",
    "rowIndex": 2025,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HG HD VR",
    "qty": 16,
    "qtyKg": null,
    "price": 1445,
    "total": 23120
  },
  {
    "id": "ledger-2024-2026-2026",
    "rowIndex": 2026,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HG HD VR",
    "qty": 27,
    "qtyKg": null,
    "price": 1445,
    "total": 39015
  },
  {
    "id": "ledger-2024-2026-2027",
    "rowIndex": 2027,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-2028",
    "rowIndex": 2028,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HG HD VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1545,
    "total": 46350
  },
  {
    "id": "ledger-2024-2026-2029",
    "rowIndex": 2029,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44218",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1435,
    "total": 43050
  },
  {
    "id": "ledger-2024-2026-2030",
    "rowIndex": 2030,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44220",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1435,
    "total": 14350
  },
  {
    "id": "ledger-2024-2026-2031",
    "rowIndex": 2031,
    "date": "2026-02-09",
    "rawDate": 46062,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44220",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2032",
    "rowIndex": 2032,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44254",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1445,
    "total": 50575
  },
  {
    "id": "ledger-2024-2026-2033",
    "rowIndex": 2033,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44254",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2034",
    "rowIndex": 2034,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44254",
    "description": "HG HD VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1545,
    "total": 46350
  },
  {
    "id": "ledger-2024-2026-2035",
    "rowIndex": 2035,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44254",
    "description": "HG HD",
    "qty": 40,
    "qtyKg": null,
    "price": 1435,
    "total": 57400
  },
  {
    "id": "ledger-2024-2026-2036",
    "rowIndex": 2036,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44254",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1445,
    "total": 50575
  },
  {
    "id": "ledger-2024-2026-2037",
    "rowIndex": 2037,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44302",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1445,
    "total": 43350
  },
  {
    "id": "ledger-2024-2026-2038",
    "rowIndex": 2038,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44302",
    "description": "HSP VI",
    "qty": 20,
    "qtyKg": null,
    "price": 1460,
    "total": 29200
  },
  {
    "id": "ledger-2024-2026-2039",
    "rowIndex": 2039,
    "date": "2026-02-10",
    "rawDate": 46063,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44302",
    "description": "HSP VT A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1520,
    "total": 45600
  },
  {
    "id": "ledger-2024-2026-2040",
    "rowIndex": 2040,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1445,
    "total": 7225
  },
  {
    "id": "ledger-2024-2026-2041",
    "rowIndex": 2041,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HG HD Pulmotil",
    "qty": 10,
    "qtyKg": null,
    "price": 1485,
    "total": 14850
  },
  {
    "id": "ledger-2024-2026-2042",
    "rowIndex": 2042,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HG HD VR",
    "qty": 36,
    "qtyKg": null,
    "price": 1455,
    "total": 52380
  },
  {
    "id": "ledger-2024-2026-2043",
    "rowIndex": 2043,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1455,
    "total": 7275
  },
  {
    "id": "ledger-2024-2026-2044",
    "rowIndex": 2044,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-2045",
    "rowIndex": 2045,
    "date": "2026-02-12",
    "rawDate": 46065,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44353",
    "description": "HG HD",
    "qty": 14,
    "qtyKg": null,
    "price": 1445,
    "total": 20230
  },
  {
    "id": "ledger-2024-2026-2046",
    "rowIndex": 2046,
    "date": "2026-02-16",
    "rawDate": 46069,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44465",
    "description": "HG HD VR",
    "qty": 24,
    "qtyKg": null,
    "price": 1455,
    "total": 34920
  },
  {
    "id": "ledger-2024-2026-2047",
    "rowIndex": 2047,
    "date": "2026-02-16",
    "rawDate": 46069,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44465",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2048",
    "rowIndex": 2048,
    "date": "2026-02-16",
    "rawDate": 46069,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44465",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-2049",
    "rowIndex": 2049,
    "date": "2026-02-16",
    "rawDate": 46069,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44465",
    "description": "HG HD",
    "qty": 41,
    "qtyKg": null,
    "price": 1445,
    "total": 59245
  },
  {
    "id": "ledger-2024-2026-2050",
    "rowIndex": 2050,
    "date": "2026-02-16",
    "rawDate": 46069,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44465",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1455,
    "total": 50925
  },
  {
    "id": "ledger-2024-2026-2051",
    "rowIndex": 2051,
    "date": "2026-02-17",
    "rawDate": 46070,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44543",
    "description": "HG HD VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1455,
    "total": 101850
  },
  {
    "id": "ledger-2024-2026-2052",
    "rowIndex": 2052,
    "date": "2026-02-17",
    "rawDate": 46070,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44543",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1445,
    "total": 7225
  },
  {
    "id": "ledger-2024-2026-2053",
    "rowIndex": 2053,
    "date": "2026-02-17",
    "rawDate": 46070,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44543",
    "description": "HG HD",
    "qty": 60,
    "qtyKg": null,
    "price": 1445,
    "total": 86700
  },
  {
    "id": "ledger-2024-2026-2054",
    "rowIndex": 2054,
    "date": "2026-02-17",
    "rawDate": 46070,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44543",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1455,
    "total": 1455
  },
  {
    "id": "ledger-2024-2026-2055",
    "rowIndex": 2055,
    "date": "2026-02-17",
    "rawDate": 46070,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44543",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-2056",
    "rowIndex": 2056,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1445,
    "total": 17340
  },
  {
    "id": "ledger-2024-2026-2057",
    "rowIndex": 2057,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD",
    "qty": 25,
    "qtyKg": null,
    "price": 1445,
    "total": 36125
  },
  {
    "id": "ledger-2024-2026-2058",
    "rowIndex": 2058,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD VR",
    "qty": 9,
    "qtyKg": null,
    "price": 1455,
    "total": 13095
  },
  {
    "id": "ledger-2024-2026-2059",
    "rowIndex": 2059,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Salvacion, Dominga",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Dominga",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-2060",
    "rowIndex": 2060,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD VR",
    "qty": 35,
    "qtyKg": null,
    "price": 1455,
    "total": 50925
  },
  {
    "id": "ledger-2024-2026-2061",
    "rowIndex": 2061,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-2062",
    "rowIndex": 2062,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44560",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1455,
    "total": 20370
  },
  {
    "id": "ledger-2024-2026-2063",
    "rowIndex": 2063,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44597",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-2064",
    "rowIndex": 2064,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44597",
    "description": "HSP VT A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1520,
    "total": 34960
  },
  {
    "id": "ledger-2024-2026-2065",
    "rowIndex": 2065,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44597",
    "description": "HSP VT A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1520,
    "total": 25840
  },
  {
    "id": "ledger-2024-2026-2066",
    "rowIndex": 2066,
    "date": "2026-02-18",
    "rawDate": 46071,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 120,
    "qtyKg": null,
    "price": 9650,
    "total": 1158000
  },
  {
    "id": "ledger-2024-2026-2067",
    "rowIndex": 2067,
    "date": "2026-02-19",
    "rawDate": 46072,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3010",
    "ledgerDescription": "Piglets",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 9560,
    "total": 478000
  },
  {
    "id": "ledger-2024-2026-2068",
    "rowIndex": 2068,
    "date": "2026-02-20",
    "rawDate": 46073,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44674",
    "description": "HSP VT A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1520,
    "total": 76000
  },
  {
    "id": "ledger-2024-2026-2069",
    "rowIndex": 2069,
    "date": "2026-02-20",
    "rawDate": 46073,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44675",
    "description": "HG HD",
    "qty": 100,
    "qtyKg": null,
    "price": 1445,
    "total": 144500
  },
  {
    "id": "ledger-2024-2026-2070",
    "rowIndex": 2070,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1455,
    "total": 24735
  },
  {
    "id": "ledger-2024-2026-2071",
    "rowIndex": 2071,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1455,
    "total": 20370
  },
  {
    "id": "ledger-2024-2026-2072",
    "rowIndex": 2072,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-2073",
    "rowIndex": 2073,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2074",
    "rowIndex": 2074,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1455,
    "total": 21825
  },
  {
    "id": "ledger-2024-2026-2075",
    "rowIndex": 2075,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 39,
    "qtyKg": null,
    "price": 1455,
    "total": 56745
  },
  {
    "id": "ledger-2024-2026-2076",
    "rowIndex": 2076,
    "date": "2026-02-23",
    "rawDate": 46076,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44750",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2077",
    "rowIndex": 2077,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44909",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1445,
    "total": 72250
  },
  {
    "id": "ledger-2024-2026-2078",
    "rowIndex": 2078,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44909",
    "description": "HG HD VR",
    "qty": 100,
    "qtyKg": null,
    "price": 1455,
    "total": 145500
  },
  {
    "id": "ledger-2024-2026-2079",
    "rowIndex": 2079,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD",
    "qty": 3,
    "qtyKg": null,
    "price": 1445,
    "total": 4335
  },
  {
    "id": "ledger-2024-2026-2080",
    "rowIndex": 2080,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-2081",
    "rowIndex": 2081,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 6,
    "qtyKg": null,
    "price": 1455,
    "total": 8730
  },
  {
    "id": "ledger-2024-2026-2082",
    "rowIndex": 2082,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HSP VT A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1520,
    "total": 18240
  },
  {
    "id": "ledger-2024-2026-2083",
    "rowIndex": 2083,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1445,
    "total": 17340
  },
  {
    "id": "ledger-2024-2026-2084",
    "rowIndex": 2084,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-2085",
    "rowIndex": 2085,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 5,
    "qtyKg": null,
    "price": 1455,
    "total": 7275
  },
  {
    "id": "ledger-2024-2026-2086",
    "rowIndex": 2086,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1455,
    "total": 24735
  },
  {
    "id": "ledger-2024-2026-2087",
    "rowIndex": 2087,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-2088",
    "rowIndex": 2088,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HSP VT A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1520,
    "total": 38000
  },
  {
    "id": "ledger-2024-2026-2089",
    "rowIndex": 2089,
    "date": "2026-02-26",
    "rawDate": 46079,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44930",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2090",
    "rowIndex": 2090,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HG HD",
    "qty": 17,
    "qtyKg": null,
    "price": 1445,
    "total": 24565
  },
  {
    "id": "ledger-2024-2026-2091",
    "rowIndex": 2091,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1445,
    "total": 18785
  },
  {
    "id": "ledger-2024-2026-2092",
    "rowIndex": 2092,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2093",
    "rowIndex": 2093,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1455,
    "total": 58200
  },
  {
    "id": "ledger-2024-2026-2094",
    "rowIndex": 2094,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HG HD",
    "qty": 35,
    "qtyKg": null,
    "price": 1445,
    "total": 50575
  },
  {
    "id": "ledger-2024-2026-2095",
    "rowIndex": 2095,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44995",
    "description": "HSP VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1470,
    "total": 36750
  },
  {
    "id": "ledger-2024-2026-2096",
    "rowIndex": 2096,
    "date": "2026-03-02",
    "rawDate": 46083,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "44997",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1455,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-2097",
    "rowIndex": 2097,
    "date": "2026-03-03",
    "rawDate": 46084,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45134",
    "description": "HSP VT A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1520,
    "total": 83600
  },
  {
    "id": "ledger-2024-2026-2098",
    "rowIndex": 2098,
    "date": "2026-03-03",
    "rawDate": 46084,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45135",
    "description": "HSP VT A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1520,
    "total": 34960
  },
  {
    "id": "ledger-2024-2026-2099",
    "rowIndex": 2099,
    "date": "2026-03-03",
    "rawDate": 46084,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45135",
    "description": "HSP VI",
    "qty": 22,
    "qtyKg": null,
    "price": 1470,
    "total": 32340
  },
  {
    "id": "ledger-2024-2026-2100",
    "rowIndex": 2100,
    "date": "2026-03-03",
    "rawDate": 46084,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45135",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2101",
    "rowIndex": 2101,
    "date": "2026-03-03",
    "rawDate": 46084,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45135",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2102",
    "rowIndex": 2102,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1445,
    "total": 10115
  },
  {
    "id": "ledger-2024-2026-2103",
    "rowIndex": 2103,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1455,
    "total": 26190
  },
  {
    "id": "ledger-2024-2026-2104",
    "rowIndex": 2104,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1455,
    "total": 10185
  },
  {
    "id": "ledger-2024-2026-2105",
    "rowIndex": 2105,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD VR",
    "qty": 60,
    "qtyKg": null,
    "price": 1455,
    "total": 87300
  },
  {
    "id": "ledger-2024-2026-2106",
    "rowIndex": 2106,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-2107",
    "rowIndex": 2107,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HSP VI",
    "qty": 23,
    "qtyKg": null,
    "price": 1470,
    "total": 33810
  },
  {
    "id": "ledger-2024-2026-2108",
    "rowIndex": 2108,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2109",
    "rowIndex": 2109,
    "date": "2026-03-04",
    "rawDate": 46085,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45177",
    "description": "HG HD VR",
    "qty": 17,
    "qtyKg": null,
    "price": 1455,
    "total": 24735
  },
  {
    "id": "ledger-2024-2026-2110",
    "rowIndex": 2110,
    "date": "2026-03-06",
    "rawDate": 46087,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45251",
    "description": "HG HD VR",
    "qty": 150,
    "qtyKg": null,
    "price": 1455,
    "total": 218250
  },
  {
    "id": "ledger-2024-2026-2111",
    "rowIndex": 2111,
    "date": "2026-03-06",
    "rawDate": 46087,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45253",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2112",
    "rowIndex": 2112,
    "date": "2026-03-06",
    "rawDate": 46087,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45253",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2113",
    "rowIndex": 2113,
    "date": "2026-03-07",
    "rawDate": 46088,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45278",
    "description": "HG HD",
    "qty": 50,
    "qtyKg": null,
    "price": 1445,
    "total": 72250
  },
  {
    "id": "ledger-2024-2026-2114",
    "rowIndex": 2114,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 18,
    "qtyKg": null,
    "price": 1445,
    "total": 26010
  },
  {
    "id": "ledger-2024-2026-2115",
    "rowIndex": 2115,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1445,
    "total": 21675
  },
  {
    "id": "ledger-2024-2026-2116",
    "rowIndex": 2116,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 21,
    "qtyKg": null,
    "price": 1445,
    "total": 30345
  },
  {
    "id": "ledger-2024-2026-2117",
    "rowIndex": 2117,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1455,
    "total": 58200
  },
  {
    "id": "ledger-2024-2026-2118",
    "rowIndex": 2118,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 26,
    "qtyKg": null,
    "price": 1445,
    "total": 37570
  },
  {
    "id": "ledger-2024-2026-2119",
    "rowIndex": 2119,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1495,
    "total": 14950
  },
  {
    "id": "ledger-2024-2026-2120",
    "rowIndex": 2120,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2121",
    "rowIndex": 2121,
    "date": "2026-03-09",
    "rawDate": 46090,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45287",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2122",
    "rowIndex": 2122,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45394",
    "description": "HG HD",
    "qty": 75,
    "qtyKg": null,
    "price": 1445,
    "total": 108375
  },
  {
    "id": "ledger-2024-2026-2123",
    "rowIndex": 2123,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45395",
    "description": "HSP VI",
    "qty": 35,
    "qtyKg": null,
    "price": 1465,
    "total": 51275
  },
  {
    "id": "ledger-2024-2026-2124",
    "rowIndex": 2124,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45395",
    "description": "HSP VT A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1520,
    "total": 38000
  },
  {
    "id": "ledger-2024-2026-2125",
    "rowIndex": 2125,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45395",
    "description": "HSP VT A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1520,
    "total": 22800
  },
  {
    "id": "ledger-2024-2026-2126",
    "rowIndex": 2126,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to R. Agon",
    "description": "HG HD VR",
    "qty": -50,
    "qtyKg": null,
    "price": 1455,
    "total": -72750
  },
  {
    "id": "ledger-2024-2026-2127",
    "rowIndex": 2127,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Dok Kenneth",
    "description": "HG HD VR",
    "qty": -25,
    "qtyKg": null,
    "price": 1455,
    "total": -36375
  },
  {
    "id": "ledger-2024-2026-2128",
    "rowIndex": 2128,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Masaya",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1455,
    "total": 72750
  },
  {
    "id": "ledger-2024-2026-2129",
    "rowIndex": 2129,
    "date": "2026-03-10",
    "rawDate": 46091,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Masaya",
    "description": "HG HD VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1455,
    "total": 36375
  },
  {
    "id": "ledger-2024-2026-2130",
    "rowIndex": 2130,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD VR",
    "qty": 46,
    "qtyKg": null,
    "price": 1455,
    "total": 66930
  },
  {
    "id": "ledger-2024-2026-2131",
    "rowIndex": 2131,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2132",
    "rowIndex": 2132,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2133",
    "rowIndex": 2133,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-2134",
    "rowIndex": 2134,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1495,
    "total": 44850
  },
  {
    "id": "ledger-2024-2026-2135",
    "rowIndex": 2135,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Macatangay, Marinel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Macatangay, Marinel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1445,
    "total": 7225
  },
  {
    "id": "ledger-2024-2026-2136",
    "rowIndex": 2136,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2137",
    "rowIndex": 2137,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45496",
    "description": "HG HD",
    "qty": 19,
    "qtyKg": null,
    "price": 1445,
    "total": 27455
  },
  {
    "id": "ledger-2024-2026-2138",
    "rowIndex": 2138,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45498",
    "description": "HG HD VR",
    "qty": 18,
    "qtyKg": null,
    "price": 1455,
    "total": 26190
  },
  {
    "id": "ledger-2024-2026-2139",
    "rowIndex": 2139,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45498",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1495,
    "total": 22425
  },
  {
    "id": "ledger-2024-2026-2140",
    "rowIndex": 2140,
    "date": "2026-03-12",
    "rawDate": 46093,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45498",
    "description": "HSP A2",
    "qty": 27,
    "qtyKg": null,
    "price": 1495,
    "total": 40365
  },
  {
    "id": "ledger-2024-2026-2141",
    "rowIndex": 2141,
    "date": "2026-03-13",
    "rawDate": 46094,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45549",
    "description": "HSP A2",
    "qty": 75,
    "qtyKg": null,
    "price": 1495,
    "total": 112125
  },
  {
    "id": "ledger-2024-2026-2142",
    "rowIndex": 2142,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-2143",
    "rowIndex": 2143,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-2144",
    "rowIndex": 2144,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD",
    "qty": 6,
    "qtyKg": null,
    "price": 1445,
    "total": 8670
  },
  {
    "id": "ledger-2024-2026-2145",
    "rowIndex": 2145,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD VR",
    "qty": 6,
    "qtyKg": null,
    "price": 1455,
    "total": 8730
  },
  {
    "id": "ledger-2024-2026-2146",
    "rowIndex": 2146,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD",
    "qty": 13,
    "qtyKg": null,
    "price": 1445,
    "total": 18785
  },
  {
    "id": "ledger-2024-2026-2147",
    "rowIndex": 2147,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD VR",
    "qty": 13,
    "qtyKg": null,
    "price": 1455,
    "total": 18915
  },
  {
    "id": "ledger-2024-2026-2148",
    "rowIndex": 2148,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD VR",
    "qty": 34,
    "qtyKg": null,
    "price": 1455,
    "total": 49470
  },
  {
    "id": "ledger-2024-2026-2149",
    "rowIndex": 2149,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD",
    "qty": 18,
    "qtyKg": null,
    "price": 1445,
    "total": 26010
  },
  {
    "id": "ledger-2024-2026-2150",
    "rowIndex": 2150,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HG HD VR",
    "qty": 19,
    "qtyKg": null,
    "price": 1455,
    "total": 27645
  },
  {
    "id": "ledger-2024-2026-2151",
    "rowIndex": 2151,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1455,
    "total": 10185
  },
  {
    "id": "ledger-2024-2026-2152",
    "rowIndex": 2152,
    "date": "2026-03-16",
    "rawDate": 46097,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45637",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1495,
    "total": 26910
  },
  {
    "id": "ledger-2024-2026-2153",
    "rowIndex": 2153,
    "date": "2026-03-17",
    "rawDate": 46098,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45677",
    "description": "HG HD",
    "qty": 150,
    "qtyKg": null,
    "price": 1445,
    "total": 216750
  },
  {
    "id": "ledger-2024-2026-2154",
    "rowIndex": 2154,
    "date": "2026-03-17",
    "rawDate": 46098,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45706",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2155",
    "rowIndex": 2155,
    "date": "2026-03-17",
    "rawDate": 46098,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45706",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1455,
    "total": 29100
  },
  {
    "id": "ledger-2024-2026-2156",
    "rowIndex": 2156,
    "date": "2026-03-18",
    "rawDate": 46099,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45748",
    "description": "HSP VI",
    "qty": 15,
    "qtyKg": null,
    "price": 1465,
    "total": 21975
  },
  {
    "id": "ledger-2024-2026-2157",
    "rowIndex": 2157,
    "date": "2026-03-18",
    "rawDate": 46099,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45748",
    "description": "HSP VT A2",
    "qty": 135,
    "qtyKg": null,
    "price": 1520,
    "total": 205200
  },
  {
    "id": "ledger-2024-2026-2158",
    "rowIndex": 2158,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45780",
    "description": "HG HD",
    "qty": 25,
    "qtyKg": null,
    "price": 1445,
    "total": 36125
  },
  {
    "id": "ledger-2024-2026-2159",
    "rowIndex": 2159,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45780",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1495,
    "total": 37375
  },
  {
    "id": "ledger-2024-2026-2160",
    "rowIndex": 2160,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45780",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1495,
    "total": 37375
  },
  {
    "id": "ledger-2024-2026-2161",
    "rowIndex": 2161,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD",
    "qty": 4,
    "qtyKg": null,
    "price": 1445,
    "total": 5780
  },
  {
    "id": "ledger-2024-2026-2162",
    "rowIndex": 2162,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD VR",
    "qty": 4,
    "qtyKg": null,
    "price": 1455,
    "total": 5820
  },
  {
    "id": "ledger-2024-2026-2163",
    "rowIndex": 2163,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1445,
    "total": 11560
  },
  {
    "id": "ledger-2024-2026-2164",
    "rowIndex": 2164,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1455,
    "total": 11640
  },
  {
    "id": "ledger-2024-2026-2165",
    "rowIndex": 2165,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HSP A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1495,
    "total": 37375
  },
  {
    "id": "ledger-2024-2026-2166",
    "rowIndex": 2166,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1445,
    "total": 28900
  },
  {
    "id": "ledger-2024-2026-2167",
    "rowIndex": 2167,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD VR",
    "qty": 47,
    "qtyKg": null,
    "price": 1455,
    "total": 68385
  },
  {
    "id": "ledger-2024-2026-2168",
    "rowIndex": 2168,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD",
    "qty": 10,
    "qtyKg": null,
    "price": 1445,
    "total": 14450
  },
  {
    "id": "ledger-2024-2026-2169",
    "rowIndex": 2169,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1455,
    "total": 14550
  },
  {
    "id": "ledger-2024-2026-2170",
    "rowIndex": 2170,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1445,
    "total": 10115
  },
  {
    "id": "ledger-2024-2026-2171",
    "rowIndex": 2171,
    "date": "2026-03-19",
    "rawDate": 46100,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45794",
    "description": "HG HD VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1455,
    "total": 10185
  },
  {
    "id": "ledger-2024-2026-2172",
    "rowIndex": 2172,
    "date": "2026-03-20",
    "rawDate": 46101,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45841",
    "description": "HSP VI",
    "qty": 40,
    "qtyKg": null,
    "price": 1465,
    "total": 58600
  },
  {
    "id": "ledger-2024-2026-2173",
    "rowIndex": 2173,
    "date": "2026-03-20",
    "rawDate": 46101,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45841",
    "description": "HSP VT A2",
    "qty": 60,
    "qtyKg": null,
    "price": 1520,
    "total": 91200
  },
  {
    "id": "ledger-2024-2026-2174",
    "rowIndex": 2174,
    "date": "2026-03-20",
    "rawDate": 46101,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45848",
    "description": "HSP VT A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1520,
    "total": 76000
  },
  {
    "id": "ledger-2024-2026-2175",
    "rowIndex": 2175,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD",
    "qty": 12,
    "qtyKg": null,
    "price": 1465,
    "total": 17580
  },
  {
    "id": "ledger-2024-2026-2176",
    "rowIndex": 2176,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD VR",
    "qty": 12,
    "qtyKg": null,
    "price": 1475,
    "total": 17700
  },
  {
    "id": "ledger-2024-2026-2177",
    "rowIndex": 2177,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD",
    "qty": 8,
    "qtyKg": null,
    "price": 1465,
    "total": 11720
  },
  {
    "id": "ledger-2024-2026-2178",
    "rowIndex": 2178,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD VR",
    "qty": 8,
    "qtyKg": null,
    "price": 1475,
    "total": 11800
  },
  {
    "id": "ledger-2024-2026-2179",
    "rowIndex": 2179,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD",
    "qty": 15,
    "qtyKg": null,
    "price": 1465,
    "total": 21975
  },
  {
    "id": "ledger-2024-2026-2180",
    "rowIndex": 2180,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1475,
    "total": 22125
  },
  {
    "id": "ledger-2024-2026-2181",
    "rowIndex": 2181,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD",
    "qty": 21,
    "qtyKg": null,
    "price": 1465,
    "total": 30765
  },
  {
    "id": "ledger-2024-2026-2182",
    "rowIndex": 2182,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1475,
    "total": 29500
  },
  {
    "id": "ledger-2024-2026-2183",
    "rowIndex": 2183,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD",
    "qty": 20,
    "qtyKg": null,
    "price": 1465,
    "total": 29300
  },
  {
    "id": "ledger-2024-2026-2184",
    "rowIndex": 2184,
    "date": "2026-03-23",
    "rawDate": 46104,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "45852",
    "description": "HG HD VR",
    "qty": 19,
    "qtyKg": null,
    "price": 1475,
    "total": 28025
  },
  {
    "id": "ledger-2024-2026-2185",
    "rowIndex": 2185,
    "date": "2026-03-25",
    "rawDate": 46106,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46035",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1515,
    "total": 30300
  },
  {
    "id": "ledger-2024-2026-2186",
    "rowIndex": 2186,
    "date": "2026-03-25",
    "rawDate": 46106,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46035",
    "description": "HSP",
    "qty": 80,
    "qtyKg": null,
    "price": 1475,
    "total": 118000
  },
  {
    "id": "ledger-2024-2026-2187",
    "rowIndex": 2187,
    "date": "2026-03-25",
    "rawDate": 46106,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46035",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1515,
    "total": 22725
  },
  {
    "id": "ledger-2024-2026-2188",
    "rowIndex": 2188,
    "date": "2026-03-25",
    "rawDate": 46106,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46035",
    "description": "HSP VT A2",
    "qty": 35,
    "qtyKg": null,
    "price": 1540,
    "total": 53900
  },
  {
    "id": "ledger-2024-2026-2189",
    "rowIndex": 2189,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46067",
    "description": "HG HD",
    "qty": 18,
    "qtyKg": null,
    "price": 1465,
    "total": 26370
  },
  {
    "id": "ledger-2024-2026-2190",
    "rowIndex": 2190,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46067",
    "description": "HG HD VAS",
    "qty": 17,
    "qtyKg": null,
    "price": 1575,
    "total": 26775
  },
  {
    "id": "ledger-2024-2026-2191",
    "rowIndex": 2191,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46067",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1475,
    "total": 59000
  },
  {
    "id": "ledger-2024-2026-2192",
    "rowIndex": 2192,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD VR",
    "qty": 6,
    "qtyKg": null,
    "price": 1475,
    "total": 8850
  },
  {
    "id": "ledger-2024-2026-2193",
    "rowIndex": 2193,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD",
    "qty": 7,
    "qtyKg": null,
    "price": 1465,
    "total": 10255
  },
  {
    "id": "ledger-2024-2026-2194",
    "rowIndex": 2194,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1475,
    "total": 22125
  },
  {
    "id": "ledger-2024-2026-2195",
    "rowIndex": 2195,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1475,
    "total": 66375
  },
  {
    "id": "ledger-2024-2026-2196",
    "rowIndex": 2196,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD",
    "qty": 9,
    "qtyKg": null,
    "price": 1465,
    "total": 13185
  },
  {
    "id": "ledger-2024-2026-2197",
    "rowIndex": 2197,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1475,
    "total": 73750
  },
  {
    "id": "ledger-2024-2026-2198",
    "rowIndex": 2198,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD VR",
    "qty": 9,
    "qtyKg": null,
    "price": 1475,
    "total": 13275
  },
  {
    "id": "ledger-2024-2026-2199",
    "rowIndex": 2199,
    "date": "2026-03-26",
    "rawDate": 46107,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46091",
    "description": "HG HD",
    "qty": 9,
    "qtyKg": null,
    "price": 1465,
    "total": 13185
  },
  {
    "id": "ledger-2024-2026-2200",
    "rowIndex": 2200,
    "date": "2026-03-27",
    "rawDate": 46108,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46121",
    "description": "HG HD",
    "qty": 150,
    "qtyKg": null,
    "price": 1465,
    "total": 219750
  },
  {
    "id": "ledger-2024-2026-2201",
    "rowIndex": 2201,
    "date": "2026-03-27",
    "rawDate": 46108,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46121",
    "description": "HSP VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1495,
    "total": 22425
  },
  {
    "id": "ledger-2024-2026-2202",
    "rowIndex": 2202,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46184",
    "description": "HG HD",
    "qty": 22,
    "qtyKg": null,
    "price": 1465,
    "total": 32230
  },
  {
    "id": "ledger-2024-2026-2203",
    "rowIndex": 2203,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46184",
    "description": "HG HD",
    "qty": 22,
    "qtyKg": null,
    "price": 1465,
    "total": 32230
  },
  {
    "id": "ledger-2024-2026-2204",
    "rowIndex": 2204,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46184",
    "description": "HG HD",
    "qty": 31,
    "qtyKg": null,
    "price": 1465,
    "total": 45415
  },
  {
    "id": "ledger-2024-2026-2205",
    "rowIndex": 2205,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46184",
    "description": "HG HD",
    "qty": 45,
    "qtyKg": null,
    "price": 1465,
    "total": 65925
  },
  {
    "id": "ledger-2024-2026-2206",
    "rowIndex": 2206,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46184",
    "description": "HG HD",
    "qty": 30,
    "qtyKg": null,
    "price": 1465,
    "total": 43950
  },
  {
    "id": "ledger-2024-2026-2207",
    "rowIndex": 2207,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46208",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1515,
    "total": 22725
  },
  {
    "id": "ledger-2024-2026-2208",
    "rowIndex": 2208,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46208",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1515,
    "total": 15150
  },
  {
    "id": "ledger-2024-2026-2209",
    "rowIndex": 2209,
    "date": "2026-03-30",
    "rawDate": 46111,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46208",
    "description": "HSP A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1515,
    "total": 15150
  },
  {
    "id": "ledger-2024-2026-2210",
    "rowIndex": 2210,
    "date": "2026-03-31",
    "rawDate": 46112,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46312",
    "description": "HSP",
    "qty": 90,
    "qtyKg": null,
    "price": 1525,
    "total": 137250
  },
  {
    "id": "ledger-2024-2026-2211",
    "rowIndex": 2211,
    "date": "2026-03-31",
    "rawDate": 46112,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46312",
    "description": "HSP VI",
    "qty": 60,
    "qtyKg": null,
    "price": 1535,
    "total": 92100
  },
  {
    "id": "ledger-2024-2026-2212",
    "rowIndex": 2212,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1515,
    "total": 15150
  },
  {
    "id": "ledger-2024-2026-2213",
    "rowIndex": 2213,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1515,
    "total": 30300
  },
  {
    "id": "ledger-2024-2026-2214",
    "rowIndex": 2214,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 3,
    "qtyKg": null,
    "price": 1515,
    "total": 4545
  },
  {
    "id": "ledger-2024-2026-2215",
    "rowIndex": 2215,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG HD",
    "qty": 17,
    "qtyKg": null,
    "price": 1515,
    "total": 25755
  },
  {
    "id": "ledger-2024-2026-2216",
    "rowIndex": 2216,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 14,
    "qtyKg": null,
    "price": 1515,
    "total": 21210
  },
  {
    "id": "ledger-2024-2026-2217",
    "rowIndex": 2217,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1525,
    "total": 45750
  },
  {
    "id": "ledger-2024-2026-2218",
    "rowIndex": 2218,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 7,
    "qtyKg": null,
    "price": 1515,
    "total": 10605
  },
  {
    "id": "ledger-2024-2026-2219",
    "rowIndex": 2219,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 13,
    "qtyKg": null,
    "price": 1515,
    "total": 19695
  },
  {
    "id": "ledger-2024-2026-2220",
    "rowIndex": 2220,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Dok Kenneth",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dok Kenneth",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 7,
    "qtyKg": null,
    "price": 1515,
    "total": 10605
  },
  {
    "id": "ledger-2024-2026-2221",
    "rowIndex": 2221,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1515,
    "total": 30300
  },
  {
    "id": "ledger-2024-2026-2222",
    "rowIndex": 2222,
    "date": "2026-04-01",
    "rawDate": 46113,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46371",
    "description": "HG Deluxe",
    "qty": 9,
    "qtyKg": null,
    "price": 1515,
    "total": 13635
  },
  {
    "id": "ledger-2024-2026-2223",
    "rowIndex": 2223,
    "date": "2026-04-04",
    "rawDate": 46116,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46385",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1525,
    "total": 68625
  },
  {
    "id": "ledger-2024-2026-2224",
    "rowIndex": 2224,
    "date": "2026-04-04",
    "rawDate": 46116,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46388",
    "description": "HSP",
    "qty": 70,
    "qtyKg": null,
    "price": 1525,
    "total": 106750
  },
  {
    "id": "ledger-2024-2026-2225",
    "rowIndex": 2225,
    "date": "2026-04-04",
    "rawDate": 46116,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46389",
    "description": "HSP",
    "qty": 80,
    "qtyKg": null,
    "price": 1525,
    "total": 122000
  },
  {
    "id": "ledger-2024-2026-2226",
    "rowIndex": 2226,
    "date": "2026-04-06",
    "rawDate": 46118,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46456",
    "description": "HG HD A2",
    "qty": 25,
    "qtyKg": null,
    "price": 1555,
    "total": 38875
  },
  {
    "id": "ledger-2024-2026-2227",
    "rowIndex": 2227,
    "date": "2026-04-06",
    "rawDate": 46118,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46456",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1515,
    "total": 37875
  },
  {
    "id": "ledger-2024-2026-2228",
    "rowIndex": 2228,
    "date": "2026-04-06",
    "rawDate": 46118,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46456",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1525,
    "total": 76250
  },
  {
    "id": "ledger-2024-2026-2229",
    "rowIndex": 2229,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46497",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1525,
    "total": 45750
  },
  {
    "id": "ledger-2024-2026-2230",
    "rowIndex": 2230,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46497",
    "description": "HSP",
    "qty": 100,
    "qtyKg": null,
    "price": 1525,
    "total": 152500
  },
  {
    "id": "ledger-2024-2026-2231",
    "rowIndex": 2231,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46497",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1525,
    "total": 15250
  },
  {
    "id": "ledger-2024-2026-2232",
    "rowIndex": 2232,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46497",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1535,
    "total": 15350
  },
  {
    "id": "ledger-2024-2026-2233",
    "rowIndex": 2233,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Ilao, Jocelyn",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Ilao, Jocelyn",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG Deluxe",
    "qty": 2,
    "qtyKg": null,
    "price": 1515,
    "total": 3030
  },
  {
    "id": "ledger-2024-2026-2234",
    "rowIndex": 2234,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1515,
    "total": 22725
  },
  {
    "id": "ledger-2024-2026-2235",
    "rowIndex": 2235,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG HD VR",
    "qty": 11,
    "qtyKg": null,
    "price": 1525,
    "total": 16775
  },
  {
    "id": "ledger-2024-2026-2236",
    "rowIndex": 2236,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1525,
    "total": 1525
  },
  {
    "id": "ledger-2024-2026-2237",
    "rowIndex": 2237,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HSP VAS",
    "qty": 7,
    "qtyKg": null,
    "price": 1545,
    "total": 10815
  },
  {
    "id": "ledger-2024-2026-2238",
    "rowIndex": 2238,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HSP VAS",
    "qty": 6,
    "qtyKg": null,
    "price": 1545,
    "total": 9270
  },
  {
    "id": "ledger-2024-2026-2239",
    "rowIndex": 2239,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HSP VAS",
    "qty": 12,
    "qtyKg": null,
    "price": 1545,
    "total": 18540
  },
  {
    "id": "ledger-2024-2026-2240",
    "rowIndex": 2240,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1525,
    "total": 45750
  },
  {
    "id": "ledger-2024-2026-2241",
    "rowIndex": 2241,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG Deluxe",
    "qty": 30,
    "qtyKg": null,
    "price": 1515,
    "total": 45450
  },
  {
    "id": "ledger-2024-2026-2242",
    "rowIndex": 2242,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1565,
    "total": 46950
  },
  {
    "id": "ledger-2024-2026-2243",
    "rowIndex": 2243,
    "date": "2026-04-07",
    "rawDate": 46119,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46539",
    "description": "HG Deluxe",
    "qty": 6,
    "qtyKg": null,
    "price": 1515,
    "total": 9090
  },
  {
    "id": "ledger-2024-2026-2244",
    "rowIndex": 2244,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46556",
    "description": "HG Deluxe",
    "qty": 120,
    "qtyKg": null,
    "price": 1540,
    "total": 184800
  },
  {
    "id": "ledger-2024-2026-2245",
    "rowIndex": 2245,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46556",
    "description": "HG HD VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1525,
    "total": 45750
  },
  {
    "id": "ledger-2024-2026-2246",
    "rowIndex": 2246,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46583",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1540,
    "total": 38500
  },
  {
    "id": "ledger-2024-2026-2247",
    "rowIndex": 2247,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46583",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1540,
    "total": 15400
  },
  {
    "id": "ledger-2024-2026-2248",
    "rowIndex": 2248,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46583",
    "description": "HG Deluxe VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1550,
    "total": 31000
  },
  {
    "id": "ledger-2024-2026-2249",
    "rowIndex": 2249,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46583",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1540,
    "total": 38500
  },
  {
    "id": "ledger-2024-2026-2250",
    "rowIndex": 2250,
    "date": "2026-04-08",
    "rawDate": 46120,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46583",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1540,
    "total": 30800
  },
  {
    "id": "ledger-2024-2026-2251",
    "rowIndex": 2251,
    "date": "2026-04-10",
    "rawDate": 46122,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46649",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1550,
    "total": 232500
  },
  {
    "id": "ledger-2024-2026-2252",
    "rowIndex": 2252,
    "date": "2026-04-10",
    "rawDate": 46122,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46650",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1550,
    "total": 232500
  },
  {
    "id": "ledger-2024-2026-2253",
    "rowIndex": 2253,
    "date": "2026-04-13",
    "rawDate": 46125,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46693",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1540,
    "total": 23100
  },
  {
    "id": "ledger-2024-2026-2254",
    "rowIndex": 2254,
    "date": "2026-04-13",
    "rawDate": 46125,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46693",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1540,
    "total": 7700
  },
  {
    "id": "ledger-2024-2026-2255",
    "rowIndex": 2255,
    "date": "2026-04-13",
    "rawDate": 46125,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46693",
    "description": "HG Deluxe VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1650,
    "total": 16500
  },
  {
    "id": "ledger-2024-2026-2256",
    "rowIndex": 2256,
    "date": "2026-04-13",
    "rawDate": 46125,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46693",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1550,
    "total": 31000
  },
  {
    "id": "ledger-2024-2026-2257",
    "rowIndex": 2257,
    "date": "2026-04-13",
    "rawDate": 46125,
    "raiser": "Patron, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Patron, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46693",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1550,
    "total": 15500
  },
  {
    "id": "ledger-2024-2026-2258",
    "rowIndex": 2258,
    "date": "2026-04-14",
    "rawDate": 46126,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46787",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1550,
    "total": 232500
  },
  {
    "id": "ledger-2024-2026-2259",
    "rowIndex": 2259,
    "date": "2026-04-14",
    "rawDate": 46126,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46809",
    "description": "HSP",
    "qty": 140,
    "qtyKg": null,
    "price": 1550,
    "total": 217000
  },
  {
    "id": "ledger-2024-2026-2260",
    "rowIndex": 2260,
    "date": "2026-04-14",
    "rawDate": 46126,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46809",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1550,
    "total": 15500
  },
  {
    "id": "ledger-2024-2026-2261",
    "rowIndex": 2261,
    "date": "2026-04-15",
    "rawDate": 46127,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46886",
    "description": "HSP",
    "qty": 39,
    "qtyKg": null,
    "price": 1550,
    "total": 60450
  },
  {
    "id": "ledger-2024-2026-2262",
    "rowIndex": 2262,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46920",
    "description": "HSP VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1560,
    "total": 39000
  },
  {
    "id": "ledger-2024-2026-2263",
    "rowIndex": 2263,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46920",
    "description": "HG Deluxe",
    "qty": 24,
    "qtyKg": null,
    "price": 1540,
    "total": 36960
  },
  {
    "id": "ledger-2024-2026-2264",
    "rowIndex": 2264,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46920",
    "description": "HG Deluxe VR",
    "qty": 21,
    "qtyKg": null,
    "price": 1550,
    "total": 32550
  },
  {
    "id": "ledger-2024-2026-2265",
    "rowIndex": 2265,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "",
    "batch": "2026-01",
    "cycleCode": "2026-01",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46920",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1540,
    "total": 7700
  },
  {
    "id": "ledger-2024-2026-2266",
    "rowIndex": 2266,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46921",
    "description": "HG Deluxe",
    "qty": 9,
    "qtyKg": null,
    "price": 1540,
    "total": 13860
  },
  {
    "id": "ledger-2024-2026-2267",
    "rowIndex": 2267,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46921",
    "description": "HG Deluxe VR",
    "qty": 9,
    "qtyKg": null,
    "price": 1550,
    "total": 13950
  },
  {
    "id": "ledger-2024-2026-2268",
    "rowIndex": 2268,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46921",
    "description": "HG Deluxe VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1650,
    "total": 33000
  },
  {
    "id": "ledger-2024-2026-2269",
    "rowIndex": 2269,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46921",
    "description": "HSP",
    "qty": 42,
    "qtyKg": null,
    "price": 1550,
    "total": 65100
  },
  {
    "id": "ledger-2024-2026-2270",
    "rowIndex": 2270,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Myrna B.",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1465,
    "total": 2930
  },
  {
    "id": "ledger-2024-2026-2271",
    "rowIndex": 2271,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Joel A.",
    "description": "HG HD",
    "qty": -2,
    "qtyKg": null,
    "price": 1465,
    "total": -2930
  },
  {
    "id": "ledger-2024-2026-2272",
    "rowIndex": 2272,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Buhay D.",
    "description": "HG Deluxe",
    "qty": -2,
    "qtyKg": null,
    "price": 1540,
    "total": -3080
  },
  {
    "id": "ledger-2024-2026-2273",
    "rowIndex": 2273,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from John A.",
    "description": "HG Deluxe",
    "qty": 2,
    "qtyKg": null,
    "price": 1540,
    "total": 3080
  },
  {
    "id": "ledger-2024-2026-2274",
    "rowIndex": 2274,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Buhay D.",
    "description": "HG HD",
    "qty": -2,
    "qtyKg": null,
    "price": 1465,
    "total": -2930
  },
  {
    "id": "ledger-2024-2026-2275",
    "rowIndex": 2275,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Myrna B.",
    "description": "HG HD",
    "qty": 2,
    "qtyKg": null,
    "price": 1465,
    "total": 2930
  },
  {
    "id": "ledger-2024-2026-2276",
    "rowIndex": 2276,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Buhay D.",
    "description": "HG HD",
    "qty": -5,
    "qtyKg": null,
    "price": 1465,
    "total": -7325
  },
  {
    "id": "ledger-2024-2026-2277",
    "rowIndex": 2277,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Myrna B.",
    "description": "HG HD",
    "qty": 5,
    "qtyKg": null,
    "price": 1465,
    "total": 7325
  },
  {
    "id": "ledger-2024-2026-2278",
    "rowIndex": 2278,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Buhay D.",
    "description": "HG Deluxe",
    "qty": -10,
    "qtyKg": null,
    "price": 1540,
    "total": -15400
  },
  {
    "id": "ledger-2024-2026-2279",
    "rowIndex": 2279,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Estok",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1540,
    "total": 15400
  },
  {
    "id": "ledger-2024-2026-2280",
    "rowIndex": 2280,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Rodel A.",
    "description": "HG HD",
    "qty": 3.5,
    "qtyKg": null,
    "price": 1445,
    "total": 5057.5
  },
  {
    "id": "ledger-2024-2026-2281",
    "rowIndex": 2281,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Agon, Rodel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Agon, Rodel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Danny D.",
    "description": "HG HD",
    "qty": -3.5,
    "qtyKg": null,
    "price": 1445,
    "total": -5057.5
  },
  {
    "id": "ledger-2024-2026-2282",
    "rowIndex": 2282,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Larry C.",
    "description": "HG HD",
    "qty": -1,
    "qtyKg": null,
    "price": 1515,
    "total": -1515
  },
  {
    "id": "ledger-2024-2026-2283",
    "rowIndex": 2283,
    "date": "2026-04-16",
    "rawDate": 46128,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Richard S.",
    "description": "HG HD",
    "qty": 1,
    "qtyKg": null,
    "price": 1515,
    "total": 1515
  },
  {
    "id": "ledger-2024-2026-2284",
    "rowIndex": 2284,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46934",
    "description": "HG Deluxe A2",
    "qty": 120,
    "qtyKg": null,
    "price": 1580,
    "total": 189600
  },
  {
    "id": "ledger-2024-2026-2285",
    "rowIndex": 2285,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46934",
    "description": "HG Deluxe VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1550,
    "total": 46500
  },
  {
    "id": "ledger-2024-2026-2286",
    "rowIndex": 2286,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46944",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1540,
    "total": 7700
  },
  {
    "id": "ledger-2024-2026-2287",
    "rowIndex": 2287,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46944",
    "description": "HG Deluxe VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1550,
    "total": 23250
  },
  {
    "id": "ledger-2024-2026-2288",
    "rowIndex": 2288,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46944",
    "description": "HSP VI",
    "qty": 11,
    "qtyKg": null,
    "price": 1565,
    "total": 17215
  },
  {
    "id": "ledger-2024-2026-2289",
    "rowIndex": 2289,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46944",
    "description": "HSP VI",
    "qty": 7,
    "qtyKg": null,
    "price": 1565,
    "total": 10955
  },
  {
    "id": "ledger-2024-2026-2290",
    "rowIndex": 2290,
    "date": "2026-04-17",
    "rawDate": 46129,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "46944",
    "description": "HSP VI",
    "qty": 7,
    "qtyKg": null,
    "price": 1565,
    "total": 10955
  },
  {
    "id": "ledger-2024-2026-2291",
    "rowIndex": 2291,
    "date": "2026-04-21",
    "rawDate": 46133,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47060",
    "description": "HSP",
    "qty": 5,
    "qtyKg": null,
    "price": 1550,
    "total": 7750
  },
  {
    "id": "ledger-2024-2026-2292",
    "rowIndex": 2292,
    "date": "2026-04-21",
    "rawDate": 46133,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47060",
    "description": "HSP A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1590,
    "total": 238500
  },
  {
    "id": "ledger-2024-2026-2293",
    "rowIndex": 2293,
    "date": "2026-04-21",
    "rawDate": 46133,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47061",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1550,
    "total": 232500
  },
  {
    "id": "ledger-2024-2026-2294",
    "rowIndex": 2294,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47116",
    "description": "HG Deluxe",
    "qty": 6,
    "qtyKg": null,
    "price": 1540,
    "total": 9240
  },
  {
    "id": "ledger-2024-2026-2295",
    "rowIndex": 2295,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47116",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1540,
    "total": 15400
  },
  {
    "id": "ledger-2024-2026-2296",
    "rowIndex": 2296,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47116",
    "description": "HG Deluxe VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1550,
    "total": 62000
  },
  {
    "id": "ledger-2024-2026-2297",
    "rowIndex": 2297,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47116",
    "description": "HG Deluxe A2",
    "qty": 50,
    "qtyKg": null,
    "price": 1580,
    "total": 79000
  },
  {
    "id": "ledger-2024-2026-2298",
    "rowIndex": 2298,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47116",
    "description": "HSP",
    "qty": 44,
    "qtyKg": null,
    "price": 1550,
    "total": 68200
  },
  {
    "id": "ledger-2024-2026-2299",
    "rowIndex": 2299,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HG Deluxe A2",
    "qty": 7,
    "qtyKg": null,
    "price": 1580,
    "total": 11060
  },
  {
    "id": "ledger-2024-2026-2300",
    "rowIndex": 2300,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Coliat, Amy",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HSP A2",
    "qty": 3,
    "qtyKg": null,
    "price": 1590,
    "total": 4770
  },
  {
    "id": "ledger-2024-2026-2301",
    "rowIndex": 2301,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HSP A2",
    "qty": 5,
    "qtyKg": null,
    "price": 1590,
    "total": 7950
  },
  {
    "id": "ledger-2024-2026-2302",
    "rowIndex": 2302,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HSP",
    "qty": 45,
    "qtyKg": null,
    "price": 1550,
    "total": 69750
  },
  {
    "id": "ledger-2024-2026-2303",
    "rowIndex": 2303,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HSP VAS",
    "qty": 40,
    "qtyKg": null,
    "price": 1615,
    "total": 64600
  },
  {
    "id": "ledger-2024-2026-2304",
    "rowIndex": 2304,
    "date": "2026-04-22",
    "rawDate": 46134,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47117",
    "description": "HG Deluxe",
    "qty": 50,
    "qtyKg": null,
    "price": 1540,
    "total": 77000
  },
  {
    "id": "ledger-2024-2026-2305",
    "rowIndex": 2305,
    "date": "2026-04-23",
    "rawDate": 46135,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47190",
    "description": "HSP",
    "qty": 135,
    "qtyKg": null,
    "price": 1550,
    "total": 209250
  },
  {
    "id": "ledger-2024-2026-2306",
    "rowIndex": 2306,
    "date": "2026-04-23",
    "rawDate": 46135,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47190",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1550,
    "total": 23250
  },
  {
    "id": "ledger-2024-2026-2307",
    "rowIndex": 2307,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47242",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1575,
    "total": 236250
  },
  {
    "id": "ledger-2024-2026-2308",
    "rowIndex": 2308,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 53,
    "qtyKg": 7449,
    "price": 211.20821586790174,
    "total": 1573290
  },
  {
    "id": "ledger-2024-2026-2309",
    "rowIndex": 2309,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 443,
    "qtyKg": null,
    "price": 50,
    "total": 22150
  },
  {
    "id": "ledger-2024-2026-2310",
    "rowIndex": 2310,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 443,
    "qtyKg": null,
    "price": 3,
    "total": 1329
  },
  {
    "id": "ledger-2024-2026-2311",
    "rowIndex": 2311,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 53,
    "qtyKg": null,
    "price": 100,
    "total": 5300
  },
  {
    "id": "ledger-2024-2026-2312",
    "rowIndex": 2312,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 53,
    "qtyKg": null,
    "price": 200,
    "total": 10600
  },
  {
    "id": "ledger-2024-2026-2313",
    "rowIndex": 2313,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 55,
    "qtyKg": null,
    "price": 500,
    "total": 27500
  },
  {
    "id": "ledger-2024-2026-2314",
    "rowIndex": 2314,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, Joel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2315",
    "rowIndex": 2315,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 38,
    "qtyKg": 5359.6,
    "price": 212.90021643406223,
    "total": 1141060
  },
  {
    "id": "ledger-2024-2026-2316",
    "rowIndex": 2316,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 338,
    "qtyKg": null,
    "price": 50,
    "total": 16900
  },
  {
    "id": "ledger-2024-2026-2317",
    "rowIndex": 2317,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 338,
    "qtyKg": null,
    "price": 3,
    "total": 1014
  },
  {
    "id": "ledger-2024-2026-2318",
    "rowIndex": 2318,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 38,
    "qtyKg": null,
    "price": 100,
    "total": 3800
  },
  {
    "id": "ledger-2024-2026-2319",
    "rowIndex": 2319,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 38,
    "qtyKg": null,
    "price": 200,
    "total": 7600
  },
  {
    "id": "ledger-2024-2026-2320",
    "rowIndex": 2320,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 500,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-2321",
    "rowIndex": 2321,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Alcantara, John",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2322",
    "rowIndex": 2322,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 68,
    "qtyKg": 8865.2,
    "price": 205.21499796958895,
    "total": 1819272
  },
  {
    "id": "ledger-2024-2026-2323",
    "rowIndex": 2323,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 918,
    "total": 918
  },
  {
    "id": "ledger-2024-2026-2324",
    "rowIndex": 2324,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 539,
    "qtyKg": null,
    "price": 50,
    "total": 26950
  },
  {
    "id": "ledger-2024-2026-2325",
    "rowIndex": 2325,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 539,
    "qtyKg": null,
    "price": 3,
    "total": 1617
  },
  {
    "id": "ledger-2024-2026-2326",
    "rowIndex": 2326,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 68,
    "qtyKg": null,
    "price": 100,
    "total": 6800
  },
  {
    "id": "ledger-2024-2026-2327",
    "rowIndex": 2327,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 68,
    "qtyKg": null,
    "price": 200,
    "total": 13600
  },
  {
    "id": "ledger-2024-2026-2328",
    "rowIndex": 2328,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": null,
    "price": 500,
    "total": 37000
  },
  {
    "id": "ledger-2024-2026-2329",
    "rowIndex": 2329,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Barro, Myrna",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 6,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2330",
    "rowIndex": 2330,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 97,
    "qtyKg": 11705.4,
    "price": 211.30110888991408,
    "total": 2473364
  },
  {
    "id": "ledger-2024-2026-2331",
    "rowIndex": 2331,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 697,
    "qtyKg": null,
    "price": 50,
    "total": 34850
  },
  {
    "id": "ledger-2024-2026-2332",
    "rowIndex": 2332,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 697,
    "qtyKg": null,
    "price": 3,
    "total": 2091
  },
  {
    "id": "ledger-2024-2026-2333",
    "rowIndex": 2333,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 97,
    "qtyKg": null,
    "price": 100,
    "total": 9700
  },
  {
    "id": "ledger-2024-2026-2334",
    "rowIndex": 2334,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 97,
    "qtyKg": null,
    "price": 200,
    "total": 19400
  },
  {
    "id": "ledger-2024-2026-2335",
    "rowIndex": 2335,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 100,
    "qtyKg": null,
    "price": 500,
    "total": 50000
  },
  {
    "id": "ledger-2024-2026-2336",
    "rowIndex": 2336,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 3,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2337",
    "rowIndex": 2337,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": 10808.8,
    "price": 206.67243357264454,
    "total": 2233881
  },
  {
    "id": "ledger-2024-2026-2338",
    "rowIndex": 2338,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 15600,
    "total": 15600
  },
  {
    "id": "ledger-2024-2026-2339",
    "rowIndex": 2339,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 661,
    "qtyKg": null,
    "price": 50,
    "total": 33050
  },
  {
    "id": "ledger-2024-2026-2340",
    "rowIndex": 2340,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 20000,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-2341",
    "rowIndex": 2341,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 661,
    "qtyKg": null,
    "price": 3,
    "total": 1983
  },
  {
    "id": "ledger-2024-2026-2342",
    "rowIndex": 2342,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": null,
    "price": 100,
    "total": 7400
  },
  {
    "id": "ledger-2024-2026-2343",
    "rowIndex": 2343,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 74,
    "qtyKg": null,
    "price": 200,
    "total": 14800
  },
  {
    "id": "ledger-2024-2026-2344",
    "rowIndex": 2344,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 80,
    "qtyKg": null,
    "price": 500,
    "total": 40000
  },
  {
    "id": "ledger-2024-2026-2345",
    "rowIndex": 2345,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Estok",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Estok",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 6,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2346",
    "rowIndex": 2346,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 87,
    "qtyKg": 10651.6,
    "price": 192.7229711968155,
    "total": 2052808.0000000002
  },
  {
    "id": "ledger-2024-2026-2347",
    "rowIndex": 2347,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 9856,
    "total": 9856
  },
  {
    "id": "ledger-2024-2026-2348",
    "rowIndex": 2348,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 595,
    "qtyKg": null,
    "price": 50,
    "total": 29750
  },
  {
    "id": "ledger-2024-2026-2349",
    "rowIndex": 2349,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 595,
    "qtyKg": null,
    "price": 3,
    "total": 1785
  },
  {
    "id": "ledger-2024-2026-2350",
    "rowIndex": 2350,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 87,
    "qtyKg": null,
    "price": 100,
    "total": 8700
  },
  {
    "id": "ledger-2024-2026-2351",
    "rowIndex": 2351,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 87,
    "qtyKg": null,
    "price": 200,
    "total": 17400
  },
  {
    "id": "ledger-2024-2026-2352",
    "rowIndex": 2352,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 90,
    "qtyKg": null,
    "price": 500,
    "total": 45000
  },
  {
    "id": "ledger-2024-2026-2353",
    "rowIndex": 2353,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Dimaano, Danny (Pen 1)",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Dimaano, Danny (Pen 1)",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 3,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2354",
    "rowIndex": 2354,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 36,
    "qtyKg": 4104.6,
    "price": 205,
    "total": 850443.0000000001
  },
  {
    "id": "ledger-2024-2026-2355",
    "rowIndex": 2355,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 6910,
    "total": 6910
  },
  {
    "id": "ledger-2024-2026-2356",
    "rowIndex": 2356,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 231,
    "qtyKg": null,
    "price": 50,
    "total": 11550
  },
  {
    "id": "ledger-2024-2026-2357",
    "rowIndex": 2357,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 231,
    "qtyKg": null,
    "price": 3,
    "total": 693
  },
  {
    "id": "ledger-2024-2026-2358",
    "rowIndex": 2358,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 36,
    "qtyKg": null,
    "price": 100,
    "total": 3600
  },
  {
    "id": "ledger-2024-2026-2359",
    "rowIndex": 2359,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 36,
    "qtyKg": null,
    "price": 200,
    "total": 7200
  },
  {
    "id": "ledger-2024-2026-2360",
    "rowIndex": 2360,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 40,
    "qtyKg": null,
    "price": 500,
    "total": 20000
  },
  {
    "id": "ledger-2024-2026-2361",
    "rowIndex": 2361,
    "date": "2026-04-27",
    "rawDate": 46139,
    "raiser": "Salvacion, Richard",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Salvacion, Richard",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 4,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2362",
    "rowIndex": 2362,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP A2",
    "qty": 23,
    "qtyKg": null,
    "price": 1615,
    "total": 37145
  },
  {
    "id": "ledger-2024-2026-2363",
    "rowIndex": 2363,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1575,
    "total": 1575
  },
  {
    "id": "ledger-2024-2026-2364",
    "rowIndex": 2364,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP A2",
    "qty": 17,
    "qtyKg": null,
    "price": 1615,
    "total": 27455
  },
  {
    "id": "ledger-2024-2026-2365",
    "rowIndex": 2365,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP A2",
    "qty": 18,
    "qtyKg": null,
    "price": 1615,
    "total": 29070
  },
  {
    "id": "ledger-2024-2026-2366",
    "rowIndex": 2366,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1575,
    "total": 31500
  },
  {
    "id": "ledger-2024-2026-2367",
    "rowIndex": 2367,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HG Deluxe VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1625,
    "total": 48750
  },
  {
    "id": "ledger-2024-2026-2368",
    "rowIndex": 2368,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1560,
    "total": 39000
  },
  {
    "id": "ledger-2024-2026-2369",
    "rowIndex": 2369,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HSP A2",
    "qty": 15,
    "qtyKg": null,
    "price": 1615,
    "total": 24225
  },
  {
    "id": "ledger-2024-2026-2370",
    "rowIndex": 2370,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47352",
    "description": "HG Deluxe",
    "qty": 1,
    "qtyKg": null,
    "price": 1560,
    "total": 1560
  },
  {
    "id": "ledger-2024-2026-2371",
    "rowIndex": 2371,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Buhay I",
    "description": "HG Deluxe",
    "qty": 2.5,
    "qtyKg": null,
    "price": 1515,
    "total": 3787.5
  },
  {
    "id": "ledger-2024-2026-2372",
    "rowIndex": 2372,
    "date": "2026-04-28",
    "rawDate": 46140,
    "raiser": "Dimaano, Mabuhay",
    "batch": "2025-02",
    "cycleCode": "2025-02 - Dimaano, Mabuhay",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Larry C.",
    "description": "HG Deluxe",
    "qty": -2.5,
    "qtyKg": null,
    "price": 1515,
    "total": -3787.5
  },
  {
    "id": "ledger-2024-2026-2373",
    "rowIndex": 2373,
    "date": "2026-04-29",
    "rawDate": 46141,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47377",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1575,
    "total": 23625
  },
  {
    "id": "ledger-2024-2026-2374",
    "rowIndex": 2374,
    "date": "2026-04-29",
    "rawDate": 46141,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47377",
    "description": "HSP",
    "qty": 135,
    "qtyKg": null,
    "price": 1575,
    "total": 212625
  },
  {
    "id": "ledger-2024-2026-2375",
    "rowIndex": 2375,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": "napera",
    "qty": 1,
    "qtyKg": null,
    "price": 12500,
    "total": 12500
  },
  {
    "id": "ledger-2024-2026-2376",
    "rowIndex": 2376,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2088",
    "description": null,
    "qty": 19,
    "qtyKg": 2572.7999999999997,
    "price": 205,
    "total": 527424
  },
  {
    "id": "ledger-2024-2026-2377",
    "rowIndex": 2377,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2089",
    "description": null,
    "qty": 1,
    "qtyKg": 107.8,
    "price": 205,
    "total": 22099
  },
  {
    "id": "ledger-2024-2026-2378",
    "rowIndex": 2378,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47479",
    "description": "HSP",
    "qty": 80,
    "qtyKg": null,
    "price": 1575,
    "total": 126000
  },
  {
    "id": "ledger-2024-2026-2379",
    "rowIndex": 2379,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47479",
    "description": "HG Deluxe A2",
    "qty": 70,
    "qtyKg": null,
    "price": 1600,
    "total": 112000
  },
  {
    "id": "ledger-2024-2026-2380",
    "rowIndex": 2380,
    "date": "2026-04-30",
    "rawDate": 46142,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47479",
    "description": "HG Deluxe VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1670,
    "total": 16700
  },
  {
    "id": "ledger-2024-2026-2381",
    "rowIndex": 2381,
    "date": "2026-05-01",
    "rawDate": 46143,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47504",
    "description": "HG Deluxe VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1670,
    "total": 50100
  },
  {
    "id": "ledger-2024-2026-2382",
    "rowIndex": 2382,
    "date": "2026-05-01",
    "rawDate": 46143,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47504",
    "description": "HG Deluxe",
    "qty": 70,
    "qtyKg": null,
    "price": 1560,
    "total": 109200
  },
  {
    "id": "ledger-2024-2026-2383",
    "rowIndex": 2383,
    "date": "2026-05-02",
    "rawDate": 46144,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2095",
    "description": null,
    "qty": 27,
    "qtyKg": 3458.6000000000004,
    "price": 205,
    "total": 709013.0000000001
  },
  {
    "id": "ledger-2024-2026-2384",
    "rowIndex": 2384,
    "date": "2026-05-06",
    "rawDate": 46148,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47664",
    "description": "HSP",
    "qty": 75,
    "qtyKg": null,
    "price": 1575,
    "total": 118125
  },
  {
    "id": "ledger-2024-2026-2385",
    "rowIndex": 2385,
    "date": "2026-05-06",
    "rawDate": 46148,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47664",
    "description": "HG Deluxe",
    "qty": 80,
    "qtyKg": null,
    "price": 1560,
    "total": 124800
  },
  {
    "id": "ledger-2024-2026-2386",
    "rowIndex": 2386,
    "date": "2026-05-06",
    "rawDate": 46148,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Erap - Tony",
    "description": "HG Deluxe VR",
    "qty": -15,
    "qtyKg": null,
    "price": 1550,
    "total": -23250
  },
  {
    "id": "ledger-2024-2026-2387",
    "rowIndex": 2387,
    "date": "2026-05-06",
    "rawDate": 46148,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Masaya",
    "description": "HG Deluxe VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1550,
    "total": 23250
  },
  {
    "id": "ledger-2024-2026-2388",
    "rowIndex": 2388,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP A2",
    "qty": 30,
    "qtyKg": null,
    "price": 1615,
    "total": 48450
  },
  {
    "id": "ledger-2024-2026-2389",
    "rowIndex": 2389,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1640,
    "total": 16400
  },
  {
    "id": "ledger-2024-2026-2390",
    "rowIndex": 2390,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP",
    "qty": 3,
    "qtyKg": null,
    "price": 1575,
    "total": 4725
  },
  {
    "id": "ledger-2024-2026-2391",
    "rowIndex": 2391,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Amie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1615,
    "total": 20995
  },
  {
    "id": "ledger-2024-2026-2392",
    "rowIndex": 2392,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP",
    "qty": 4,
    "qtyKg": null,
    "price": 1575,
    "total": 6300
  },
  {
    "id": "ledger-2024-2026-2393",
    "rowIndex": 2393,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP A2",
    "qty": 12,
    "qtyKg": null,
    "price": 1615,
    "total": 19380
  },
  {
    "id": "ledger-2024-2026-2394",
    "rowIndex": 2394,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP",
    "qty": 8,
    "qtyKg": null,
    "price": 1575,
    "total": 12600
  },
  {
    "id": "ledger-2024-2026-2395",
    "rowIndex": 2395,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Coliat, Nardo",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47716",
    "description": "HSP A2",
    "qty": 20,
    "qtyKg": null,
    "price": 1615,
    "total": 32300
  },
  {
    "id": "ledger-2024-2026-2396",
    "rowIndex": 2396,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47717",
    "description": "HG Deluxe",
    "qty": 55,
    "qtyKg": null,
    "price": 1560,
    "total": 85800
  },
  {
    "id": "ledger-2024-2026-2397",
    "rowIndex": 2397,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47718",
    "description": "HSP",
    "qty": 15,
    "qtyKg": null,
    "price": 1575,
    "total": 23625
  },
  {
    "id": "ledger-2024-2026-2398",
    "rowIndex": 2398,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47718",
    "description": "HSP",
    "qty": 80,
    "qtyKg": null,
    "price": 1575,
    "total": 126000
  },
  {
    "id": "ledger-2024-2026-2399",
    "rowIndex": 2399,
    "date": "2026-05-07",
    "rawDate": 46149,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47719",
    "description": "HSP",
    "qty": 60,
    "qtyKg": null,
    "price": 1575,
    "total": 94500
  },
  {
    "id": "ledger-2024-2026-2400",
    "rowIndex": 2400,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2101",
    "description": null,
    "qty": 1,
    "qtyKg": 113.8,
    "price": 200,
    "total": 22760
  },
  {
    "id": "ledger-2024-2026-2401",
    "rowIndex": 2401,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2101",
    "description": null,
    "qty": null,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2402",
    "rowIndex": 2402,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47753",
    "description": "HSP",
    "qty": 150,
    "qtyKg": null,
    "price": 1575,
    "total": 236250
  },
  {
    "id": "ledger-2024-2026-2403",
    "rowIndex": 2403,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Patron, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47762",
    "description": "HSP VTA2",
    "qty": 10,
    "qtyKg": null,
    "price": 1640,
    "total": 16400
  },
  {
    "id": "ledger-2024-2026-2404",
    "rowIndex": 2404,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": 8599.6,
    "price": 204.9041815898414,
    "total": 1762094
  },
  {
    "id": "ledger-2024-2026-2405",
    "rowIndex": 2405,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2101",
    "description": null,
    "qty": 50,
    "qtyKg": 5301,
    "price": 200,
    "total": 1060200
  },
  {
    "id": "ledger-2024-2026-2406",
    "rowIndex": 2406,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 2927,
    "total": 2927
  },
  {
    "id": "ledger-2024-2026-2407",
    "rowIndex": 2407,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 450,
    "qtyKg": null,
    "price": 50,
    "total": 22500
  },
  {
    "id": "ledger-2024-2026-2408",
    "rowIndex": 2408,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 450,
    "qtyKg": null,
    "price": 3,
    "total": 1350
  },
  {
    "id": "ledger-2024-2026-2409",
    "rowIndex": 2409,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": null,
    "price": 100,
    "total": 6900
  },
  {
    "id": "ledger-2024-2026-2410",
    "rowIndex": 2410,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 69,
    "qtyKg": null,
    "price": 200,
    "total": 13800
  },
  {
    "id": "ledger-2024-2026-2411",
    "rowIndex": 2411,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 500,
    "total": 35000
  },
  {
    "id": "ledger-2024-2026-2412",
    "rowIndex": 2412,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Vergara, Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Vergara, Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2413",
    "rowIndex": 2413,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 48,
    "qtyKg": 6248.2,
    "price": 205.67075317691496,
    "total": 1285072
  },
  {
    "id": "ledger-2024-2026-2414",
    "rowIndex": 2414,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 2525,
    "total": 2525
  },
  {
    "id": "ledger-2024-2026-2415",
    "rowIndex": 2415,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 328,
    "qtyKg": null,
    "price": 50,
    "total": 16400
  },
  {
    "id": "ledger-2024-2026-2416",
    "rowIndex": 2416,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 328,
    "qtyKg": null,
    "price": 3,
    "total": 984
  },
  {
    "id": "ledger-2024-2026-2417",
    "rowIndex": 2417,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 15000,
    "total": 15000
  },
  {
    "id": "ledger-2024-2026-2418",
    "rowIndex": 2418,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 48,
    "qtyKg": null,
    "price": 100,
    "total": 4800
  },
  {
    "id": "ledger-2024-2026-2419",
    "rowIndex": 2419,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 48,
    "qtyKg": null,
    "price": 200,
    "total": 9600
  },
  {
    "id": "ledger-2024-2026-2420",
    "rowIndex": 2420,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 50,
    "qtyKg": null,
    "price": 500,
    "total": 25000
  },
  {
    "id": "ledger-2024-2026-2421",
    "rowIndex": 2421,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Coliat, Larry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Larry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2422",
    "rowIndex": 2422,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 271,
    "qtyKg": 31774,
    "price": 201.33395228803425,
    "total": 6397185
  },
  {
    "id": "ledger-2024-2026-2423",
    "rowIndex": 2423,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 12474,
    "total": 12474
  },
  {
    "id": "ledger-2024-2026-2424",
    "rowIndex": 2424,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": null,
    "description": "lost feeds+trucking",
    "qty": 1,
    "qtyKg": null,
    "price": 3300,
    "total": 3300
  },
  {
    "id": "ledger-2024-2026-2425",
    "rowIndex": 2425,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 1870,
    "qtyKg": null,
    "price": 50,
    "total": 93500
  },
  {
    "id": "ledger-2024-2026-2426",
    "rowIndex": 2426,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 1870,
    "qtyKg": null,
    "price": 3,
    "total": 5610
  },
  {
    "id": "ledger-2024-2026-2427",
    "rowIndex": 2427,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4030",
    "ledgerDescription": "Adj - cash advance",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 100000,
    "total": 100000
  },
  {
    "id": "ledger-2024-2026-2428",
    "rowIndex": 2428,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 271,
    "qtyKg": null,
    "price": 100,
    "total": 27100
  },
  {
    "id": "ledger-2024-2026-2429",
    "rowIndex": 2429,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 271,
    "qtyKg": null,
    "price": 200,
    "total": 54200
  },
  {
    "id": "ledger-2024-2026-2430",
    "rowIndex": 2430,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 300,
    "qtyKg": null,
    "price": 500,
    "total": 150000
  },
  {
    "id": "ledger-2024-2026-2431",
    "rowIndex": 2431,
    "date": "2026-05-08",
    "rawDate": 46150,
    "raiser": "Masaya",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Masaya",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 29,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2432",
    "rowIndex": 2432,
    "date": "2026-05-09",
    "rawDate": 46151,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2104",
    "description": null,
    "qty": 24,
    "qtyKg": 3108.3999999999996,
    "price": 205,
    "total": 637221.9999999999
  },
  {
    "id": "ledger-2024-2026-2433",
    "rowIndex": 2433,
    "date": "2026-05-09",
    "rawDate": 46151,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2105",
    "description": null,
    "qty": 3,
    "qtyKg": 360.2,
    "price": 205,
    "total": 73841
  },
  {
    "id": "ledger-2024-2026-2434",
    "rowIndex": 2434,
    "date": "2026-05-10",
    "rawDate": 46152,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2106",
    "description": null,
    "qty": 10,
    "qtyKg": 1481.8,
    "price": 205,
    "total": 303769
  },
  {
    "id": "ledger-2024-2026-2435",
    "rowIndex": 2435,
    "date": "2026-05-12",
    "rawDate": 46154,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "47878",
    "description": "HSP VTA2",
    "qty": 30,
    "qtyKg": null,
    "price": 1650,
    "total": 49500
  },
  {
    "id": "ledger-2024-2026-2436",
    "rowIndex": 2436,
    "date": "2026-05-13",
    "rawDate": 46155,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47935",
    "description": "HG Deluxe VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1670,
    "total": 16700
  },
  {
    "id": "ledger-2024-2026-2437",
    "rowIndex": 2437,
    "date": "2026-05-13",
    "rawDate": 46155,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47935",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1575,
    "total": 31500
  },
  {
    "id": "ledger-2024-2026-2438",
    "rowIndex": 2438,
    "date": "2026-05-13",
    "rawDate": 46155,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "47935",
    "description": "HSP",
    "qty": 120,
    "qtyKg": null,
    "price": 1575,
    "total": 189000
  },
  {
    "id": "ledger-2024-2026-2439",
    "rowIndex": 2439,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48002",
    "description": "HG Deluxe VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1570,
    "total": 78500
  },
  {
    "id": "ledger-2024-2026-2440",
    "rowIndex": 2440,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48002",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1560,
    "total": 7800
  },
  {
    "id": "ledger-2024-2026-2441",
    "rowIndex": 2441,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Patron, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48002",
    "description": "HSP VTA2",
    "qty": 5,
    "qtyKg": null,
    "price": 1650,
    "total": 8250
  },
  {
    "id": "ledger-2024-2026-2442",
    "rowIndex": 2442,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1575,
    "total": 55125
  },
  {
    "id": "ledger-2024-2026-2443",
    "rowIndex": 2443,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HG Deluxe",
    "qty": 31,
    "qtyKg": null,
    "price": 1560,
    "total": 48360
  },
  {
    "id": "ledger-2024-2026-2444",
    "rowIndex": 2444,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HG Deluxe VR",
    "qty": 38,
    "qtyKg": null,
    "price": 1570,
    "total": 59660
  },
  {
    "id": "ledger-2024-2026-2445",
    "rowIndex": 2445,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HSP",
    "qty": 19,
    "qtyKg": null,
    "price": 1575,
    "total": 29925
  },
  {
    "id": "ledger-2024-2026-2446",
    "rowIndex": 2446,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Coliat, Amy",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amy",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1575,
    "total": 22050
  },
  {
    "id": "ledger-2024-2026-2447",
    "rowIndex": 2447,
    "date": "2026-05-14",
    "rawDate": 46156,
    "raiser": "Ailyn M.",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Ailyn M.",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48004",
    "description": "HSP",
    "qty": 13,
    "qtyKg": null,
    "price": 1575,
    "total": 20475
  },
  {
    "id": "ledger-2024-2026-2448",
    "rowIndex": 2448,
    "date": "2026-05-15",
    "rawDate": 46157,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48029",
    "description": "HSP SD",
    "qty": 150,
    "qtyKg": null,
    "price": 1595,
    "total": 239250
  },
  {
    "id": "ledger-2024-2026-2449",
    "rowIndex": 2449,
    "date": "2026-05-15",
    "rawDate": 46157,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48030",
    "description": "HG Deluxe",
    "qty": 100,
    "qtyKg": null,
    "price": 1560,
    "total": 156000
  },
  {
    "id": "ledger-2024-2026-2450",
    "rowIndex": 2450,
    "date": "2026-05-15",
    "rawDate": 46157,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48030",
    "description": "HG Deluxe VAS",
    "qty": 50,
    "qtyKg": null,
    "price": 1670,
    "total": 83500
  },
  {
    "id": "ledger-2024-2026-2451",
    "rowIndex": 2451,
    "date": "2026-05-16",
    "rawDate": 46158,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2114",
    "description": null,
    "qty": 13,
    "qtyKg": 1780.8,
    "price": 200,
    "total": 356160
  },
  {
    "id": "ledger-2024-2026-2452",
    "rowIndex": 2452,
    "date": "2026-05-16",
    "rawDate": 46158,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2115",
    "description": null,
    "qty": 12,
    "qtyKg": 1774.2,
    "price": 200,
    "total": 354840
  },
  {
    "id": "ledger-2024-2026-2453",
    "rowIndex": 2453,
    "date": "2026-05-16",
    "rawDate": 46158,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2115",
    "description": null,
    "qty": 1,
    "qtyKg": 51,
    "price": 165,
    "total": 8415
  },
  {
    "id": "ledger-2024-2026-2454",
    "rowIndex": 2454,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 10357,
    "total": 10357
  },
  {
    "id": "ledger-2024-2026-2455",
    "rowIndex": 2455,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 891,
    "qtyKg": null,
    "price": 50,
    "total": 44550
  },
  {
    "id": "ledger-2024-2026-2456",
    "rowIndex": 2456,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 891,
    "qtyKg": null,
    "price": 3,
    "total": 2673
  },
  {
    "id": "ledger-2024-2026-2457",
    "rowIndex": 2457,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 111,
    "qtyKg": null,
    "price": 100,
    "total": 11100
  },
  {
    "id": "ledger-2024-2026-2458",
    "rowIndex": 2458,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 111,
    "qtyKg": null,
    "price": 200,
    "total": 22200
  },
  {
    "id": "ledger-2024-2026-2459",
    "rowIndex": 2459,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 125,
    "qtyKg": null,
    "price": 500,
    "total": 62500
  },
  {
    "id": "ledger-2024-2026-2460",
    "rowIndex": 2460,
    "date": "2026-05-18",
    "rawDate": 46160,
    "raiser": "Casas, Joseph - Tony",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Casas, Joseph - Tony",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 14,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2461",
    "rowIndex": 2461,
    "date": "2026-05-20",
    "rawDate": 46162,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48173",
    "description": "HG Deluxe VAS",
    "qty": 60,
    "qtyKg": null,
    "price": 1670,
    "total": 100200
  },
  {
    "id": "ledger-2024-2026-2462",
    "rowIndex": 2462,
    "date": "2026-05-20",
    "rawDate": 46162,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48173",
    "description": "HSP",
    "qty": 90,
    "qtyKg": null,
    "price": 1575,
    "total": 141750
  },
  {
    "id": "ledger-2024-2026-2463",
    "rowIndex": 2463,
    "date": "2026-05-21",
    "rawDate": 46163,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48268",
    "description": "HG Deluxe",
    "qty": 70,
    "qtyKg": null,
    "price": 1560,
    "total": 109200
  },
  {
    "id": "ledger-2024-2026-2464",
    "rowIndex": 2464,
    "date": "2026-05-21",
    "rawDate": 46163,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48268",
    "description": "HG Deluxe VR",
    "qty": 80,
    "qtyKg": null,
    "price": 1570,
    "total": 125600
  },
  {
    "id": "ledger-2024-2026-2465",
    "rowIndex": 2465,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2118",
    "description": null,
    "qty": 13,
    "qtyKg": 1378.8,
    "price": 193,
    "total": 266108.39999999997
  },
  {
    "id": "ledger-2024-2026-2466",
    "rowIndex": 2466,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2119",
    "description": null,
    "qty": 3,
    "qtyKg": 369,
    "price": 193,
    "total": 71217
  },
  {
    "id": "ledger-2024-2026-2467",
    "rowIndex": 2467,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": 54,
    "price": 150,
    "total": 8100
  },
  {
    "id": "ledger-2024-2026-2468",
    "rowIndex": 2468,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48282",
    "description": "HG Deluxe VAS",
    "qty": 80,
    "qtyKg": null,
    "price": 1670,
    "total": 133600
  },
  {
    "id": "ledger-2024-2026-2469",
    "rowIndex": 2469,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48282",
    "description": "HSP",
    "qty": 70,
    "qtyKg": null,
    "price": 1575,
    "total": 110250
  },
  {
    "id": "ledger-2024-2026-2470",
    "rowIndex": 2470,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48284",
    "description": "HG Deluxe VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1570,
    "total": 47100
  },
  {
    "id": "ledger-2024-2026-2471",
    "rowIndex": 2471,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48284",
    "description": "HSP VTA2",
    "qty": 5,
    "qtyKg": null,
    "price": 1650,
    "total": 8250
  },
  {
    "id": "ledger-2024-2026-2472",
    "rowIndex": 2472,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48285",
    "description": "HG Deluxe VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1570,
    "total": 15700
  },
  {
    "id": "ledger-2024-2026-2473",
    "rowIndex": 2473,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48285",
    "description": "HSP VI",
    "qty": 25,
    "qtyKg": null,
    "price": 1590,
    "total": 39750
  },
  {
    "id": "ledger-2024-2026-2474",
    "rowIndex": 2474,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48285",
    "description": "HSP",
    "qty": 6,
    "qtyKg": null,
    "price": 1575,
    "total": 9450
  },
  {
    "id": "ledger-2024-2026-2475",
    "rowIndex": 2475,
    "date": "2026-05-22",
    "rawDate": 46164,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48285",
    "description": "HSP VT A2",
    "qty": 24,
    "qtyKg": null,
    "price": 1640,
    "total": 39360
  },
  {
    "id": "ledger-2024-2026-2476",
    "rowIndex": 2476,
    "date": "2026-05-25",
    "rawDate": 46167,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48369",
    "description": "HSP",
    "qty": 31,
    "qtyKg": null,
    "price": 1580,
    "total": 48980
  },
  {
    "id": "ledger-2024-2026-2477",
    "rowIndex": 2477,
    "date": "2026-05-25",
    "rawDate": 46167,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48369",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1580,
    "total": 39500
  },
  {
    "id": "ledger-2024-2026-2478",
    "rowIndex": 2478,
    "date": "2026-05-25",
    "rawDate": 46167,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48369",
    "description": "HSP",
    "qty": 24,
    "qtyKg": null,
    "price": 1580,
    "total": 37920
  },
  {
    "id": "ledger-2024-2026-2479",
    "rowIndex": 2479,
    "date": "2026-05-25",
    "rawDate": 46167,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48369",
    "description": "HG Deluxe VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1595,
    "total": 111650
  },
  {
    "id": "ledger-2024-2026-2480",
    "rowIndex": 2480,
    "date": "2026-05-26",
    "rawDate": 46168,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48401",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1585,
    "total": 39625
  },
  {
    "id": "ledger-2024-2026-2481",
    "rowIndex": 2481,
    "date": "2026-05-26",
    "rawDate": 46168,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48401",
    "description": "HG Deluxe",
    "qty": 55,
    "qtyKg": null,
    "price": 1585,
    "total": 87175
  },
  {
    "id": "ledger-2024-2026-2482",
    "rowIndex": 2482,
    "date": "2026-05-26",
    "rawDate": 46168,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48401",
    "description": "HG Deluxe VR",
    "qty": 70,
    "qtyKg": null,
    "price": 1595,
    "total": 111650
  },
  {
    "id": "ledger-2024-2026-2483",
    "rowIndex": 2483,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": null,
    "description": null,
    "qty": 81,
    "qtyKg": 7472.2,
    "price": 177.53419341024062,
    "total": 1326571
  },
  {
    "id": "ledger-2024-2026-2484",
    "rowIndex": 2484,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48437",
    "description": "HG Deluxe",
    "qty": 80,
    "qtyKg": null,
    "price": 1585,
    "total": 126800
  },
  {
    "id": "ledger-2024-2026-2485",
    "rowIndex": 2485,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48437",
    "description": "HG Deluxe VAS",
    "qty": 70,
    "qtyKg": null,
    "price": 1695,
    "total": 118650
  },
  {
    "id": "ledger-2024-2026-2486",
    "rowIndex": 2486,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48462",
    "description": "HG Deluxe VR",
    "qty": 80,
    "qtyKg": null,
    "price": 1595,
    "total": 127600
  },
  {
    "id": "ledger-2024-2026-2487",
    "rowIndex": 2487,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48462",
    "description": "HSP VI",
    "qty": 10,
    "qtyKg": null,
    "price": 1595,
    "total": 15950
  },
  {
    "id": "ledger-2024-2026-2488",
    "rowIndex": 2488,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48463",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1580,
    "total": 55300
  },
  {
    "id": "ledger-2024-2026-2489",
    "rowIndex": 2489,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48463",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1690,
    "total": 42250
  },
  {
    "id": "ledger-2024-2026-2490",
    "rowIndex": 2490,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3031",
    "ledgerDescription": "Meds - SIDC",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 1921,
    "total": 1921
  },
  {
    "id": "ledger-2024-2026-2491",
    "rowIndex": 2491,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 420,
    "qtyKg": null,
    "price": 50,
    "total": 21000
  },
  {
    "id": "ledger-2024-2026-2492",
    "rowIndex": 2492,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 420,
    "qtyKg": null,
    "price": 3,
    "total": 1260
  },
  {
    "id": "ledger-2024-2026-2493",
    "rowIndex": 2493,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 81,
    "qtyKg": null,
    "price": 100,
    "total": 8100
  },
  {
    "id": "ledger-2024-2026-2494",
    "rowIndex": 2494,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 81,
    "qtyKg": null,
    "price": 200,
    "total": 16200
  },
  {
    "id": "ledger-2024-2026-2495",
    "rowIndex": 2495,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 105,
    "qtyKg": null,
    "price": 500,
    "total": 52500
  },
  {
    "id": "ledger-2024-2026-2496",
    "rowIndex": 2496,
    "date": "2026-05-27",
    "rawDate": 46169,
    "raiser": "Baes, Vicente",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Baes, Vicente",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 24,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2497",
    "rowIndex": 2497,
    "date": "2026-05-29",
    "rawDate": 46171,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48527",
    "description": "HG Deluxe",
    "qty": 70,
    "qtyKg": null,
    "price": 1585,
    "total": 110950
  },
  {
    "id": "ledger-2024-2026-2498",
    "rowIndex": 2498,
    "date": "2026-05-29",
    "rawDate": 46171,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48527",
    "description": "HG Deluxe VR",
    "qty": 80,
    "qtyKg": null,
    "price": 1595,
    "total": 127600
  },
  {
    "id": "ledger-2024-2026-2499",
    "rowIndex": 2499,
    "date": "2026-05-29",
    "rawDate": 46171,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48528/29",
    "description": "HG Deluxe VAS2",
    "qty": 140,
    "qtyKg": null,
    "price": 1805,
    "total": 252700
  },
  {
    "id": "ledger-2024-2026-2500",
    "rowIndex": 2500,
    "date": "2026-05-29",
    "rawDate": 46171,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48529",
    "description": "HG Deluxe VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1695,
    "total": 16950
  },
  {
    "id": "ledger-2024-2026-2501",
    "rowIndex": 2501,
    "date": "2026-06-02",
    "rawDate": 46175,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Jerry V.",
    "description": "HG Deluxe",
    "qty": -1,
    "qtyKg": null,
    "price": 1560,
    "total": -1560
  },
  {
    "id": "ledger-2024-2026-2502",
    "rowIndex": 2502,
    "date": "2026-06-02",
    "rawDate": 46175,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Ladie H",
    "description": "HG Deluxe",
    "qty": 1,
    "qtyKg": null,
    "price": 1560,
    "total": 1560
  },
  {
    "id": "ledger-2024-2026-2503",
    "rowIndex": 2503,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48688",
    "description": "HG Deluxe VR",
    "qty": 150,
    "qtyKg": null,
    "price": 1595,
    "total": 239250
  },
  {
    "id": "ledger-2024-2026-2504",
    "rowIndex": 2504,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HG Deluxe VR",
    "qty": 15,
    "qtyKg": null,
    "price": 1595,
    "total": 23925
  },
  {
    "id": "ledger-2024-2026-2505",
    "rowIndex": 2505,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1580,
    "total": 39500
  },
  {
    "id": "ledger-2024-2026-2506",
    "rowIndex": 2506,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1580,
    "total": 31600
  },
  {
    "id": "ledger-2024-2026-2507",
    "rowIndex": 2507,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HSP",
    "qty": 20,
    "qtyKg": null,
    "price": 1580,
    "total": 31600
  },
  {
    "id": "ledger-2024-2026-2508",
    "rowIndex": 2508,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HSP",
    "qty": 40,
    "qtyKg": null,
    "price": 1580,
    "total": 63200
  },
  {
    "id": "ledger-2024-2026-2509",
    "rowIndex": 2509,
    "date": "2026-06-03",
    "rawDate": 46176,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48736",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1580,
    "total": 47400
  },
  {
    "id": "ledger-2024-2026-2510",
    "rowIndex": 2510,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2135",
    "description": null,
    "qty": 25,
    "qtyKg": 2843.2,
    "price": 190,
    "total": 540208
  },
  {
    "id": "ledger-2024-2026-2511",
    "rowIndex": 2511,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48745",
    "description": "HG Deluxe",
    "qty": 130,
    "qtyKg": null,
    "price": 1585,
    "total": 206050
  },
  {
    "id": "ledger-2024-2026-2512",
    "rowIndex": 2512,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48745",
    "description": "HG Deluxe VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1595,
    "total": 31900
  },
  {
    "id": "ledger-2024-2026-2513",
    "rowIndex": 2513,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48746",
    "description": "HG Deluxe VR",
    "qty": 30,
    "qtyKg": null,
    "price": 1595,
    "total": 47850
  },
  {
    "id": "ledger-2024-2026-2514",
    "rowIndex": 2514,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48746",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1580,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-2515",
    "rowIndex": 2515,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 4352,
    "total": 4352
  },
  {
    "id": "ledger-2024-2026-2516",
    "rowIndex": 2516,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 336,
    "qtyKg": null,
    "price": 50,
    "total": 16800
  },
  {
    "id": "ledger-2024-2026-2517",
    "rowIndex": 2517,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 336,
    "qtyKg": null,
    "price": 3,
    "total": 1008
  },
  {
    "id": "ledger-2024-2026-2518",
    "rowIndex": 2518,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 68,
    "qtyKg": null,
    "price": 100,
    "total": 6800
  },
  {
    "id": "ledger-2024-2026-2519",
    "rowIndex": 2519,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 68,
    "qtyKg": null,
    "price": 200,
    "total": 13600
  },
  {
    "id": "ledger-2024-2026-2520",
    "rowIndex": 2520,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 70,
    "qtyKg": null,
    "price": 500,
    "total": 35000
  },
  {
    "id": "ledger-2024-2026-2521",
    "rowIndex": 2521,
    "date": "2026-06-04",
    "rawDate": 46177,
    "raiser": "Hernandez, Ladie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Hernandez, Ladie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 2,
    "qtyKg": null,
    "price": null,
    "total": 0
  },
  {
    "id": "ledger-2024-2026-2522",
    "rowIndex": 2522,
    "date": "2026-06-05",
    "rawDate": 46178,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48770",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1585,
    "total": 23775
  },
  {
    "id": "ledger-2024-2026-2523",
    "rowIndex": 2523,
    "date": "2026-06-05",
    "rawDate": 46178,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48771",
    "description": "HG Deluxe",
    "qty": 135,
    "qtyKg": null,
    "price": 1585,
    "total": 213975
  },
  {
    "id": "ledger-2024-2026-2524",
    "rowIndex": 2524,
    "date": "2026-06-05",
    "rawDate": 46178,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48771",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1585,
    "total": 31700
  },
  {
    "id": "ledger-2024-2026-2525",
    "rowIndex": 2525,
    "date": "2026-06-08",
    "rawDate": 46181,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48818",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2526",
    "rowIndex": 2526,
    "date": "2026-06-09",
    "rawDate": 46182,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48904",
    "description": "HG Deluxe VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1595,
    "total": 63800
  },
  {
    "id": "ledger-2024-2026-2527",
    "rowIndex": 2527,
    "date": "2026-06-09",
    "rawDate": 46182,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48904",
    "description": "HSP",
    "qty": 60,
    "qtyKg": null,
    "price": 1580,
    "total": 94800
  },
  {
    "id": "ledger-2024-2026-2528",
    "rowIndex": 2528,
    "date": "2026-06-09",
    "rawDate": 46182,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48904",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1580,
    "total": 79000
  },
  {
    "id": "ledger-2024-2026-2529",
    "rowIndex": 2529,
    "date": "2026-06-10",
    "rawDate": 46183,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48964",
    "description": "HG Deluxe",
    "qty": 140,
    "qtyKg": null,
    "price": 1585,
    "total": 221900
  },
  {
    "id": "ledger-2024-2026-2530",
    "rowIndex": 2530,
    "date": "2026-06-10",
    "rawDate": 46183,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48964",
    "description": "HG Deluxe VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1595,
    "total": 15950
  },
  {
    "id": "ledger-2024-2026-2531",
    "rowIndex": 2531,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "48985",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2532",
    "rowIndex": 2532,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49006",
    "description": "HG Deluxe",
    "qty": 55,
    "qtyKg": null,
    "price": 1585,
    "total": 87175
  },
  {
    "id": "ledger-2024-2026-2533",
    "rowIndex": 2533,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49006",
    "description": "HSP VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1690,
    "total": 25350
  },
  {
    "id": "ledger-2024-2026-2534",
    "rowIndex": 2534,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49006",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1690,
    "total": 42250
  },
  {
    "id": "ledger-2024-2026-2535",
    "rowIndex": 2535,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49006",
    "description": "HSP VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1690,
    "total": 50700
  },
  {
    "id": "ledger-2024-2026-2536",
    "rowIndex": 2536,
    "date": "2026-06-11",
    "rawDate": 46184,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49006",
    "description": "HSP VAS",
    "qty": 25,
    "qtyKg": null,
    "price": 1690,
    "total": 42250
  },
  {
    "id": "ledger-2024-2026-2537",
    "rowIndex": 2537,
    "date": "2026-06-15",
    "rawDate": 46188,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49046-48",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2538",
    "rowIndex": 2538,
    "date": "2026-06-17",
    "rawDate": 46190,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49156",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1580,
    "total": 79000
  },
  {
    "id": "ledger-2024-2026-2539",
    "rowIndex": 2539,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2157",
    "description": null,
    "qty": 22,
    "qtyKg": 2509.6,
    "price": 185,
    "total": 464276
  },
  {
    "id": "ledger-2024-2026-2540",
    "rowIndex": 2540,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2158",
    "description": null,
    "qty": 16,
    "qtyKg": 1759.6,
    "price": 185,
    "total": 325526
  },
  {
    "id": "ledger-2024-2026-2541",
    "rowIndex": 2541,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49217",
    "description": "HG Deluxe VT A2",
    "qty": 140,
    "qtyKg": null,
    "price": 1650,
    "total": 231000
  },
  {
    "id": "ledger-2024-2026-2542",
    "rowIndex": 2542,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49217",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1580,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-2543",
    "rowIndex": 2543,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49218",
    "description": "HG Deluxe VT A2",
    "qty": 130,
    "qtyKg": null,
    "price": 1650,
    "total": 214500
  },
  {
    "id": "ledger-2024-2026-2544",
    "rowIndex": 2544,
    "date": "2026-06-18",
    "rawDate": 46191,
    "raiser": "Nato",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49218",
    "description": "HG Deluxe VR",
    "qty": 20,
    "qtyKg": null,
    "price": 1595,
    "total": 31900
  },
  {
    "id": "ledger-2024-2026-2545",
    "rowIndex": 2545,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49252",
    "description": "HG Deluxe VT A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1650,
    "total": 247500
  },
  {
    "id": "ledger-2024-2026-2546",
    "rowIndex": 2546,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HG Deluxe",
    "qty": 30,
    "qtyKg": null,
    "price": 1585,
    "total": 47550
  },
  {
    "id": "ledger-2024-2026-2547",
    "rowIndex": 2547,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1580,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-2548",
    "rowIndex": 2548,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HSP VAS",
    "qty": 5,
    "qtyKg": null,
    "price": 1690,
    "total": 8450
  },
  {
    "id": "ledger-2024-2026-2549",
    "rowIndex": 2549,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HSP VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1690,
    "total": 16900
  },
  {
    "id": "ledger-2024-2026-2550",
    "rowIndex": 2550,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HSP VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1690,
    "total": 16900
  },
  {
    "id": "ledger-2024-2026-2551",
    "rowIndex": 2551,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49269",
    "description": "HSP",
    "qty": 35,
    "qtyKg": null,
    "price": 1580,
    "total": 55300
  },
  {
    "id": "ledger-2024-2026-2552",
    "rowIndex": 2552,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49270",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1585,
    "total": 39625
  },
  {
    "id": "ledger-2024-2026-2553",
    "rowIndex": 2553,
    "date": "2026-06-19",
    "rawDate": 46192,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49270",
    "description": "HSP",
    "qty": 25,
    "qtyKg": null,
    "price": 1580,
    "total": 39500
  },
  {
    "id": "ledger-2024-2026-2554",
    "rowIndex": 2554,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "2163",
    "description": null,
    "qty": 20,
    "qtyKg": 2146,
    "price": 185,
    "total": 397010
  },
  {
    "id": "ledger-2024-2026-2555",
    "rowIndex": 2555,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "2164",
    "description": null,
    "qty": 8,
    "qtyKg": 992,
    "price": 185,
    "total": 183520
  },
  {
    "id": "ledger-2024-2026-2556",
    "rowIndex": 2556,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49394",
    "description": "HG Deluxe",
    "qty": 100,
    "qtyKg": null,
    "price": 1585,
    "total": 158500
  },
  {
    "id": "ledger-2024-2026-2557",
    "rowIndex": 2557,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49394",
    "description": "HG Deluxe VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1595,
    "total": 79750
  },
  {
    "id": "ledger-2024-2026-2558",
    "rowIndex": 2558,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HSP VAS",
    "qty": 45,
    "qtyKg": null,
    "price": 1690,
    "total": 76050
  },
  {
    "id": "ledger-2024-2026-2559",
    "rowIndex": 2559,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1580,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-2560",
    "rowIndex": 2560,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HG Deluxe VAS",
    "qty": 30,
    "qtyKg": null,
    "price": 1695,
    "total": 50850
  },
  {
    "id": "ledger-2024-2026-2561",
    "rowIndex": 2561,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HG Deluxe",
    "qty": 31,
    "qtyKg": null,
    "price": 1585,
    "total": 49135
  },
  {
    "id": "ledger-2024-2026-2562",
    "rowIndex": 2562,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HSP VAS",
    "qty": 5,
    "qtyKg": null,
    "price": 1690,
    "total": 8450
  },
  {
    "id": "ledger-2024-2026-2563",
    "rowIndex": 2563,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HG Deluxe VAS",
    "qty": 7,
    "qtyKg": null,
    "price": 1695,
    "total": 11865
  },
  {
    "id": "ledger-2024-2026-2564",
    "rowIndex": 2564,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HSP VAS",
    "qty": 10,
    "qtyKg": null,
    "price": 1690,
    "total": 16900
  },
  {
    "id": "ledger-2024-2026-2565",
    "rowIndex": 2565,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HG Deluxe VAS",
    "qty": 5,
    "qtyKg": null,
    "price": 1695,
    "total": 8475
  },
  {
    "id": "ledger-2024-2026-2566",
    "rowIndex": 2566,
    "date": "2026-06-24",
    "rawDate": 46197,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49422",
    "description": "HG Deluxe VAS",
    "qty": 7,
    "qtyKg": null,
    "price": 1695,
    "total": 11865
  },
  {
    "id": "ledger-2024-2026-2567",
    "rowIndex": 2567,
    "date": "2026-06-25",
    "rawDate": 46198,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49459",
    "description": "HG Deluxe",
    "qty": 135,
    "qtyKg": null,
    "price": 1585,
    "total": 213975
  },
  {
    "id": "ledger-2024-2026-2568",
    "rowIndex": 2568,
    "date": "2026-06-25",
    "rawDate": 46198,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49459",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1585,
    "total": 23775
  },
  {
    "id": "ledger-2024-2026-2569",
    "rowIndex": 2569,
    "date": "2026-06-26",
    "rawDate": 46199,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49497",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2570",
    "rowIndex": 2570,
    "date": "2026-06-27",
    "rawDate": 46200,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2168",
    "description": null,
    "qty": 25,
    "qtyKg": 2842.6,
    "price": 185,
    "total": 525881
  },
  {
    "id": "ledger-2024-2026-2571",
    "rowIndex": 2571,
    "date": "2026-06-29",
    "rawDate": 46202,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49545",
    "description": "HSP",
    "qty": 50,
    "qtyKg": null,
    "price": 1580,
    "total": 79000
  },
  {
    "id": "ledger-2024-2026-2572",
    "rowIndex": 2572,
    "date": "2026-06-29",
    "rawDate": 46202,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49545",
    "description": "HG Deluxe",
    "qty": 50,
    "qtyKg": null,
    "price": 1585,
    "total": 79250
  },
  {
    "id": "ledger-2024-2026-2573",
    "rowIndex": 2573,
    "date": "2026-06-29",
    "rawDate": 46202,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49545",
    "description": "HG Deluxe VAS",
    "qty": 20,
    "qtyKg": null,
    "price": 1695,
    "total": 33900
  },
  {
    "id": "ledger-2024-2026-2574",
    "rowIndex": 2574,
    "date": "2026-06-29",
    "rawDate": 46202,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49545",
    "description": "HG Deluxe VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1695,
    "total": 25425
  },
  {
    "id": "ledger-2024-2026-2575",
    "rowIndex": 2575,
    "date": "2026-06-29",
    "rawDate": 46202,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49545",
    "description": "HG Deluxe VAS",
    "qty": 15,
    "qtyKg": null,
    "price": 1695,
    "total": 25425
  },
  {
    "id": "ledger-2024-2026-2576",
    "rowIndex": 2576,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2170",
    "description": null,
    "qty": 20,
    "qtyKg": 2347,
    "price": 185,
    "total": 434195
  },
  {
    "id": "ledger-2024-2026-2577",
    "rowIndex": 2577,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2171",
    "description": null,
    "qty": 20,
    "qtyKg": 2223,
    "price": 185,
    "total": 411255
  },
  {
    "id": "ledger-2024-2026-2578",
    "rowIndex": 2578,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2172",
    "description": null,
    "qty": 8,
    "qtyKg": 979,
    "price": 185,
    "total": 181115
  },
  {
    "id": "ledger-2024-2026-2579",
    "rowIndex": 2579,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49646",
    "description": "HG Deluxe VR",
    "qty": 34,
    "qtyKg": null,
    "price": 1595,
    "total": 54230
  },
  {
    "id": "ledger-2024-2026-2580",
    "rowIndex": 2580,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Alcantara, Joel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49646",
    "description": "HSP VT A2",
    "qty": 11,
    "qtyKg": null,
    "price": 1655,
    "total": 18205
  },
  {
    "id": "ledger-2024-2026-2581",
    "rowIndex": 2581,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Alcantara, John",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49646",
    "description": "HSP VT A2",
    "qty": 8,
    "qtyKg": null,
    "price": 1655,
    "total": 13240
  },
  {
    "id": "ledger-2024-2026-2582",
    "rowIndex": 2582,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Barro, Myrna",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49646",
    "description": "HSP VT A2",
    "qty": 13,
    "qtyKg": null,
    "price": 1655,
    "total": 21515
  },
  {
    "id": "ledger-2024-2026-2583",
    "rowIndex": 2583,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49646",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1580,
    "total": 22120
  },
  {
    "id": "ledger-2024-2026-2584",
    "rowIndex": 2584,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49647",
    "description": "HG Deluxe VT A2",
    "qty": 140,
    "qtyKg": null,
    "price": 1660,
    "total": 232400
  },
  {
    "id": "ledger-2024-2026-2585",
    "rowIndex": 2585,
    "date": "2026-07-01",
    "rawDate": 46204,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49647",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1585,
    "total": 15850
  },
  {
    "id": "ledger-2024-2026-2586",
    "rowIndex": 2586,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49690",
    "description": "HG Deluxe VT A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1660,
    "total": 249000
  },
  {
    "id": "ledger-2024-2026-2587",
    "rowIndex": 2587,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49691",
    "description": "HG Deluxe VT A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1660,
    "total": 91300
  },
  {
    "id": "ledger-2024-2026-2588",
    "rowIndex": 2588,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49692",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1585,
    "total": 31700
  },
  {
    "id": "ledger-2024-2026-2589",
    "rowIndex": 2589,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49692",
    "description": "HG Deluxe VT A2",
    "qty": 55,
    "qtyKg": null,
    "price": 1660,
    "total": 91300
  },
  {
    "id": "ledger-2024-2026-2590",
    "rowIndex": 2590,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49692",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1585,
    "total": 15850
  },
  {
    "id": "ledger-2024-2026-2591",
    "rowIndex": 2591,
    "date": "2026-07-02",
    "rawDate": 46205,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49692",
    "description": "HG Deluxe VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1595,
    "total": 15950
  },
  {
    "id": "ledger-2024-2026-2592",
    "rowIndex": 2592,
    "date": "2026-07-03",
    "rawDate": 46206,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49734",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1585,
    "total": 7925
  },
  {
    "id": "ledger-2024-2026-2593",
    "rowIndex": 2593,
    "date": "2026-07-03",
    "rawDate": 46206,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49734",
    "description": "HG Deluxe",
    "qty": 12,
    "qtyKg": null,
    "price": 1585,
    "total": 19020
  },
  {
    "id": "ledger-2024-2026-2594",
    "rowIndex": 2594,
    "date": "2026-07-03",
    "rawDate": 46206,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49734",
    "description": "HG Deluxe",
    "qty": 18,
    "qtyKg": null,
    "price": 1585,
    "total": 28530
  },
  {
    "id": "ledger-2024-2026-2595",
    "rowIndex": 2595,
    "date": "2026-07-03",
    "rawDate": 46206,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49734",
    "description": "HG Deluxe",
    "qty": 40,
    "qtyKg": null,
    "price": 1585,
    "total": 63400
  },
  {
    "id": "ledger-2024-2026-2596",
    "rowIndex": 2596,
    "date": "2026-07-04",
    "rawDate": 46207,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2174",
    "description": null,
    "qty": 30,
    "qtyKg": 3389.6,
    "price": 185,
    "total": 627076
  },
  {
    "id": "ledger-2024-2026-2597",
    "rowIndex": 2597,
    "date": "2026-07-04",
    "rawDate": 46207,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2175",
    "description": null,
    "qty": 17,
    "qtyKg": 2158,
    "price": 185,
    "total": 399230
  },
  {
    "id": "ledger-2024-2026-2598",
    "rowIndex": 2598,
    "date": "2026-07-04",
    "rawDate": 46207,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2176",
    "description": null,
    "qty": 20,
    "qtyKg": 2480,
    "price": 185,
    "total": 458800
  },
  {
    "id": "ledger-2024-2026-2599",
    "rowIndex": 2599,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2177",
    "description": null,
    "qty": 25,
    "qtyKg": 2895.2,
    "price": 185,
    "total": 535612
  },
  {
    "id": "ledger-2024-2026-2600",
    "rowIndex": 2600,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2178",
    "description": null,
    "qty": 10,
    "qtyKg": 1250.4,
    "price": 185,
    "total": 231324.00000000003
  },
  {
    "id": "ledger-2024-2026-2601",
    "rowIndex": 2601,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2178",
    "description": null,
    "qty": 2,
    "qtyKg": 140,
    "price": 145,
    "total": 20300
  },
  {
    "id": "ledger-2024-2026-2602",
    "rowIndex": 2602,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49754",
    "description": "HSP",
    "qty": 70,
    "qtyKg": null,
    "price": 1580,
    "total": 110600
  },
  {
    "id": "ledger-2024-2026-2603",
    "rowIndex": 2603,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49754",
    "description": "HG Deluxe",
    "qty": 40,
    "qtyKg": null,
    "price": 1585,
    "total": 63400
  },
  {
    "id": "ledger-2024-2026-2604",
    "rowIndex": 2604,
    "date": "2026-07-06",
    "rawDate": 46209,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49754",
    "description": "HG Deluxe VR",
    "qty": 40,
    "qtyKg": null,
    "price": 1595,
    "total": 63800
  },
  {
    "id": "ledger-2024-2026-2605",
    "rowIndex": 2605,
    "date": "2026-07-08",
    "rawDate": 46211,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49859",
    "description": "HG Deluxe VT A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1660,
    "total": 249000
  },
  {
    "id": "ledger-2024-2026-2606",
    "rowIndex": 2606,
    "date": "2026-07-08",
    "rawDate": 46211,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49860",
    "description": "HG Deluxe VT A2",
    "qty": 150,
    "qtyKg": null,
    "price": 1660,
    "total": 249000
  },
  {
    "id": "ledger-2024-2026-2607",
    "rowIndex": 2607,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "2182",
    "description": null,
    "qty": 1,
    "qtyKg": 80,
    "price": 185,
    "total": 14800
  },
  {
    "id": "ledger-2024-2026-2608",
    "rowIndex": 2608,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "2182",
    "description": null,
    "qty": 1,
    "qtyKg": 67,
    "price": 155,
    "total": 10385
  },
  {
    "id": "ledger-2024-2026-2609",
    "rowIndex": 2609,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49930",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1585,
    "total": 15850
  },
  {
    "id": "ledger-2024-2026-2610",
    "rowIndex": 2610,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49930",
    "description": "HG Deluxe VR",
    "qty": 10,
    "qtyKg": null,
    "price": 1595,
    "total": 15950
  },
  {
    "id": "ledger-2024-2026-2611",
    "rowIndex": 2611,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49930",
    "description": "HG Deluxe",
    "qty": 30,
    "qtyKg": null,
    "price": 1585,
    "total": 47550
  },
  {
    "id": "ledger-2024-2026-2612",
    "rowIndex": 2612,
    "date": "2026-07-09",
    "rawDate": 46212,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49930",
    "description": "HG Deluxe VT A2",
    "qty": 100,
    "qtyKg": null,
    "price": 1660,
    "total": 166000
  },
  {
    "id": "ledger-2024-2026-2613",
    "rowIndex": 2613,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49954",
    "description": "HSP",
    "qty": 30,
    "qtyKg": null,
    "price": 1580,
    "total": 47400
  },
  {
    "id": "ledger-2024-2026-2614",
    "rowIndex": 2614,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Alcantara, Joel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49954",
    "description": "HSP VT A2",
    "qty": 14,
    "qtyKg": null,
    "price": 1655,
    "total": 23170
  },
  {
    "id": "ledger-2024-2026-2615",
    "rowIndex": 2615,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Alcantara, John",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49954",
    "description": "HSP VT A2",
    "qty": 10,
    "qtyKg": null,
    "price": 1655,
    "total": 16550
  },
  {
    "id": "ledger-2024-2026-2616",
    "rowIndex": 2616,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Barro, Myrna",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49954",
    "description": "HSP VT A2",
    "qty": 16,
    "qtyKg": null,
    "price": 1655,
    "total": 26480
  },
  {
    "id": "ledger-2024-2026-2617",
    "rowIndex": 2617,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49955",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1585,
    "total": 39625
  },
  {
    "id": "ledger-2024-2026-2618",
    "rowIndex": 2618,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49955",
    "description": "HSP",
    "qty": 1,
    "qtyKg": null,
    "price": 1580,
    "total": 1580
  },
  {
    "id": "ledger-2024-2026-2619",
    "rowIndex": 2619,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49955",
    "description": "HG Deluxe",
    "qty": 19,
    "qtyKg": null,
    "price": 1585,
    "total": 30115
  },
  {
    "id": "ledger-2024-2026-2620",
    "rowIndex": 2620,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49955",
    "description": "HG Deluxe",
    "qty": 25,
    "qtyKg": null,
    "price": 1585,
    "total": 39625
  },
  {
    "id": "ledger-2024-2026-2621",
    "rowIndex": 2621,
    "date": "2026-07-10",
    "rawDate": 46213,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49955",
    "description": "HG Deluxe",
    "qty": 10,
    "qtyKg": null,
    "price": 1585,
    "total": 15850
  },
  {
    "id": "ledger-2024-2026-2622",
    "rowIndex": 2622,
    "date": "2026-07-11",
    "rawDate": 46214,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2183",
    "description": null,
    "qty": 30,
    "qtyKg": 3583,
    "price": 185,
    "total": 662855
  },
  {
    "id": "ledger-2024-2026-2623",
    "rowIndex": 2623,
    "date": "2026-07-11",
    "rawDate": 46214,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2184",
    "description": null,
    "qty": 25,
    "qtyKg": 2965,
    "price": 185,
    "total": 548525
  },
  {
    "id": "ledger-2024-2026-2624",
    "rowIndex": 2624,
    "date": "2026-07-11",
    "rawDate": 46214,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2185",
    "description": null,
    "qty": 17,
    "qtyKg": 2197,
    "price": 185,
    "total": 406445
  },
  {
    "id": "ledger-2024-2026-2625",
    "rowIndex": 2625,
    "date": "2026-07-13",
    "rawDate": 46216,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49996",
    "description": "HSP",
    "qty": 80,
    "qtyKg": null,
    "price": 1580,
    "total": 126400
  },
  {
    "id": "ledger-2024-2026-2626",
    "rowIndex": 2626,
    "date": "2026-07-13",
    "rawDate": 46216,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49996",
    "description": "HG Deluxe VR",
    "qty": 50,
    "qtyKg": null,
    "price": 1595,
    "total": 79750
  },
  {
    "id": "ledger-2024-2026-2627",
    "rowIndex": 2627,
    "date": "2026-07-13",
    "rawDate": 46216,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "49996",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1585,
    "total": 31700
  },
  {
    "id": "ledger-2024-2026-2628",
    "rowIndex": 2628,
    "date": "2026-07-14",
    "rawDate": 46217,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2186",
    "description": null,
    "qty": 2,
    "qtyKg": 217,
    "price": 185,
    "total": 40145
  },
  {
    "id": "ledger-2024-2026-2629",
    "rowIndex": 2629,
    "date": "2026-07-14",
    "rawDate": 46217,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50057",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2630",
    "rowIndex": 2630,
    "date": "2026-07-15",
    "rawDate": 46218,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2188",
    "description": null,
    "qty": 19,
    "qtyKg": 1998,
    "price": 185,
    "total": 369630
  },
  {
    "id": "ledger-2024-2026-2631",
    "rowIndex": 2631,
    "date": "2026-07-15",
    "rawDate": 46218,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2188",
    "description": null,
    "qty": 1,
    "qtyKg": 95,
    "price": 185,
    "total": 17575
  },
  {
    "id": "ledger-2024-2026-2632",
    "rowIndex": 2632,
    "date": "2026-07-15",
    "rawDate": 46218,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2189",
    "description": null,
    "qty": 7,
    "qtyKg": 806.6,
    "price": 185,
    "total": 149221
  },
  {
    "id": "ledger-2024-2026-2633",
    "rowIndex": 2633,
    "date": "2026-07-15",
    "rawDate": 46218,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2189",
    "description": null,
    "qty": 1,
    "qtyKg": 102,
    "price": 185,
    "total": 18870
  },
  {
    "id": "ledger-2024-2026-2634",
    "rowIndex": 2634,
    "date": "2026-07-15",
    "rawDate": 46218,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2190",
    "description": null,
    "qty": 25,
    "qtyKg": 2906,
    "price": 185,
    "total": 537610
  },
  {
    "id": "ledger-2024-2026-2635",
    "rowIndex": 2635,
    "date": "2026-07-16",
    "rawDate": 46219,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50147",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1585,
    "total": 23775
  },
  {
    "id": "ledger-2024-2026-2636",
    "rowIndex": 2636,
    "date": "2026-07-16",
    "rawDate": 46219,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50147",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2637",
    "rowIndex": 2637,
    "date": "2026-07-16",
    "rawDate": 46219,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50147",
    "description": "HG Deluxe",
    "qty": 135,
    "qtyKg": null,
    "price": 1585,
    "total": 213975
  },
  {
    "id": "ledger-2024-2026-2638",
    "rowIndex": 2638,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe",
    "qty": 5,
    "qtyKg": null,
    "price": 1585,
    "total": 7925
  },
  {
    "id": "ledger-2024-2026-2639",
    "rowIndex": 2639,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 1585,
    "total": 12680
  },
  {
    "id": "ledger-2024-2026-2640",
    "rowIndex": 2640,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1595,
    "total": 11165
  },
  {
    "id": "ledger-2024-2026-2641",
    "rowIndex": 2641,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 1585,
    "total": 12680
  },
  {
    "id": "ledger-2024-2026-2642",
    "rowIndex": 2642,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1595,
    "total": 11165
  },
  {
    "id": "ledger-2024-2026-2643",
    "rowIndex": 2643,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 1585,
    "total": 12680
  },
  {
    "id": "ledger-2024-2026-2644",
    "rowIndex": 2644,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe VR",
    "qty": 7,
    "qtyKg": null,
    "price": 1595,
    "total": 11165
  },
  {
    "id": "ledger-2024-2026-2645",
    "rowIndex": 2645,
    "date": "2026-07-17",
    "rawDate": 46220,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50177",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1585,
    "total": 23775
  },
  {
    "id": "ledger-2024-2026-2646",
    "rowIndex": 2646,
    "date": "2026-07-18",
    "rawDate": 46221,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2191",
    "description": null,
    "qty": 20,
    "qtyKg": 2671,
    "price": 185,
    "total": 494135
  },
  {
    "id": "ledger-2024-2026-2647",
    "rowIndex": 2647,
    "date": "2026-07-18",
    "rawDate": 46221,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2192",
    "description": null,
    "qty": 30,
    "qtyKg": 3796,
    "price": 185,
    "total": 702260
  },
  {
    "id": "ledger-2024-2026-2648",
    "rowIndex": 2648,
    "date": "2026-07-18",
    "rawDate": 46221,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2193",
    "description": null,
    "qty": 25,
    "qtyKg": 2837,
    "price": 185,
    "total": 524845
  },
  {
    "id": "ledger-2024-2026-2649",
    "rowIndex": 2649,
    "date": "2026-07-21",
    "rawDate": 46224,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50280",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2650",
    "rowIndex": 2650,
    "date": "2026-07-21",
    "rawDate": 46224,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50281",
    "description": "HG Deluxe VAS",
    "qty": 65,
    "qtyKg": null,
    "price": 1695,
    "total": 110175
  },
  {
    "id": "ledger-2024-2026-2651",
    "rowIndex": 2651,
    "date": "2026-07-21",
    "rawDate": 46224,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50281",
    "description": "HSP",
    "qty": 85,
    "qtyKg": null,
    "price": 1580,
    "total": 134300
  },
  {
    "id": "ledger-2024-2026-2652",
    "rowIndex": 2652,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2194",
    "description": null,
    "qty": 16,
    "qtyKg": 1970,
    "price": 185,
    "total": 364450
  },
  {
    "id": "ledger-2024-2026-2653",
    "rowIndex": 2653,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2195",
    "description": null,
    "qty": 25,
    "qtyKg": 2999,
    "price": 185,
    "total": 554815
  },
  {
    "id": "ledger-2024-2026-2654",
    "rowIndex": 2654,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2196",
    "description": null,
    "qty": 20,
    "qtyKg": 2116,
    "price": 185,
    "total": 391460
  },
  {
    "id": "ledger-2024-2026-2655",
    "rowIndex": 2655,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2197",
    "description": null,
    "qty": 8,
    "qtyKg": 955,
    "price": 185,
    "total": 176675
  },
  {
    "id": "ledger-2024-2026-2656",
    "rowIndex": 2656,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50331",
    "description": "HG Deluxe",
    "qty": 4,
    "qtyKg": null,
    "price": 1585,
    "total": 6340
  },
  {
    "id": "ledger-2024-2026-2657",
    "rowIndex": 2657,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Alcantara, Joel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50331",
    "description": "HSP VI",
    "qty": 9,
    "qtyKg": null,
    "price": 1595,
    "total": 14355
  },
  {
    "id": "ledger-2024-2026-2658",
    "rowIndex": 2658,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Alcantara, John",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50331",
    "description": "HSP VI",
    "qty": 6,
    "qtyKg": null,
    "price": 1595,
    "total": 9570
  },
  {
    "id": "ledger-2024-2026-2659",
    "rowIndex": 2659,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Barro, Myrna",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50331",
    "description": "HSP VI",
    "qty": 13,
    "qtyKg": null,
    "price": 1595,
    "total": 20735
  },
  {
    "id": "ledger-2024-2026-2660",
    "rowIndex": 2660,
    "date": "2026-07-22",
    "rawDate": 46225,
    "raiser": "Patron, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50331",
    "description": "HSP",
    "qty": 18,
    "qtyKg": null,
    "price": 1580,
    "total": 28440
  },
  {
    "id": "ledger-2024-2026-2661",
    "rowIndex": 2661,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2199",
    "description": null,
    "qty": 30,
    "qtyKg": 3672,
    "price": 185,
    "total": 679320
  },
  {
    "id": "ledger-2024-2026-2662",
    "rowIndex": 2662,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe",
    "qty": 16,
    "qtyKg": null,
    "price": 1585,
    "total": 25360
  },
  {
    "id": "ledger-2024-2026-2663",
    "rowIndex": 2663,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe",
    "qty": 12,
    "qtyKg": null,
    "price": 1585,
    "total": 19020
  },
  {
    "id": "ledger-2024-2026-2664",
    "rowIndex": 2664,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe VR",
    "qty": 11,
    "qtyKg": null,
    "price": 1595,
    "total": 17545
  },
  {
    "id": "ledger-2024-2026-2665",
    "rowIndex": 2665,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe",
    "qty": 12,
    "qtyKg": null,
    "price": 1585,
    "total": 19020
  },
  {
    "id": "ledger-2024-2026-2666",
    "rowIndex": 2666,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe VR",
    "qty": 11,
    "qtyKg": null,
    "price": 1595,
    "total": 17545
  },
  {
    "id": "ledger-2024-2026-2667",
    "rowIndex": 2667,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe",
    "qty": 14,
    "qtyKg": null,
    "price": 1585,
    "total": 22190
  },
  {
    "id": "ledger-2024-2026-2668",
    "rowIndex": 2668,
    "date": "2026-07-23",
    "rawDate": 46226,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50397",
    "description": "HG Deluxe VR",
    "qty": 14,
    "qtyKg": null,
    "price": 1595,
    "total": 22330
  },
  {
    "id": "ledger-2024-2026-2669",
    "rowIndex": 2669,
    "date": "2026-07-24",
    "rawDate": 46227,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50412",
    "description": "HG Deluxe",
    "qty": 50,
    "qtyKg": null,
    "price": 1585,
    "total": 79250
  },
  {
    "id": "ledger-2024-2026-2670",
    "rowIndex": 2670,
    "date": "2026-07-24",
    "rawDate": 46227,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50412",
    "description": "HG Deluxe",
    "qty": 80,
    "qtyKg": null,
    "price": 1585,
    "total": 126800
  },
  {
    "id": "ledger-2024-2026-2671",
    "rowIndex": 2671,
    "date": "2026-07-24",
    "rawDate": 46227,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50412",
    "description": "HG Deluxe",
    "qty": 20,
    "qtyKg": null,
    "price": 1585,
    "total": 31700
  },
  {
    "id": "ledger-2024-2026-2672",
    "rowIndex": 2672,
    "date": "2026-07-25",
    "rawDate": 46228,
    "raiser": "Sibal, Andres",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2200",
    "description": null,
    "qty": 2,
    "qtyKg": 218.2,
    "price": 185,
    "total": 40367
  },
  {
    "id": "ledger-2024-2026-2673",
    "rowIndex": 2673,
    "date": "2026-07-25",
    "rawDate": 46228,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2200",
    "description": null,
    "qty": 1,
    "qtyKg": 87,
    "price": 185,
    "total": 16095
  },
  {
    "id": "ledger-2024-2026-2674",
    "rowIndex": 2674,
    "date": "2026-07-25",
    "rawDate": 46228,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2201",
    "description": null,
    "qty": 23,
    "qtyKg": 2648,
    "price": 185,
    "total": 489880
  },
  {
    "id": "ledger-2024-2026-2675",
    "rowIndex": 2675,
    "date": "2026-07-25",
    "rawDate": 46228,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2202",
    "description": null,
    "qty": 25,
    "qtyKg": 2637,
    "price": 185,
    "total": 487845
  },
  {
    "id": "ledger-2024-2026-2676",
    "rowIndex": 2676,
    "date": "2026-07-25",
    "rawDate": 46228,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2203",
    "description": null,
    "qty": 10,
    "qtyKg": 1237.4,
    "price": 185,
    "total": 228919.00000000003
  },
  {
    "id": "ledger-2024-2026-2677",
    "rowIndex": 2677,
    "date": "2026-07-28",
    "rawDate": 46231,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50512",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1580,
    "total": 11060
  },
  {
    "id": "ledger-2024-2026-2678",
    "rowIndex": 2678,
    "date": "2026-07-28",
    "rawDate": 46231,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50512",
    "description": "HG Deluxe VAS",
    "qty": 7,
    "qtyKg": null,
    "price": 1695,
    "total": 11865
  },
  {
    "id": "ledger-2024-2026-2679",
    "rowIndex": 2679,
    "date": "2026-07-28",
    "rawDate": 46231,
    "raiser": "Perez, Joel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Perez, Joel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50512",
    "description": "HSP",
    "qty": 10,
    "qtyKg": null,
    "price": 1580,
    "total": 15800
  },
  {
    "id": "ledger-2024-2026-2680",
    "rowIndex": 2680,
    "date": "2026-07-28",
    "rawDate": 46231,
    "raiser": "Alcantara, John",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Alcantara, John",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50512",
    "description": "HSP",
    "qty": 7,
    "qtyKg": null,
    "price": 1580,
    "total": 11060
  },
  {
    "id": "ledger-2024-2026-2681",
    "rowIndex": 2681,
    "date": "2026-07-28",
    "rawDate": 46231,
    "raiser": "Barro, Myrna",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Barro, Myrna",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50512",
    "description": "HSP",
    "qty": 14,
    "qtyKg": null,
    "price": 1580,
    "total": 22120
  },
  {
    "id": "ledger-2024-2026-2682",
    "rowIndex": 2682,
    "date": "2026-07-29",
    "rawDate": 46232,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2204",
    "description": null,
    "qty": 17,
    "qtyKg": 1979.2,
    "price": 185,
    "total": 366152
  },
  {
    "id": "ledger-2024-2026-2683",
    "rowIndex": 2683,
    "date": "2026-07-29",
    "rawDate": 46232,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2204",
    "description": null,
    "qty": 1,
    "qtyKg": 60.8,
    "price": 145,
    "total": 8816
  },
  {
    "id": "ledger-2024-2026-2684",
    "rowIndex": 2684,
    "date": "2026-07-29",
    "rawDate": 46232,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2204",
    "description": null,
    "qty": 7,
    "qtyKg": 741.8,
    "price": 185,
    "total": 137233
  },
  {
    "id": "ledger-2024-2026-2685",
    "rowIndex": 2685,
    "date": "2026-07-29",
    "rawDate": 46232,
    "raiser": "Mabalor - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Mabalor - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50565",
    "description": "HG Deluxe",
    "qty": 150,
    "qtyKg": null,
    "price": 1585,
    "total": 237750
  },
  {
    "id": "ledger-2024-2026-2686",
    "rowIndex": 2686,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Sibal, Andres",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Sibal, Andres",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2205",
    "description": null,
    "qty": 12,
    "qtyKg": 1445.4,
    "price": 185,
    "total": 267399
  },
  {
    "id": "ledger-2024-2026-2687",
    "rowIndex": 2687,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Coliat, Bernie",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "1010",
    "ledgerDescription": "Pig Sales",
    "invoiceRef": "2205",
    "description": null,
    "qty": 1,
    "qtyKg": 90.6,
    "price": 180,
    "total": 16307.999999999998
  },
  {
    "id": "ledger-2024-2026-2688",
    "rowIndex": 2688,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Cahigam - Marcel",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Marcel",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50605",
    "description": "HG Deluxe",
    "qty": 75,
    "qtyKg": null,
    "price": 1585,
    "total": 118875
  },
  {
    "id": "ledger-2024-2026-2689",
    "rowIndex": 2689,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Cahigam - Lesty",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Cahigam - Lesty",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50605",
    "description": "HG Deluxe",
    "qty": 60,
    "qtyKg": null,
    "price": 1585,
    "total": 95100
  },
  {
    "id": "ledger-2024-2026-2690",
    "rowIndex": 2690,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Nato",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Nato",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50605",
    "description": "HG Deluxe",
    "qty": 15,
    "qtyKg": null,
    "price": 1585,
    "total": 23775
  },
  {
    "id": "ledger-2024-2026-2691",
    "rowIndex": 2691,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Coliat, Nardo",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Nardo",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HG Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 1585,
    "total": 12680
  },
  {
    "id": "ledger-2024-2026-2692",
    "rowIndex": 2692,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Coliat, Amie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Amie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HG Deluxe",
    "qty": 8,
    "qtyKg": null,
    "price": 1585,
    "total": 12680
  },
  {
    "id": "ledger-2024-2026-2693",
    "rowIndex": 2693,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Coliat, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Coliat, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HG Deluxe",
    "qty": 14,
    "qtyKg": null,
    "price": 1585,
    "total": 22190
  },
  {
    "id": "ledger-2024-2026-2694",
    "rowIndex": 2694,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HG Deluxe",
    "qty": 30,
    "qtyKg": null,
    "price": 1585,
    "total": 47550
  },
  {
    "id": "ledger-2024-2026-2695",
    "rowIndex": 2695,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Casas, Joseph - Reymond",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Casas, Joseph - Reymond",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HG Deluxe VR",
    "qty": 25,
    "qtyKg": null,
    "price": 1595,
    "total": 39875
  },
  {
    "id": "ledger-2024-2026-2696",
    "rowIndex": 2696,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Culiat, Annabelle",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Culiat, Annabelle",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "50613",
    "description": "HSP",
    "qty": 65,
    "qtyKg": null,
    "price": 1580,
    "total": 102700
  },
  {
    "id": "ledger-2024-2026-2697",
    "rowIndex": 2697,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "to Bernie P.",
    "description": "HG Deluxe",
    "qty": -1,
    "qtyKg": null,
    "price": 1585,
    "total": -1585
  },
  {
    "id": "ledger-2024-2026-2698",
    "rowIndex": 2698,
    "date": "2026-07-30",
    "rawDate": 46233,
    "raiser": "Patron, Bernie",
    "batch": "2026-02",
    "cycleCode": "2026-02 - Patron, Bernie",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3020",
    "ledgerDescription": "Feeds",
    "invoiceRef": "from Jerry V.",
    "description": "HG Deluxe",
    "qty": 1,
    "qtyKg": null,
    "price": 1585,
    "total": 1585
  },
  {
    "id": "ledger-2024-2026-2699",
    "rowIndex": 2699,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3030",
    "ledgerDescription": "Meds - VSB",
    "invoiceRef": null,
    "description": null,
    "qty": 1,
    "qtyKg": null,
    "price": 8469,
    "total": 8469
  },
  {
    "id": "ledger-2024-2026-2700",
    "rowIndex": 2700,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3040",
    "ledgerDescription": "Trucking - Feeds",
    "invoiceRef": null,
    "description": null,
    "qty": 873,
    "qtyKg": null,
    "price": 50,
    "total": 43650
  },
  {
    "id": "ledger-2024-2026-2701",
    "rowIndex": 2701,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "4020",
    "ledgerDescription": "Adj - sales from used sacks",
    "invoiceRef": null,
    "description": null,
    "qty": 873,
    "qtyKg": null,
    "price": 3,
    "total": 2619
  },
  {
    "id": "ledger-2024-2026-2702",
    "rowIndex": 2702,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3050",
    "ledgerDescription": "Management",
    "invoiceRef": null,
    "description": null,
    "qty": 161,
    "qtyKg": null,
    "price": 100,
    "total": 16100
  },
  {
    "id": "ledger-2024-2026-2703",
    "rowIndex": 2703,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3051",
    "ledgerDescription": "Pig Hauling Permit",
    "invoiceRef": null,
    "description": null,
    "qty": 161,
    "qtyKg": null,
    "price": 200,
    "total": 32200
  },
  {
    "id": "ledger-2024-2026-2704",
    "rowIndex": 2704,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "3034",
    "ledgerDescription": "ASF Vaccine",
    "invoiceRef": null,
    "description": null,
    "qty": 170,
    "qtyKg": null,
    "price": 400,
    "total": 68000
  },
  {
    "id": "ledger-2024-2026-2705",
    "rowIndex": 2705,
    "date": "2026-08-10",
    "rawDate": 46244,
    "raiser": "Virtucio, Jerry",
    "batch": "2026-01",
    "cycleCode": "2026-01 - Virtucio, Jerry",
    "supplier": null,
    "customer": null,
    "ledgerNr": "2010",
    "ledgerDescription": "Mortality",
    "invoiceRef": null,
    "description": null,
    "qty": 9,
    "qtyKg": null,
    "price": null,
    "total": 0
  }
];
